(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // node_modules/core-js/modules/_global.js
  var require_global = __commonJS({
    "node_modules/core-js/modules/_global.js"(exports, module) {
      var global2 = module.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
      if (typeof __g == "number") __g = global2;
    }
  });

  // node_modules/core-js/modules/_has.js
  var require_has = __commonJS({
    "node_modules/core-js/modules/_has.js"(exports, module) {
      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function(it, key) {
        return hasOwnProperty.call(it, key);
      };
    }
  });

  // node_modules/core-js/modules/_fails.js
  var require_fails = __commonJS({
    "node_modules/core-js/modules/_fails.js"(exports, module) {
      module.exports = function(exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };
    }
  });

  // node_modules/core-js/modules/_descriptors.js
  var require_descriptors = __commonJS({
    "node_modules/core-js/modules/_descriptors.js"(exports, module) {
      module.exports = !require_fails()(function() {
        return Object.defineProperty({}, "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }
  });

  // node_modules/core-js/modules/_core.js
  var require_core = __commonJS({
    "node_modules/core-js/modules/_core.js"(exports, module) {
      var core = module.exports = { version: "2.6.12" };
      if (typeof __e == "number") __e = core;
    }
  });

  // node_modules/core-js/modules/_is-object.js
  var require_is_object = __commonJS({
    "node_modules/core-js/modules/_is-object.js"(exports, module) {
      module.exports = function(it) {
        return typeof it === "object" ? it !== null : typeof it === "function";
      };
    }
  });

  // node_modules/core-js/modules/_an-object.js
  var require_an_object = __commonJS({
    "node_modules/core-js/modules/_an-object.js"(exports, module) {
      var isObject = require_is_object();
      module.exports = function(it) {
        if (!isObject(it)) throw TypeError(it + " is not an object!");
        return it;
      };
    }
  });

  // node_modules/core-js/modules/_dom-create.js
  var require_dom_create = __commonJS({
    "node_modules/core-js/modules/_dom-create.js"(exports, module) {
      var isObject = require_is_object();
      var document2 = require_global().document;
      var is = isObject(document2) && isObject(document2.createElement);
      module.exports = function(it) {
        return is ? document2.createElement(it) : {};
      };
    }
  });

  // node_modules/core-js/modules/_ie8-dom-define.js
  var require_ie8_dom_define = __commonJS({
    "node_modules/core-js/modules/_ie8-dom-define.js"(exports, module) {
      module.exports = !require_descriptors() && !require_fails()(function() {
        return Object.defineProperty(require_dom_create()("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }
  });

  // node_modules/core-js/modules/_to-primitive.js
  var require_to_primitive = __commonJS({
    "node_modules/core-js/modules/_to-primitive.js"(exports, module) {
      var isObject = require_is_object();
      module.exports = function(it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == "function" && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == "function" && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == "function" && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };
    }
  });

  // node_modules/core-js/modules/_object-dp.js
  var require_object_dp = __commonJS({
    "node_modules/core-js/modules/_object-dp.js"(exports) {
      var anObject = require_an_object();
      var IE8_DOM_DEFINE = require_ie8_dom_define();
      var toPrimitive = require_to_primitive();
      var dP = Object.defineProperty;
      exports.f = require_descriptors() ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {
        }
        if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
        if ("value" in Attributes) O[P] = Attributes.value;
        return O;
      };
    }
  });

  // node_modules/core-js/modules/_property-desc.js
  var require_property_desc = __commonJS({
    "node_modules/core-js/modules/_property-desc.js"(exports, module) {
      module.exports = function(bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value
        };
      };
    }
  });

  // node_modules/core-js/modules/_hide.js
  var require_hide = __commonJS({
    "node_modules/core-js/modules/_hide.js"(exports, module) {
      var dP = require_object_dp();
      var createDesc = require_property_desc();
      module.exports = require_descriptors() ? function(object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function(object, key, value) {
        object[key] = value;
        return object;
      };
    }
  });

  // node_modules/core-js/modules/_uid.js
  var require_uid = __commonJS({
    "node_modules/core-js/modules/_uid.js"(exports, module) {
      var id = 0;
      var px = Math.random();
      module.exports = function(key) {
        return "Symbol(".concat(key === void 0 ? "" : key, ")_", (++id + px).toString(36));
      };
    }
  });

  // node_modules/core-js/modules/_library.js
  var require_library = __commonJS({
    "node_modules/core-js/modules/_library.js"(exports, module) {
      module.exports = false;
    }
  });

  // node_modules/core-js/modules/_shared.js
  var require_shared = __commonJS({
    "node_modules/core-js/modules/_shared.js"(exports, module) {
      var core = require_core();
      var global2 = require_global();
      var SHARED = "__core-js_shared__";
      var store = global2[SHARED] || (global2[SHARED] = {});
      (module.exports = function(key, value) {
        return store[key] || (store[key] = value !== void 0 ? value : {});
      })("versions", []).push({
        version: core.version,
        mode: require_library() ? "pure" : "global",
        copyright: "\xA9 2020 Denis Pushkarev (zloirock.ru)"
      });
    }
  });

  // node_modules/core-js/modules/_function-to-string.js
  var require_function_to_string = __commonJS({
    "node_modules/core-js/modules/_function-to-string.js"(exports, module) {
      module.exports = require_shared()("native-function-to-string", Function.toString);
    }
  });

  // node_modules/core-js/modules/_redefine.js
  var require_redefine = __commonJS({
    "node_modules/core-js/modules/_redefine.js"(exports, module) {
      var global2 = require_global();
      var hide = require_hide();
      var has = require_has();
      var SRC = require_uid()("src");
      var $toString = require_function_to_string();
      var TO_STRING = "toString";
      var TPL = ("" + $toString).split(TO_STRING);
      require_core().inspectSource = function(it) {
        return $toString.call(it);
      };
      (module.exports = function(O, key, val, safe) {
        var isFunction = typeof val == "function";
        if (isFunction) has(val, "name") || hide(val, "name", key);
        if (O[key] === val) return;
        if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? "" + O[key] : TPL.join(String(key)));
        if (O === global2) {
          O[key] = val;
        } else if (!safe) {
          delete O[key];
          hide(O, key, val);
        } else if (O[key]) {
          O[key] = val;
        } else {
          hide(O, key, val);
        }
      })(Function.prototype, TO_STRING, function toString() {
        return typeof this == "function" && this[SRC] || $toString.call(this);
      });
    }
  });

  // node_modules/core-js/modules/_a-function.js
  var require_a_function = __commonJS({
    "node_modules/core-js/modules/_a-function.js"(exports, module) {
      module.exports = function(it) {
        if (typeof it != "function") throw TypeError(it + " is not a function!");
        return it;
      };
    }
  });

  // node_modules/core-js/modules/_ctx.js
  var require_ctx = __commonJS({
    "node_modules/core-js/modules/_ctx.js"(exports, module) {
      var aFunction = require_a_function();
      module.exports = function(fn, that, length) {
        aFunction(fn);
        if (that === void 0) return fn;
        switch (length) {
          case 1:
            return function(a) {
              return fn.call(that, a);
            };
          case 2:
            return function(a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function(a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function() {
          return fn.apply(that, arguments);
        };
      };
    }
  });

  // node_modules/core-js/modules/_export.js
  var require_export = __commonJS({
    "node_modules/core-js/modules/_export.js"(exports, module) {
      var global2 = require_global();
      var core = require_core();
      var hide = require_hide();
      var redefine = require_redefine();
      var ctx = require_ctx();
      var PROTOTYPE = "prototype";
      var $export = function(type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var target = IS_GLOBAL ? global2 : IS_STATIC ? global2[name] || (global2[name] = {}) : (global2[name] || {})[PROTOTYPE];
        var exports2 = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports2[PROTOTYPE] || (exports2[PROTOTYPE] = {});
        var key, own, out, exp;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          own = !IS_FORCED && target && target[key] !== void 0;
          out = (own ? target : source)[key];
          exp = IS_BIND && own ? ctx(out, global2) : IS_PROTO && typeof out == "function" ? ctx(Function.call, out) : out;
          if (target) redefine(target, key, out, type & $export.U);
          if (exports2[key] != out) hide(exports2, key, exp);
          if (IS_PROTO && expProto[key] != out) expProto[key] = out;
        }
      };
      global2.core = core;
      $export.F = 1;
      $export.G = 2;
      $export.S = 4;
      $export.P = 8;
      $export.B = 16;
      $export.W = 32;
      $export.U = 64;
      $export.R = 128;
      module.exports = $export;
    }
  });

  // node_modules/core-js/modules/_meta.js
  var require_meta = __commonJS({
    "node_modules/core-js/modules/_meta.js"(exports, module) {
      var META = require_uid()("meta");
      var isObject = require_is_object();
      var has = require_has();
      var setDesc = require_object_dp().f;
      var id = 0;
      var isExtensible = Object.isExtensible || function() {
        return true;
      };
      var FREEZE = !require_fails()(function() {
        return isExtensible(Object.preventExtensions({}));
      });
      var setMeta = function(it) {
        setDesc(it, META, { value: {
          i: "O" + ++id,
          // object ID
          w: {}
          // weak collections IDs
        } });
      };
      var fastKey = function(it, create) {
        if (!isObject(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
        if (!has(it, META)) {
          if (!isExtensible(it)) return "F";
          if (!create) return "E";
          setMeta(it);
        }
        return it[META].i;
      };
      var getWeak = function(it, create) {
        if (!has(it, META)) {
          if (!isExtensible(it)) return true;
          if (!create) return false;
          setMeta(it);
        }
        return it[META].w;
      };
      var onFreeze = function(it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
        return it;
      };
      var meta = module.exports = {
        KEY: META,
        NEED: false,
        fastKey,
        getWeak,
        onFreeze
      };
    }
  });

  // node_modules/core-js/modules/_wks.js
  var require_wks = __commonJS({
    "node_modules/core-js/modules/_wks.js"(exports, module) {
      var store = require_shared()("wks");
      var uid = require_uid();
      var Symbol2 = require_global().Symbol;
      var USE_SYMBOL = typeof Symbol2 == "function";
      var $exports = module.exports = function(name) {
        return store[name] || (store[name] = USE_SYMBOL && Symbol2[name] || (USE_SYMBOL ? Symbol2 : uid)("Symbol." + name));
      };
      $exports.store = store;
    }
  });

  // node_modules/core-js/modules/_set-to-string-tag.js
  var require_set_to_string_tag = __commonJS({
    "node_modules/core-js/modules/_set-to-string-tag.js"(exports, module) {
      var def = require_object_dp().f;
      var has = require_has();
      var TAG = require_wks()("toStringTag");
      module.exports = function(it, tag, stat) {
        if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
      };
    }
  });

  // node_modules/core-js/modules/_wks-ext.js
  var require_wks_ext = __commonJS({
    "node_modules/core-js/modules/_wks-ext.js"(exports) {
      exports.f = require_wks();
    }
  });

  // node_modules/core-js/modules/_wks-define.js
  var require_wks_define = __commonJS({
    "node_modules/core-js/modules/_wks-define.js"(exports, module) {
      var global2 = require_global();
      var core = require_core();
      var LIBRARY = require_library();
      var wksExt = require_wks_ext();
      var defineProperty = require_object_dp().f;
      module.exports = function(name) {
        var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global2.Symbol || {});
        if (name.charAt(0) != "_" && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
      };
    }
  });

  // node_modules/core-js/modules/_cof.js
  var require_cof = __commonJS({
    "node_modules/core-js/modules/_cof.js"(exports, module) {
      var toString = {}.toString;
      module.exports = function(it) {
        return toString.call(it).slice(8, -1);
      };
    }
  });

  // node_modules/core-js/modules/_iobject.js
  var require_iobject = __commonJS({
    "node_modules/core-js/modules/_iobject.js"(exports, module) {
      var cof = require_cof();
      module.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
        return cof(it) == "String" ? it.split("") : Object(it);
      };
    }
  });

  // node_modules/core-js/modules/_defined.js
  var require_defined = __commonJS({
    "node_modules/core-js/modules/_defined.js"(exports, module) {
      module.exports = function(it) {
        if (it == void 0) throw TypeError("Can't call method on  " + it);
        return it;
      };
    }
  });

  // node_modules/core-js/modules/_to-iobject.js
  var require_to_iobject = __commonJS({
    "node_modules/core-js/modules/_to-iobject.js"(exports, module) {
      var IObject = require_iobject();
      var defined = require_defined();
      module.exports = function(it) {
        return IObject(defined(it));
      };
    }
  });

  // node_modules/core-js/modules/_to-integer.js
  var require_to_integer = __commonJS({
    "node_modules/core-js/modules/_to-integer.js"(exports, module) {
      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function(it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
      };
    }
  });

  // node_modules/core-js/modules/_to-length.js
  var require_to_length = __commonJS({
    "node_modules/core-js/modules/_to-length.js"(exports, module) {
      var toInteger = require_to_integer();
      var min = Math.min;
      module.exports = function(it) {
        return it > 0 ? min(toInteger(it), 9007199254740991) : 0;
      };
    }
  });

  // node_modules/core-js/modules/_to-absolute-index.js
  var require_to_absolute_index = __commonJS({
    "node_modules/core-js/modules/_to-absolute-index.js"(exports, module) {
      var toInteger = require_to_integer();
      var max = Math.max;
      var min = Math.min;
      module.exports = function(index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };
    }
  });

  // node_modules/core-js/modules/_array-includes.js
  var require_array_includes = __commonJS({
    "node_modules/core-js/modules/_array-includes.js"(exports, module) {
      var toIObject = require_to_iobject();
      var toLength = require_to_length();
      var toAbsoluteIndex = require_to_absolute_index();
      module.exports = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++];
            if (value != value) return true;
          }
          else for (; length > index; index++) if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
          }
          return !IS_INCLUDES && -1;
        };
      };
    }
  });

  // node_modules/core-js/modules/_shared-key.js
  var require_shared_key = __commonJS({
    "node_modules/core-js/modules/_shared-key.js"(exports, module) {
      var shared = require_shared()("keys");
      var uid = require_uid();
      module.exports = function(key) {
        return shared[key] || (shared[key] = uid(key));
      };
    }
  });

  // node_modules/core-js/modules/_object-keys-internal.js
  var require_object_keys_internal = __commonJS({
    "node_modules/core-js/modules/_object-keys-internal.js"(exports, module) {
      var has = require_has();
      var toIObject = require_to_iobject();
      var arrayIndexOf = require_array_includes()(false);
      var IE_PROTO = require_shared_key()("IE_PROTO");
      module.exports = function(object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
        while (names.length > i) if (has(O, key = names[i++])) {
          ~arrayIndexOf(result, key) || result.push(key);
        }
        return result;
      };
    }
  });

  // node_modules/core-js/modules/_enum-bug-keys.js
  var require_enum_bug_keys = __commonJS({
    "node_modules/core-js/modules/_enum-bug-keys.js"(exports, module) {
      module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }
  });

  // node_modules/core-js/modules/_object-keys.js
  var require_object_keys = __commonJS({
    "node_modules/core-js/modules/_object-keys.js"(exports, module) {
      var $keys = require_object_keys_internal();
      var enumBugKeys = require_enum_bug_keys();
      module.exports = Object.keys || function keys(O) {
        return $keys(O, enumBugKeys);
      };
    }
  });

  // node_modules/core-js/modules/_object-gops.js
  var require_object_gops = __commonJS({
    "node_modules/core-js/modules/_object-gops.js"(exports) {
      exports.f = Object.getOwnPropertySymbols;
    }
  });

  // node_modules/core-js/modules/_object-pie.js
  var require_object_pie = __commonJS({
    "node_modules/core-js/modules/_object-pie.js"(exports) {
      exports.f = {}.propertyIsEnumerable;
    }
  });

  // node_modules/core-js/modules/_enum-keys.js
  var require_enum_keys = __commonJS({
    "node_modules/core-js/modules/_enum-keys.js"(exports, module) {
      var getKeys = require_object_keys();
      var gOPS = require_object_gops();
      var pIE = require_object_pie();
      module.exports = function(it) {
        var result = getKeys(it);
        var getSymbols = gOPS.f;
        if (getSymbols) {
          var symbols = getSymbols(it);
          var isEnum = pIE.f;
          var i = 0;
          var key;
          while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
        }
        return result;
      };
    }
  });

  // node_modules/core-js/modules/_is-array.js
  var require_is_array = __commonJS({
    "node_modules/core-js/modules/_is-array.js"(exports, module) {
      var cof = require_cof();
      module.exports = Array.isArray || function isArray(arg) {
        return cof(arg) == "Array";
      };
    }
  });

  // node_modules/core-js/modules/_to-object.js
  var require_to_object = __commonJS({
    "node_modules/core-js/modules/_to-object.js"(exports, module) {
      var defined = require_defined();
      module.exports = function(it) {
        return Object(defined(it));
      };
    }
  });

  // node_modules/core-js/modules/_object-dps.js
  var require_object_dps = __commonJS({
    "node_modules/core-js/modules/_object-dps.js"(exports, module) {
      var dP = require_object_dp();
      var anObject = require_an_object();
      var getKeys = require_object_keys();
      module.exports = require_descriptors() ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = getKeys(Properties);
        var length = keys.length;
        var i = 0;
        var P;
        while (length > i) dP.f(O, P = keys[i++], Properties[P]);
        return O;
      };
    }
  });

  // node_modules/core-js/modules/_html.js
  var require_html = __commonJS({
    "node_modules/core-js/modules/_html.js"(exports, module) {
      var document2 = require_global().document;
      module.exports = document2 && document2.documentElement;
    }
  });

  // node_modules/core-js/modules/_object-create.js
  var require_object_create = __commonJS({
    "node_modules/core-js/modules/_object-create.js"(exports, module) {
      var anObject = require_an_object();
      var dPs = require_object_dps();
      var enumBugKeys = require_enum_bug_keys();
      var IE_PROTO = require_shared_key()("IE_PROTO");
      var Empty = function() {
      };
      var PROTOTYPE = "prototype";
      var createDict = function() {
        var iframe = require_dom_create()("iframe");
        var i = enumBugKeys.length;
        var lt = "<";
        var gt = ">";
        var iframeDocument;
        iframe.style.display = "none";
        require_html().appendChild(iframe);
        iframe.src = "javascript:";
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
        iframeDocument.close();
        createDict = iframeDocument.F;
        while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
        return createDict();
      };
      module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
          Empty[PROTOTYPE] = anObject(O);
          result = new Empty();
          Empty[PROTOTYPE] = null;
          result[IE_PROTO] = O;
        } else result = createDict();
        return Properties === void 0 ? result : dPs(result, Properties);
      };
    }
  });

  // node_modules/core-js/modules/_object-gopn.js
  var require_object_gopn = __commonJS({
    "node_modules/core-js/modules/_object-gopn.js"(exports) {
      var $keys = require_object_keys_internal();
      var hiddenKeys = require_enum_bug_keys().concat("length", "prototype");
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $keys(O, hiddenKeys);
      };
    }
  });

  // node_modules/core-js/modules/_object-gopn-ext.js
  var require_object_gopn_ext = __commonJS({
    "node_modules/core-js/modules/_object-gopn-ext.js"(exports, module) {
      var toIObject = require_to_iobject();
      var gOPN = require_object_gopn().f;
      var toString = {}.toString;
      var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
      var getWindowNames = function(it) {
        try {
          return gOPN(it);
        } catch (e) {
          return windowNames.slice();
        }
      };
      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == "[object Window]" ? getWindowNames(it) : gOPN(toIObject(it));
      };
    }
  });

  // node_modules/core-js/modules/_object-gopd.js
  var require_object_gopd = __commonJS({
    "node_modules/core-js/modules/_object-gopd.js"(exports) {
      var pIE = require_object_pie();
      var createDesc = require_property_desc();
      var toIObject = require_to_iobject();
      var toPrimitive = require_to_primitive();
      var has = require_has();
      var IE8_DOM_DEFINE = require_ie8_dom_define();
      var gOPD = Object.getOwnPropertyDescriptor;
      exports.f = require_descriptors() ? gOPD : function getOwnPropertyDescriptor(O, P) {
        O = toIObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return gOPD(O, P);
        } catch (e) {
        }
        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
      };
    }
  });

  // node_modules/core-js/modules/es6.symbol.js
  var require_es6_symbol = __commonJS({
    "node_modules/core-js/modules/es6.symbol.js"() {
      "use strict";
      var global2 = require_global();
      var has = require_has();
      var DESCRIPTORS = require_descriptors();
      var $export = require_export();
      var redefine = require_redefine();
      var META = require_meta().KEY;
      var $fails = require_fails();
      var shared = require_shared();
      var setToStringTag = require_set_to_string_tag();
      var uid = require_uid();
      var wks = require_wks();
      var wksExt = require_wks_ext();
      var wksDefine = require_wks_define();
      var enumKeys = require_enum_keys();
      var isArray = require_is_array();
      var anObject = require_an_object();
      var isObject = require_is_object();
      var toObject = require_to_object();
      var toIObject = require_to_iobject();
      var toPrimitive = require_to_primitive();
      var createDesc = require_property_desc();
      var _create = require_object_create();
      var gOPNExt = require_object_gopn_ext();
      var $GOPD = require_object_gopd();
      var $GOPS = require_object_gops();
      var $DP = require_object_dp();
      var $keys = require_object_keys();
      var gOPD = $GOPD.f;
      var dP = $DP.f;
      var gOPN = gOPNExt.f;
      var $Symbol = global2.Symbol;
      var $JSON = global2.JSON;
      var _stringify = $JSON && $JSON.stringify;
      var PROTOTYPE = "prototype";
      var HIDDEN = wks("_hidden");
      var TO_PRIMITIVE = wks("toPrimitive");
      var isEnum = {}.propertyIsEnumerable;
      var SymbolRegistry = shared("symbol-registry");
      var AllSymbols = shared("symbols");
      var OPSymbols = shared("op-symbols");
      var ObjectProto = Object[PROTOTYPE];
      var USE_NATIVE = typeof $Symbol == "function" && !!$GOPS.f;
      var QObject = global2.QObject;
      var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
      var setSymbolDesc = DESCRIPTORS && $fails(function() {
        return _create(dP({}, "a", {
          get: function() {
            return dP(this, "a", { value: 7 }).a;
          }
        })).a != 7;
      }) ? function(it, key, D) {
        var protoDesc = gOPD(ObjectProto, key);
        if (protoDesc) delete ObjectProto[key];
        dP(it, key, D);
        if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
      } : dP;
      var wrap = function(tag) {
        var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
        sym._k = tag;
        return sym;
      };
      var isSymbol = USE_NATIVE && typeof $Symbol.iterator == "symbol" ? function(it) {
        return typeof it == "symbol";
      } : function(it) {
        return it instanceof $Symbol;
      };
      var $defineProperty = function defineProperty(it, key, D) {
        if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
        anObject(it);
        key = toPrimitive(key, true);
        anObject(D);
        if (has(AllSymbols, key)) {
          if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
          } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, { enumerable: createDesc(0, false) });
          }
          return setSymbolDesc(it, key, D);
        }
        return dP(it, key, D);
      };
      var $defineProperties = function defineProperties(it, P) {
        anObject(it);
        var keys = enumKeys(P = toIObject(P));
        var i = 0;
        var l = keys.length;
        var key;
        while (l > i) $defineProperty(it, key = keys[i++], P[key]);
        return it;
      };
      var $create = function create(it, P) {
        return P === void 0 ? _create(it) : $defineProperties(_create(it), P);
      };
      var $propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = isEnum.call(this, key = toPrimitive(key, true));
        if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
        return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
      };
      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = toIObject(it);
        key = toPrimitive(key, true);
        if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
        var D = gOPD(it, key);
        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
        return D;
      };
      var $getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = gOPN(toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
        }
        return result;
      };
      var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === ObjectProto;
        var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
        }
        return result;
      };
      if (!USE_NATIVE) {
        $Symbol = function Symbol2() {
          if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor!");
          var tag = uid(arguments.length > 0 ? arguments[0] : void 0);
          var $set = function(value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
          };
          if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
          return wrap(tag);
        };
        redefine($Symbol[PROTOTYPE], "toString", function toString() {
          return this._k;
        });
        $GOPD.f = $getOwnPropertyDescriptor;
        $DP.f = $defineProperty;
        require_object_gopn().f = gOPNExt.f = $getOwnPropertyNames;
        require_object_pie().f = $propertyIsEnumerable;
        $GOPS.f = $getOwnPropertySymbols;
        if (DESCRIPTORS && !require_library()) {
          redefine(ObjectProto, "propertyIsEnumerable", $propertyIsEnumerable, true);
        }
        wksExt.f = function(name) {
          return wrap(wks(name));
        };
      }
      $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
      for (es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
      "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), j = 0; es6Symbols.length > j; ) wks(es6Symbols[j++]);
      var es6Symbols;
      var j;
      for (wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k; ) wksDefine(wellKnownSymbols[k++]);
      var wellKnownSymbols;
      var k;
      $export($export.S + $export.F * !USE_NATIVE, "Symbol", {
        // 19.4.2.1 Symbol.for(key)
        "for": function(key) {
          return has(SymbolRegistry, key += "") ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
        },
        // 19.4.2.5 Symbol.keyFor(sym)
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol!");
          for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
        },
        useSetter: function() {
          setter = true;
        },
        useSimple: function() {
          setter = false;
        }
      });
      $export($export.S + $export.F * !USE_NATIVE, "Object", {
        // 19.1.2.2 Object.create(O [, Properties])
        create: $create,
        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
        defineProperty: $defineProperty,
        // 19.1.2.3 Object.defineProperties(O, Properties)
        defineProperties: $defineProperties,
        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        // 19.1.2.7 Object.getOwnPropertyNames(O)
        getOwnPropertyNames: $getOwnPropertyNames,
        // 19.1.2.8 Object.getOwnPropertySymbols(O)
        getOwnPropertySymbols: $getOwnPropertySymbols
      });
      var FAILS_ON_PRIMITIVES = $fails(function() {
        $GOPS.f(1);
      });
      $export($export.S + $export.F * FAILS_ON_PRIMITIVES, "Object", {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
          return $GOPS.f(toObject(it));
        }
      });
      $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function() {
        var S = $Symbol();
        return _stringify([S]) != "[null]" || _stringify({ a: S }) != "{}" || _stringify(Object(S)) != "{}";
      })), "JSON", {
        stringify: function stringify(it) {
          var args = [it];
          var i = 1;
          var replacer, $replacer;
          while (arguments.length > i) args.push(arguments[i++]);
          $replacer = replacer = args[1];
          if (!isObject(replacer) && it === void 0 || isSymbol(it)) return;
          if (!isArray(replacer)) replacer = function(key, value) {
            if (typeof $replacer == "function") value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
          };
          args[1] = replacer;
          return _stringify.apply($JSON, args);
        }
      });
      $Symbol[PROTOTYPE][TO_PRIMITIVE] || require_hide()($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
      setToStringTag($Symbol, "Symbol");
      setToStringTag(Math, "Math", true);
      setToStringTag(global2.JSON, "JSON", true);
    }
  });

  // node_modules/core-js/modules/es6.object.create.js
  var require_es6_object_create = __commonJS({
    "node_modules/core-js/modules/es6.object.create.js"() {
      var $export = require_export();
      $export($export.S, "Object", { create: require_object_create() });
    }
  });

  // node_modules/core-js/modules/es6.object.define-property.js
  var require_es6_object_define_property = __commonJS({
    "node_modules/core-js/modules/es6.object.define-property.js"() {
      var $export = require_export();
      $export($export.S + $export.F * !require_descriptors(), "Object", { defineProperty: require_object_dp().f });
    }
  });

  // node_modules/core-js/modules/es6.object.define-properties.js
  var require_es6_object_define_properties = __commonJS({
    "node_modules/core-js/modules/es6.object.define-properties.js"() {
      var $export = require_export();
      $export($export.S + $export.F * !require_descriptors(), "Object", { defineProperties: require_object_dps() });
    }
  });

  // node_modules/core-js/modules/_object-sap.js
  var require_object_sap = __commonJS({
    "node_modules/core-js/modules/_object-sap.js"(exports, module) {
      var $export = require_export();
      var core = require_core();
      var fails = require_fails();
      module.exports = function(KEY, exec) {
        var fn = (core.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $export($export.S + $export.F * fails(function() {
          fn(1);
        }), "Object", exp);
      };
    }
  });

  // node_modules/core-js/modules/es6.object.get-own-property-descriptor.js
  var require_es6_object_get_own_property_descriptor = __commonJS({
    "node_modules/core-js/modules/es6.object.get-own-property-descriptor.js"() {
      var toIObject = require_to_iobject();
      var $getOwnPropertyDescriptor = require_object_gopd().f;
      require_object_sap()("getOwnPropertyDescriptor", function() {
        return function getOwnPropertyDescriptor(it, key) {
          return $getOwnPropertyDescriptor(toIObject(it), key);
        };
      });
    }
  });

  // node_modules/core-js/modules/_object-gpo.js
  var require_object_gpo = __commonJS({
    "node_modules/core-js/modules/_object-gpo.js"(exports, module) {
      var has = require_has();
      var toObject = require_to_object();
      var IE_PROTO = require_shared_key()("IE_PROTO");
      var ObjectProto = Object.prototype;
      module.exports = Object.getPrototypeOf || function(O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];
        if (typeof O.constructor == "function" && O instanceof O.constructor) {
          return O.constructor.prototype;
        }
        return O instanceof Object ? ObjectProto : null;
      };
    }
  });

  // node_modules/core-js/modules/es6.object.get-prototype-of.js
  var require_es6_object_get_prototype_of = __commonJS({
    "node_modules/core-js/modules/es6.object.get-prototype-of.js"() {
      var toObject = require_to_object();
      var $getPrototypeOf = require_object_gpo();
      require_object_sap()("getPrototypeOf", function() {
        return function getPrototypeOf(it) {
          return $getPrototypeOf(toObject(it));
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.object.keys.js
  var require_es6_object_keys = __commonJS({
    "node_modules/core-js/modules/es6.object.keys.js"() {
      var toObject = require_to_object();
      var $keys = require_object_keys();
      require_object_sap()("keys", function() {
        return function keys(it) {
          return $keys(toObject(it));
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.object.get-own-property-names.js
  var require_es6_object_get_own_property_names = __commonJS({
    "node_modules/core-js/modules/es6.object.get-own-property-names.js"() {
      require_object_sap()("getOwnPropertyNames", function() {
        return require_object_gopn_ext().f;
      });
    }
  });

  // node_modules/core-js/modules/es6.object.freeze.js
  var require_es6_object_freeze = __commonJS({
    "node_modules/core-js/modules/es6.object.freeze.js"() {
      var isObject = require_is_object();
      var meta = require_meta().onFreeze;
      require_object_sap()("freeze", function($freeze) {
        return function freeze(it) {
          return $freeze && isObject(it) ? $freeze(meta(it)) : it;
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.object.seal.js
  var require_es6_object_seal = __commonJS({
    "node_modules/core-js/modules/es6.object.seal.js"() {
      var isObject = require_is_object();
      var meta = require_meta().onFreeze;
      require_object_sap()("seal", function($seal) {
        return function seal(it) {
          return $seal && isObject(it) ? $seal(meta(it)) : it;
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.object.prevent-extensions.js
  var require_es6_object_prevent_extensions = __commonJS({
    "node_modules/core-js/modules/es6.object.prevent-extensions.js"() {
      var isObject = require_is_object();
      var meta = require_meta().onFreeze;
      require_object_sap()("preventExtensions", function($preventExtensions) {
        return function preventExtensions(it) {
          return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.object.is-frozen.js
  var require_es6_object_is_frozen = __commonJS({
    "node_modules/core-js/modules/es6.object.is-frozen.js"() {
      var isObject = require_is_object();
      require_object_sap()("isFrozen", function($isFrozen) {
        return function isFrozen(it) {
          return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.object.is-sealed.js
  var require_es6_object_is_sealed = __commonJS({
    "node_modules/core-js/modules/es6.object.is-sealed.js"() {
      var isObject = require_is_object();
      require_object_sap()("isSealed", function($isSealed) {
        return function isSealed(it) {
          return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.object.is-extensible.js
  var require_es6_object_is_extensible = __commonJS({
    "node_modules/core-js/modules/es6.object.is-extensible.js"() {
      var isObject = require_is_object();
      require_object_sap()("isExtensible", function($isExtensible) {
        return function isExtensible(it) {
          return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
        };
      });
    }
  });

  // node_modules/core-js/modules/_object-assign.js
  var require_object_assign = __commonJS({
    "node_modules/core-js/modules/_object-assign.js"(exports, module) {
      "use strict";
      var DESCRIPTORS = require_descriptors();
      var getKeys = require_object_keys();
      var gOPS = require_object_gops();
      var pIE = require_object_pie();
      var toObject = require_to_object();
      var IObject = require_iobject();
      var $assign = Object.assign;
      module.exports = !$assign || require_fails()(function() {
        var A = {};
        var B = {};
        var S = Symbol();
        var K = "abcdefghijklmnopqrst";
        A[S] = 7;
        K.split("").forEach(function(k) {
          B[k] = k;
        });
        return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join("") != K;
      }) ? function assign(target, source) {
        var T = toObject(target);
        var aLen = arguments.length;
        var index = 1;
        var getSymbols = gOPS.f;
        var isEnum = pIE.f;
        while (aLen > index) {
          var S = IObject(arguments[index++]);
          var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
          var length = keys.length;
          var j = 0;
          var key;
          while (length > j) {
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
          }
        }
        return T;
      } : $assign;
    }
  });

  // node_modules/core-js/modules/es6.object.assign.js
  var require_es6_object_assign = __commonJS({
    "node_modules/core-js/modules/es6.object.assign.js"() {
      var $export = require_export();
      $export($export.S + $export.F, "Object", { assign: require_object_assign() });
    }
  });

  // node_modules/core-js/modules/_same-value.js
  var require_same_value = __commonJS({
    "node_modules/core-js/modules/_same-value.js"(exports, module) {
      module.exports = Object.is || function is(x, y) {
        return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
      };
    }
  });

  // node_modules/core-js/modules/es6.object.is.js
  var require_es6_object_is = __commonJS({
    "node_modules/core-js/modules/es6.object.is.js"() {
      var $export = require_export();
      $export($export.S, "Object", { is: require_same_value() });
    }
  });

  // node_modules/core-js/modules/_set-proto.js
  var require_set_proto = __commonJS({
    "node_modules/core-js/modules/_set-proto.js"(exports, module) {
      var isObject = require_is_object();
      var anObject = require_an_object();
      var check = function(O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
      };
      module.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? (
          // eslint-disable-line
          function(test, buggy, set) {
            try {
              set = require_ctx()(Function.call, require_object_gopd().f(Object.prototype, "__proto__").set, 2);
              set(test, []);
              buggy = !(test instanceof Array);
            } catch (e) {
              buggy = true;
            }
            return function setPrototypeOf(O, proto) {
              check(O, proto);
              if (buggy) O.__proto__ = proto;
              else set(O, proto);
              return O;
            };
          }({}, false)
        ) : void 0),
        check
      };
    }
  });

  // node_modules/core-js/modules/es6.object.set-prototype-of.js
  var require_es6_object_set_prototype_of = __commonJS({
    "node_modules/core-js/modules/es6.object.set-prototype-of.js"() {
      var $export = require_export();
      $export($export.S, "Object", { setPrototypeOf: require_set_proto().set });
    }
  });

  // node_modules/core-js/modules/_classof.js
  var require_classof = __commonJS({
    "node_modules/core-js/modules/_classof.js"(exports, module) {
      var cof = require_cof();
      var TAG = require_wks()("toStringTag");
      var ARG = cof(/* @__PURE__ */ function() {
        return arguments;
      }()) == "Arguments";
      var tryGet = function(it, key) {
        try {
          return it[key];
        } catch (e) {
        }
      };
      module.exports = function(it) {
        var O, T, B;
        return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (T = tryGet(O = Object(it), TAG)) == "string" ? T : ARG ? cof(O) : (B = cof(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : B;
      };
    }
  });

  // node_modules/core-js/modules/es6.object.to-string.js
  var require_es6_object_to_string = __commonJS({
    "node_modules/core-js/modules/es6.object.to-string.js"() {
      "use strict";
      var classof = require_classof();
      var test = {};
      test[require_wks()("toStringTag")] = "z";
      if (test + "" != "[object z]") {
        require_redefine()(Object.prototype, "toString", function toString() {
          return "[object " + classof(this) + "]";
        }, true);
      }
    }
  });

  // node_modules/core-js/modules/_invoke.js
  var require_invoke = __commonJS({
    "node_modules/core-js/modules/_invoke.js"(exports, module) {
      module.exports = function(fn, args, that) {
        var un = that === void 0;
        switch (args.length) {
          case 0:
            return un ? fn() : fn.call(that);
          case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
          case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
          case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
          case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
        }
        return fn.apply(that, args);
      };
    }
  });

  // node_modules/core-js/modules/_bind.js
  var require_bind = __commonJS({
    "node_modules/core-js/modules/_bind.js"(exports, module) {
      "use strict";
      var aFunction = require_a_function();
      var isObject = require_is_object();
      var invoke = require_invoke();
      var arraySlice = [].slice;
      var factories = {};
      var construct = function(F, len, args) {
        if (!(len in factories)) {
          for (var n = [], i = 0; i < len; i++) n[i] = "a[" + i + "]";
          factories[len] = Function("F,a", "return new F(" + n.join(",") + ")");
        }
        return factories[len](F, args);
      };
      module.exports = Function.bind || function bind(that) {
        var fn = aFunction(this);
        var partArgs = arraySlice.call(arguments, 1);
        var bound = function() {
          var args = partArgs.concat(arraySlice.call(arguments));
          return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
        };
        if (isObject(fn.prototype)) bound.prototype = fn.prototype;
        return bound;
      };
    }
  });

  // node_modules/core-js/modules/es6.function.bind.js
  var require_es6_function_bind = __commonJS({
    "node_modules/core-js/modules/es6.function.bind.js"() {
      var $export = require_export();
      $export($export.P, "Function", { bind: require_bind() });
    }
  });

  // node_modules/core-js/modules/es6.function.name.js
  var require_es6_function_name = __commonJS({
    "node_modules/core-js/modules/es6.function.name.js"() {
      var dP = require_object_dp().f;
      var FProto = Function.prototype;
      var nameRE = /^\s*function ([^ (]*)/;
      var NAME = "name";
      NAME in FProto || require_descriptors() && dP(FProto, NAME, {
        configurable: true,
        get: function() {
          try {
            return ("" + this).match(nameRE)[1];
          } catch (e) {
            return "";
          }
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.function.has-instance.js
  var require_es6_function_has_instance = __commonJS({
    "node_modules/core-js/modules/es6.function.has-instance.js"() {
      "use strict";
      var isObject = require_is_object();
      var getPrototypeOf = require_object_gpo();
      var HAS_INSTANCE = require_wks()("hasInstance");
      var FunctionProto = Function.prototype;
      if (!(HAS_INSTANCE in FunctionProto)) require_object_dp().f(FunctionProto, HAS_INSTANCE, { value: function(O) {
        if (typeof this != "function" || !isObject(O)) return false;
        if (!isObject(this.prototype)) return O instanceof this;
        while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
        return false;
      } });
    }
  });

  // node_modules/core-js/modules/_string-ws.js
  var require_string_ws = __commonJS({
    "node_modules/core-js/modules/_string-ws.js"(exports, module) {
      module.exports = "	\n\v\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
    }
  });

  // node_modules/core-js/modules/_string-trim.js
  var require_string_trim = __commonJS({
    "node_modules/core-js/modules/_string-trim.js"(exports, module) {
      var $export = require_export();
      var defined = require_defined();
      var fails = require_fails();
      var spaces = require_string_ws();
      var space = "[" + spaces + "]";
      var non = "\u200B\x85";
      var ltrim = RegExp("^" + space + space + "*");
      var rtrim = RegExp(space + space + "*$");
      var exporter = function(KEY, exec, ALIAS) {
        var exp = {};
        var FORCE = fails(function() {
          return !!spaces[KEY]() || non[KEY]() != non;
        });
        var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
        if (ALIAS) exp[ALIAS] = fn;
        $export($export.P + $export.F * FORCE, "String", exp);
      };
      var trim = exporter.trim = function(string, TYPE) {
        string = String(defined(string));
        if (TYPE & 1) string = string.replace(ltrim, "");
        if (TYPE & 2) string = string.replace(rtrim, "");
        return string;
      };
      module.exports = exporter;
    }
  });

  // node_modules/core-js/modules/_parse-int.js
  var require_parse_int = __commonJS({
    "node_modules/core-js/modules/_parse-int.js"(exports, module) {
      var $parseInt = require_global().parseInt;
      var $trim = require_string_trim().trim;
      var ws = require_string_ws();
      var hex = /^[-+]?0[xX]/;
      module.exports = $parseInt(ws + "08") !== 8 || $parseInt(ws + "0x16") !== 22 ? function parseInt2(str, radix) {
        var string = $trim(String(str), 3);
        return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
      } : $parseInt;
    }
  });

  // node_modules/core-js/modules/es6.parse-int.js
  var require_es6_parse_int = __commonJS({
    "node_modules/core-js/modules/es6.parse-int.js"() {
      var $export = require_export();
      var $parseInt = require_parse_int();
      $export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });
    }
  });

  // node_modules/core-js/modules/_parse-float.js
  var require_parse_float = __commonJS({
    "node_modules/core-js/modules/_parse-float.js"(exports, module) {
      var $parseFloat = require_global().parseFloat;
      var $trim = require_string_trim().trim;
      module.exports = 1 / $parseFloat(require_string_ws() + "-0") !== -Infinity ? function parseFloat2(str) {
        var string = $trim(String(str), 3);
        var result = $parseFloat(string);
        return result === 0 && string.charAt(0) == "-" ? -0 : result;
      } : $parseFloat;
    }
  });

  // node_modules/core-js/modules/es6.parse-float.js
  var require_es6_parse_float = __commonJS({
    "node_modules/core-js/modules/es6.parse-float.js"() {
      var $export = require_export();
      var $parseFloat = require_parse_float();
      $export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });
    }
  });

  // node_modules/core-js/modules/_inherit-if-required.js
  var require_inherit_if_required = __commonJS({
    "node_modules/core-js/modules/_inherit-if-required.js"(exports, module) {
      var isObject = require_is_object();
      var setPrototypeOf = require_set_proto().set;
      module.exports = function(that, target, C) {
        var S = target.constructor;
        var P;
        if (S !== C && typeof S == "function" && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
          setPrototypeOf(that, P);
        }
        return that;
      };
    }
  });

  // node_modules/core-js/modules/es6.number.constructor.js
  var require_es6_number_constructor = __commonJS({
    "node_modules/core-js/modules/es6.number.constructor.js"() {
      "use strict";
      var global2 = require_global();
      var has = require_has();
      var cof = require_cof();
      var inheritIfRequired = require_inherit_if_required();
      var toPrimitive = require_to_primitive();
      var fails = require_fails();
      var gOPN = require_object_gopn().f;
      var gOPD = require_object_gopd().f;
      var dP = require_object_dp().f;
      var $trim = require_string_trim().trim;
      var NUMBER = "Number";
      var $Number = global2[NUMBER];
      var Base = $Number;
      var proto = $Number.prototype;
      var BROKEN_COF = cof(require_object_create()(proto)) == NUMBER;
      var TRIM = "trim" in String.prototype;
      var toNumber = function(argument) {
        var it = toPrimitive(argument, false);
        if (typeof it == "string" && it.length > 2) {
          it = TRIM ? it.trim() : $trim(it, 3);
          var first = it.charCodeAt(0);
          var third, radix, maxCode;
          if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN;
          } else if (first === 48) {
            switch (it.charCodeAt(1)) {
              case 66:
              case 98:
                radix = 2;
                maxCode = 49;
                break;
              // fast equal /^0b[01]+$/i
              case 79:
              case 111:
                radix = 8;
                maxCode = 55;
                break;
              // fast equal /^0o[0-7]+$/i
              default:
                return +it;
            }
            for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
              code = digits.charCodeAt(i);
              if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
          }
        }
        return +it;
      };
      if (!$Number(" 0o1") || !$Number("0b1") || $Number("+0x1")) {
        $Number = function Number2(value) {
          var it = arguments.length < 1 ? 0 : value;
          var that = this;
          return that instanceof $Number && (BROKEN_COF ? fails(function() {
            proto.valueOf.call(that);
          }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
        };
        for (keys = require_descriptors() ? gOPN(Base) : (
          // ES3:
          "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(",")
        ), j = 0; keys.length > j; j++) {
          if (has(Base, key = keys[j]) && !has($Number, key)) {
            dP($Number, key, gOPD(Base, key));
          }
        }
        $Number.prototype = proto;
        proto.constructor = $Number;
        require_redefine()(global2, NUMBER, $Number);
      }
      var keys;
      var j;
      var key;
    }
  });

  // node_modules/core-js/modules/_a-number-value.js
  var require_a_number_value = __commonJS({
    "node_modules/core-js/modules/_a-number-value.js"(exports, module) {
      var cof = require_cof();
      module.exports = function(it, msg) {
        if (typeof it != "number" && cof(it) != "Number") throw TypeError(msg);
        return +it;
      };
    }
  });

  // node_modules/core-js/modules/_string-repeat.js
  var require_string_repeat = __commonJS({
    "node_modules/core-js/modules/_string-repeat.js"(exports, module) {
      "use strict";
      var toInteger = require_to_integer();
      var defined = require_defined();
      module.exports = function repeat(count) {
        var str = String(defined(this));
        var res = "";
        var n = toInteger(count);
        if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
        for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
        return res;
      };
    }
  });

  // node_modules/core-js/modules/es6.number.to-fixed.js
  var require_es6_number_to_fixed = __commonJS({
    "node_modules/core-js/modules/es6.number.to-fixed.js"() {
      "use strict";
      var $export = require_export();
      var toInteger = require_to_integer();
      var aNumberValue = require_a_number_value();
      var repeat = require_string_repeat();
      var $toFixed = 1 .toFixed;
      var floor = Math.floor;
      var data = [0, 0, 0, 0, 0, 0];
      var ERROR = "Number.toFixed: incorrect invocation!";
      var ZERO = "0";
      var multiply = function(n, c) {
        var i = -1;
        var c2 = c;
        while (++i < 6) {
          c2 += n * data[i];
          data[i] = c2 % 1e7;
          c2 = floor(c2 / 1e7);
        }
      };
      var divide = function(n) {
        var i = 6;
        var c = 0;
        while (--i >= 0) {
          c += data[i];
          data[i] = floor(c / n);
          c = c % n * 1e7;
        }
      };
      var numToString = function() {
        var i = 6;
        var s = "";
        while (--i >= 0) {
          if (s !== "" || i === 0 || data[i] !== 0) {
            var t = String(data[i]);
            s = s === "" ? t : s + repeat.call(ZERO, 7 - t.length) + t;
          }
        }
        return s;
      };
      var pow = function(x, n, acc) {
        return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
      };
      var log = function(x) {
        var n = 0;
        var x2 = x;
        while (x2 >= 4096) {
          n += 12;
          x2 /= 4096;
        }
        while (x2 >= 2) {
          n += 1;
          x2 /= 2;
        }
        return n;
      };
      $export($export.P + $export.F * (!!$toFixed && (8e-5.toFixed(3) !== "0.000" || 0.9.toFixed(0) !== "1" || 1.255.toFixed(2) !== "1.25" || 1000000000000000100 .toFixed(0) !== "1000000000000000128") || !require_fails()(function() {
        $toFixed.call({});
      })), "Number", {
        toFixed: function toFixed(fractionDigits) {
          var x = aNumberValue(this, ERROR);
          var f = toInteger(fractionDigits);
          var s = "";
          var m = ZERO;
          var e, z, j, k;
          if (f < 0 || f > 20) throw RangeError(ERROR);
          if (x != x) return "NaN";
          if (x <= -1e21 || x >= 1e21) return String(x);
          if (x < 0) {
            s = "-";
            x = -x;
          }
          if (x > 1e-21) {
            e = log(x * pow(2, 69, 1)) - 69;
            z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
            z *= 4503599627370496;
            e = 52 - e;
            if (e > 0) {
              multiply(0, z);
              j = f;
              while (j >= 7) {
                multiply(1e7, 0);
                j -= 7;
              }
              multiply(pow(10, j, 1), 0);
              j = e - 1;
              while (j >= 23) {
                divide(1 << 23);
                j -= 23;
              }
              divide(1 << j);
              multiply(1, 1);
              divide(2);
              m = numToString();
            } else {
              multiply(0, z);
              multiply(1 << -e, 0);
              m = numToString() + repeat.call(ZERO, f);
            }
          }
          if (f > 0) {
            k = m.length;
            m = s + (k <= f ? "0." + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + "." + m.slice(k - f));
          } else {
            m = s + m;
          }
          return m;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.number.to-precision.js
  var require_es6_number_to_precision = __commonJS({
    "node_modules/core-js/modules/es6.number.to-precision.js"() {
      "use strict";
      var $export = require_export();
      var $fails = require_fails();
      var aNumberValue = require_a_number_value();
      var $toPrecision = 1 .toPrecision;
      $export($export.P + $export.F * ($fails(function() {
        return $toPrecision.call(1, void 0) !== "1";
      }) || !$fails(function() {
        $toPrecision.call({});
      })), "Number", {
        toPrecision: function toPrecision(precision) {
          var that = aNumberValue(this, "Number#toPrecision: incorrect invocation!");
          return precision === void 0 ? $toPrecision.call(that) : $toPrecision.call(that, precision);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.number.epsilon.js
  var require_es6_number_epsilon = __commonJS({
    "node_modules/core-js/modules/es6.number.epsilon.js"() {
      var $export = require_export();
      $export($export.S, "Number", { EPSILON: Math.pow(2, -52) });
    }
  });

  // node_modules/core-js/modules/es6.number.is-finite.js
  var require_es6_number_is_finite = __commonJS({
    "node_modules/core-js/modules/es6.number.is-finite.js"() {
      var $export = require_export();
      var _isFinite = require_global().isFinite;
      $export($export.S, "Number", {
        isFinite: function isFinite2(it) {
          return typeof it == "number" && _isFinite(it);
        }
      });
    }
  });

  // node_modules/core-js/modules/_is-integer.js
  var require_is_integer = __commonJS({
    "node_modules/core-js/modules/_is-integer.js"(exports, module) {
      var isObject = require_is_object();
      var floor = Math.floor;
      module.exports = function isInteger(it) {
        return !isObject(it) && isFinite(it) && floor(it) === it;
      };
    }
  });

  // node_modules/core-js/modules/es6.number.is-integer.js
  var require_es6_number_is_integer = __commonJS({
    "node_modules/core-js/modules/es6.number.is-integer.js"() {
      var $export = require_export();
      $export($export.S, "Number", { isInteger: require_is_integer() });
    }
  });

  // node_modules/core-js/modules/es6.number.is-nan.js
  var require_es6_number_is_nan = __commonJS({
    "node_modules/core-js/modules/es6.number.is-nan.js"() {
      var $export = require_export();
      $export($export.S, "Number", {
        isNaN: function isNaN2(number) {
          return number != number;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.number.is-safe-integer.js
  var require_es6_number_is_safe_integer = __commonJS({
    "node_modules/core-js/modules/es6.number.is-safe-integer.js"() {
      var $export = require_export();
      var isInteger = require_is_integer();
      var abs = Math.abs;
      $export($export.S, "Number", {
        isSafeInteger: function isSafeInteger(number) {
          return isInteger(number) && abs(number) <= 9007199254740991;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.number.max-safe-integer.js
  var require_es6_number_max_safe_integer = __commonJS({
    "node_modules/core-js/modules/es6.number.max-safe-integer.js"() {
      var $export = require_export();
      $export($export.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 });
    }
  });

  // node_modules/core-js/modules/es6.number.min-safe-integer.js
  var require_es6_number_min_safe_integer = __commonJS({
    "node_modules/core-js/modules/es6.number.min-safe-integer.js"() {
      var $export = require_export();
      $export($export.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 });
    }
  });

  // node_modules/core-js/modules/es6.number.parse-float.js
  var require_es6_number_parse_float = __commonJS({
    "node_modules/core-js/modules/es6.number.parse-float.js"() {
      var $export = require_export();
      var $parseFloat = require_parse_float();
      $export($export.S + $export.F * (Number.parseFloat != $parseFloat), "Number", { parseFloat: $parseFloat });
    }
  });

  // node_modules/core-js/modules/es6.number.parse-int.js
  var require_es6_number_parse_int = __commonJS({
    "node_modules/core-js/modules/es6.number.parse-int.js"() {
      var $export = require_export();
      var $parseInt = require_parse_int();
      $export($export.S + $export.F * (Number.parseInt != $parseInt), "Number", { parseInt: $parseInt });
    }
  });

  // node_modules/core-js/modules/_math-log1p.js
  var require_math_log1p = __commonJS({
    "node_modules/core-js/modules/_math-log1p.js"(exports, module) {
      module.exports = Math.log1p || function log1p(x) {
        return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
      };
    }
  });

  // node_modules/core-js/modules/es6.math.acosh.js
  var require_es6_math_acosh = __commonJS({
    "node_modules/core-js/modules/es6.math.acosh.js"() {
      var $export = require_export();
      var log1p = require_math_log1p();
      var sqrt = Math.sqrt;
      var $acosh = Math.acosh;
      $export($export.S + $export.F * !($acosh && Math.floor($acosh(Number.MAX_VALUE)) == 710 && $acosh(Infinity) == Infinity), "Math", {
        acosh: function acosh(x) {
          return (x = +x) < 1 ? NaN : x > 9490626562425156e-8 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.asinh.js
  var require_es6_math_asinh = __commonJS({
    "node_modules/core-js/modules/es6.math.asinh.js"() {
      var $export = require_export();
      var $asinh = Math.asinh;
      function asinh(x) {
        return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
      }
      $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), "Math", { asinh });
    }
  });

  // node_modules/core-js/modules/es6.math.atanh.js
  var require_es6_math_atanh = __commonJS({
    "node_modules/core-js/modules/es6.math.atanh.js"() {
      var $export = require_export();
      var $atanh = Math.atanh;
      $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), "Math", {
        atanh: function atanh(x) {
          return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
        }
      });
    }
  });

  // node_modules/core-js/modules/_math-sign.js
  var require_math_sign = __commonJS({
    "node_modules/core-js/modules/_math-sign.js"(exports, module) {
      module.exports = Math.sign || function sign(x) {
        return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
      };
    }
  });

  // node_modules/core-js/modules/es6.math.cbrt.js
  var require_es6_math_cbrt = __commonJS({
    "node_modules/core-js/modules/es6.math.cbrt.js"() {
      var $export = require_export();
      var sign = require_math_sign();
      $export($export.S, "Math", {
        cbrt: function cbrt(x) {
          return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.clz32.js
  var require_es6_math_clz32 = __commonJS({
    "node_modules/core-js/modules/es6.math.clz32.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        clz32: function clz32(x) {
          return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.cosh.js
  var require_es6_math_cosh = __commonJS({
    "node_modules/core-js/modules/es6.math.cosh.js"() {
      var $export = require_export();
      var exp = Math.exp;
      $export($export.S, "Math", {
        cosh: function cosh(x) {
          return (exp(x = +x) + exp(-x)) / 2;
        }
      });
    }
  });

  // node_modules/core-js/modules/_math-expm1.js
  var require_math_expm1 = __commonJS({
    "node_modules/core-js/modules/_math-expm1.js"(exports, module) {
      var $expm1 = Math.expm1;
      module.exports = !$expm1 || $expm1(10) > 22025.465794806718 || $expm1(10) < 22025.465794806718 || $expm1(-2e-17) != -2e-17 ? function expm1(x) {
        return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
      } : $expm1;
    }
  });

  // node_modules/core-js/modules/es6.math.expm1.js
  var require_es6_math_expm1 = __commonJS({
    "node_modules/core-js/modules/es6.math.expm1.js"() {
      var $export = require_export();
      var $expm1 = require_math_expm1();
      $export($export.S + $export.F * ($expm1 != Math.expm1), "Math", { expm1: $expm1 });
    }
  });

  // node_modules/core-js/modules/_math-fround.js
  var require_math_fround = __commonJS({
    "node_modules/core-js/modules/_math-fround.js"(exports, module) {
      var sign = require_math_sign();
      var pow = Math.pow;
      var EPSILON = pow(2, -52);
      var EPSILON32 = pow(2, -23);
      var MAX32 = pow(2, 127) * (2 - EPSILON32);
      var MIN32 = pow(2, -126);
      var roundTiesToEven = function(n) {
        return n + 1 / EPSILON - 1 / EPSILON;
      };
      module.exports = Math.fround || function fround(x) {
        var $abs = Math.abs(x);
        var $sign = sign(x);
        var a, result;
        if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
        a = (1 + EPSILON32 / EPSILON) * $abs;
        result = a - (a - $abs);
        if (result > MAX32 || result != result) return $sign * Infinity;
        return $sign * result;
      };
    }
  });

  // node_modules/core-js/modules/es6.math.fround.js
  var require_es6_math_fround = __commonJS({
    "node_modules/core-js/modules/es6.math.fround.js"() {
      var $export = require_export();
      $export($export.S, "Math", { fround: require_math_fround() });
    }
  });

  // node_modules/core-js/modules/es6.math.hypot.js
  var require_es6_math_hypot = __commonJS({
    "node_modules/core-js/modules/es6.math.hypot.js"() {
      var $export = require_export();
      var abs = Math.abs;
      $export($export.S, "Math", {
        hypot: function hypot(value1, value2) {
          var sum = 0;
          var i = 0;
          var aLen = arguments.length;
          var larg = 0;
          var arg, div;
          while (i < aLen) {
            arg = abs(arguments[i++]);
            if (larg < arg) {
              div = larg / arg;
              sum = sum * div * div + 1;
              larg = arg;
            } else if (arg > 0) {
              div = arg / larg;
              sum += div * div;
            } else sum += arg;
          }
          return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.imul.js
  var require_es6_math_imul = __commonJS({
    "node_modules/core-js/modules/es6.math.imul.js"() {
      var $export = require_export();
      var $imul = Math.imul;
      $export($export.S + $export.F * require_fails()(function() {
        return $imul(4294967295, 5) != -5 || $imul.length != 2;
      }), "Math", {
        imul: function imul(x, y) {
          var UINT16 = 65535;
          var xn = +x;
          var yn = +y;
          var xl = UINT16 & xn;
          var yl = UINT16 & yn;
          return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.log10.js
  var require_es6_math_log10 = __commonJS({
    "node_modules/core-js/modules/es6.math.log10.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        log10: function log10(x) {
          return Math.log(x) * Math.LOG10E;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.log1p.js
  var require_es6_math_log1p = __commonJS({
    "node_modules/core-js/modules/es6.math.log1p.js"() {
      var $export = require_export();
      $export($export.S, "Math", { log1p: require_math_log1p() });
    }
  });

  // node_modules/core-js/modules/es6.math.log2.js
  var require_es6_math_log2 = __commonJS({
    "node_modules/core-js/modules/es6.math.log2.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        log2: function log2(x) {
          return Math.log(x) / Math.LN2;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.sign.js
  var require_es6_math_sign = __commonJS({
    "node_modules/core-js/modules/es6.math.sign.js"() {
      var $export = require_export();
      $export($export.S, "Math", { sign: require_math_sign() });
    }
  });

  // node_modules/core-js/modules/es6.math.sinh.js
  var require_es6_math_sinh = __commonJS({
    "node_modules/core-js/modules/es6.math.sinh.js"() {
      var $export = require_export();
      var expm1 = require_math_expm1();
      var exp = Math.exp;
      $export($export.S + $export.F * require_fails()(function() {
        return !Math.sinh(-2e-17) != -2e-17;
      }), "Math", {
        sinh: function sinh(x) {
          return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.tanh.js
  var require_es6_math_tanh = __commonJS({
    "node_modules/core-js/modules/es6.math.tanh.js"() {
      var $export = require_export();
      var expm1 = require_math_expm1();
      var exp = Math.exp;
      $export($export.S, "Math", {
        tanh: function tanh(x) {
          var a = expm1(x = +x);
          var b = expm1(-x);
          return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.math.trunc.js
  var require_es6_math_trunc = __commonJS({
    "node_modules/core-js/modules/es6.math.trunc.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        trunc: function trunc(it) {
          return (it > 0 ? Math.floor : Math.ceil)(it);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.string.from-code-point.js
  var require_es6_string_from_code_point = __commonJS({
    "node_modules/core-js/modules/es6.string.from-code-point.js"() {
      var $export = require_export();
      var toAbsoluteIndex = require_to_absolute_index();
      var fromCharCode = String.fromCharCode;
      var $fromCodePoint = String.fromCodePoint;
      $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), "String", {
        // 21.1.2.2 String.fromCodePoint(...codePoints)
        fromCodePoint: function fromCodePoint(x) {
          var res = [];
          var aLen = arguments.length;
          var i = 0;
          var code;
          while (aLen > i) {
            code = +arguments[i++];
            if (toAbsoluteIndex(code, 1114111) !== code) throw RangeError(code + " is not a valid code point");
            res.push(
              code < 65536 ? fromCharCode(code) : fromCharCode(((code -= 65536) >> 10) + 55296, code % 1024 + 56320)
            );
          }
          return res.join("");
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.string.raw.js
  var require_es6_string_raw = __commonJS({
    "node_modules/core-js/modules/es6.string.raw.js"() {
      var $export = require_export();
      var toIObject = require_to_iobject();
      var toLength = require_to_length();
      $export($export.S, "String", {
        // 21.1.2.4 String.raw(callSite, ...substitutions)
        raw: function raw(callSite) {
          var tpl = toIObject(callSite.raw);
          var len = toLength(tpl.length);
          var aLen = arguments.length;
          var res = [];
          var i = 0;
          while (len > i) {
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
          }
          return res.join("");
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.string.trim.js
  var require_es6_string_trim = __commonJS({
    "node_modules/core-js/modules/es6.string.trim.js"() {
      "use strict";
      require_string_trim()("trim", function($trim) {
        return function trim() {
          return $trim(this, 3);
        };
      });
    }
  });

  // node_modules/core-js/modules/_string-at.js
  var require_string_at = __commonJS({
    "node_modules/core-js/modules/_string-at.js"(exports, module) {
      var toInteger = require_to_integer();
      var defined = require_defined();
      module.exports = function(TO_STRING) {
        return function(that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? "" : void 0;
          a = s.charCodeAt(i);
          return a < 55296 || a > 56319 || i + 1 === l || (b = s.charCodeAt(i + 1)) < 56320 || b > 57343 ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 55296 << 10) + (b - 56320) + 65536;
        };
      };
    }
  });

  // node_modules/core-js/modules/_iterators.js
  var require_iterators = __commonJS({
    "node_modules/core-js/modules/_iterators.js"(exports, module) {
      module.exports = {};
    }
  });

  // node_modules/core-js/modules/_iter-create.js
  var require_iter_create = __commonJS({
    "node_modules/core-js/modules/_iter-create.js"(exports, module) {
      "use strict";
      var create = require_object_create();
      var descriptor = require_property_desc();
      var setToStringTag = require_set_to_string_tag();
      var IteratorPrototype = {};
      require_hide()(IteratorPrototype, require_wks()("iterator"), function() {
        return this;
      });
      module.exports = function(Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
        setToStringTag(Constructor, NAME + " Iterator");
      };
    }
  });

  // node_modules/core-js/modules/_iter-define.js
  var require_iter_define = __commonJS({
    "node_modules/core-js/modules/_iter-define.js"(exports, module) {
      "use strict";
      var LIBRARY = require_library();
      var $export = require_export();
      var redefine = require_redefine();
      var hide = require_hide();
      var Iterators = require_iterators();
      var $iterCreate = require_iter_create();
      var setToStringTag = require_set_to_string_tag();
      var getPrototypeOf = require_object_gpo();
      var ITERATOR = require_wks()("iterator");
      var BUGGY = !([].keys && "next" in [].keys());
      var FF_ITERATOR = "@@iterator";
      var KEYS = "keys";
      var VALUES = "values";
      var returnThis = function() {
        return this;
      };
      module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);
        var getMethod = function(kind) {
          if (!BUGGY && kind in proto) return proto[kind];
          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };
            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }
          return function entries() {
            return new Constructor(this, kind);
          };
        };
        var TAG = NAME + " Iterator";
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : void 0;
        var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            setToStringTag(IteratorPrototype, TAG, true);
            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != "function") hide(IteratorPrototype, ITERATOR, returnThis);
          }
        }
        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;
          $default = function values() {
            return $native.call(this);
          };
        }
        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        }
        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;
        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED) for (key in methods) {
            if (!(key in proto)) redefine(proto, key, methods[key]);
          }
          else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
      };
    }
  });

  // node_modules/core-js/modules/es6.string.iterator.js
  var require_es6_string_iterator = __commonJS({
    "node_modules/core-js/modules/es6.string.iterator.js"() {
      "use strict";
      var $at = require_string_at()(true);
      require_iter_define()(String, "String", function(iterated) {
        this._t = String(iterated);
        this._i = 0;
      }, function() {
        var O = this._t;
        var index = this._i;
        var point;
        if (index >= O.length) return { value: void 0, done: true };
        point = $at(O, index);
        this._i += point.length;
        return { value: point, done: false };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.code-point-at.js
  var require_es6_string_code_point_at = __commonJS({
    "node_modules/core-js/modules/es6.string.code-point-at.js"() {
      "use strict";
      var $export = require_export();
      var $at = require_string_at()(false);
      $export($export.P, "String", {
        // 21.1.3.3 String.prototype.codePointAt(pos)
        codePointAt: function codePointAt(pos) {
          return $at(this, pos);
        }
      });
    }
  });

  // node_modules/core-js/modules/_is-regexp.js
  var require_is_regexp = __commonJS({
    "node_modules/core-js/modules/_is-regexp.js"(exports, module) {
      var isObject = require_is_object();
      var cof = require_cof();
      var MATCH = require_wks()("match");
      module.exports = function(it) {
        var isRegExp;
        return isObject(it) && ((isRegExp = it[MATCH]) !== void 0 ? !!isRegExp : cof(it) == "RegExp");
      };
    }
  });

  // node_modules/core-js/modules/_string-context.js
  var require_string_context = __commonJS({
    "node_modules/core-js/modules/_string-context.js"(exports, module) {
      var isRegExp = require_is_regexp();
      var defined = require_defined();
      module.exports = function(that, searchString, NAME) {
        if (isRegExp(searchString)) throw TypeError("String#" + NAME + " doesn't accept regex!");
        return String(defined(that));
      };
    }
  });

  // node_modules/core-js/modules/_fails-is-regexp.js
  var require_fails_is_regexp = __commonJS({
    "node_modules/core-js/modules/_fails-is-regexp.js"(exports, module) {
      var MATCH = require_wks()("match");
      module.exports = function(KEY) {
        var re = /./;
        try {
          "/./"[KEY](re);
        } catch (e) {
          try {
            re[MATCH] = false;
            return !"/./"[KEY](re);
          } catch (f) {
          }
        }
        return true;
      };
    }
  });

  // node_modules/core-js/modules/es6.string.ends-with.js
  var require_es6_string_ends_with = __commonJS({
    "node_modules/core-js/modules/es6.string.ends-with.js"() {
      "use strict";
      var $export = require_export();
      var toLength = require_to_length();
      var context = require_string_context();
      var ENDS_WITH = "endsWith";
      var $endsWith = ""[ENDS_WITH];
      $export($export.P + $export.F * require_fails_is_regexp()(ENDS_WITH), "String", {
        endsWith: function endsWith(searchString) {
          var that = context(this, searchString, ENDS_WITH);
          var endPosition = arguments.length > 1 ? arguments[1] : void 0;
          var len = toLength(that.length);
          var end = endPosition === void 0 ? len : Math.min(toLength(endPosition), len);
          var search = String(searchString);
          return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.string.includes.js
  var require_es6_string_includes = __commonJS({
    "node_modules/core-js/modules/es6.string.includes.js"() {
      "use strict";
      var $export = require_export();
      var context = require_string_context();
      var INCLUDES = "includes";
      $export($export.P + $export.F * require_fails_is_regexp()(INCLUDES), "String", {
        includes: function includes(searchString) {
          return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.string.repeat.js
  var require_es6_string_repeat = __commonJS({
    "node_modules/core-js/modules/es6.string.repeat.js"() {
      var $export = require_export();
      $export($export.P, "String", {
        // 21.1.3.13 String.prototype.repeat(count)
        repeat: require_string_repeat()
      });
    }
  });

  // node_modules/core-js/modules/es6.string.starts-with.js
  var require_es6_string_starts_with = __commonJS({
    "node_modules/core-js/modules/es6.string.starts-with.js"() {
      "use strict";
      var $export = require_export();
      var toLength = require_to_length();
      var context = require_string_context();
      var STARTS_WITH = "startsWith";
      var $startsWith = ""[STARTS_WITH];
      $export($export.P + $export.F * require_fails_is_regexp()(STARTS_WITH), "String", {
        startsWith: function startsWith(searchString) {
          var that = context(this, searchString, STARTS_WITH);
          var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : void 0, that.length));
          var search = String(searchString);
          return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
        }
      });
    }
  });

  // node_modules/core-js/modules/_string-html.js
  var require_string_html = __commonJS({
    "node_modules/core-js/modules/_string-html.js"(exports, module) {
      var $export = require_export();
      var fails = require_fails();
      var defined = require_defined();
      var quot = /"/g;
      var createHTML = function(string, tag, attribute, value) {
        var S = String(defined(string));
        var p1 = "<" + tag;
        if (attribute !== "") p1 += " " + attribute + '="' + String(value).replace(quot, "&quot;") + '"';
        return p1 + ">" + S + "</" + tag + ">";
      };
      module.exports = function(NAME, exec) {
        var O = {};
        O[NAME] = exec(createHTML);
        $export($export.P + $export.F * fails(function() {
          var test = ""[NAME]('"');
          return test !== test.toLowerCase() || test.split('"').length > 3;
        }), "String", O);
      };
    }
  });

  // node_modules/core-js/modules/es6.string.anchor.js
  var require_es6_string_anchor = __commonJS({
    "node_modules/core-js/modules/es6.string.anchor.js"() {
      "use strict";
      require_string_html()("anchor", function(createHTML) {
        return function anchor(name) {
          return createHTML(this, "a", "name", name);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.big.js
  var require_es6_string_big = __commonJS({
    "node_modules/core-js/modules/es6.string.big.js"() {
      "use strict";
      require_string_html()("big", function(createHTML) {
        return function big() {
          return createHTML(this, "big", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.blink.js
  var require_es6_string_blink = __commonJS({
    "node_modules/core-js/modules/es6.string.blink.js"() {
      "use strict";
      require_string_html()("blink", function(createHTML) {
        return function blink() {
          return createHTML(this, "blink", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.bold.js
  var require_es6_string_bold = __commonJS({
    "node_modules/core-js/modules/es6.string.bold.js"() {
      "use strict";
      require_string_html()("bold", function(createHTML) {
        return function bold() {
          return createHTML(this, "b", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.fixed.js
  var require_es6_string_fixed = __commonJS({
    "node_modules/core-js/modules/es6.string.fixed.js"() {
      "use strict";
      require_string_html()("fixed", function(createHTML) {
        return function fixed() {
          return createHTML(this, "tt", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.fontcolor.js
  var require_es6_string_fontcolor = __commonJS({
    "node_modules/core-js/modules/es6.string.fontcolor.js"() {
      "use strict";
      require_string_html()("fontcolor", function(createHTML) {
        return function fontcolor(color) {
          return createHTML(this, "font", "color", color);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.fontsize.js
  var require_es6_string_fontsize = __commonJS({
    "node_modules/core-js/modules/es6.string.fontsize.js"() {
      "use strict";
      require_string_html()("fontsize", function(createHTML) {
        return function fontsize(size) {
          return createHTML(this, "font", "size", size);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.italics.js
  var require_es6_string_italics = __commonJS({
    "node_modules/core-js/modules/es6.string.italics.js"() {
      "use strict";
      require_string_html()("italics", function(createHTML) {
        return function italics() {
          return createHTML(this, "i", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.link.js
  var require_es6_string_link = __commonJS({
    "node_modules/core-js/modules/es6.string.link.js"() {
      "use strict";
      require_string_html()("link", function(createHTML) {
        return function link(url) {
          return createHTML(this, "a", "href", url);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.small.js
  var require_es6_string_small = __commonJS({
    "node_modules/core-js/modules/es6.string.small.js"() {
      "use strict";
      require_string_html()("small", function(createHTML) {
        return function small() {
          return createHTML(this, "small", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.strike.js
  var require_es6_string_strike = __commonJS({
    "node_modules/core-js/modules/es6.string.strike.js"() {
      "use strict";
      require_string_html()("strike", function(createHTML) {
        return function strike() {
          return createHTML(this, "strike", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.sub.js
  var require_es6_string_sub = __commonJS({
    "node_modules/core-js/modules/es6.string.sub.js"() {
      "use strict";
      require_string_html()("sub", function(createHTML) {
        return function sub() {
          return createHTML(this, "sub", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.string.sup.js
  var require_es6_string_sup = __commonJS({
    "node_modules/core-js/modules/es6.string.sup.js"() {
      "use strict";
      require_string_html()("sup", function(createHTML) {
        return function sup() {
          return createHTML(this, "sup", "", "");
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.date.now.js
  var require_es6_date_now = __commonJS({
    "node_modules/core-js/modules/es6.date.now.js"() {
      var $export = require_export();
      $export($export.S, "Date", { now: function() {
        return (/* @__PURE__ */ new Date()).getTime();
      } });
    }
  });

  // node_modules/core-js/modules/es6.date.to-json.js
  var require_es6_date_to_json = __commonJS({
    "node_modules/core-js/modules/es6.date.to-json.js"() {
      "use strict";
      var $export = require_export();
      var toObject = require_to_object();
      var toPrimitive = require_to_primitive();
      $export($export.P + $export.F * require_fails()(function() {
        return (/* @__PURE__ */ new Date(NaN)).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function() {
          return 1;
        } }) !== 1;
      }), "Date", {
        // eslint-disable-next-line no-unused-vars
        toJSON: function toJSON(key) {
          var O = toObject(this);
          var pv = toPrimitive(O);
          return typeof pv == "number" && !isFinite(pv) ? null : O.toISOString();
        }
      });
    }
  });

  // node_modules/core-js/modules/_date-to-iso-string.js
  var require_date_to_iso_string = __commonJS({
    "node_modules/core-js/modules/_date-to-iso-string.js"(exports, module) {
      "use strict";
      var fails = require_fails();
      var getTime = Date.prototype.getTime;
      var $toISOString = Date.prototype.toISOString;
      var lz = function(num) {
        return num > 9 ? num : "0" + num;
      };
      module.exports = fails(function() {
        return $toISOString.call(new Date(-5e13 - 1)) != "0385-07-25T07:06:39.999Z";
      }) || !fails(function() {
        $toISOString.call(/* @__PURE__ */ new Date(NaN));
      }) ? function toISOString() {
        if (!isFinite(getTime.call(this))) throw RangeError("Invalid time value");
        var d = this;
        var y = d.getUTCFullYear();
        var m = d.getUTCMilliseconds();
        var s = y < 0 ? "-" : y > 9999 ? "+" : "";
        return s + ("00000" + Math.abs(y)).slice(s ? -6 : -4) + "-" + lz(d.getUTCMonth() + 1) + "-" + lz(d.getUTCDate()) + "T" + lz(d.getUTCHours()) + ":" + lz(d.getUTCMinutes()) + ":" + lz(d.getUTCSeconds()) + "." + (m > 99 ? m : "0" + lz(m)) + "Z";
      } : $toISOString;
    }
  });

  // node_modules/core-js/modules/es6.date.to-iso-string.js
  var require_es6_date_to_iso_string = __commonJS({
    "node_modules/core-js/modules/es6.date.to-iso-string.js"() {
      var $export = require_export();
      var toISOString = require_date_to_iso_string();
      $export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), "Date", {
        toISOString
      });
    }
  });

  // node_modules/core-js/modules/es6.date.to-string.js
  var require_es6_date_to_string = __commonJS({
    "node_modules/core-js/modules/es6.date.to-string.js"() {
      var DateProto = Date.prototype;
      var INVALID_DATE = "Invalid Date";
      var TO_STRING = "toString";
      var $toString = DateProto[TO_STRING];
      var getTime = DateProto.getTime;
      if (/* @__PURE__ */ new Date(NaN) + "" != INVALID_DATE) {
        require_redefine()(DateProto, TO_STRING, function toString() {
          var value = getTime.call(this);
          return value === value ? $toString.call(this) : INVALID_DATE;
        });
      }
    }
  });

  // node_modules/core-js/modules/_date-to-primitive.js
  var require_date_to_primitive = __commonJS({
    "node_modules/core-js/modules/_date-to-primitive.js"(exports, module) {
      "use strict";
      var anObject = require_an_object();
      var toPrimitive = require_to_primitive();
      var NUMBER = "number";
      module.exports = function(hint) {
        if (hint !== "string" && hint !== NUMBER && hint !== "default") throw TypeError("Incorrect hint");
        return toPrimitive(anObject(this), hint != NUMBER);
      };
    }
  });

  // node_modules/core-js/modules/es6.date.to-primitive.js
  var require_es6_date_to_primitive = __commonJS({
    "node_modules/core-js/modules/es6.date.to-primitive.js"() {
      var TO_PRIMITIVE = require_wks()("toPrimitive");
      var proto = Date.prototype;
      if (!(TO_PRIMITIVE in proto)) require_hide()(proto, TO_PRIMITIVE, require_date_to_primitive());
    }
  });

  // node_modules/core-js/modules/es6.array.is-array.js
  var require_es6_array_is_array = __commonJS({
    "node_modules/core-js/modules/es6.array.is-array.js"() {
      var $export = require_export();
      $export($export.S, "Array", { isArray: require_is_array() });
    }
  });

  // node_modules/core-js/modules/_iter-call.js
  var require_iter_call = __commonJS({
    "node_modules/core-js/modules/_iter-call.js"(exports, module) {
      var anObject = require_an_object();
      module.exports = function(iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value);
        } catch (e) {
          var ret = iterator["return"];
          if (ret !== void 0) anObject(ret.call(iterator));
          throw e;
        }
      };
    }
  });

  // node_modules/core-js/modules/_is-array-iter.js
  var require_is_array_iter = __commonJS({
    "node_modules/core-js/modules/_is-array-iter.js"(exports, module) {
      var Iterators = require_iterators();
      var ITERATOR = require_wks()("iterator");
      var ArrayProto = Array.prototype;
      module.exports = function(it) {
        return it !== void 0 && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };
    }
  });

  // node_modules/core-js/modules/_create-property.js
  var require_create_property = __commonJS({
    "node_modules/core-js/modules/_create-property.js"(exports, module) {
      "use strict";
      var $defineProperty = require_object_dp();
      var createDesc = require_property_desc();
      module.exports = function(object, index, value) {
        if (index in object) $defineProperty.f(object, index, createDesc(0, value));
        else object[index] = value;
      };
    }
  });

  // node_modules/core-js/modules/core.get-iterator-method.js
  var require_core_get_iterator_method = __commonJS({
    "node_modules/core-js/modules/core.get-iterator-method.js"(exports, module) {
      var classof = require_classof();
      var ITERATOR = require_wks()("iterator");
      var Iterators = require_iterators();
      module.exports = require_core().getIteratorMethod = function(it) {
        if (it != void 0) return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
      };
    }
  });

  // node_modules/core-js/modules/_iter-detect.js
  var require_iter_detect = __commonJS({
    "node_modules/core-js/modules/_iter-detect.js"(exports, module) {
      var ITERATOR = require_wks()("iterator");
      var SAFE_CLOSING = false;
      try {
        riter = [7][ITERATOR]();
        riter["return"] = function() {
          SAFE_CLOSING = true;
        };
        Array.from(riter, function() {
          throw 2;
        });
      } catch (e) {
      }
      var riter;
      module.exports = function(exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;
        try {
          var arr = [7];
          var iter = arr[ITERATOR]();
          iter.next = function() {
            return { done: safe = true };
          };
          arr[ITERATOR] = function() {
            return iter;
          };
          exec(arr);
        } catch (e) {
        }
        return safe;
      };
    }
  });

  // node_modules/core-js/modules/es6.array.from.js
  var require_es6_array_from = __commonJS({
    "node_modules/core-js/modules/es6.array.from.js"() {
      "use strict";
      var ctx = require_ctx();
      var $export = require_export();
      var toObject = require_to_object();
      var call = require_iter_call();
      var isArrayIter = require_is_array_iter();
      var toLength = require_to_length();
      var createProperty = require_create_property();
      var getIterFn = require_core_get_iterator_method();
      $export($export.S + $export.F * !require_iter_detect()(function(iter) {
        Array.from(iter);
      }), "Array", {
        // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
        from: function from(arrayLike) {
          var O = toObject(arrayLike);
          var C = typeof this == "function" ? this : Array;
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : void 0;
          var mapping = mapfn !== void 0;
          var index = 0;
          var iterFn = getIterFn(O);
          var length, result, step, iterator;
          if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : void 0, 2);
          if (iterFn != void 0 && !(C == Array && isArrayIter(iterFn))) {
            for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
              createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
            }
          } else {
            length = toLength(O.length);
            for (result = new C(length); length > index; index++) {
              createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
            }
          }
          result.length = index;
          return result;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.of.js
  var require_es6_array_of = __commonJS({
    "node_modules/core-js/modules/es6.array.of.js"() {
      "use strict";
      var $export = require_export();
      var createProperty = require_create_property();
      $export($export.S + $export.F * require_fails()(function() {
        function F() {
        }
        return !(Array.of.call(F) instanceof F);
      }), "Array", {
        // 22.1.2.3 Array.of( ...items)
        of: function of() {
          var index = 0;
          var aLen = arguments.length;
          var result = new (typeof this == "function" ? this : Array)(aLen);
          while (aLen > index) createProperty(result, index, arguments[index++]);
          result.length = aLen;
          return result;
        }
      });
    }
  });

  // node_modules/core-js/modules/_strict-method.js
  var require_strict_method = __commonJS({
    "node_modules/core-js/modules/_strict-method.js"(exports, module) {
      "use strict";
      var fails = require_fails();
      module.exports = function(method, arg) {
        return !!method && fails(function() {
          arg ? method.call(null, function() {
          }, 1) : method.call(null);
        });
      };
    }
  });

  // node_modules/core-js/modules/es6.array.join.js
  var require_es6_array_join = __commonJS({
    "node_modules/core-js/modules/es6.array.join.js"() {
      "use strict";
      var $export = require_export();
      var toIObject = require_to_iobject();
      var arrayJoin = [].join;
      $export($export.P + $export.F * (require_iobject() != Object || !require_strict_method()(arrayJoin)), "Array", {
        join: function join(separator) {
          return arrayJoin.call(toIObject(this), separator === void 0 ? "," : separator);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.slice.js
  var require_es6_array_slice = __commonJS({
    "node_modules/core-js/modules/es6.array.slice.js"() {
      "use strict";
      var $export = require_export();
      var html = require_html();
      var cof = require_cof();
      var toAbsoluteIndex = require_to_absolute_index();
      var toLength = require_to_length();
      var arraySlice = [].slice;
      $export($export.P + $export.F * require_fails()(function() {
        if (html) arraySlice.call(html);
      }), "Array", {
        slice: function slice(begin, end) {
          var len = toLength(this.length);
          var klass = cof(this);
          end = end === void 0 ? len : end;
          if (klass == "Array") return arraySlice.call(this, begin, end);
          var start = toAbsoluteIndex(begin, len);
          var upTo = toAbsoluteIndex(end, len);
          var size = toLength(upTo - start);
          var cloned = new Array(size);
          var i = 0;
          for (; i < size; i++) cloned[i] = klass == "String" ? this.charAt(start + i) : this[start + i];
          return cloned;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.sort.js
  var require_es6_array_sort = __commonJS({
    "node_modules/core-js/modules/es6.array.sort.js"() {
      "use strict";
      var $export = require_export();
      var aFunction = require_a_function();
      var toObject = require_to_object();
      var fails = require_fails();
      var $sort = [].sort;
      var test = [1, 2, 3];
      $export($export.P + $export.F * (fails(function() {
        test.sort(void 0);
      }) || !fails(function() {
        test.sort(null);
      }) || !require_strict_method()($sort)), "Array", {
        // 22.1.3.25 Array.prototype.sort(comparefn)
        sort: function sort(comparefn) {
          return comparefn === void 0 ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
        }
      });
    }
  });

  // node_modules/core-js/modules/_array-species-constructor.js
  var require_array_species_constructor = __commonJS({
    "node_modules/core-js/modules/_array-species-constructor.js"(exports, module) {
      var isObject = require_is_object();
      var isArray = require_is_array();
      var SPECIES = require_wks()("species");
      module.exports = function(original) {
        var C;
        if (isArray(original)) {
          C = original.constructor;
          if (typeof C == "function" && (C === Array || isArray(C.prototype))) C = void 0;
          if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = void 0;
          }
        }
        return C === void 0 ? Array : C;
      };
    }
  });

  // node_modules/core-js/modules/_array-species-create.js
  var require_array_species_create = __commonJS({
    "node_modules/core-js/modules/_array-species-create.js"(exports, module) {
      var speciesConstructor = require_array_species_constructor();
      module.exports = function(original, length) {
        return new (speciesConstructor(original))(length);
      };
    }
  });

  // node_modules/core-js/modules/_array-methods.js
  var require_array_methods = __commonJS({
    "node_modules/core-js/modules/_array-methods.js"(exports, module) {
      var ctx = require_ctx();
      var IObject = require_iobject();
      var toObject = require_to_object();
      var toLength = require_to_length();
      var asc = require_array_species_create();
      module.exports = function(TYPE, $create) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        var create = $create || asc;
        return function($this, callbackfn, that) {
          var O = toObject($this);
          var self2 = IObject(O);
          var f = ctx(callbackfn, that, 3);
          var length = toLength(self2.length);
          var index = 0;
          var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : void 0;
          var val, res;
          for (; length > index; index++) if (NO_HOLES || index in self2) {
            val = self2[index];
            res = f(val, index, O);
            if (TYPE) {
              if (IS_MAP) result[index] = res;
              else if (res) switch (TYPE) {
                case 3:
                  return true;
                // some
                case 5:
                  return val;
                // find
                case 6:
                  return index;
                // findIndex
                case 2:
                  result.push(val);
              }
              else if (IS_EVERY) return false;
            }
          }
          return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
        };
      };
    }
  });

  // node_modules/core-js/modules/es6.array.for-each.js
  var require_es6_array_for_each = __commonJS({
    "node_modules/core-js/modules/es6.array.for-each.js"() {
      "use strict";
      var $export = require_export();
      var $forEach = require_array_methods()(0);
      var STRICT = require_strict_method()([].forEach, true);
      $export($export.P + $export.F * !STRICT, "Array", {
        // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
        forEach: function forEach(callbackfn) {
          return $forEach(this, callbackfn, arguments[1]);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.map.js
  var require_es6_array_map = __commonJS({
    "node_modules/core-js/modules/es6.array.map.js"() {
      "use strict";
      var $export = require_export();
      var $map = require_array_methods()(1);
      $export($export.P + $export.F * !require_strict_method()([].map, true), "Array", {
        // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
        map: function map(callbackfn) {
          return $map(this, callbackfn, arguments[1]);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.filter.js
  var require_es6_array_filter = __commonJS({
    "node_modules/core-js/modules/es6.array.filter.js"() {
      "use strict";
      var $export = require_export();
      var $filter = require_array_methods()(2);
      $export($export.P + $export.F * !require_strict_method()([].filter, true), "Array", {
        // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
        filter: function filter(callbackfn) {
          return $filter(this, callbackfn, arguments[1]);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.some.js
  var require_es6_array_some = __commonJS({
    "node_modules/core-js/modules/es6.array.some.js"() {
      "use strict";
      var $export = require_export();
      var $some = require_array_methods()(3);
      $export($export.P + $export.F * !require_strict_method()([].some, true), "Array", {
        // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
        some: function some(callbackfn) {
          return $some(this, callbackfn, arguments[1]);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.every.js
  var require_es6_array_every = __commonJS({
    "node_modules/core-js/modules/es6.array.every.js"() {
      "use strict";
      var $export = require_export();
      var $every = require_array_methods()(4);
      $export($export.P + $export.F * !require_strict_method()([].every, true), "Array", {
        // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
        every: function every(callbackfn) {
          return $every(this, callbackfn, arguments[1]);
        }
      });
    }
  });

  // node_modules/core-js/modules/_array-reduce.js
  var require_array_reduce = __commonJS({
    "node_modules/core-js/modules/_array-reduce.js"(exports, module) {
      var aFunction = require_a_function();
      var toObject = require_to_object();
      var IObject = require_iobject();
      var toLength = require_to_length();
      module.exports = function(that, callbackfn, aLen, memo, isRight) {
        aFunction(callbackfn);
        var O = toObject(that);
        var self2 = IObject(O);
        var length = toLength(O.length);
        var index = isRight ? length - 1 : 0;
        var i = isRight ? -1 : 1;
        if (aLen < 2) for (; ; ) {
          if (index in self2) {
            memo = self2[index];
            index += i;
            break;
          }
          index += i;
          if (isRight ? index < 0 : length <= index) {
            throw TypeError("Reduce of empty array with no initial value");
          }
        }
        for (; isRight ? index >= 0 : length > index; index += i) if (index in self2) {
          memo = callbackfn(memo, self2[index], index, O);
        }
        return memo;
      };
    }
  });

  // node_modules/core-js/modules/es6.array.reduce.js
  var require_es6_array_reduce = __commonJS({
    "node_modules/core-js/modules/es6.array.reduce.js"() {
      "use strict";
      var $export = require_export();
      var $reduce = require_array_reduce();
      $export($export.P + $export.F * !require_strict_method()([].reduce, true), "Array", {
        // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
        reduce: function reduce(callbackfn) {
          return $reduce(this, callbackfn, arguments.length, arguments[1], false);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.reduce-right.js
  var require_es6_array_reduce_right = __commonJS({
    "node_modules/core-js/modules/es6.array.reduce-right.js"() {
      "use strict";
      var $export = require_export();
      var $reduce = require_array_reduce();
      $export($export.P + $export.F * !require_strict_method()([].reduceRight, true), "Array", {
        // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
        reduceRight: function reduceRight(callbackfn) {
          return $reduce(this, callbackfn, arguments.length, arguments[1], true);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.index-of.js
  var require_es6_array_index_of = __commonJS({
    "node_modules/core-js/modules/es6.array.index-of.js"() {
      "use strict";
      var $export = require_export();
      var $indexOf = require_array_includes()(false);
      var $native = [].indexOf;
      var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
      $export($export.P + $export.F * (NEGATIVE_ZERO || !require_strict_method()($native)), "Array", {
        // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
        indexOf: function indexOf(searchElement) {
          return NEGATIVE_ZERO ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.array.last-index-of.js
  var require_es6_array_last_index_of = __commonJS({
    "node_modules/core-js/modules/es6.array.last-index-of.js"() {
      "use strict";
      var $export = require_export();
      var toIObject = require_to_iobject();
      var toInteger = require_to_integer();
      var toLength = require_to_length();
      var $native = [].lastIndexOf;
      var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
      $export($export.P + $export.F * (NEGATIVE_ZERO || !require_strict_method()($native)), "Array", {
        // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
        lastIndexOf: function lastIndexOf(searchElement) {
          if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
          var O = toIObject(this);
          var length = toLength(O.length);
          var index = length - 1;
          if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
          if (index < 0) index = length + index;
          for (; index >= 0; index--) if (index in O) {
            if (O[index] === searchElement) return index || 0;
          }
          return -1;
        }
      });
    }
  });

  // node_modules/core-js/modules/_array-copy-within.js
  var require_array_copy_within = __commonJS({
    "node_modules/core-js/modules/_array-copy-within.js"(exports, module) {
      "use strict";
      var toObject = require_to_object();
      var toAbsoluteIndex = require_to_absolute_index();
      var toLength = require_to_length();
      module.exports = [].copyWithin || function copyWithin(target, start) {
        var O = toObject(this);
        var len = toLength(O.length);
        var to = toAbsoluteIndex(target, len);
        var from = toAbsoluteIndex(start, len);
        var end = arguments.length > 2 ? arguments[2] : void 0;
        var count = Math.min((end === void 0 ? len : toAbsoluteIndex(end, len)) - from, len - to);
        var inc = 1;
        if (from < to && to < from + count) {
          inc = -1;
          from += count - 1;
          to += count - 1;
        }
        while (count-- > 0) {
          if (from in O) O[to] = O[from];
          else delete O[to];
          to += inc;
          from += inc;
        }
        return O;
      };
    }
  });

  // node_modules/core-js/modules/_add-to-unscopables.js
  var require_add_to_unscopables = __commonJS({
    "node_modules/core-js/modules/_add-to-unscopables.js"(exports, module) {
      var UNSCOPABLES = require_wks()("unscopables");
      var ArrayProto = Array.prototype;
      if (ArrayProto[UNSCOPABLES] == void 0) require_hide()(ArrayProto, UNSCOPABLES, {});
      module.exports = function(key) {
        ArrayProto[UNSCOPABLES][key] = true;
      };
    }
  });

  // node_modules/core-js/modules/es6.array.copy-within.js
  var require_es6_array_copy_within = __commonJS({
    "node_modules/core-js/modules/es6.array.copy-within.js"() {
      var $export = require_export();
      $export($export.P, "Array", { copyWithin: require_array_copy_within() });
      require_add_to_unscopables()("copyWithin");
    }
  });

  // node_modules/core-js/modules/_array-fill.js
  var require_array_fill = __commonJS({
    "node_modules/core-js/modules/_array-fill.js"(exports, module) {
      "use strict";
      var toObject = require_to_object();
      var toAbsoluteIndex = require_to_absolute_index();
      var toLength = require_to_length();
      module.exports = function fill(value) {
        var O = toObject(this);
        var length = toLength(O.length);
        var aLen = arguments.length;
        var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : void 0, length);
        var end = aLen > 2 ? arguments[2] : void 0;
        var endPos = end === void 0 ? length : toAbsoluteIndex(end, length);
        while (endPos > index) O[index++] = value;
        return O;
      };
    }
  });

  // node_modules/core-js/modules/es6.array.fill.js
  var require_es6_array_fill = __commonJS({
    "node_modules/core-js/modules/es6.array.fill.js"() {
      var $export = require_export();
      $export($export.P, "Array", { fill: require_array_fill() });
      require_add_to_unscopables()("fill");
    }
  });

  // node_modules/core-js/modules/es6.array.find.js
  var require_es6_array_find = __commonJS({
    "node_modules/core-js/modules/es6.array.find.js"() {
      "use strict";
      var $export = require_export();
      var $find = require_array_methods()(5);
      var KEY = "find";
      var forced = true;
      if (KEY in []) Array(1)[KEY](function() {
        forced = false;
      });
      $export($export.P + $export.F * forced, "Array", {
        find: function find(callbackfn) {
          return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      require_add_to_unscopables()(KEY);
    }
  });

  // node_modules/core-js/modules/es6.array.find-index.js
  var require_es6_array_find_index = __commonJS({
    "node_modules/core-js/modules/es6.array.find-index.js"() {
      "use strict";
      var $export = require_export();
      var $find = require_array_methods()(6);
      var KEY = "findIndex";
      var forced = true;
      if (KEY in []) Array(1)[KEY](function() {
        forced = false;
      });
      $export($export.P + $export.F * forced, "Array", {
        findIndex: function findIndex(callbackfn) {
          return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      require_add_to_unscopables()(KEY);
    }
  });

  // node_modules/core-js/modules/_set-species.js
  var require_set_species = __commonJS({
    "node_modules/core-js/modules/_set-species.js"(exports, module) {
      "use strict";
      var global2 = require_global();
      var dP = require_object_dp();
      var DESCRIPTORS = require_descriptors();
      var SPECIES = require_wks()("species");
      module.exports = function(KEY) {
        var C = global2[KEY];
        if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
          configurable: true,
          get: function() {
            return this;
          }
        });
      };
    }
  });

  // node_modules/core-js/modules/es6.array.species.js
  var require_es6_array_species = __commonJS({
    "node_modules/core-js/modules/es6.array.species.js"() {
      require_set_species()("Array");
    }
  });

  // node_modules/core-js/modules/_iter-step.js
  var require_iter_step = __commonJS({
    "node_modules/core-js/modules/_iter-step.js"(exports, module) {
      module.exports = function(done, value) {
        return { value, done: !!done };
      };
    }
  });

  // node_modules/core-js/modules/es6.array.iterator.js
  var require_es6_array_iterator = __commonJS({
    "node_modules/core-js/modules/es6.array.iterator.js"(exports, module) {
      "use strict";
      var addToUnscopables = require_add_to_unscopables();
      var step = require_iter_step();
      var Iterators = require_iterators();
      var toIObject = require_to_iobject();
      module.exports = require_iter_define()(Array, "Array", function(iterated, kind) {
        this._t = toIObject(iterated);
        this._i = 0;
        this._k = kind;
      }, function() {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;
        if (!O || index >= O.length) {
          this._t = void 0;
          return step(1);
        }
        if (kind == "keys") return step(0, index);
        if (kind == "values") return step(0, O[index]);
        return step(0, [index, O[index]]);
      }, "values");
      Iterators.Arguments = Iterators.Array;
      addToUnscopables("keys");
      addToUnscopables("values");
      addToUnscopables("entries");
    }
  });

  // node_modules/core-js/modules/_flags.js
  var require_flags = __commonJS({
    "node_modules/core-js/modules/_flags.js"(exports, module) {
      "use strict";
      var anObject = require_an_object();
      module.exports = function() {
        var that = anObject(this);
        var result = "";
        if (that.global) result += "g";
        if (that.ignoreCase) result += "i";
        if (that.multiline) result += "m";
        if (that.unicode) result += "u";
        if (that.sticky) result += "y";
        return result;
      };
    }
  });

  // node_modules/core-js/modules/es6.regexp.constructor.js
  var require_es6_regexp_constructor = __commonJS({
    "node_modules/core-js/modules/es6.regexp.constructor.js"() {
      var global2 = require_global();
      var inheritIfRequired = require_inherit_if_required();
      var dP = require_object_dp().f;
      var gOPN = require_object_gopn().f;
      var isRegExp = require_is_regexp();
      var $flags = require_flags();
      var $RegExp = global2.RegExp;
      var Base = $RegExp;
      var proto = $RegExp.prototype;
      var re1 = /a/g;
      var re2 = /a/g;
      var CORRECT_NEW = new $RegExp(re1) !== re1;
      if (require_descriptors() && (!CORRECT_NEW || require_fails()(function() {
        re2[require_wks()("match")] = false;
        return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, "i") != "/a/i";
      }))) {
        $RegExp = function RegExp2(p, f) {
          var tiRE = this instanceof $RegExp;
          var piRE = isRegExp(p);
          var fiU = f === void 0;
          return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(
            CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f),
            tiRE ? this : proto,
            $RegExp
          );
        };
        proxy = function(key) {
          key in $RegExp || dP($RegExp, key, {
            configurable: true,
            get: function() {
              return Base[key];
            },
            set: function(it) {
              Base[key] = it;
            }
          });
        };
        for (keys = gOPN(Base), i = 0; keys.length > i; ) proxy(keys[i++]);
        proto.constructor = $RegExp;
        $RegExp.prototype = proto;
        require_redefine()(global2, "RegExp", $RegExp);
      }
      var proxy;
      var keys;
      var i;
      require_set_species()("RegExp");
    }
  });

  // node_modules/core-js/modules/_regexp-exec.js
  var require_regexp_exec = __commonJS({
    "node_modules/core-js/modules/_regexp-exec.js"(exports, module) {
      "use strict";
      var regexpFlags = require_flags();
      var nativeExec = RegExp.prototype.exec;
      var nativeReplace = String.prototype.replace;
      var patchedExec = nativeExec;
      var LAST_INDEX = "lastIndex";
      var UPDATES_LAST_INDEX_WRONG = function() {
        var re1 = /a/, re2 = /b*/g;
        nativeExec.call(re1, "a");
        nativeExec.call(re2, "a");
        return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
      }();
      var NPCG_INCLUDED = /()??/.exec("")[1] !== void 0;
      var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
      if (PATCH) {
        patchedExec = function exec(str) {
          var re = this;
          var lastIndex, reCopy, match, i;
          if (NPCG_INCLUDED) {
            reCopy = new RegExp("^" + re.source + "$(?!\\s)", regexpFlags.call(re));
          }
          if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
          match = nativeExec.call(re, str);
          if (UPDATES_LAST_INDEX_WRONG && match) {
            re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
          }
          if (NPCG_INCLUDED && match && match.length > 1) {
            nativeReplace.call(match[0], reCopy, function() {
              for (i = 1; i < arguments.length - 2; i++) {
                if (arguments[i] === void 0) match[i] = void 0;
              }
            });
          }
          return match;
        };
      }
      module.exports = patchedExec;
    }
  });

  // node_modules/core-js/modules/es6.regexp.exec.js
  var require_es6_regexp_exec = __commonJS({
    "node_modules/core-js/modules/es6.regexp.exec.js"() {
      "use strict";
      var regexpExec = require_regexp_exec();
      require_export()({
        target: "RegExp",
        proto: true,
        forced: regexpExec !== /./.exec
      }, {
        exec: regexpExec
      });
    }
  });

  // node_modules/core-js/modules/es6.regexp.flags.js
  var require_es6_regexp_flags = __commonJS({
    "node_modules/core-js/modules/es6.regexp.flags.js"() {
      if (require_descriptors() && /./g.flags != "g") require_object_dp().f(RegExp.prototype, "flags", {
        configurable: true,
        get: require_flags()
      });
    }
  });

  // node_modules/core-js/modules/es6.regexp.to-string.js
  var require_es6_regexp_to_string = __commonJS({
    "node_modules/core-js/modules/es6.regexp.to-string.js"() {
      "use strict";
      require_es6_regexp_flags();
      var anObject = require_an_object();
      var $flags = require_flags();
      var DESCRIPTORS = require_descriptors();
      var TO_STRING = "toString";
      var $toString = /./[TO_STRING];
      var define2 = function(fn) {
        require_redefine()(RegExp.prototype, TO_STRING, fn, true);
      };
      if (require_fails()(function() {
        return $toString.call({ source: "a", flags: "b" }) != "/a/b";
      })) {
        define2(function toString() {
          var R = anObject(this);
          return "/".concat(
            R.source,
            "/",
            "flags" in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : void 0
          );
        });
      } else if ($toString.name != TO_STRING) {
        define2(function toString() {
          return $toString.call(this);
        });
      }
    }
  });

  // node_modules/core-js/modules/_advance-string-index.js
  var require_advance_string_index = __commonJS({
    "node_modules/core-js/modules/_advance-string-index.js"(exports, module) {
      "use strict";
      var at = require_string_at()(true);
      module.exports = function(S, index, unicode) {
        return index + (unicode ? at(S, index).length : 1);
      };
    }
  });

  // node_modules/core-js/modules/_regexp-exec-abstract.js
  var require_regexp_exec_abstract = __commonJS({
    "node_modules/core-js/modules/_regexp-exec-abstract.js"(exports, module) {
      "use strict";
      var classof = require_classof();
      var builtinExec = RegExp.prototype.exec;
      module.exports = function(R, S) {
        var exec = R.exec;
        if (typeof exec === "function") {
          var result = exec.call(R, S);
          if (typeof result !== "object") {
            throw new TypeError("RegExp exec method returned something other than an Object or null");
          }
          return result;
        }
        if (classof(R) !== "RegExp") {
          throw new TypeError("RegExp#exec called on incompatible receiver");
        }
        return builtinExec.call(R, S);
      };
    }
  });

  // node_modules/core-js/modules/_fix-re-wks.js
  var require_fix_re_wks = __commonJS({
    "node_modules/core-js/modules/_fix-re-wks.js"(exports, module) {
      "use strict";
      require_es6_regexp_exec();
      var redefine = require_redefine();
      var hide = require_hide();
      var fails = require_fails();
      var defined = require_defined();
      var wks = require_wks();
      var regexpExec = require_regexp_exec();
      var SPECIES = wks("species");
      var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
        var re = /./;
        re.exec = function() {
          var result = [];
          result.groups = { a: "7" };
          return result;
        };
        return "".replace(re, "$<a>") !== "7";
      });
      var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function() {
        var re = /(?:)/;
        var originalExec = re.exec;
        re.exec = function() {
          return originalExec.apply(this, arguments);
        };
        var result = "ab".split(re);
        return result.length === 2 && result[0] === "a" && result[1] === "b";
      }();
      module.exports = function(KEY, length, exec) {
        var SYMBOL = wks(KEY);
        var DELEGATES_TO_SYMBOL = !fails(function() {
          var O = {};
          O[SYMBOL] = function() {
            return 7;
          };
          return ""[KEY](O) != 7;
        });
        var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function() {
          var execCalled = false;
          var re = /a/;
          re.exec = function() {
            execCalled = true;
            return null;
          };
          if (KEY === "split") {
            re.constructor = {};
            re.constructor[SPECIES] = function() {
              return re;
            };
          }
          re[SYMBOL]("");
          return !execCalled;
        }) : void 0;
        if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === "replace" && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === "split" && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
          var nativeRegExpMethod = /./[SYMBOL];
          var fns = exec(
            defined,
            SYMBOL,
            ""[KEY],
            function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
              if (regexp.exec === regexpExec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                  return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
                }
                return { done: true, value: nativeMethod.call(str, regexp, arg2) };
              }
              return { done: false };
            }
          );
          var strfn = fns[0];
          var rxfn = fns[1];
          redefine(String.prototype, KEY, strfn);
          hide(
            RegExp.prototype,
            SYMBOL,
            length == 2 ? function(string, arg) {
              return rxfn.call(string, this, arg);
            } : function(string) {
              return rxfn.call(string, this);
            }
          );
        }
      };
    }
  });

  // node_modules/core-js/modules/es6.regexp.match.js
  var require_es6_regexp_match = __commonJS({
    "node_modules/core-js/modules/es6.regexp.match.js"() {
      "use strict";
      var anObject = require_an_object();
      var toLength = require_to_length();
      var advanceStringIndex = require_advance_string_index();
      var regExpExec = require_regexp_exec_abstract();
      require_fix_re_wks()("match", 1, function(defined, MATCH, $match, maybeCallNative) {
        return [
          // `String.prototype.match` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.match
          function match(regexp) {
            var O = defined(this);
            var fn = regexp == void 0 ? void 0 : regexp[MATCH];
            return fn !== void 0 ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
          },
          // `RegExp.prototype[@@match]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
          function(regexp) {
            var res = maybeCallNative($match, regexp, this);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            if (!rx.global) return regExpExec(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while ((result = regExpExec(rx, S)) !== null) {
              var matchStr = String(result[0]);
              A[n] = matchStr;
              if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
              n++;
            }
            return n === 0 ? null : A;
          }
        ];
      });
    }
  });

  // node_modules/core-js/modules/es6.regexp.replace.js
  var require_es6_regexp_replace = __commonJS({
    "node_modules/core-js/modules/es6.regexp.replace.js"() {
      "use strict";
      var anObject = require_an_object();
      var toObject = require_to_object();
      var toLength = require_to_length();
      var toInteger = require_to_integer();
      var advanceStringIndex = require_advance_string_index();
      var regExpExec = require_regexp_exec_abstract();
      var max = Math.max;
      var min = Math.min;
      var floor = Math.floor;
      var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
      var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
      var maybeToString = function(it) {
        return it === void 0 ? it : String(it);
      };
      require_fix_re_wks()("replace", 2, function(defined, REPLACE, $replace, maybeCallNative) {
        return [
          // `String.prototype.replace` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.replace
          function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == void 0 ? void 0 : searchValue[REPLACE];
            return fn !== void 0 ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
          },
          // `RegExp.prototype[@@replace]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
          function(regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === "function";
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global2 = rx.global;
            if (global2) {
              var fullUnicode = rx.unicode;
              rx.lastIndex = 0;
            }
            var results = [];
            while (true) {
              var result = regExpExec(rx, S);
              if (result === null) break;
              results.push(result);
              if (!global2) break;
              var matchStr = String(result[0]);
              if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for (var i = 0; i < results.length; i++) {
              result = results[i];
              var matched = String(result[0]);
              var position = max(min(toInteger(result.index), S.length), 0);
              var captures = [];
              for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
              var namedCaptures = result.groups;
              if (functionalReplace) {
                var replacerArgs = [matched].concat(captures, position, S);
                if (namedCaptures !== void 0) replacerArgs.push(namedCaptures);
                var replacement = String(replaceValue.apply(void 0, replacerArgs));
              } else {
                replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
              }
              if (position >= nextSourcePosition) {
                accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                nextSourcePosition = position + matched.length;
              }
            }
            return accumulatedResult + S.slice(nextSourcePosition);
          }
        ];
        function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
          var tailPos = position + matched.length;
          var m = captures.length;
          var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
          if (namedCaptures !== void 0) {
            namedCaptures = toObject(namedCaptures);
            symbols = SUBSTITUTION_SYMBOLS;
          }
          return $replace.call(replacement, symbols, function(match, ch) {
            var capture;
            switch (ch.charAt(0)) {
              case "$":
                return "$";
              case "&":
                return matched;
              case "`":
                return str.slice(0, position);
              case "'":
                return str.slice(tailPos);
              case "<":
                capture = namedCaptures[ch.slice(1, -1)];
                break;
              default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                  var f = floor(n / 10);
                  if (f === 0) return match;
                  if (f <= m) return captures[f - 1] === void 0 ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                  return match;
                }
                capture = captures[n - 1];
            }
            return capture === void 0 ? "" : capture;
          });
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.regexp.search.js
  var require_es6_regexp_search = __commonJS({
    "node_modules/core-js/modules/es6.regexp.search.js"() {
      "use strict";
      var anObject = require_an_object();
      var sameValue = require_same_value();
      var regExpExec = require_regexp_exec_abstract();
      require_fix_re_wks()("search", 1, function(defined, SEARCH, $search, maybeCallNative) {
        return [
          // `String.prototype.search` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.search
          function search(regexp) {
            var O = defined(this);
            var fn = regexp == void 0 ? void 0 : regexp[SEARCH];
            return fn !== void 0 ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
          },
          // `RegExp.prototype[@@search]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
          function(regexp) {
            var res = maybeCallNative($search, regexp, this);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var previousLastIndex = rx.lastIndex;
            if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = regExpExec(rx, S);
            if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
          }
        ];
      });
    }
  });

  // node_modules/core-js/modules/_species-constructor.js
  var require_species_constructor = __commonJS({
    "node_modules/core-js/modules/_species-constructor.js"(exports, module) {
      var anObject = require_an_object();
      var aFunction = require_a_function();
      var SPECIES = require_wks()("species");
      module.exports = function(O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === void 0 || (S = anObject(C)[SPECIES]) == void 0 ? D : aFunction(S);
      };
    }
  });

  // node_modules/core-js/modules/es6.regexp.split.js
  var require_es6_regexp_split = __commonJS({
    "node_modules/core-js/modules/es6.regexp.split.js"() {
      "use strict";
      var isRegExp = require_is_regexp();
      var anObject = require_an_object();
      var speciesConstructor = require_species_constructor();
      var advanceStringIndex = require_advance_string_index();
      var toLength = require_to_length();
      var callRegExpExec = require_regexp_exec_abstract();
      var regexpExec = require_regexp_exec();
      var fails = require_fails();
      var $min = Math.min;
      var $push = [].push;
      var $SPLIT = "split";
      var LENGTH = "length";
      var LAST_INDEX = "lastIndex";
      var MAX_UINT32 = 4294967295;
      var SUPPORTS_Y = !fails(function() {
        RegExp(MAX_UINT32, "y");
      });
      require_fix_re_wks()("split", 2, function(defined, SPLIT, $split, maybeCallNative) {
        var internalSplit;
        if ("abbc"[$SPLIT](/(b)*/)[1] == "c" || "test"[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || "ab"[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || "."[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || "."[$SPLIT](/()()/)[LENGTH] > 1 || ""[$SPLIT](/.?/)[LENGTH]) {
          internalSplit = function(separator, limit) {
            var string = String(this);
            if (separator === void 0 && limit === 0) return [];
            if (!isRegExp(separator)) return $split.call(string, separator, limit);
            var output = [];
            var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
            var lastLastIndex = 0;
            var splitLimit = limit === void 0 ? MAX_UINT32 : limit >>> 0;
            var separatorCopy = new RegExp(separator.source, flags + "g");
            var match, lastIndex, lastLength;
            while (match = regexpExec.call(separatorCopy, string)) {
              lastIndex = separatorCopy[LAST_INDEX];
              if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                lastLength = match[0][LENGTH];
                lastLastIndex = lastIndex;
                if (output[LENGTH] >= splitLimit) break;
              }
              if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++;
            }
            if (lastLastIndex === string[LENGTH]) {
              if (lastLength || !separatorCopy.test("")) output.push("");
            } else output.push(string.slice(lastLastIndex));
            return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
          };
        } else if ("0"[$SPLIT](void 0, 0)[LENGTH]) {
          internalSplit = function(separator, limit) {
            return separator === void 0 && limit === 0 ? [] : $split.call(this, separator, limit);
          };
        } else {
          internalSplit = $split;
        }
        return [
          // `String.prototype.split` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.split
          function split(separator, limit) {
            var O = defined(this);
            var splitter = separator == void 0 ? void 0 : separator[SPLIT];
            return splitter !== void 0 ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
          },
          // `RegExp.prototype[@@split]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
          //
          // NOTE: This cannot be properly polyfilled in engines that don't support
          // the 'y' flag.
          function(regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var C = speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + (SUPPORTS_Y ? "y" : "g");
            var splitter = new C(SUPPORTS_Y ? rx : "^(?:" + rx.source + ")", flags);
            var lim = limit === void 0 ? MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while (q < S.length) {
              splitter.lastIndex = SUPPORTS_Y ? q : 0;
              var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
              var e;
              if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
                q = advanceStringIndex(S, q, unicodeMatching);
              } else {
                A.push(S.slice(p, q));
                if (A.length === lim) return A;
                for (var i = 1; i <= z.length - 1; i++) {
                  A.push(z[i]);
                  if (A.length === lim) return A;
                }
                q = p = e;
              }
            }
            A.push(S.slice(p));
            return A;
          }
        ];
      });
    }
  });

  // node_modules/core-js/modules/_an-instance.js
  var require_an_instance = __commonJS({
    "node_modules/core-js/modules/_an-instance.js"(exports, module) {
      module.exports = function(it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || forbiddenField !== void 0 && forbiddenField in it) {
          throw TypeError(name + ": incorrect invocation!");
        }
        return it;
      };
    }
  });

  // node_modules/core-js/modules/_for-of.js
  var require_for_of = __commonJS({
    "node_modules/core-js/modules/_for-of.js"(exports, module) {
      var ctx = require_ctx();
      var call = require_iter_call();
      var isArrayIter = require_is_array_iter();
      var anObject = require_an_object();
      var toLength = require_to_length();
      var getIterFn = require_core_get_iterator_method();
      var BREAK = {};
      var RETURN = {};
      var exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
        var iterFn = ITERATOR ? function() {
          return iterable;
        } : getIterFn(iterable);
        var f = ctx(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn != "function") throw TypeError(iterable + " is not iterable!");
        if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
          result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
          if (result === BREAK || result === RETURN) return result;
        }
        else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done; ) {
          result = call(iterator, f, step.value, entries);
          if (result === BREAK || result === RETURN) return result;
        }
      };
      exports.BREAK = BREAK;
      exports.RETURN = RETURN;
    }
  });

  // node_modules/core-js/modules/_task.js
  var require_task = __commonJS({
    "node_modules/core-js/modules/_task.js"(exports, module) {
      var ctx = require_ctx();
      var invoke = require_invoke();
      var html = require_html();
      var cel = require_dom_create();
      var global2 = require_global();
      var process = global2.process;
      var setTask = global2.setImmediate;
      var clearTask = global2.clearImmediate;
      var MessageChannel = global2.MessageChannel;
      var Dispatch = global2.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = "onreadystatechange";
      var defer;
      var channel;
      var port;
      var run = function() {
        var id = +this;
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      var listener = function(event2) {
        run.call(event2.data);
      };
      if (!setTask || !clearTask) {
        setTask = function setImmediate(fn) {
          var args = [];
          var i = 1;
          while (arguments.length > i) args.push(arguments[i++]);
          queue[++counter] = function() {
            invoke(typeof fn == "function" ? fn : Function(fn), args);
          };
          defer(counter);
          return counter;
        };
        clearTask = function clearImmediate(id) {
          delete queue[id];
        };
        if (require_cof()(process) == "process") {
          defer = function(id) {
            process.nextTick(ctx(run, id, 1));
          };
        } else if (Dispatch && Dispatch.now) {
          defer = function(id) {
            Dispatch.now(ctx(run, id, 1));
          };
        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = ctx(port.postMessage, port, 1);
        } else if (global2.addEventListener && typeof postMessage == "function" && !global2.importScripts) {
          defer = function(id) {
            global2.postMessage(id + "", "*");
          };
          global2.addEventListener("message", listener, false);
        } else if (ONREADYSTATECHANGE in cel("script")) {
          defer = function(id) {
            html.appendChild(cel("script"))[ONREADYSTATECHANGE] = function() {
              html.removeChild(this);
              run.call(id);
            };
          };
        } else {
          defer = function(id) {
            setTimeout(ctx(run, id, 1), 0);
          };
        }
      }
      module.exports = {
        set: setTask,
        clear: clearTask
      };
    }
  });

  // node_modules/core-js/modules/_microtask.js
  var require_microtask = __commonJS({
    "node_modules/core-js/modules/_microtask.js"(exports, module) {
      var global2 = require_global();
      var macrotask = require_task().set;
      var Observer = global2.MutationObserver || global2.WebKitMutationObserver;
      var process = global2.process;
      var Promise2 = global2.Promise;
      var isNode = require_cof()(process) == "process";
      module.exports = function() {
        var head, last, notify;
        var flush = function() {
          var parent, fn;
          if (isNode && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (e) {
              if (head) notify();
              else last = void 0;
              throw e;
            }
          }
          last = void 0;
          if (parent) parent.enter();
        };
        if (isNode) {
          notify = function() {
            process.nextTick(flush);
          };
        } else if (Observer && !(global2.navigator && global2.navigator.standalone)) {
          var toggle = true;
          var node = document.createTextNode("");
          new Observer(flush).observe(node, { characterData: true });
          notify = function() {
            node.data = toggle = !toggle;
          };
        } else if (Promise2 && Promise2.resolve) {
          var promise = Promise2.resolve(void 0);
          notify = function() {
            promise.then(flush);
          };
        } else {
          notify = function() {
            macrotask.call(global2, flush);
          };
        }
        return function(fn) {
          var task = { fn, next: void 0 };
          if (last) last.next = task;
          if (!head) {
            head = task;
            notify();
          }
          last = task;
        };
      };
    }
  });

  // node_modules/core-js/modules/_new-promise-capability.js
  var require_new_promise_capability = __commonJS({
    "node_modules/core-js/modules/_new-promise-capability.js"(exports, module) {
      "use strict";
      var aFunction = require_a_function();
      function PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function($$resolve, $$reject) {
          if (resolve !== void 0 || reject !== void 0) throw TypeError("Bad Promise constructor");
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      }
      module.exports.f = function(C) {
        return new PromiseCapability(C);
      };
    }
  });

  // node_modules/core-js/modules/_perform.js
  var require_perform = __commonJS({
    "node_modules/core-js/modules/_perform.js"(exports, module) {
      module.exports = function(exec) {
        try {
          return { e: false, v: exec() };
        } catch (e) {
          return { e: true, v: e };
        }
      };
    }
  });

  // node_modules/core-js/modules/_user-agent.js
  var require_user_agent = __commonJS({
    "node_modules/core-js/modules/_user-agent.js"(exports, module) {
      var global2 = require_global();
      var navigator2 = global2.navigator;
      module.exports = navigator2 && navigator2.userAgent || "";
    }
  });

  // node_modules/core-js/modules/_promise-resolve.js
  var require_promise_resolve = __commonJS({
    "node_modules/core-js/modules/_promise-resolve.js"(exports, module) {
      var anObject = require_an_object();
      var isObject = require_is_object();
      var newPromiseCapability = require_new_promise_capability();
      module.exports = function(C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };
    }
  });

  // node_modules/core-js/modules/_redefine-all.js
  var require_redefine_all = __commonJS({
    "node_modules/core-js/modules/_redefine-all.js"(exports, module) {
      var redefine = require_redefine();
      module.exports = function(target, src, safe) {
        for (var key in src) redefine(target, key, src[key], safe);
        return target;
      };
    }
  });

  // node_modules/core-js/modules/es6.promise.js
  var require_es6_promise = __commonJS({
    "node_modules/core-js/modules/es6.promise.js"() {
      "use strict";
      var LIBRARY = require_library();
      var global2 = require_global();
      var ctx = require_ctx();
      var classof = require_classof();
      var $export = require_export();
      var isObject = require_is_object();
      var aFunction = require_a_function();
      var anInstance = require_an_instance();
      var forOf = require_for_of();
      var speciesConstructor = require_species_constructor();
      var task = require_task().set;
      var microtask = require_microtask()();
      var newPromiseCapabilityModule = require_new_promise_capability();
      var perform = require_perform();
      var userAgent = require_user_agent();
      var promiseResolve = require_promise_resolve();
      var PROMISE = "Promise";
      var TypeError2 = global2.TypeError;
      var process = global2.process;
      var versions = process && process.versions;
      var v8 = versions && versions.v8 || "";
      var $Promise = global2[PROMISE];
      var isNode = classof(process) == "process";
      var empty = function() {
      };
      var Internal;
      var newGenericPromiseCapability;
      var OwnPromiseCapability;
      var Wrapper;
      var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
      var USE_NATIVE = !!function() {
        try {
          var promise = $Promise.resolve(1);
          var FakePromise = (promise.constructor = {})[require_wks()("species")] = function(exec) {
            exec(empty, empty);
          };
          return (isNode || typeof PromiseRejectionEvent == "function") && promise.then(empty) instanceof FakePromise && v8.indexOf("6.6") !== 0 && userAgent.indexOf("Chrome/66") === -1;
        } catch (e) {
        }
      }();
      var isThenable = function(it) {
        var then;
        return isObject(it) && typeof (then = it.then) == "function" ? then : false;
      };
      var notify = function(promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        microtask(function() {
          var value = promise._v;
          var ok = promise._s == 1;
          var i = 0;
          var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
              if (handler) {
                if (!ok) {
                  if (promise._h == 2) onHandleUnhandled(promise);
                  promise._h = 1;
                }
                if (handler === true) result = value;
                else {
                  if (domain) domain.enter();
                  result = handler(value);
                  if (domain) {
                    domain.exit();
                    exited = true;
                  }
                }
                if (result === reaction.promise) {
                  reject(TypeError2("Promise-chain cycle"));
                } else if (then = isThenable(result)) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (e) {
              if (domain && !exited) domain.exit();
              reject(e);
            }
          };
          while (chain.length > i) run(chain[i++]);
          promise._c = [];
          promise._n = false;
          if (isReject && !promise._h) onUnhandled(promise);
        });
      };
      var onUnhandled = function(promise) {
        task.call(global2, function() {
          var value = promise._v;
          var unhandled = isUnhandled(promise);
          var result, handler, console2;
          if (unhandled) {
            result = perform(function() {
              if (isNode) {
                process.emit("unhandledRejection", value, promise);
              } else if (handler = global2.onunhandledrejection) {
                handler({ promise, reason: value });
              } else if ((console2 = global2.console) && console2.error) {
                console2.error("Unhandled promise rejection", value);
              }
            });
            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
          }
          promise._a = void 0;
          if (unhandled && result.e) throw result.v;
        });
      };
      var isUnhandled = function(promise) {
        return promise._h !== 1 && (promise._a || promise._c).length === 0;
      };
      var onHandleUnhandled = function(promise) {
        task.call(global2, function() {
          var handler;
          if (isNode) {
            process.emit("rejectionHandled", promise);
          } else if (handler = global2.onrejectionhandled) {
            handler({ promise, reason: promise._v });
          }
        });
      };
      var $reject = function(value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise;
        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        notify(promise, true);
      };
      var $resolve = function(value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise;
        try {
          if (promise === value) throw TypeError2("Promise can't be resolved itself");
          if (then = isThenable(value)) {
            microtask(function() {
              var wrapper = { _w: promise, _d: false };
              try {
                then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
              } catch (e) {
                $reject.call(wrapper, e);
              }
            });
          } else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
          }
        } catch (e) {
          $reject.call({ _w: promise, _d: false }, e);
        }
      };
      if (!USE_NATIVE) {
        $Promise = function Promise2(executor) {
          anInstance(this, $Promise, PROMISE, "_h");
          aFunction(executor);
          Internal.call(this);
          try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
          } catch (err) {
            $reject.call(this, err);
          }
        };
        Internal = function Promise2(executor) {
          this._c = [];
          this._a = void 0;
          this._s = 0;
          this._d = false;
          this._v = void 0;
          this._h = 0;
          this._n = false;
        };
        Internal.prototype = require_redefine_all()($Promise.prototype, {
          // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
          then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
            reaction.ok = typeof onFulfilled == "function" ? onFulfilled : true;
            reaction.fail = typeof onRejected == "function" && onRejected;
            reaction.domain = isNode ? process.domain : void 0;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) notify(this, false);
            return reaction.promise;
          },
          // 25.4.5.1 Promise.prototype.catch(onRejected)
          "catch": function(onRejected) {
            return this.then(void 0, onRejected);
          }
        });
        OwnPromiseCapability = function() {
          var promise = new Internal();
          this.promise = promise;
          this.resolve = ctx($resolve, promise, 1);
          this.reject = ctx($reject, promise, 1);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
          return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
      }
      $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
      require_set_to_string_tag()($Promise, PROMISE);
      require_set_species()(PROMISE);
      Wrapper = require_core()[PROMISE];
      $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
        // 25.4.4.5 Promise.reject(r)
        reject: function reject(r2) {
          var capability = newPromiseCapability(this);
          var $$reject = capability.reject;
          $$reject(r2);
          return capability.promise;
        }
      });
      $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
        // 25.4.4.6 Promise.resolve(x)
        resolve: function resolve(x) {
          return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
        }
      });
      $export($export.S + $export.F * !(USE_NATIVE && require_iter_detect()(function(iter) {
        $Promise.all(iter)["catch"](empty);
      })), PROMISE, {
        // 25.4.4.1 Promise.all(iterable)
        all: function all(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            forOf(iterable, false, function(promise) {
              var $index = index++;
              var alreadyCalled = false;
              values.push(void 0);
              remaining++;
              C.resolve(promise).then(function(value) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[$index] = value;
                --remaining || resolve(values);
              }, reject);
            });
            --remaining || resolve(values);
          });
          if (result.e) reject(result.v);
          return capability.promise;
        },
        // 25.4.4.4 Promise.race(iterable)
        race: function race(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var reject = capability.reject;
          var result = perform(function() {
            forOf(iterable, false, function(promise) {
              C.resolve(promise).then(capability.resolve, reject);
            });
          });
          if (result.e) reject(result.v);
          return capability.promise;
        }
      });
    }
  });

  // node_modules/core-js/modules/_validate-collection.js
  var require_validate_collection = __commonJS({
    "node_modules/core-js/modules/_validate-collection.js"(exports, module) {
      var isObject = require_is_object();
      module.exports = function(it, TYPE) {
        if (!isObject(it) || it._t !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required!");
        return it;
      };
    }
  });

  // node_modules/core-js/modules/_collection-strong.js
  var require_collection_strong = __commonJS({
    "node_modules/core-js/modules/_collection-strong.js"(exports, module) {
      "use strict";
      var dP = require_object_dp().f;
      var create = require_object_create();
      var redefineAll = require_redefine_all();
      var ctx = require_ctx();
      var anInstance = require_an_instance();
      var forOf = require_for_of();
      var $iterDefine = require_iter_define();
      var step = require_iter_step();
      var setSpecies = require_set_species();
      var DESCRIPTORS = require_descriptors();
      var fastKey = require_meta().fastKey;
      var validate = require_validate_collection();
      var SIZE = DESCRIPTORS ? "_s" : "size";
      var getEntry = function(that, key) {
        var index = fastKey(key);
        var entry;
        if (index !== "F") return that._i[index];
        for (entry = that._f; entry; entry = entry.n) {
          if (entry.k == key) return entry;
        }
      };
      module.exports = {
        getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function(that, iterable) {
            anInstance(that, C, NAME, "_i");
            that._t = NAME;
            that._i = create(null);
            that._f = void 0;
            that._l = void 0;
            that[SIZE] = 0;
            if (iterable != void 0) forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
              for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
                entry.r = true;
                if (entry.p) entry.p = entry.p.n = void 0;
                delete data[entry.i];
              }
              that._f = that._l = void 0;
              that[SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            "delete": function(key) {
              var that = validate(this, NAME);
              var entry = getEntry(that, key);
              if (entry) {
                var next = entry.n;
                var prev = entry.p;
                delete that._i[entry.i];
                entry.r = true;
                if (prev) prev.n = next;
                if (next) next.p = prev;
                if (that._f == entry) that._f = next;
                if (that._l == entry) that._l = prev;
                that[SIZE]--;
              }
              return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn) {
              validate(this, NAME);
              var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : void 0, 3);
              var entry;
              while (entry = entry ? entry.n : this._f) {
                f(entry.v, entry.k, this);
                while (entry && entry.r) entry = entry.p;
              }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
              return !!getEntry(validate(this, NAME), key);
            }
          });
          if (DESCRIPTORS) dP(C.prototype, "size", {
            get: function() {
              return validate(this, NAME)[SIZE];
            }
          });
          return C;
        },
        def: function(that, key, value) {
          var entry = getEntry(that, key);
          var prev, index;
          if (entry) {
            entry.v = value;
          } else {
            that._l = entry = {
              i: index = fastKey(key, true),
              // <- index
              k: key,
              // <- key
              v: value,
              // <- value
              p: prev = that._l,
              // <- previous entry
              n: void 0,
              // <- next entry
              r: false
              // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[SIZE]++;
            if (index !== "F") that._i[index] = entry;
          }
          return that;
        },
        getEntry,
        setStrong: function(C, NAME, IS_MAP) {
          $iterDefine(C, NAME, function(iterated, kind) {
            this._t = validate(iterated, NAME);
            this._k = kind;
            this._l = void 0;
          }, function() {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            while (entry && entry.r) entry = entry.p;
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
              that._t = void 0;
              return step(1);
            }
            if (kind == "keys") return step(0, entry.k);
            if (kind == "values") return step(0, entry.v);
            return step(0, [entry.k, entry.v]);
          }, IS_MAP ? "entries" : "values", !IS_MAP, true);
          setSpecies(NAME);
        }
      };
    }
  });

  // node_modules/core-js/modules/_collection.js
  var require_collection = __commonJS({
    "node_modules/core-js/modules/_collection.js"(exports, module) {
      "use strict";
      var global2 = require_global();
      var $export = require_export();
      var redefine = require_redefine();
      var redefineAll = require_redefine_all();
      var meta = require_meta();
      var forOf = require_for_of();
      var anInstance = require_an_instance();
      var isObject = require_is_object();
      var fails = require_fails();
      var $iterDetect = require_iter_detect();
      var setToStringTag = require_set_to_string_tag();
      var inheritIfRequired = require_inherit_if_required();
      module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
        var Base = global2[NAME];
        var C = Base;
        var ADDER = IS_MAP ? "set" : "add";
        var proto = C && C.prototype;
        var O = {};
        var fixMethod = function(KEY) {
          var fn = proto[KEY];
          redefine(
            proto,
            KEY,
            KEY == "delete" ? function(a) {
              return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
            } : KEY == "has" ? function has(a) {
              return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
            } : KEY == "get" ? function get(a) {
              return IS_WEAK && !isObject(a) ? void 0 : fn.call(this, a === 0 ? 0 : a);
            } : KEY == "add" ? function add(a) {
              fn.call(this, a === 0 ? 0 : a);
              return this;
            } : function set(a, b) {
              fn.call(this, a === 0 ? 0 : a, b);
              return this;
            }
          );
        };
        if (typeof C != "function" || !(IS_WEAK || proto.forEach && !fails(function() {
          new C().entries().next();
        }))) {
          C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
          redefineAll(C.prototype, methods);
          meta.NEED = true;
        } else {
          var instance = new C();
          var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
          var THROWS_ON_PRIMITIVES = fails(function() {
            instance.has(1);
          });
          var ACCEPT_ITERABLES = $iterDetect(function(iter) {
            new C(iter);
          });
          var BUGGY_ZERO = !IS_WEAK && fails(function() {
            var $instance = new C();
            var index = 5;
            while (index--) $instance[ADDER](index, index);
            return !$instance.has(-0);
          });
          if (!ACCEPT_ITERABLES) {
            C = wrapper(function(target, iterable) {
              anInstance(target, C, NAME);
              var that = inheritIfRequired(new Base(), target, C);
              if (iterable != void 0) forOf(iterable, IS_MAP, that[ADDER], that);
              return that;
            });
            C.prototype = proto;
            proto.constructor = C;
          }
          if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
          }
          if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
          if (IS_WEAK && proto.clear) delete proto.clear;
        }
        setToStringTag(C, NAME);
        O[NAME] = C;
        $export($export.G + $export.W + $export.F * (C != Base), O);
        if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
        return C;
      };
    }
  });

  // node_modules/core-js/modules/es6.map.js
  var require_es6_map = __commonJS({
    "node_modules/core-js/modules/es6.map.js"(exports, module) {
      "use strict";
      var strong = require_collection_strong();
      var validate = require_validate_collection();
      var MAP = "Map";
      module.exports = require_collection()(MAP, function(get) {
        return function Map() {
          return get(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      }, {
        // 23.1.3.6 Map.prototype.get(key)
        get: function get(key) {
          var entry = strong.getEntry(validate(this, MAP), key);
          return entry && entry.v;
        },
        // 23.1.3.9 Map.prototype.set(key, value)
        set: function set(key, value) {
          return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
        }
      }, strong, true);
    }
  });

  // node_modules/core-js/modules/es6.set.js
  var require_es6_set = __commonJS({
    "node_modules/core-js/modules/es6.set.js"(exports, module) {
      "use strict";
      var strong = require_collection_strong();
      var validate = require_validate_collection();
      var SET = "Set";
      module.exports = require_collection()(SET, function(get) {
        return function Set2() {
          return get(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      }, {
        // 23.2.3.1 Set.prototype.add(value)
        add: function add(value) {
          return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
        }
      }, strong);
    }
  });

  // node_modules/core-js/modules/_collection-weak.js
  var require_collection_weak = __commonJS({
    "node_modules/core-js/modules/_collection-weak.js"(exports, module) {
      "use strict";
      var redefineAll = require_redefine_all();
      var getWeak = require_meta().getWeak;
      var anObject = require_an_object();
      var isObject = require_is_object();
      var anInstance = require_an_instance();
      var forOf = require_for_of();
      var createArrayMethod = require_array_methods();
      var $has = require_has();
      var validate = require_validate_collection();
      var arrayFind = createArrayMethod(5);
      var arrayFindIndex = createArrayMethod(6);
      var id = 0;
      var uncaughtFrozenStore = function(that) {
        return that._l || (that._l = new UncaughtFrozenStore());
      };
      var UncaughtFrozenStore = function() {
        this.a = [];
      };
      var findUncaughtFrozen = function(store, key) {
        return arrayFind(store.a, function(it) {
          return it[0] === key;
        });
      };
      UncaughtFrozenStore.prototype = {
        get: function(key) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) return entry[1];
        },
        has: function(key) {
          return !!findUncaughtFrozen(this, key);
        },
        set: function(key, value) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) entry[1] = value;
          else this.a.push([key, value]);
        },
        "delete": function(key) {
          var index = arrayFindIndex(this.a, function(it) {
            return it[0] === key;
          });
          if (~index) this.a.splice(index, 1);
          return !!~index;
        }
      };
      module.exports = {
        getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function(that, iterable) {
            anInstance(that, C, NAME, "_i");
            that._t = NAME;
            that._i = id++;
            that._l = void 0;
            if (iterable != void 0) forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            "delete": function(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME))["delete"](key);
              return data && $has(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
              return data && $has(data, this._i);
            }
          });
          return C;
        },
        def: function(that, key, value) {
          var data = getWeak(anObject(key), true);
          if (data === true) uncaughtFrozenStore(that).set(key, value);
          else data[that._i] = value;
          return that;
        },
        ufstore: uncaughtFrozenStore
      };
    }
  });

  // node_modules/core-js/modules/es6.weak-map.js
  var require_es6_weak_map = __commonJS({
    "node_modules/core-js/modules/es6.weak-map.js"(exports, module) {
      "use strict";
      var global2 = require_global();
      var each = require_array_methods()(0);
      var redefine = require_redefine();
      var meta = require_meta();
      var assign = require_object_assign();
      var weak = require_collection_weak();
      var isObject = require_is_object();
      var validate = require_validate_collection();
      var NATIVE_WEAK_MAP = require_validate_collection();
      var IS_IE11 = !global2.ActiveXObject && "ActiveXObject" in global2;
      var WEAK_MAP = "WeakMap";
      var getWeak = meta.getWeak;
      var isExtensible = Object.isExtensible;
      var uncaughtFrozenStore = weak.ufstore;
      var InternalMap;
      var wrapper = function(get) {
        return function WeakMap() {
          return get(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      };
      var methods = {
        // 23.3.3.3 WeakMap.prototype.get(key)
        get: function get(key) {
          if (isObject(key)) {
            var data = getWeak(key);
            if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
            return data ? data[this._i] : void 0;
          }
        },
        // 23.3.3.5 WeakMap.prototype.set(key, value)
        set: function set(key, value) {
          return weak.def(validate(this, WEAK_MAP), key, value);
        }
      };
      var $WeakMap = module.exports = require_collection()(WEAK_MAP, wrapper, methods, weak, true, true);
      if (NATIVE_WEAK_MAP && IS_IE11) {
        InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
        assign(InternalMap.prototype, methods);
        meta.NEED = true;
        each(["delete", "has", "get", "set"], function(key) {
          var proto = $WeakMap.prototype;
          var method = proto[key];
          redefine(proto, key, function(a, b) {
            if (isObject(a) && !isExtensible(a)) {
              if (!this._f) this._f = new InternalMap();
              var result = this._f[key](a, b);
              return key == "set" ? this : result;
            }
            return method.call(this, a, b);
          });
        });
      }
    }
  });

  // node_modules/core-js/modules/es6.weak-set.js
  var require_es6_weak_set = __commonJS({
    "node_modules/core-js/modules/es6.weak-set.js"() {
      "use strict";
      var weak = require_collection_weak();
      var validate = require_validate_collection();
      var WEAK_SET = "WeakSet";
      require_collection()(WEAK_SET, function(get) {
        return function WeakSet2() {
          return get(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      }, {
        // 23.4.3.1 WeakSet.prototype.add(value)
        add: function add(value) {
          return weak.def(validate(this, WEAK_SET), value, true);
        }
      }, weak, false, true);
    }
  });

  // node_modules/core-js/modules/_typed.js
  var require_typed = __commonJS({
    "node_modules/core-js/modules/_typed.js"(exports, module) {
      var global2 = require_global();
      var hide = require_hide();
      var uid = require_uid();
      var TYPED = uid("typed_array");
      var VIEW = uid("view");
      var ABV = !!(global2.ArrayBuffer && global2.DataView);
      var CONSTR = ABV;
      var i = 0;
      var l = 9;
      var Typed;
      var TypedArrayConstructors = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");
      while (i < l) {
        if (Typed = global2[TypedArrayConstructors[i++]]) {
          hide(Typed.prototype, TYPED, true);
          hide(Typed.prototype, VIEW, true);
        } else CONSTR = false;
      }
      module.exports = {
        ABV,
        CONSTR,
        TYPED,
        VIEW
      };
    }
  });

  // node_modules/core-js/modules/_to-index.js
  var require_to_index = __commonJS({
    "node_modules/core-js/modules/_to-index.js"(exports, module) {
      var toInteger = require_to_integer();
      var toLength = require_to_length();
      module.exports = function(it) {
        if (it === void 0) return 0;
        var number = toInteger(it);
        var length = toLength(number);
        if (number !== length) throw RangeError("Wrong length!");
        return length;
      };
    }
  });

  // node_modules/core-js/modules/_typed-buffer.js
  var require_typed_buffer = __commonJS({
    "node_modules/core-js/modules/_typed-buffer.js"(exports) {
      "use strict";
      var global2 = require_global();
      var DESCRIPTORS = require_descriptors();
      var LIBRARY = require_library();
      var $typed = require_typed();
      var hide = require_hide();
      var redefineAll = require_redefine_all();
      var fails = require_fails();
      var anInstance = require_an_instance();
      var toInteger = require_to_integer();
      var toLength = require_to_length();
      var toIndex = require_to_index();
      var gOPN = require_object_gopn().f;
      var dP = require_object_dp().f;
      var arrayFill = require_array_fill();
      var setToStringTag = require_set_to_string_tag();
      var ARRAY_BUFFER = "ArrayBuffer";
      var DATA_VIEW = "DataView";
      var PROTOTYPE = "prototype";
      var WRONG_LENGTH = "Wrong length!";
      var WRONG_INDEX = "Wrong index!";
      var $ArrayBuffer = global2[ARRAY_BUFFER];
      var $DataView = global2[DATA_VIEW];
      var Math2 = global2.Math;
      var RangeError2 = global2.RangeError;
      var Infinity2 = global2.Infinity;
      var BaseBuffer = $ArrayBuffer;
      var abs = Math2.abs;
      var pow = Math2.pow;
      var floor = Math2.floor;
      var log = Math2.log;
      var LN2 = Math2.LN2;
      var BUFFER = "buffer";
      var BYTE_LENGTH = "byteLength";
      var BYTE_OFFSET = "byteOffset";
      var $BUFFER = DESCRIPTORS ? "_b" : BUFFER;
      var $LENGTH = DESCRIPTORS ? "_l" : BYTE_LENGTH;
      var $OFFSET = DESCRIPTORS ? "_o" : BYTE_OFFSET;
      function packIEEE754(value, mLen, nBytes) {
        var buffer = new Array(nBytes);
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
        var i = 0;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        var e, m, c;
        value = abs(value);
        if (value != value || value === Infinity2) {
          m = value != value ? 1 : 0;
          e = eMax;
        } else {
          e = floor(log(value) / LN2);
          if (value * (c = pow(2, -e)) < 1) {
            e--;
            c *= 2;
          }
          if (e + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e++;
            c /= 2;
          }
          if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
          } else if (e + eBias >= 1) {
            m = (value * c - 1) * pow(2, mLen);
            e = e + eBias;
          } else {
            m = value * pow(2, eBias - 1) * pow(2, mLen);
            e = 0;
          }
        }
        for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) ;
        e = e << mLen | m;
        eLen += mLen;
        for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) ;
        buffer[--i] |= s * 128;
        return buffer;
      }
      function unpackIEEE754(buffer, mLen, nBytes) {
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = eLen - 7;
        var i = nBytes - 1;
        var s = buffer[i--];
        var e = s & 127;
        var m;
        s >>= 7;
        for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) ;
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) ;
        if (e === 0) {
          e = 1 - eBias;
        } else if (e === eMax) {
          return m ? NaN : s ? -Infinity2 : Infinity2;
        } else {
          m = m + pow(2, mLen);
          e = e - eBias;
        }
        return (s ? -1 : 1) * m * pow(2, e - mLen);
      }
      function unpackI32(bytes) {
        return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
      }
      function packI8(it) {
        return [it & 255];
      }
      function packI16(it) {
        return [it & 255, it >> 8 & 255];
      }
      function packI32(it) {
        return [it & 255, it >> 8 & 255, it >> 16 & 255, it >> 24 & 255];
      }
      function packF64(it) {
        return packIEEE754(it, 52, 8);
      }
      function packF32(it) {
        return packIEEE754(it, 23, 4);
      }
      function addGetter(C, key2, internal) {
        dP(C[PROTOTYPE], key2, { get: function() {
          return this[internal];
        } });
      }
      function get(view2, bytes, index, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view2[$LENGTH]) throw RangeError2(WRONG_INDEX);
        var store = view2[$BUFFER]._b;
        var start = intIndex + view2[$OFFSET];
        var pack = store.slice(start, start + bytes);
        return isLittleEndian ? pack : pack.reverse();
      }
      function set(view2, bytes, index, conversion, value, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view2[$LENGTH]) throw RangeError2(WRONG_INDEX);
        var store = view2[$BUFFER]._b;
        var start = intIndex + view2[$OFFSET];
        var pack = conversion(+value);
        for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
      }
      if (!$typed.ABV) {
        $ArrayBuffer = function ArrayBuffer(length) {
          anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
          var byteLength = toIndex(length);
          this._b = arrayFill.call(new Array(byteLength), 0);
          this[$LENGTH] = byteLength;
        };
        $DataView = function DataView(buffer, byteOffset, byteLength) {
          anInstance(this, $DataView, DATA_VIEW);
          anInstance(buffer, $ArrayBuffer, DATA_VIEW);
          var bufferLength = buffer[$LENGTH];
          var offset = toInteger(byteOffset);
          if (offset < 0 || offset > bufferLength) throw RangeError2("Wrong offset!");
          byteLength = byteLength === void 0 ? bufferLength - offset : toLength(byteLength);
          if (offset + byteLength > bufferLength) throw RangeError2(WRONG_LENGTH);
          this[$BUFFER] = buffer;
          this[$OFFSET] = offset;
          this[$LENGTH] = byteLength;
        };
        if (DESCRIPTORS) {
          addGetter($ArrayBuffer, BYTE_LENGTH, "_l");
          addGetter($DataView, BUFFER, "_b");
          addGetter($DataView, BYTE_LENGTH, "_l");
          addGetter($DataView, BYTE_OFFSET, "_o");
        }
        redefineAll($DataView[PROTOTYPE], {
          getInt8: function getInt8(byteOffset) {
            return get(this, 1, byteOffset)[0] << 24 >> 24;
          },
          getUint8: function getUint8(byteOffset) {
            return get(this, 1, byteOffset)[0];
          },
          getInt16: function getInt16(byteOffset) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
          },
          getUint16: function getUint16(byteOffset) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
          },
          getInt32: function getInt32(byteOffset) {
            return unpackI32(get(this, 4, byteOffset, arguments[1]));
          },
          getUint32: function getUint32(byteOffset) {
            return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
          },
          getFloat32: function getFloat32(byteOffset) {
            return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
          },
          getFloat64: function getFloat64(byteOffset) {
            return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
          },
          setInt8: function setInt8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setUint8: function setUint8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setInt16: function setInt16(byteOffset, value) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setUint16: function setUint16(byteOffset, value) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setInt32: function setInt32(byteOffset, value) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setUint32: function setUint32(byteOffset, value) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setFloat32: function setFloat32(byteOffset, value) {
            set(this, 4, byteOffset, packF32, value, arguments[2]);
          },
          setFloat64: function setFloat64(byteOffset, value) {
            set(this, 8, byteOffset, packF64, value, arguments[2]);
          }
        });
      } else {
        if (!fails(function() {
          $ArrayBuffer(1);
        }) || !fails(function() {
          new $ArrayBuffer(-1);
        }) || fails(function() {
          new $ArrayBuffer();
          new $ArrayBuffer(1.5);
          new $ArrayBuffer(NaN);
          return $ArrayBuffer.name != ARRAY_BUFFER;
        })) {
          $ArrayBuffer = function ArrayBuffer(length) {
            anInstance(this, $ArrayBuffer);
            return new BaseBuffer(toIndex(length));
          };
          ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
          for (keys = gOPN(BaseBuffer), j = 0; keys.length > j; ) {
            if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
          }
          if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
        }
        view = new $DataView(new $ArrayBuffer(2));
        $setInt8 = $DataView[PROTOTYPE].setInt8;
        view.setInt8(0, 2147483648);
        view.setInt8(1, 2147483649);
        if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
          setInt8: function setInt8(byteOffset, value) {
            $setInt8.call(this, byteOffset, value << 24 >> 24);
          },
          setUint8: function setUint8(byteOffset, value) {
            $setInt8.call(this, byteOffset, value << 24 >> 24);
          }
        }, true);
      }
      var ArrayBufferProto;
      var keys;
      var j;
      var key;
      var view;
      var $setInt8;
      setToStringTag($ArrayBuffer, ARRAY_BUFFER);
      setToStringTag($DataView, DATA_VIEW);
      hide($DataView[PROTOTYPE], $typed.VIEW, true);
      exports[ARRAY_BUFFER] = $ArrayBuffer;
      exports[DATA_VIEW] = $DataView;
    }
  });

  // node_modules/core-js/modules/es6.typed.array-buffer.js
  var require_es6_typed_array_buffer = __commonJS({
    "node_modules/core-js/modules/es6.typed.array-buffer.js"() {
      "use strict";
      var $export = require_export();
      var $typed = require_typed();
      var buffer = require_typed_buffer();
      var anObject = require_an_object();
      var toAbsoluteIndex = require_to_absolute_index();
      var toLength = require_to_length();
      var isObject = require_is_object();
      var ArrayBuffer = require_global().ArrayBuffer;
      var speciesConstructor = require_species_constructor();
      var $ArrayBuffer = buffer.ArrayBuffer;
      var $DataView = buffer.DataView;
      var $isView = $typed.ABV && ArrayBuffer.isView;
      var $slice = $ArrayBuffer.prototype.slice;
      var VIEW = $typed.VIEW;
      var ARRAY_BUFFER = "ArrayBuffer";
      $export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
      $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
        // 24.1.3.1 ArrayBuffer.isView(arg)
        isView: function isView(it) {
          return $isView && $isView(it) || isObject(it) && VIEW in it;
        }
      });
      $export($export.P + $export.U + $export.F * require_fails()(function() {
        return !new $ArrayBuffer(2).slice(1, void 0).byteLength;
      }), ARRAY_BUFFER, {
        // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
        slice: function slice(start, end) {
          if ($slice !== void 0 && end === void 0) return $slice.call(anObject(this), start);
          var len = anObject(this).byteLength;
          var first = toAbsoluteIndex(start, len);
          var fin = toAbsoluteIndex(end === void 0 ? len : end, len);
          var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
          var viewS = new $DataView(this);
          var viewT = new $DataView(result);
          var index = 0;
          while (first < fin) {
            viewT.setUint8(index++, viewS.getUint8(first++));
          }
          return result;
        }
      });
      require_set_species()(ARRAY_BUFFER);
    }
  });

  // node_modules/core-js/modules/es6.typed.data-view.js
  var require_es6_typed_data_view = __commonJS({
    "node_modules/core-js/modules/es6.typed.data-view.js"() {
      var $export = require_export();
      $export($export.G + $export.W + $export.F * !require_typed().ABV, {
        DataView: require_typed_buffer().DataView
      });
    }
  });

  // node_modules/core-js/modules/_typed-array.js
  var require_typed_array = __commonJS({
    "node_modules/core-js/modules/_typed-array.js"(exports, module) {
      "use strict";
      if (require_descriptors()) {
        LIBRARY = require_library();
        global2 = require_global();
        fails = require_fails();
        $export = require_export();
        $typed = require_typed();
        $buffer = require_typed_buffer();
        ctx = require_ctx();
        anInstance = require_an_instance();
        propertyDesc = require_property_desc();
        hide = require_hide();
        redefineAll = require_redefine_all();
        toInteger = require_to_integer();
        toLength = require_to_length();
        toIndex = require_to_index();
        toAbsoluteIndex = require_to_absolute_index();
        toPrimitive = require_to_primitive();
        has = require_has();
        classof = require_classof();
        isObject = require_is_object();
        toObject = require_to_object();
        isArrayIter = require_is_array_iter();
        create = require_object_create();
        getPrototypeOf = require_object_gpo();
        gOPN = require_object_gopn().f;
        getIterFn = require_core_get_iterator_method();
        uid = require_uid();
        wks = require_wks();
        createArrayMethod = require_array_methods();
        createArrayIncludes = require_array_includes();
        speciesConstructor = require_species_constructor();
        ArrayIterators = require_es6_array_iterator();
        Iterators = require_iterators();
        $iterDetect = require_iter_detect();
        setSpecies = require_set_species();
        arrayFill = require_array_fill();
        arrayCopyWithin = require_array_copy_within();
        $DP = require_object_dp();
        $GOPD = require_object_gopd();
        dP = $DP.f;
        gOPD = $GOPD.f;
        RangeError2 = global2.RangeError;
        TypeError2 = global2.TypeError;
        Uint8Array2 = global2.Uint8Array;
        ARRAY_BUFFER = "ArrayBuffer";
        SHARED_BUFFER = "Shared" + ARRAY_BUFFER;
        BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
        PROTOTYPE = "prototype";
        ArrayProto = Array[PROTOTYPE];
        $ArrayBuffer = $buffer.ArrayBuffer;
        $DataView = $buffer.DataView;
        arrayForEach = createArrayMethod(0);
        arrayFilter = createArrayMethod(2);
        arraySome = createArrayMethod(3);
        arrayEvery = createArrayMethod(4);
        arrayFind = createArrayMethod(5);
        arrayFindIndex = createArrayMethod(6);
        arrayIncludes = createArrayIncludes(true);
        arrayIndexOf = createArrayIncludes(false);
        arrayValues = ArrayIterators.values;
        arrayKeys = ArrayIterators.keys;
        arrayEntries = ArrayIterators.entries;
        arrayLastIndexOf = ArrayProto.lastIndexOf;
        arrayReduce = ArrayProto.reduce;
        arrayReduceRight = ArrayProto.reduceRight;
        arrayJoin = ArrayProto.join;
        arraySort = ArrayProto.sort;
        arraySlice = ArrayProto.slice;
        arrayToString = ArrayProto.toString;
        arrayToLocaleString = ArrayProto.toLocaleString;
        ITERATOR = wks("iterator");
        TAG = wks("toStringTag");
        TYPED_CONSTRUCTOR = uid("typed_constructor");
        DEF_CONSTRUCTOR = uid("def_constructor");
        ALL_CONSTRUCTORS = $typed.CONSTR;
        TYPED_ARRAY = $typed.TYPED;
        VIEW = $typed.VIEW;
        WRONG_LENGTH = "Wrong length!";
        $map = createArrayMethod(1, function(O, length) {
          return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
        });
        LITTLE_ENDIAN = fails(function() {
          return new Uint8Array2(new Uint16Array([1]).buffer)[0] === 1;
        });
        FORCED_SET = !!Uint8Array2 && !!Uint8Array2[PROTOTYPE].set && fails(function() {
          new Uint8Array2(1).set({});
        });
        toOffset = function(it, BYTES) {
          var offset = toInteger(it);
          if (offset < 0 || offset % BYTES) throw RangeError2("Wrong offset!");
          return offset;
        };
        validate = function(it) {
          if (isObject(it) && TYPED_ARRAY in it) return it;
          throw TypeError2(it + " is not a typed array!");
        };
        allocate = function(C, length) {
          if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
            throw TypeError2("It is not a typed array constructor!");
          }
          return new C(length);
        };
        speciesFromList = function(O, list) {
          return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
        };
        fromList = function(C, list) {
          var index = 0;
          var length = list.length;
          var result = allocate(C, length);
          while (length > index) result[index] = list[index++];
          return result;
        };
        addGetter = function(it, key, internal) {
          dP(it, key, { get: function() {
            return this._d[internal];
          } });
        };
        $from = function from(source) {
          var O = toObject(source);
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : void 0;
          var mapping = mapfn !== void 0;
          var iterFn = getIterFn(O);
          var i, length, values, result, step, iterator;
          if (iterFn != void 0 && !isArrayIter(iterFn)) {
            for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
              values.push(step.value);
            }
            O = values;
          }
          if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
          for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
            result[i] = mapping ? mapfn(O[i], i) : O[i];
          }
          return result;
        };
        $of = function of() {
          var index = 0;
          var length = arguments.length;
          var result = allocate(this, length);
          while (length > index) result[index] = arguments[index++];
          return result;
        };
        TO_LOCALE_BUG = !!Uint8Array2 && fails(function() {
          arrayToLocaleString.call(new Uint8Array2(1));
        });
        $toLocaleString = function toLocaleString() {
          return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
        };
        proto = {
          copyWithin: function copyWithin(target, start) {
            return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : void 0);
          },
          every: function every(callbackfn) {
            return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
          },
          fill: function fill(value) {
            return arrayFill.apply(validate(this), arguments);
          },
          filter: function filter(callbackfn) {
            return speciesFromList(this, arrayFilter(
              validate(this),
              callbackfn,
              arguments.length > 1 ? arguments[1] : void 0
            ));
          },
          find: function find(predicate) {
            return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : void 0);
          },
          findIndex: function findIndex(predicate) {
            return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : void 0);
          },
          forEach: function forEach(callbackfn) {
            arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
          },
          indexOf: function indexOf(searchElement) {
            return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : void 0);
          },
          includes: function includes(searchElement) {
            return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : void 0);
          },
          join: function join(separator) {
            return arrayJoin.apply(validate(this), arguments);
          },
          lastIndexOf: function lastIndexOf(searchElement) {
            return arrayLastIndexOf.apply(validate(this), arguments);
          },
          map: function map(mapfn) {
            return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : void 0);
          },
          reduce: function reduce(callbackfn) {
            return arrayReduce.apply(validate(this), arguments);
          },
          reduceRight: function reduceRight(callbackfn) {
            return arrayReduceRight.apply(validate(this), arguments);
          },
          reverse: function reverse() {
            var that = this;
            var length = validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while (index < middle) {
              value = that[index];
              that[index++] = that[--length];
              that[length] = value;
            }
            return that;
          },
          some: function some(callbackfn) {
            return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
          },
          sort: function sort(comparefn) {
            return arraySort.call(validate(this), comparefn);
          },
          subarray: function subarray(begin, end) {
            var O = validate(this);
            var length = O.length;
            var $begin = toAbsoluteIndex(begin, length);
            return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
              O.buffer,
              O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
              toLength((end === void 0 ? length : toAbsoluteIndex(end, length)) - $begin)
            );
          }
        };
        $slice = function slice(start, end) {
          return speciesFromList(this, arraySlice.call(validate(this), start, end));
        };
        $set = function set(arrayLike) {
          validate(this);
          var offset = toOffset(arguments[1], 1);
          var length = this.length;
          var src = toObject(arrayLike);
          var len = toLength(src.length);
          var index = 0;
          if (len + offset > length) throw RangeError2(WRONG_LENGTH);
          while (index < len) this[offset + index] = src[index++];
        };
        $iterators = {
          entries: function entries() {
            return arrayEntries.call(validate(this));
          },
          keys: function keys() {
            return arrayKeys.call(validate(this));
          },
          values: function values() {
            return arrayValues.call(validate(this));
          }
        };
        isTAIndex = function(target, key) {
          return isObject(target) && target[TYPED_ARRAY] && typeof key != "symbol" && key in target && String(+key) == String(key);
        };
        $getDesc = function getOwnPropertyDescriptor(target, key) {
          return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
        };
        $setDesc = function defineProperty(target, key, desc) {
          if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, "value") && !has(desc, "get") && !has(desc, "set") && !desc.configurable && (!has(desc, "writable") || desc.writable) && (!has(desc, "enumerable") || desc.enumerable)) {
            target[key] = desc.value;
            return target;
          }
          return dP(target, key, desc);
        };
        if (!ALL_CONSTRUCTORS) {
          $GOPD.f = $getDesc;
          $DP.f = $setDesc;
        }
        $export($export.S + $export.F * !ALL_CONSTRUCTORS, "Object", {
          getOwnPropertyDescriptor: $getDesc,
          defineProperty: $setDesc
        });
        if (fails(function() {
          arrayToString.call({});
        })) {
          arrayToString = arrayToLocaleString = function toString() {
            return arrayJoin.call(this);
          };
        }
        $TypedArrayPrototype$ = redefineAll({}, proto);
        redefineAll($TypedArrayPrototype$, $iterators);
        hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
        redefineAll($TypedArrayPrototype$, {
          slice: $slice,
          set: $set,
          constructor: function() {
          },
          toString: arrayToString,
          toLocaleString: $toLocaleString
        });
        addGetter($TypedArrayPrototype$, "buffer", "b");
        addGetter($TypedArrayPrototype$, "byteOffset", "o");
        addGetter($TypedArrayPrototype$, "byteLength", "l");
        addGetter($TypedArrayPrototype$, "length", "e");
        dP($TypedArrayPrototype$, TAG, {
          get: function() {
            return this[TYPED_ARRAY];
          }
        });
        module.exports = function(KEY, BYTES, wrapper, CLAMPED) {
          CLAMPED = !!CLAMPED;
          var NAME = KEY + (CLAMPED ? "Clamped" : "") + "Array";
          var GETTER = "get" + KEY;
          var SETTER = "set" + KEY;
          var TypedArray = global2[NAME];
          var Base = TypedArray || {};
          var TAC = TypedArray && getPrototypeOf(TypedArray);
          var FORCED = !TypedArray || !$typed.ABV;
          var O = {};
          var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
          var getter = function(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
          };
          var setter = function(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 255 ? 255 : value & 255;
            data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
          };
          var addElement = function(that, index) {
            dP(that, index, {
              get: function() {
                return getter(this, index);
              },
              set: function(value) {
                return setter(this, index, value);
              },
              enumerable: true
            });
          };
          if (FORCED) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME, "_d");
              var index = 0;
              var offset = 0;
              var buffer, byteLength, length, klass;
              if (!isObject(data)) {
                length = toIndex(data);
                byteLength = length * BYTES;
                buffer = new $ArrayBuffer(byteLength);
              } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                buffer = data;
                offset = toOffset($offset, BYTES);
                var $len = data.byteLength;
                if ($length === void 0) {
                  if ($len % BYTES) throw RangeError2(WRONG_LENGTH);
                  byteLength = $len - offset;
                  if (byteLength < 0) throw RangeError2(WRONG_LENGTH);
                } else {
                  byteLength = toLength($length) * BYTES;
                  if (byteLength + offset > $len) throw RangeError2(WRONG_LENGTH);
                }
                length = byteLength / BYTES;
              } else if (TYPED_ARRAY in data) {
                return fromList(TypedArray, data);
              } else {
                return $from.call(TypedArray, data);
              }
              hide(that, "_d", {
                b: buffer,
                o: offset,
                l: byteLength,
                e: length,
                v: new $DataView(buffer)
              });
              while (index < length) addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
            hide(TypedArrayPrototype, "constructor", TypedArray);
          } else if (!fails(function() {
            TypedArray(1);
          }) || !fails(function() {
            new TypedArray(-1);
          }) || !$iterDetect(function(iter) {
            new TypedArray();
            new TypedArray(null);
            new TypedArray(1.5);
            new TypedArray(iter);
          }, true)) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME);
              var klass;
              if (!isObject(data)) return new Base(toIndex(data));
              if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                return $length !== void 0 ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== void 0 ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
              }
              if (TYPED_ARRAY in data) return fromList(TypedArray, data);
              return $from.call(TypedArray, data);
            });
            arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key) {
              if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
            });
            TypedArray[PROTOTYPE] = TypedArrayPrototype;
            if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
          }
          var $nativeIterator = TypedArrayPrototype[ITERATOR];
          var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == "values" || $nativeIterator.name == void 0);
          var $iterator = $iterators.values;
          hide(TypedArray, TYPED_CONSTRUCTOR, true);
          hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
          hide(TypedArrayPrototype, VIEW, true);
          hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
          if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
            dP(TypedArrayPrototype, TAG, {
              get: function() {
                return NAME;
              }
            });
          }
          O[NAME] = TypedArray;
          $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
          $export($export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES
          });
          $export($export.S + $export.F * fails(function() {
            Base.of.call(TypedArray, 1);
          }), NAME, {
            from: $from,
            of: $of
          });
          if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
          $export($export.P, NAME, proto);
          setSpecies(NAME);
          $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
          $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
          if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
          $export($export.P + $export.F * fails(function() {
            new TypedArray(1).slice();
          }), NAME, { slice: $slice });
          $export($export.P + $export.F * (fails(function() {
            return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
          }) || !fails(function() {
            TypedArrayPrototype.toLocaleString.call([1, 2]);
          })), NAME, { toLocaleString: $toLocaleString });
          Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
          if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
        };
      } else module.exports = function() {
      };
      var LIBRARY;
      var global2;
      var fails;
      var $export;
      var $typed;
      var $buffer;
      var ctx;
      var anInstance;
      var propertyDesc;
      var hide;
      var redefineAll;
      var toInteger;
      var toLength;
      var toIndex;
      var toAbsoluteIndex;
      var toPrimitive;
      var has;
      var classof;
      var isObject;
      var toObject;
      var isArrayIter;
      var create;
      var getPrototypeOf;
      var gOPN;
      var getIterFn;
      var uid;
      var wks;
      var createArrayMethod;
      var createArrayIncludes;
      var speciesConstructor;
      var ArrayIterators;
      var Iterators;
      var $iterDetect;
      var setSpecies;
      var arrayFill;
      var arrayCopyWithin;
      var $DP;
      var $GOPD;
      var dP;
      var gOPD;
      var RangeError2;
      var TypeError2;
      var Uint8Array2;
      var ARRAY_BUFFER;
      var SHARED_BUFFER;
      var BYTES_PER_ELEMENT;
      var PROTOTYPE;
      var ArrayProto;
      var $ArrayBuffer;
      var $DataView;
      var arrayForEach;
      var arrayFilter;
      var arraySome;
      var arrayEvery;
      var arrayFind;
      var arrayFindIndex;
      var arrayIncludes;
      var arrayIndexOf;
      var arrayValues;
      var arrayKeys;
      var arrayEntries;
      var arrayLastIndexOf;
      var arrayReduce;
      var arrayReduceRight;
      var arrayJoin;
      var arraySort;
      var arraySlice;
      var arrayToString;
      var arrayToLocaleString;
      var ITERATOR;
      var TAG;
      var TYPED_CONSTRUCTOR;
      var DEF_CONSTRUCTOR;
      var ALL_CONSTRUCTORS;
      var TYPED_ARRAY;
      var VIEW;
      var WRONG_LENGTH;
      var $map;
      var LITTLE_ENDIAN;
      var FORCED_SET;
      var toOffset;
      var validate;
      var allocate;
      var speciesFromList;
      var fromList;
      var addGetter;
      var $from;
      var $of;
      var TO_LOCALE_BUG;
      var $toLocaleString;
      var proto;
      var $slice;
      var $set;
      var $iterators;
      var isTAIndex;
      var $getDesc;
      var $setDesc;
      var $TypedArrayPrototype$;
    }
  });

  // node_modules/core-js/modules/es6.typed.int8-array.js
  var require_es6_typed_int8_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.int8-array.js"() {
      require_typed_array()("Int8", 1, function(init) {
        return function Int8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.typed.uint8-array.js
  var require_es6_typed_uint8_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.uint8-array.js"() {
      require_typed_array()("Uint8", 1, function(init) {
        return function Uint8Array2(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.typed.uint8-clamped-array.js
  var require_es6_typed_uint8_clamped_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.uint8-clamped-array.js"() {
      require_typed_array()("Uint8", 1, function(init) {
        return function Uint8ClampedArray(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      }, true);
    }
  });

  // node_modules/core-js/modules/es6.typed.int16-array.js
  var require_es6_typed_int16_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.int16-array.js"() {
      require_typed_array()("Int16", 2, function(init) {
        return function Int16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.typed.uint16-array.js
  var require_es6_typed_uint16_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.uint16-array.js"() {
      require_typed_array()("Uint16", 2, function(init) {
        return function Uint16Array2(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.typed.int32-array.js
  var require_es6_typed_int32_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.int32-array.js"() {
      require_typed_array()("Int32", 4, function(init) {
        return function Int32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.typed.uint32-array.js
  var require_es6_typed_uint32_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.uint32-array.js"() {
      require_typed_array()("Uint32", 4, function(init) {
        return function Uint32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.typed.float32-array.js
  var require_es6_typed_float32_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.float32-array.js"() {
      require_typed_array()("Float32", 4, function(init) {
        return function Float32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.typed.float64-array.js
  var require_es6_typed_float64_array = __commonJS({
    "node_modules/core-js/modules/es6.typed.float64-array.js"() {
      require_typed_array()("Float64", 8, function(init) {
        return function Float64Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.apply.js
  var require_es6_reflect_apply = __commonJS({
    "node_modules/core-js/modules/es6.reflect.apply.js"() {
      var $export = require_export();
      var aFunction = require_a_function();
      var anObject = require_an_object();
      var rApply = (require_global().Reflect || {}).apply;
      var fApply = Function.apply;
      $export($export.S + $export.F * !require_fails()(function() {
        rApply(function() {
        });
      }), "Reflect", {
        apply: function apply(target, thisArgument, argumentsList) {
          var T = aFunction(target);
          var L = anObject(argumentsList);
          return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.construct.js
  var require_es6_reflect_construct = __commonJS({
    "node_modules/core-js/modules/es6.reflect.construct.js"() {
      var $export = require_export();
      var create = require_object_create();
      var aFunction = require_a_function();
      var anObject = require_an_object();
      var isObject = require_is_object();
      var fails = require_fails();
      var bind = require_bind();
      var rConstruct = (require_global().Reflect || {}).construct;
      var NEW_TARGET_BUG = fails(function() {
        function F() {
        }
        return !(rConstruct(function() {
        }, [], F) instanceof F);
      });
      var ARGS_BUG = !fails(function() {
        rConstruct(function() {
        });
      });
      $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), "Reflect", {
        construct: function construct(Target, args) {
          aFunction(Target);
          anObject(args);
          var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
          if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
          if (Target == newTarget) {
            switch (args.length) {
              case 0:
                return new Target();
              case 1:
                return new Target(args[0]);
              case 2:
                return new Target(args[0], args[1]);
              case 3:
                return new Target(args[0], args[1], args[2]);
              case 4:
                return new Target(args[0], args[1], args[2], args[3]);
            }
            var $args = [null];
            $args.push.apply($args, args);
            return new (bind.apply(Target, $args))();
          }
          var proto = newTarget.prototype;
          var instance = create(isObject(proto) ? proto : Object.prototype);
          var result = Function.apply.call(Target, instance, args);
          return isObject(result) ? result : instance;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.define-property.js
  var require_es6_reflect_define_property = __commonJS({
    "node_modules/core-js/modules/es6.reflect.define-property.js"() {
      var dP = require_object_dp();
      var $export = require_export();
      var anObject = require_an_object();
      var toPrimitive = require_to_primitive();
      $export($export.S + $export.F * require_fails()(function() {
        Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
      }), "Reflect", {
        defineProperty: function defineProperty(target, propertyKey, attributes) {
          anObject(target);
          propertyKey = toPrimitive(propertyKey, true);
          anObject(attributes);
          try {
            dP.f(target, propertyKey, attributes);
            return true;
          } catch (e) {
            return false;
          }
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.delete-property.js
  var require_es6_reflect_delete_property = __commonJS({
    "node_modules/core-js/modules/es6.reflect.delete-property.js"() {
      var $export = require_export();
      var gOPD = require_object_gopd().f;
      var anObject = require_an_object();
      $export($export.S, "Reflect", {
        deleteProperty: function deleteProperty(target, propertyKey) {
          var desc = gOPD(anObject(target), propertyKey);
          return desc && !desc.configurable ? false : delete target[propertyKey];
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.enumerate.js
  var require_es6_reflect_enumerate = __commonJS({
    "node_modules/core-js/modules/es6.reflect.enumerate.js"() {
      "use strict";
      var $export = require_export();
      var anObject = require_an_object();
      var Enumerate = function(iterated) {
        this._t = anObject(iterated);
        this._i = 0;
        var keys = this._k = [];
        var key;
        for (key in iterated) keys.push(key);
      };
      require_iter_create()(Enumerate, "Object", function() {
        var that = this;
        var keys = that._k;
        var key;
        do {
          if (that._i >= keys.length) return { value: void 0, done: true };
        } while (!((key = keys[that._i++]) in that._t));
        return { value: key, done: false };
      });
      $export($export.S, "Reflect", {
        enumerate: function enumerate(target) {
          return new Enumerate(target);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.get.js
  var require_es6_reflect_get = __commonJS({
    "node_modules/core-js/modules/es6.reflect.get.js"() {
      var gOPD = require_object_gopd();
      var getPrototypeOf = require_object_gpo();
      var has = require_has();
      var $export = require_export();
      var isObject = require_is_object();
      var anObject = require_an_object();
      function get(target, propertyKey) {
        var receiver = arguments.length < 3 ? target : arguments[2];
        var desc, proto;
        if (anObject(target) === receiver) return target[propertyKey];
        if (desc = gOPD.f(target, propertyKey)) return has(desc, "value") ? desc.value : desc.get !== void 0 ? desc.get.call(receiver) : void 0;
        if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
      }
      $export($export.S, "Reflect", { get });
    }
  });

  // node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js
  var require_es6_reflect_get_own_property_descriptor = __commonJS({
    "node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js"() {
      var gOPD = require_object_gopd();
      var $export = require_export();
      var anObject = require_an_object();
      $export($export.S, "Reflect", {
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
          return gOPD.f(anObject(target), propertyKey);
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.get-prototype-of.js
  var require_es6_reflect_get_prototype_of = __commonJS({
    "node_modules/core-js/modules/es6.reflect.get-prototype-of.js"() {
      var $export = require_export();
      var getProto = require_object_gpo();
      var anObject = require_an_object();
      $export($export.S, "Reflect", {
        getPrototypeOf: function getPrototypeOf(target) {
          return getProto(anObject(target));
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.has.js
  var require_es6_reflect_has = __commonJS({
    "node_modules/core-js/modules/es6.reflect.has.js"() {
      var $export = require_export();
      $export($export.S, "Reflect", {
        has: function has(target, propertyKey) {
          return propertyKey in target;
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.is-extensible.js
  var require_es6_reflect_is_extensible = __commonJS({
    "node_modules/core-js/modules/es6.reflect.is-extensible.js"() {
      var $export = require_export();
      var anObject = require_an_object();
      var $isExtensible = Object.isExtensible;
      $export($export.S, "Reflect", {
        isExtensible: function isExtensible(target) {
          anObject(target);
          return $isExtensible ? $isExtensible(target) : true;
        }
      });
    }
  });

  // node_modules/core-js/modules/_own-keys.js
  var require_own_keys = __commonJS({
    "node_modules/core-js/modules/_own-keys.js"(exports, module) {
      var gOPN = require_object_gopn();
      var gOPS = require_object_gops();
      var anObject = require_an_object();
      var Reflect2 = require_global().Reflect;
      module.exports = Reflect2 && Reflect2.ownKeys || function ownKeys(it) {
        var keys = gOPN.f(anObject(it));
        var getSymbols = gOPS.f;
        return getSymbols ? keys.concat(getSymbols(it)) : keys;
      };
    }
  });

  // node_modules/core-js/modules/es6.reflect.own-keys.js
  var require_es6_reflect_own_keys = __commonJS({
    "node_modules/core-js/modules/es6.reflect.own-keys.js"() {
      var $export = require_export();
      $export($export.S, "Reflect", { ownKeys: require_own_keys() });
    }
  });

  // node_modules/core-js/modules/es6.reflect.prevent-extensions.js
  var require_es6_reflect_prevent_extensions = __commonJS({
    "node_modules/core-js/modules/es6.reflect.prevent-extensions.js"() {
      var $export = require_export();
      var anObject = require_an_object();
      var $preventExtensions = Object.preventExtensions;
      $export($export.S, "Reflect", {
        preventExtensions: function preventExtensions(target) {
          anObject(target);
          try {
            if ($preventExtensions) $preventExtensions(target);
            return true;
          } catch (e) {
            return false;
          }
        }
      });
    }
  });

  // node_modules/core-js/modules/es6.reflect.set.js
  var require_es6_reflect_set = __commonJS({
    "node_modules/core-js/modules/es6.reflect.set.js"() {
      var dP = require_object_dp();
      var gOPD = require_object_gopd();
      var getPrototypeOf = require_object_gpo();
      var has = require_has();
      var $export = require_export();
      var createDesc = require_property_desc();
      var anObject = require_an_object();
      var isObject = require_is_object();
      function set(target, propertyKey, V) {
        var receiver = arguments.length < 4 ? target : arguments[3];
        var ownDesc = gOPD.f(anObject(target), propertyKey);
        var existingDescriptor, proto;
        if (!ownDesc) {
          if (isObject(proto = getPrototypeOf(target))) {
            return set(proto, propertyKey, V, receiver);
          }
          ownDesc = createDesc(0);
        }
        if (has(ownDesc, "value")) {
          if (ownDesc.writable === false || !isObject(receiver)) return false;
          if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            dP.f(receiver, propertyKey, existingDescriptor);
          } else dP.f(receiver, propertyKey, createDesc(0, V));
          return true;
        }
        return ownDesc.set === void 0 ? false : (ownDesc.set.call(receiver, V), true);
      }
      $export($export.S, "Reflect", { set });
    }
  });

  // node_modules/core-js/modules/es6.reflect.set-prototype-of.js
  var require_es6_reflect_set_prototype_of = __commonJS({
    "node_modules/core-js/modules/es6.reflect.set-prototype-of.js"() {
      var $export = require_export();
      var setProto = require_set_proto();
      if (setProto) $export($export.S, "Reflect", {
        setPrototypeOf: function setPrototypeOf(target, proto) {
          setProto.check(target, proto);
          try {
            setProto.set(target, proto);
            return true;
          } catch (e) {
            return false;
          }
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.array.includes.js
  var require_es7_array_includes = __commonJS({
    "node_modules/core-js/modules/es7.array.includes.js"() {
      "use strict";
      var $export = require_export();
      var $includes = require_array_includes()(true);
      $export($export.P, "Array", {
        includes: function includes(el) {
          return $includes(this, el, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      require_add_to_unscopables()("includes");
    }
  });

  // node_modules/core-js/modules/_flatten-into-array.js
  var require_flatten_into_array = __commonJS({
    "node_modules/core-js/modules/_flatten-into-array.js"(exports, module) {
      "use strict";
      var isArray = require_is_array();
      var isObject = require_is_object();
      var toLength = require_to_length();
      var ctx = require_ctx();
      var IS_CONCAT_SPREADABLE = require_wks()("isConcatSpreadable");
      function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
        var targetIndex = start;
        var sourceIndex = 0;
        var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
        var element, spreadable;
        while (sourceIndex < sourceLen) {
          if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            spreadable = false;
            if (isObject(element)) {
              spreadable = element[IS_CONCAT_SPREADABLE];
              spreadable = spreadable !== void 0 ? !!spreadable : isArray(element);
            }
            if (spreadable && depth > 0) {
              targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
            } else {
              if (targetIndex >= 9007199254740991) throw TypeError();
              target[targetIndex] = element;
            }
            targetIndex++;
          }
          sourceIndex++;
        }
        return targetIndex;
      }
      module.exports = flattenIntoArray;
    }
  });

  // node_modules/core-js/modules/es7.array.flat-map.js
  var require_es7_array_flat_map = __commonJS({
    "node_modules/core-js/modules/es7.array.flat-map.js"() {
      "use strict";
      var $export = require_export();
      var flattenIntoArray = require_flatten_into_array();
      var toObject = require_to_object();
      var toLength = require_to_length();
      var aFunction = require_a_function();
      var arraySpeciesCreate = require_array_species_create();
      $export($export.P, "Array", {
        flatMap: function flatMap(callbackfn) {
          var O = toObject(this);
          var sourceLen, A;
          aFunction(callbackfn);
          sourceLen = toLength(O.length);
          A = arraySpeciesCreate(O, 0);
          flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
          return A;
        }
      });
      require_add_to_unscopables()("flatMap");
    }
  });

  // node_modules/core-js/modules/es7.array.flatten.js
  var require_es7_array_flatten = __commonJS({
    "node_modules/core-js/modules/es7.array.flatten.js"() {
      "use strict";
      var $export = require_export();
      var flattenIntoArray = require_flatten_into_array();
      var toObject = require_to_object();
      var toLength = require_to_length();
      var toInteger = require_to_integer();
      var arraySpeciesCreate = require_array_species_create();
      $export($export.P, "Array", {
        flatten: function flatten() {
          var depthArg = arguments[0];
          var O = toObject(this);
          var sourceLen = toLength(O.length);
          var A = arraySpeciesCreate(O, 0);
          flattenIntoArray(A, O, O, sourceLen, 0, depthArg === void 0 ? 1 : toInteger(depthArg));
          return A;
        }
      });
      require_add_to_unscopables()("flatten");
    }
  });

  // node_modules/core-js/modules/es7.string.at.js
  var require_es7_string_at = __commonJS({
    "node_modules/core-js/modules/es7.string.at.js"() {
      "use strict";
      var $export = require_export();
      var $at = require_string_at()(true);
      var $fails = require_fails();
      var FORCED = $fails(function() {
        return "\u{20BB7}".at(0) !== "\u{20BB7}";
      });
      $export($export.P + $export.F * FORCED, "String", {
        at: function at(pos) {
          return $at(this, pos);
        }
      });
    }
  });

  // node_modules/core-js/modules/_string-pad.js
  var require_string_pad = __commonJS({
    "node_modules/core-js/modules/_string-pad.js"(exports, module) {
      var toLength = require_to_length();
      var repeat = require_string_repeat();
      var defined = require_defined();
      module.exports = function(that, maxLength, fillString, left) {
        var S = String(defined(that));
        var stringLength = S.length;
        var fillStr = fillString === void 0 ? " " : String(fillString);
        var intMaxLength = toLength(maxLength);
        if (intMaxLength <= stringLength || fillStr == "") return S;
        var fillLen = intMaxLength - stringLength;
        var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
        return left ? stringFiller + S : S + stringFiller;
      };
    }
  });

  // node_modules/core-js/modules/es7.string.pad-start.js
  var require_es7_string_pad_start = __commonJS({
    "node_modules/core-js/modules/es7.string.pad-start.js"() {
      "use strict";
      var $export = require_export();
      var $pad = require_string_pad();
      var userAgent = require_user_agent();
      var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
      $export($export.P + $export.F * WEBKIT_BUG, "String", {
        padStart: function padStart(maxLength) {
          return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : void 0, true);
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.string.pad-end.js
  var require_es7_string_pad_end = __commonJS({
    "node_modules/core-js/modules/es7.string.pad-end.js"() {
      "use strict";
      var $export = require_export();
      var $pad = require_string_pad();
      var userAgent = require_user_agent();
      var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
      $export($export.P + $export.F * WEBKIT_BUG, "String", {
        padEnd: function padEnd(maxLength) {
          return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : void 0, false);
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.string.trim-left.js
  var require_es7_string_trim_left = __commonJS({
    "node_modules/core-js/modules/es7.string.trim-left.js"() {
      "use strict";
      require_string_trim()("trimLeft", function($trim) {
        return function trimLeft() {
          return $trim(this, 1);
        };
      }, "trimStart");
    }
  });

  // node_modules/core-js/modules/es7.string.trim-right.js
  var require_es7_string_trim_right = __commonJS({
    "node_modules/core-js/modules/es7.string.trim-right.js"() {
      "use strict";
      require_string_trim()("trimRight", function($trim) {
        return function trimRight() {
          return $trim(this, 2);
        };
      }, "trimEnd");
    }
  });

  // node_modules/core-js/modules/es7.string.match-all.js
  var require_es7_string_match_all = __commonJS({
    "node_modules/core-js/modules/es7.string.match-all.js"() {
      "use strict";
      var $export = require_export();
      var defined = require_defined();
      var toLength = require_to_length();
      var isRegExp = require_is_regexp();
      var getFlags = require_flags();
      var RegExpProto = RegExp.prototype;
      var $RegExpStringIterator = function(regexp, string) {
        this._r = regexp;
        this._s = string;
      };
      require_iter_create()($RegExpStringIterator, "RegExp String", function next() {
        var match = this._r.exec(this._s);
        return { value: match, done: match === null };
      });
      $export($export.P, "String", {
        matchAll: function matchAll(regexp) {
          defined(this);
          if (!isRegExp(regexp)) throw TypeError(regexp + " is not a regexp!");
          var S = String(this);
          var flags = "flags" in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
          var rx = new RegExp(regexp.source, ~flags.indexOf("g") ? flags : "g" + flags);
          rx.lastIndex = toLength(regexp.lastIndex);
          return new $RegExpStringIterator(rx, S);
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.symbol.async-iterator.js
  var require_es7_symbol_async_iterator = __commonJS({
    "node_modules/core-js/modules/es7.symbol.async-iterator.js"() {
      require_wks_define()("asyncIterator");
    }
  });

  // node_modules/core-js/modules/es7.symbol.observable.js
  var require_es7_symbol_observable = __commonJS({
    "node_modules/core-js/modules/es7.symbol.observable.js"() {
      require_wks_define()("observable");
    }
  });

  // node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
  var require_es7_object_get_own_property_descriptors = __commonJS({
    "node_modules/core-js/modules/es7.object.get-own-property-descriptors.js"() {
      var $export = require_export();
      var ownKeys = require_own_keys();
      var toIObject = require_to_iobject();
      var gOPD = require_object_gopd();
      var createProperty = require_create_property();
      $export($export.S, "Object", {
        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
          var O = toIObject(object);
          var getDesc = gOPD.f;
          var keys = ownKeys(O);
          var result = {};
          var i = 0;
          var key, desc;
          while (keys.length > i) {
            desc = getDesc(O, key = keys[i++]);
            if (desc !== void 0) createProperty(result, key, desc);
          }
          return result;
        }
      });
    }
  });

  // node_modules/core-js/modules/_object-to-array.js
  var require_object_to_array = __commonJS({
    "node_modules/core-js/modules/_object-to-array.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var getKeys = require_object_keys();
      var toIObject = require_to_iobject();
      var isEnum = require_object_pie().f;
      module.exports = function(isEntries) {
        return function(it) {
          var O = toIObject(it);
          var keys = getKeys(O);
          var length = keys.length;
          var i = 0;
          var result = [];
          var key;
          while (length > i) {
            key = keys[i++];
            if (!DESCRIPTORS || isEnum.call(O, key)) {
              result.push(isEntries ? [key, O[key]] : O[key]);
            }
          }
          return result;
        };
      };
    }
  });

  // node_modules/core-js/modules/es7.object.values.js
  var require_es7_object_values = __commonJS({
    "node_modules/core-js/modules/es7.object.values.js"() {
      var $export = require_export();
      var $values = require_object_to_array()(false);
      $export($export.S, "Object", {
        values: function values(it) {
          return $values(it);
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.object.entries.js
  var require_es7_object_entries = __commonJS({
    "node_modules/core-js/modules/es7.object.entries.js"() {
      var $export = require_export();
      var $entries = require_object_to_array()(true);
      $export($export.S, "Object", {
        entries: function entries(it) {
          return $entries(it);
        }
      });
    }
  });

  // node_modules/core-js/modules/_object-forced-pam.js
  var require_object_forced_pam = __commonJS({
    "node_modules/core-js/modules/_object-forced-pam.js"(exports, module) {
      "use strict";
      module.exports = require_library() || !require_fails()(function() {
        var K = Math.random();
        __defineSetter__.call(null, K, function() {
        });
        delete require_global()[K];
      });
    }
  });

  // node_modules/core-js/modules/es7.object.define-getter.js
  var require_es7_object_define_getter = __commonJS({
    "node_modules/core-js/modules/es7.object.define-getter.js"() {
      "use strict";
      var $export = require_export();
      var toObject = require_to_object();
      var aFunction = require_a_function();
      var $defineProperty = require_object_dp();
      require_descriptors() && $export($export.P + require_object_forced_pam(), "Object", {
        __defineGetter__: function __defineGetter__(P, getter) {
          $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.object.define-setter.js
  var require_es7_object_define_setter = __commonJS({
    "node_modules/core-js/modules/es7.object.define-setter.js"() {
      "use strict";
      var $export = require_export();
      var toObject = require_to_object();
      var aFunction = require_a_function();
      var $defineProperty = require_object_dp();
      require_descriptors() && $export($export.P + require_object_forced_pam(), "Object", {
        __defineSetter__: function __defineSetter__2(P, setter) {
          $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.object.lookup-getter.js
  var require_es7_object_lookup_getter = __commonJS({
    "node_modules/core-js/modules/es7.object.lookup-getter.js"() {
      "use strict";
      var $export = require_export();
      var toObject = require_to_object();
      var toPrimitive = require_to_primitive();
      var getPrototypeOf = require_object_gpo();
      var getOwnPropertyDescriptor = require_object_gopd().f;
      require_descriptors() && $export($export.P + require_object_forced_pam(), "Object", {
        __lookupGetter__: function __lookupGetter__(P) {
          var O = toObject(this);
          var K = toPrimitive(P, true);
          var D;
          do {
            if (D = getOwnPropertyDescriptor(O, K)) return D.get;
          } while (O = getPrototypeOf(O));
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.object.lookup-setter.js
  var require_es7_object_lookup_setter = __commonJS({
    "node_modules/core-js/modules/es7.object.lookup-setter.js"() {
      "use strict";
      var $export = require_export();
      var toObject = require_to_object();
      var toPrimitive = require_to_primitive();
      var getPrototypeOf = require_object_gpo();
      var getOwnPropertyDescriptor = require_object_gopd().f;
      require_descriptors() && $export($export.P + require_object_forced_pam(), "Object", {
        __lookupSetter__: function __lookupSetter__(P) {
          var O = toObject(this);
          var K = toPrimitive(P, true);
          var D;
          do {
            if (D = getOwnPropertyDescriptor(O, K)) return D.set;
          } while (O = getPrototypeOf(O));
        }
      });
    }
  });

  // node_modules/core-js/modules/_array-from-iterable.js
  var require_array_from_iterable = __commonJS({
    "node_modules/core-js/modules/_array-from-iterable.js"(exports, module) {
      var forOf = require_for_of();
      module.exports = function(iter, ITERATOR) {
        var result = [];
        forOf(iter, false, result.push, result, ITERATOR);
        return result;
      };
    }
  });

  // node_modules/core-js/modules/_collection-to-json.js
  var require_collection_to_json = __commonJS({
    "node_modules/core-js/modules/_collection-to-json.js"(exports, module) {
      var classof = require_classof();
      var from = require_array_from_iterable();
      module.exports = function(NAME) {
        return function toJSON() {
          if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
          return from(this);
        };
      };
    }
  });

  // node_modules/core-js/modules/es7.map.to-json.js
  var require_es7_map_to_json = __commonJS({
    "node_modules/core-js/modules/es7.map.to-json.js"() {
      var $export = require_export();
      $export($export.P + $export.R, "Map", { toJSON: require_collection_to_json()("Map") });
    }
  });

  // node_modules/core-js/modules/es7.set.to-json.js
  var require_es7_set_to_json = __commonJS({
    "node_modules/core-js/modules/es7.set.to-json.js"() {
      var $export = require_export();
      $export($export.P + $export.R, "Set", { toJSON: require_collection_to_json()("Set") });
    }
  });

  // node_modules/core-js/modules/_set-collection-of.js
  var require_set_collection_of = __commonJS({
    "node_modules/core-js/modules/_set-collection-of.js"(exports, module) {
      "use strict";
      var $export = require_export();
      module.exports = function(COLLECTION) {
        $export($export.S, COLLECTION, { of: function of() {
          var length = arguments.length;
          var A = new Array(length);
          while (length--) A[length] = arguments[length];
          return new this(A);
        } });
      };
    }
  });

  // node_modules/core-js/modules/es7.map.of.js
  var require_es7_map_of = __commonJS({
    "node_modules/core-js/modules/es7.map.of.js"() {
      require_set_collection_of()("Map");
    }
  });

  // node_modules/core-js/modules/es7.set.of.js
  var require_es7_set_of = __commonJS({
    "node_modules/core-js/modules/es7.set.of.js"() {
      require_set_collection_of()("Set");
    }
  });

  // node_modules/core-js/modules/es7.weak-map.of.js
  var require_es7_weak_map_of = __commonJS({
    "node_modules/core-js/modules/es7.weak-map.of.js"() {
      require_set_collection_of()("WeakMap");
    }
  });

  // node_modules/core-js/modules/es7.weak-set.of.js
  var require_es7_weak_set_of = __commonJS({
    "node_modules/core-js/modules/es7.weak-set.of.js"() {
      require_set_collection_of()("WeakSet");
    }
  });

  // node_modules/core-js/modules/_set-collection-from.js
  var require_set_collection_from = __commonJS({
    "node_modules/core-js/modules/_set-collection-from.js"(exports, module) {
      "use strict";
      var $export = require_export();
      var aFunction = require_a_function();
      var ctx = require_ctx();
      var forOf = require_for_of();
      module.exports = function(COLLECTION) {
        $export($export.S, COLLECTION, { from: function from(source) {
          var mapFn = arguments[1];
          var mapping, A, n, cb;
          aFunction(this);
          mapping = mapFn !== void 0;
          if (mapping) aFunction(mapFn);
          if (source == void 0) return new this();
          A = [];
          if (mapping) {
            n = 0;
            cb = ctx(mapFn, arguments[2], 2);
            forOf(source, false, function(nextItem) {
              A.push(cb(nextItem, n++));
            });
          } else {
            forOf(source, false, A.push, A);
          }
          return new this(A);
        } });
      };
    }
  });

  // node_modules/core-js/modules/es7.map.from.js
  var require_es7_map_from = __commonJS({
    "node_modules/core-js/modules/es7.map.from.js"() {
      require_set_collection_from()("Map");
    }
  });

  // node_modules/core-js/modules/es7.set.from.js
  var require_es7_set_from = __commonJS({
    "node_modules/core-js/modules/es7.set.from.js"() {
      require_set_collection_from()("Set");
    }
  });

  // node_modules/core-js/modules/es7.weak-map.from.js
  var require_es7_weak_map_from = __commonJS({
    "node_modules/core-js/modules/es7.weak-map.from.js"() {
      require_set_collection_from()("WeakMap");
    }
  });

  // node_modules/core-js/modules/es7.weak-set.from.js
  var require_es7_weak_set_from = __commonJS({
    "node_modules/core-js/modules/es7.weak-set.from.js"() {
      require_set_collection_from()("WeakSet");
    }
  });

  // node_modules/core-js/modules/es7.global.js
  var require_es7_global = __commonJS({
    "node_modules/core-js/modules/es7.global.js"() {
      var $export = require_export();
      $export($export.G, { global: require_global() });
    }
  });

  // node_modules/core-js/modules/es7.system.global.js
  var require_es7_system_global = __commonJS({
    "node_modules/core-js/modules/es7.system.global.js"() {
      var $export = require_export();
      $export($export.S, "System", { global: require_global() });
    }
  });

  // node_modules/core-js/modules/es7.error.is-error.js
  var require_es7_error_is_error = __commonJS({
    "node_modules/core-js/modules/es7.error.is-error.js"() {
      var $export = require_export();
      var cof = require_cof();
      $export($export.S, "Error", {
        isError: function isError(it) {
          return cof(it) === "Error";
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.math.clamp.js
  var require_es7_math_clamp = __commonJS({
    "node_modules/core-js/modules/es7.math.clamp.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        clamp: function clamp(x, lower, upper) {
          return Math.min(upper, Math.max(lower, x));
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.math.deg-per-rad.js
  var require_es7_math_deg_per_rad = __commonJS({
    "node_modules/core-js/modules/es7.math.deg-per-rad.js"() {
      var $export = require_export();
      $export($export.S, "Math", { DEG_PER_RAD: Math.PI / 180 });
    }
  });

  // node_modules/core-js/modules/es7.math.degrees.js
  var require_es7_math_degrees = __commonJS({
    "node_modules/core-js/modules/es7.math.degrees.js"() {
      var $export = require_export();
      var RAD_PER_DEG = 180 / Math.PI;
      $export($export.S, "Math", {
        degrees: function degrees(radians) {
          return radians * RAD_PER_DEG;
        }
      });
    }
  });

  // node_modules/core-js/modules/_math-scale.js
  var require_math_scale = __commonJS({
    "node_modules/core-js/modules/_math-scale.js"(exports, module) {
      module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
        if (arguments.length === 0 || x != x || inLow != inLow || inHigh != inHigh || outLow != outLow || outHigh != outHigh) return NaN;
        if (x === Infinity || x === -Infinity) return x;
        return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
      };
    }
  });

  // node_modules/core-js/modules/es7.math.fscale.js
  var require_es7_math_fscale = __commonJS({
    "node_modules/core-js/modules/es7.math.fscale.js"() {
      var $export = require_export();
      var scale = require_math_scale();
      var fround = require_math_fround();
      $export($export.S, "Math", {
        fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
          return fround(scale(x, inLow, inHigh, outLow, outHigh));
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.math.iaddh.js
  var require_es7_math_iaddh = __commonJS({
    "node_modules/core-js/modules/es7.math.iaddh.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        iaddh: function iaddh(x0, x1, y0, y1) {
          var $x0 = x0 >>> 0;
          var $x1 = x1 >>> 0;
          var $y0 = y0 >>> 0;
          return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.math.isubh.js
  var require_es7_math_isubh = __commonJS({
    "node_modules/core-js/modules/es7.math.isubh.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        isubh: function isubh(x0, x1, y0, y1) {
          var $x0 = x0 >>> 0;
          var $x1 = x1 >>> 0;
          var $y0 = y0 >>> 0;
          return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.math.imulh.js
  var require_es7_math_imulh = __commonJS({
    "node_modules/core-js/modules/es7.math.imulh.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        imulh: function imulh(u, v) {
          var UINT16 = 65535;
          var $u = +u;
          var $v = +v;
          var u0 = $u & UINT16;
          var v0 = $v & UINT16;
          var u1 = $u >> 16;
          var v1 = $v >> 16;
          var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
          return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.math.rad-per-deg.js
  var require_es7_math_rad_per_deg = __commonJS({
    "node_modules/core-js/modules/es7.math.rad-per-deg.js"() {
      var $export = require_export();
      $export($export.S, "Math", { RAD_PER_DEG: 180 / Math.PI });
    }
  });

  // node_modules/core-js/modules/es7.math.radians.js
  var require_es7_math_radians = __commonJS({
    "node_modules/core-js/modules/es7.math.radians.js"() {
      var $export = require_export();
      var DEG_PER_RAD = Math.PI / 180;
      $export($export.S, "Math", {
        radians: function radians(degrees) {
          return degrees * DEG_PER_RAD;
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.math.scale.js
  var require_es7_math_scale = __commonJS({
    "node_modules/core-js/modules/es7.math.scale.js"() {
      var $export = require_export();
      $export($export.S, "Math", { scale: require_math_scale() });
    }
  });

  // node_modules/core-js/modules/es7.math.umulh.js
  var require_es7_math_umulh = __commonJS({
    "node_modules/core-js/modules/es7.math.umulh.js"() {
      var $export = require_export();
      $export($export.S, "Math", {
        umulh: function umulh(u, v) {
          var UINT16 = 65535;
          var $u = +u;
          var $v = +v;
          var u0 = $u & UINT16;
          var v0 = $v & UINT16;
          var u1 = $u >>> 16;
          var v1 = $v >>> 16;
          var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
          return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.math.signbit.js
  var require_es7_math_signbit = __commonJS({
    "node_modules/core-js/modules/es7.math.signbit.js"() {
      var $export = require_export();
      $export($export.S, "Math", { signbit: function signbit(x) {
        return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
      } });
    }
  });

  // node_modules/core-js/modules/es7.promise.finally.js
  var require_es7_promise_finally = __commonJS({
    "node_modules/core-js/modules/es7.promise.finally.js"() {
      "use strict";
      var $export = require_export();
      var core = require_core();
      var global2 = require_global();
      var speciesConstructor = require_species_constructor();
      var promiseResolve = require_promise_resolve();
      $export($export.P + $export.R, "Promise", { "finally": function(onFinally) {
        var C = speciesConstructor(this, core.Promise || global2.Promise);
        var isFunction = typeof onFinally == "function";
        return this.then(
          isFunction ? function(x) {
            return promiseResolve(C, onFinally()).then(function() {
              return x;
            });
          } : onFinally,
          isFunction ? function(e) {
            return promiseResolve(C, onFinally()).then(function() {
              throw e;
            });
          } : onFinally
        );
      } });
    }
  });

  // node_modules/core-js/modules/es7.promise.try.js
  var require_es7_promise_try = __commonJS({
    "node_modules/core-js/modules/es7.promise.try.js"() {
      "use strict";
      var $export = require_export();
      var newPromiseCapability = require_new_promise_capability();
      var perform = require_perform();
      $export($export.S, "Promise", { "try": function(callbackfn) {
        var promiseCapability = newPromiseCapability.f(this);
        var result = perform(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
      } });
    }
  });

  // node_modules/core-js/modules/_metadata.js
  var require_metadata = __commonJS({
    "node_modules/core-js/modules/_metadata.js"(exports, module) {
      var Map = require_es6_map();
      var $export = require_export();
      var shared = require_shared()("metadata");
      var store = shared.store || (shared.store = new (require_es6_weak_map())());
      var getOrCreateMetadataMap = function(target, targetKey, create) {
        var targetMetadata = store.get(target);
        if (!targetMetadata) {
          if (!create) return void 0;
          store.set(target, targetMetadata = new Map());
        }
        var keyMetadata = targetMetadata.get(targetKey);
        if (!keyMetadata) {
          if (!create) return void 0;
          targetMetadata.set(targetKey, keyMetadata = new Map());
        }
        return keyMetadata;
      };
      var ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
        var metadataMap = getOrCreateMetadataMap(O, P, false);
        return metadataMap === void 0 ? false : metadataMap.has(MetadataKey);
      };
      var ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
        var metadataMap = getOrCreateMetadataMap(O, P, false);
        return metadataMap === void 0 ? void 0 : metadataMap.get(MetadataKey);
      };
      var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
        getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
      };
      var ordinaryOwnMetadataKeys = function(target, targetKey) {
        var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
        var keys = [];
        if (metadataMap) metadataMap.forEach(function(_2, key) {
          keys.push(key);
        });
        return keys;
      };
      var toMetaKey = function(it) {
        return it === void 0 || typeof it == "symbol" ? it : String(it);
      };
      var exp = function(O) {
        $export($export.S, "Reflect", O);
      };
      module.exports = {
        store,
        map: getOrCreateMetadataMap,
        has: ordinaryHasOwnMetadata,
        get: ordinaryGetOwnMetadata,
        set: ordinaryDefineOwnMetadata,
        keys: ordinaryOwnMetadataKeys,
        key: toMetaKey,
        exp
      };
    }
  });

  // node_modules/core-js/modules/es7.reflect.define-metadata.js
  var require_es7_reflect_define_metadata = __commonJS({
    "node_modules/core-js/modules/es7.reflect.define-metadata.js"() {
      var metadata = require_metadata();
      var anObject = require_an_object();
      var toMetaKey = metadata.key;
      var ordinaryDefineOwnMetadata = metadata.set;
      metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
        ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
      } });
    }
  });

  // node_modules/core-js/modules/es7.reflect.delete-metadata.js
  var require_es7_reflect_delete_metadata = __commonJS({
    "node_modules/core-js/modules/es7.reflect.delete-metadata.js"() {
      var metadata = require_metadata();
      var anObject = require_an_object();
      var toMetaKey = metadata.key;
      var getOrCreateMetadataMap = metadata.map;
      var store = metadata.store;
      metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target) {
        var targetKey = arguments.length < 3 ? void 0 : toMetaKey(arguments[2]);
        var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
        if (metadataMap === void 0 || !metadataMap["delete"](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = store.get(target);
        targetMetadata["delete"](targetKey);
        return !!targetMetadata.size || store["delete"](target);
      } });
    }
  });

  // node_modules/core-js/modules/es7.reflect.get-metadata.js
  var require_es7_reflect_get_metadata = __commonJS({
    "node_modules/core-js/modules/es7.reflect.get-metadata.js"() {
      var metadata = require_metadata();
      var anObject = require_an_object();
      var getPrototypeOf = require_object_gpo();
      var ordinaryHasOwnMetadata = metadata.has;
      var ordinaryGetOwnMetadata = metadata.get;
      var toMetaKey = metadata.key;
      var ordinaryGetMetadata = function(MetadataKey, O, P) {
        var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
        var parent = getPrototypeOf(O);
        return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : void 0;
      };
      metadata.exp({ getMetadata: function getMetadata(metadataKey, target) {
        return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? void 0 : toMetaKey(arguments[2]));
      } });
    }
  });

  // node_modules/core-js/modules/es7.reflect.get-metadata-keys.js
  var require_es7_reflect_get_metadata_keys = __commonJS({
    "node_modules/core-js/modules/es7.reflect.get-metadata-keys.js"() {
      var Set2 = require_es6_set();
      var from = require_array_from_iterable();
      var metadata = require_metadata();
      var anObject = require_an_object();
      var getPrototypeOf = require_object_gpo();
      var ordinaryOwnMetadataKeys = metadata.keys;
      var toMetaKey = metadata.key;
      var ordinaryMetadataKeys = function(O, P) {
        var oKeys = ordinaryOwnMetadataKeys(O, P);
        var parent = getPrototypeOf(O);
        if (parent === null) return oKeys;
        var pKeys = ordinaryMetadataKeys(parent, P);
        return pKeys.length ? oKeys.length ? from(new Set2(oKeys.concat(pKeys))) : pKeys : oKeys;
      };
      metadata.exp({ getMetadataKeys: function getMetadataKeys(target) {
        return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? void 0 : toMetaKey(arguments[1]));
      } });
    }
  });

  // node_modules/core-js/modules/es7.reflect.get-own-metadata.js
  var require_es7_reflect_get_own_metadata = __commonJS({
    "node_modules/core-js/modules/es7.reflect.get-own-metadata.js"() {
      var metadata = require_metadata();
      var anObject = require_an_object();
      var ordinaryGetOwnMetadata = metadata.get;
      var toMetaKey = metadata.key;
      metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target) {
        return ordinaryGetOwnMetadata(
          metadataKey,
          anObject(target),
          arguments.length < 3 ? void 0 : toMetaKey(arguments[2])
        );
      } });
    }
  });

  // node_modules/core-js/modules/es7.reflect.get-own-metadata-keys.js
  var require_es7_reflect_get_own_metadata_keys = __commonJS({
    "node_modules/core-js/modules/es7.reflect.get-own-metadata-keys.js"() {
      var metadata = require_metadata();
      var anObject = require_an_object();
      var ordinaryOwnMetadataKeys = metadata.keys;
      var toMetaKey = metadata.key;
      metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target) {
        return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? void 0 : toMetaKey(arguments[1]));
      } });
    }
  });

  // node_modules/core-js/modules/es7.reflect.has-metadata.js
  var require_es7_reflect_has_metadata = __commonJS({
    "node_modules/core-js/modules/es7.reflect.has-metadata.js"() {
      var metadata = require_metadata();
      var anObject = require_an_object();
      var getPrototypeOf = require_object_gpo();
      var ordinaryHasOwnMetadata = metadata.has;
      var toMetaKey = metadata.key;
      var ordinaryHasMetadata = function(MetadataKey, O, P) {
        var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn) return true;
        var parent = getPrototypeOf(O);
        return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
      };
      metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target) {
        return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? void 0 : toMetaKey(arguments[2]));
      } });
    }
  });

  // node_modules/core-js/modules/es7.reflect.has-own-metadata.js
  var require_es7_reflect_has_own_metadata = __commonJS({
    "node_modules/core-js/modules/es7.reflect.has-own-metadata.js"() {
      var metadata = require_metadata();
      var anObject = require_an_object();
      var ordinaryHasOwnMetadata = metadata.has;
      var toMetaKey = metadata.key;
      metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target) {
        return ordinaryHasOwnMetadata(
          metadataKey,
          anObject(target),
          arguments.length < 3 ? void 0 : toMetaKey(arguments[2])
        );
      } });
    }
  });

  // node_modules/core-js/modules/es7.reflect.metadata.js
  var require_es7_reflect_metadata = __commonJS({
    "node_modules/core-js/modules/es7.reflect.metadata.js"() {
      var $metadata = require_metadata();
      var anObject = require_an_object();
      var aFunction = require_a_function();
      var toMetaKey = $metadata.key;
      var ordinaryDefineOwnMetadata = $metadata.set;
      $metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, targetKey) {
          ordinaryDefineOwnMetadata(
            metadataKey,
            metadataValue,
            (targetKey !== void 0 ? anObject : aFunction)(target),
            toMetaKey(targetKey)
          );
        };
      } });
    }
  });

  // node_modules/core-js/modules/es7.asap.js
  var require_es7_asap = __commonJS({
    "node_modules/core-js/modules/es7.asap.js"() {
      var $export = require_export();
      var microtask = require_microtask()();
      var process = require_global().process;
      var isNode = require_cof()(process) == "process";
      $export($export.G, {
        asap: function asap(fn) {
          var domain = isNode && process.domain;
          microtask(domain ? domain.bind(fn) : fn);
        }
      });
    }
  });

  // node_modules/core-js/modules/es7.observable.js
  var require_es7_observable = __commonJS({
    "node_modules/core-js/modules/es7.observable.js"() {
      "use strict";
      var $export = require_export();
      var global2 = require_global();
      var core = require_core();
      var microtask = require_microtask()();
      var OBSERVABLE = require_wks()("observable");
      var aFunction = require_a_function();
      var anObject = require_an_object();
      var anInstance = require_an_instance();
      var redefineAll = require_redefine_all();
      var hide = require_hide();
      var forOf = require_for_of();
      var RETURN = forOf.RETURN;
      var getMethod = function(fn) {
        return fn == null ? void 0 : aFunction(fn);
      };
      var cleanupSubscription = function(subscription) {
        var cleanup = subscription._c;
        if (cleanup) {
          subscription._c = void 0;
          cleanup();
        }
      };
      var subscriptionClosed = function(subscription) {
        return subscription._o === void 0;
      };
      var closeSubscription = function(subscription) {
        if (!subscriptionClosed(subscription)) {
          subscription._o = void 0;
          cleanupSubscription(subscription);
        }
      };
      var Subscription = function(observer, subscriber) {
        anObject(observer);
        this._c = void 0;
        this._o = observer;
        observer = new SubscriptionObserver(this);
        try {
          var cleanup = subscriber(observer);
          var subscription = cleanup;
          if (cleanup != null) {
            if (typeof cleanup.unsubscribe === "function") cleanup = function() {
              subscription.unsubscribe();
            };
            else aFunction(cleanup);
            this._c = cleanup;
          }
        } catch (e) {
          observer.error(e);
          return;
        }
        if (subscriptionClosed(this)) cleanupSubscription(this);
      };
      Subscription.prototype = redefineAll({}, {
        unsubscribe: function unsubscribe() {
          closeSubscription(this);
        }
      });
      var SubscriptionObserver = function(subscription) {
        this._s = subscription;
      };
      SubscriptionObserver.prototype = redefineAll({}, {
        next: function next(value) {
          var subscription = this._s;
          if (!subscriptionClosed(subscription)) {
            var observer = subscription._o;
            try {
              var m = getMethod(observer.next);
              if (m) return m.call(observer, value);
            } catch (e) {
              try {
                closeSubscription(subscription);
              } finally {
                throw e;
              }
            }
          }
        },
        error: function error(value) {
          var subscription = this._s;
          if (subscriptionClosed(subscription)) throw value;
          var observer = subscription._o;
          subscription._o = void 0;
          try {
            var m = getMethod(observer.error);
            if (!m) throw value;
            value = m.call(observer, value);
          } catch (e) {
            try {
              cleanupSubscription(subscription);
            } finally {
              throw e;
            }
          }
          cleanupSubscription(subscription);
          return value;
        },
        complete: function complete(value) {
          var subscription = this._s;
          if (!subscriptionClosed(subscription)) {
            var observer = subscription._o;
            subscription._o = void 0;
            try {
              var m = getMethod(observer.complete);
              value = m ? m.call(observer, value) : void 0;
            } catch (e) {
              try {
                cleanupSubscription(subscription);
              } finally {
                throw e;
              }
            }
            cleanupSubscription(subscription);
            return value;
          }
        }
      });
      var $Observable = function Observable(subscriber) {
        anInstance(this, $Observable, "Observable", "_f")._f = aFunction(subscriber);
      };
      redefineAll($Observable.prototype, {
        subscribe: function subscribe(observer) {
          return new Subscription(observer, this._f);
        },
        forEach: function forEach(fn) {
          var that = this;
          return new (core.Promise || global2.Promise)(function(resolve, reject) {
            aFunction(fn);
            var subscription = that.subscribe({
              next: function(value) {
                try {
                  return fn(value);
                } catch (e) {
                  reject(e);
                  subscription.unsubscribe();
                }
              },
              error: reject,
              complete: resolve
            });
          });
        }
      });
      redefineAll($Observable, {
        from: function from(x) {
          var C = typeof this === "function" ? this : $Observable;
          var method = getMethod(anObject(x)[OBSERVABLE]);
          if (method) {
            var observable = anObject(method.call(x));
            return observable.constructor === C ? observable : new C(function(observer) {
              return observable.subscribe(observer);
            });
          }
          return new C(function(observer) {
            var done = false;
            microtask(function() {
              if (!done) {
                try {
                  if (forOf(x, false, function(it) {
                    observer.next(it);
                    if (done) return RETURN;
                  }) === RETURN) return;
                } catch (e) {
                  if (done) throw e;
                  observer.error(e);
                  return;
                }
                observer.complete();
              }
            });
            return function() {
              done = true;
            };
          });
        },
        of: function of() {
          for (var i = 0, l = arguments.length, items = new Array(l); i < l; ) items[i] = arguments[i++];
          return new (typeof this === "function" ? this : $Observable)(function(observer) {
            var done = false;
            microtask(function() {
              if (!done) {
                for (var j = 0; j < items.length; ++j) {
                  observer.next(items[j]);
                  if (done) return;
                }
                observer.complete();
              }
            });
            return function() {
              done = true;
            };
          });
        }
      });
      hide($Observable.prototype, OBSERVABLE, function() {
        return this;
      });
      $export($export.G, { Observable: $Observable });
      require_set_species()("Observable");
    }
  });

  // node_modules/core-js/modules/web.timers.js
  var require_web_timers = __commonJS({
    "node_modules/core-js/modules/web.timers.js"() {
      var global2 = require_global();
      var $export = require_export();
      var userAgent = require_user_agent();
      var slice = [].slice;
      var MSIE = /MSIE .\./.test(userAgent);
      var wrap = function(set) {
        return function(fn, time) {
          var boundArgs = arguments.length > 2;
          var args = boundArgs ? slice.call(arguments, 2) : false;
          return set(boundArgs ? function() {
            (typeof fn == "function" ? fn : Function(fn)).apply(this, args);
          } : fn, time);
        };
      };
      $export($export.G + $export.B + $export.F * MSIE, {
        setTimeout: wrap(global2.setTimeout),
        setInterval: wrap(global2.setInterval)
      });
    }
  });

  // node_modules/core-js/modules/web.immediate.js
  var require_web_immediate = __commonJS({
    "node_modules/core-js/modules/web.immediate.js"() {
      var $export = require_export();
      var $task = require_task();
      $export($export.G + $export.B, {
        setImmediate: $task.set,
        clearImmediate: $task.clear
      });
    }
  });

  // node_modules/core-js/modules/web.dom.iterable.js
  var require_web_dom_iterable = __commonJS({
    "node_modules/core-js/modules/web.dom.iterable.js"() {
      var $iterators = require_es6_array_iterator();
      var getKeys = require_object_keys();
      var redefine = require_redefine();
      var global2 = require_global();
      var hide = require_hide();
      var Iterators = require_iterators();
      var wks = require_wks();
      var ITERATOR = wks("iterator");
      var TO_STRING_TAG = wks("toStringTag");
      var ArrayValues = Iterators.Array;
      var DOMIterables = {
        CSSRuleList: true,
        // TODO: Not spec compliant, should be false.
        CSSStyleDeclaration: false,
        CSSValueList: false,
        ClientRectList: false,
        DOMRectList: false,
        DOMStringList: false,
        DOMTokenList: true,
        DataTransferItemList: false,
        FileList: false,
        HTMLAllCollection: false,
        HTMLCollection: false,
        HTMLFormElement: false,
        HTMLSelectElement: false,
        MediaList: true,
        // TODO: Not spec compliant, should be false.
        MimeTypeArray: false,
        NamedNodeMap: false,
        NodeList: true,
        PaintRequestList: false,
        Plugin: false,
        PluginArray: false,
        SVGLengthList: false,
        SVGNumberList: false,
        SVGPathSegList: false,
        SVGPointList: false,
        SVGStringList: false,
        SVGTransformList: false,
        SourceBufferList: false,
        StyleSheetList: true,
        // TODO: Not spec compliant, should be false.
        TextTrackCueList: false,
        TextTrackList: false,
        TouchList: false
      };
      for (collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
        NAME = collections[i];
        explicit = DOMIterables[NAME];
        Collection = global2[NAME];
        proto = Collection && Collection.prototype;
        if (proto) {
          if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
          if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = ArrayValues;
          if (explicit) {
            for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
          }
        }
      }
      var NAME;
      var explicit;
      var Collection;
      var proto;
      var key;
      var collections;
      var i;
    }
  });

  // node_modules/core-js/shim.js
  var require_shim = __commonJS({
    "node_modules/core-js/shim.js"(exports, module) {
      require_es6_symbol();
      require_es6_object_create();
      require_es6_object_define_property();
      require_es6_object_define_properties();
      require_es6_object_get_own_property_descriptor();
      require_es6_object_get_prototype_of();
      require_es6_object_keys();
      require_es6_object_get_own_property_names();
      require_es6_object_freeze();
      require_es6_object_seal();
      require_es6_object_prevent_extensions();
      require_es6_object_is_frozen();
      require_es6_object_is_sealed();
      require_es6_object_is_extensible();
      require_es6_object_assign();
      require_es6_object_is();
      require_es6_object_set_prototype_of();
      require_es6_object_to_string();
      require_es6_function_bind();
      require_es6_function_name();
      require_es6_function_has_instance();
      require_es6_parse_int();
      require_es6_parse_float();
      require_es6_number_constructor();
      require_es6_number_to_fixed();
      require_es6_number_to_precision();
      require_es6_number_epsilon();
      require_es6_number_is_finite();
      require_es6_number_is_integer();
      require_es6_number_is_nan();
      require_es6_number_is_safe_integer();
      require_es6_number_max_safe_integer();
      require_es6_number_min_safe_integer();
      require_es6_number_parse_float();
      require_es6_number_parse_int();
      require_es6_math_acosh();
      require_es6_math_asinh();
      require_es6_math_atanh();
      require_es6_math_cbrt();
      require_es6_math_clz32();
      require_es6_math_cosh();
      require_es6_math_expm1();
      require_es6_math_fround();
      require_es6_math_hypot();
      require_es6_math_imul();
      require_es6_math_log10();
      require_es6_math_log1p();
      require_es6_math_log2();
      require_es6_math_sign();
      require_es6_math_sinh();
      require_es6_math_tanh();
      require_es6_math_trunc();
      require_es6_string_from_code_point();
      require_es6_string_raw();
      require_es6_string_trim();
      require_es6_string_iterator();
      require_es6_string_code_point_at();
      require_es6_string_ends_with();
      require_es6_string_includes();
      require_es6_string_repeat();
      require_es6_string_starts_with();
      require_es6_string_anchor();
      require_es6_string_big();
      require_es6_string_blink();
      require_es6_string_bold();
      require_es6_string_fixed();
      require_es6_string_fontcolor();
      require_es6_string_fontsize();
      require_es6_string_italics();
      require_es6_string_link();
      require_es6_string_small();
      require_es6_string_strike();
      require_es6_string_sub();
      require_es6_string_sup();
      require_es6_date_now();
      require_es6_date_to_json();
      require_es6_date_to_iso_string();
      require_es6_date_to_string();
      require_es6_date_to_primitive();
      require_es6_array_is_array();
      require_es6_array_from();
      require_es6_array_of();
      require_es6_array_join();
      require_es6_array_slice();
      require_es6_array_sort();
      require_es6_array_for_each();
      require_es6_array_map();
      require_es6_array_filter();
      require_es6_array_some();
      require_es6_array_every();
      require_es6_array_reduce();
      require_es6_array_reduce_right();
      require_es6_array_index_of();
      require_es6_array_last_index_of();
      require_es6_array_copy_within();
      require_es6_array_fill();
      require_es6_array_find();
      require_es6_array_find_index();
      require_es6_array_species();
      require_es6_array_iterator();
      require_es6_regexp_constructor();
      require_es6_regexp_exec();
      require_es6_regexp_to_string();
      require_es6_regexp_flags();
      require_es6_regexp_match();
      require_es6_regexp_replace();
      require_es6_regexp_search();
      require_es6_regexp_split();
      require_es6_promise();
      require_es6_map();
      require_es6_set();
      require_es6_weak_map();
      require_es6_weak_set();
      require_es6_typed_array_buffer();
      require_es6_typed_data_view();
      require_es6_typed_int8_array();
      require_es6_typed_uint8_array();
      require_es6_typed_uint8_clamped_array();
      require_es6_typed_int16_array();
      require_es6_typed_uint16_array();
      require_es6_typed_int32_array();
      require_es6_typed_uint32_array();
      require_es6_typed_float32_array();
      require_es6_typed_float64_array();
      require_es6_reflect_apply();
      require_es6_reflect_construct();
      require_es6_reflect_define_property();
      require_es6_reflect_delete_property();
      require_es6_reflect_enumerate();
      require_es6_reflect_get();
      require_es6_reflect_get_own_property_descriptor();
      require_es6_reflect_get_prototype_of();
      require_es6_reflect_has();
      require_es6_reflect_is_extensible();
      require_es6_reflect_own_keys();
      require_es6_reflect_prevent_extensions();
      require_es6_reflect_set();
      require_es6_reflect_set_prototype_of();
      require_es7_array_includes();
      require_es7_array_flat_map();
      require_es7_array_flatten();
      require_es7_string_at();
      require_es7_string_pad_start();
      require_es7_string_pad_end();
      require_es7_string_trim_left();
      require_es7_string_trim_right();
      require_es7_string_match_all();
      require_es7_symbol_async_iterator();
      require_es7_symbol_observable();
      require_es7_object_get_own_property_descriptors();
      require_es7_object_values();
      require_es7_object_entries();
      require_es7_object_define_getter();
      require_es7_object_define_setter();
      require_es7_object_lookup_getter();
      require_es7_object_lookup_setter();
      require_es7_map_to_json();
      require_es7_set_to_json();
      require_es7_map_of();
      require_es7_set_of();
      require_es7_weak_map_of();
      require_es7_weak_set_of();
      require_es7_map_from();
      require_es7_set_from();
      require_es7_weak_map_from();
      require_es7_weak_set_from();
      require_es7_global();
      require_es7_system_global();
      require_es7_error_is_error();
      require_es7_math_clamp();
      require_es7_math_deg_per_rad();
      require_es7_math_degrees();
      require_es7_math_fscale();
      require_es7_math_iaddh();
      require_es7_math_isubh();
      require_es7_math_imulh();
      require_es7_math_rad_per_deg();
      require_es7_math_radians();
      require_es7_math_scale();
      require_es7_math_umulh();
      require_es7_math_signbit();
      require_es7_promise_finally();
      require_es7_promise_try();
      require_es7_reflect_define_metadata();
      require_es7_reflect_delete_metadata();
      require_es7_reflect_get_metadata();
      require_es7_reflect_get_metadata_keys();
      require_es7_reflect_get_own_metadata();
      require_es7_reflect_get_own_metadata_keys();
      require_es7_reflect_has_metadata();
      require_es7_reflect_has_own_metadata();
      require_es7_reflect_metadata();
      require_es7_asap();
      require_es7_observable();
      require_web_timers();
      require_web_immediate();
      require_web_dom_iterable();
      module.exports = require_core();
    }
  });

  // node_modules/regenerator-runtime/runtime.js
  var require_runtime = __commonJS({
    "node_modules/regenerator-runtime/runtime.js"(exports, module) {
      !function(global2) {
        "use strict";
        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined2;
        var $Symbol = typeof Symbol === "function" ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || "@@iterator";
        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
        var inModule = typeof module === "object";
        var runtime = global2.regeneratorRuntime;
        if (runtime) {
          if (inModule) {
            module.exports = runtime;
          }
          return;
        }
        runtime = global2.regeneratorRuntime = inModule ? module.exports : {};
        function wrap(innerFn, outerFn, self2, tryLocsList) {
          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
          var generator = Object.create(protoGenerator.prototype);
          var context = new Context(tryLocsList || []);
          generator._invoke = makeInvokeMethod(innerFn, self2, context);
          return generator;
        }
        runtime.wrap = wrap;
        function tryCatch(fn, obj, arg) {
          try {
            return { type: "normal", arg: fn.call(obj, arg) };
          } catch (err) {
            return { type: "throw", arg: err };
          }
        }
        var GenStateSuspendedStart = "suspendedStart";
        var GenStateSuspendedYield = "suspendedYield";
        var GenStateExecuting = "executing";
        var GenStateCompleted = "completed";
        var ContinueSentinel = {};
        function Generator() {
        }
        function GeneratorFunction() {
        }
        function GeneratorFunctionPrototype() {
        }
        var IteratorPrototype = {};
        IteratorPrototype[iteratorSymbol] = function() {
          return this;
        };
        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
        if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
          IteratorPrototype = NativeIteratorPrototype;
        }
        var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
        GeneratorFunctionPrototype.constructor = GeneratorFunction;
        GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
        function defineIteratorMethods(prototype) {
          ["next", "throw", "return"].forEach(function(method) {
            prototype[method] = function(arg) {
              return this._invoke(method, arg);
            };
          });
        }
        runtime.isGeneratorFunction = function(genFun) {
          var ctor = typeof genFun === "function" && genFun.constructor;
          return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
        };
        runtime.mark = function(genFun) {
          if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
          } else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            if (!(toStringTagSymbol in genFun)) {
              genFun[toStringTagSymbol] = "GeneratorFunction";
            }
          }
          genFun.prototype = Object.create(Gp);
          return genFun;
        };
        runtime.awrap = function(arg) {
          return { __await: arg };
        };
        function AsyncIterator(generator) {
          function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") {
              reject(record.arg);
            } else {
              var result = record.arg;
              var value = result.value;
              if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                return Promise.resolve(value.__await).then(function(value2) {
                  invoke("next", value2, resolve, reject);
                }, function(err) {
                  invoke("throw", err, resolve, reject);
                });
              }
              return Promise.resolve(value).then(function(unwrapped) {
                result.value = unwrapped;
                resolve(result);
              }, reject);
            }
          }
          if (typeof global2.process === "object" && global2.process.domain) {
            invoke = global2.process.domain.bind(invoke);
          }
          var previousPromise;
          function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new Promise(function(resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(
              callInvokeWithMethodAndArg,
              // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg
            ) : callInvokeWithMethodAndArg();
          }
          this._invoke = enqueue;
        }
        defineIteratorMethods(AsyncIterator.prototype);
        AsyncIterator.prototype[asyncIteratorSymbol] = function() {
          return this;
        };
        runtime.AsyncIterator = AsyncIterator;
        runtime.async = function(innerFn, outerFn, self2, tryLocsList) {
          var iter = new AsyncIterator(
            wrap(innerFn, outerFn, self2, tryLocsList)
          );
          return runtime.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
          });
        };
        function makeInvokeMethod(innerFn, self2, context) {
          var state = GenStateSuspendedStart;
          return function invoke(method, arg) {
            if (state === GenStateExecuting) {
              throw new Error("Generator is already running");
            }
            if (state === GenStateCompleted) {
              if (method === "throw") {
                throw arg;
              }
              return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while (true) {
              var delegate = context.delegate;
              if (delegate) {
                var delegateResult = maybeInvokeDelegate(delegate, context);
                if (delegateResult) {
                  if (delegateResult === ContinueSentinel) continue;
                  return delegateResult;
                }
              }
              if (context.method === "next") {
                context.sent = context._sent = context.arg;
              } else if (context.method === "throw") {
                if (state === GenStateSuspendedStart) {
                  state = GenStateCompleted;
                  throw context.arg;
                }
                context.dispatchException(context.arg);
              } else if (context.method === "return") {
                context.abrupt("return", context.arg);
              }
              state = GenStateExecuting;
              var record = tryCatch(innerFn, self2, context);
              if (record.type === "normal") {
                state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                if (record.arg === ContinueSentinel) {
                  continue;
                }
                return {
                  value: record.arg,
                  done: context.done
                };
              } else if (record.type === "throw") {
                state = GenStateCompleted;
                context.method = "throw";
                context.arg = record.arg;
              }
            }
          };
        }
        function maybeInvokeDelegate(delegate, context) {
          var method = delegate.iterator[context.method];
          if (method === undefined2) {
            context.delegate = null;
            if (context.method === "throw") {
              if (delegate.iterator.return) {
                context.method = "return";
                context.arg = undefined2;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") {
                  return ContinueSentinel;
                }
              }
              context.method = "throw";
              context.arg = new TypeError(
                "The iterator does not provide a 'throw' method"
              );
            }
            return ContinueSentinel;
          }
          var record = tryCatch(method, delegate.iterator, context.arg);
          if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
          }
          var info = record.arg;
          if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
          }
          if (info.done) {
            context[delegate.resultName] = info.value;
            context.next = delegate.nextLoc;
            if (context.method !== "return") {
              context.method = "next";
              context.arg = undefined2;
            }
          } else {
            return info;
          }
          context.delegate = null;
          return ContinueSentinel;
        }
        defineIteratorMethods(Gp);
        Gp[toStringTagSymbol] = "Generator";
        Gp[iteratorSymbol] = function() {
          return this;
        };
        Gp.toString = function() {
          return "[object Generator]";
        };
        function pushTryEntry(locs) {
          var entry = { tryLoc: locs[0] };
          if (1 in locs) {
            entry.catchLoc = locs[1];
          }
          if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
          }
          this.tryEntries.push(entry);
        }
        function resetTryEntry(entry) {
          var record = entry.completion || {};
          record.type = "normal";
          delete record.arg;
          entry.completion = record;
        }
        function Context(tryLocsList) {
          this.tryEntries = [{ tryLoc: "root" }];
          tryLocsList.forEach(pushTryEntry, this);
          this.reset(true);
        }
        runtime.keys = function(object) {
          var keys = [];
          for (var key in object) {
            keys.push(key);
          }
          keys.reverse();
          return function next() {
            while (keys.length) {
              var key2 = keys.pop();
              if (key2 in object) {
                next.value = key2;
                next.done = false;
                return next;
              }
            }
            next.done = true;
            return next;
          };
        };
        function values(iterable) {
          if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) {
              return iteratorMethod.call(iterable);
            }
            if (typeof iterable.next === "function") {
              return iterable;
            }
            if (!isNaN(iterable.length)) {
              var i = -1, next = function next2() {
                while (++i < iterable.length) {
                  if (hasOwn.call(iterable, i)) {
                    next2.value = iterable[i];
                    next2.done = false;
                    return next2;
                  }
                }
                next2.value = undefined2;
                next2.done = true;
                return next2;
              };
              return next.next = next;
            }
          }
          return { next: doneResult };
        }
        runtime.values = values;
        function doneResult() {
          return { value: undefined2, done: true };
        }
        Context.prototype = {
          constructor: Context,
          reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            this.sent = this._sent = undefined2;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined2;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
              for (var name in this) {
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                  this[name] = undefined2;
                }
              }
            }
          },
          stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") {
              throw rootRecord.arg;
            }
            return this.rval;
          },
          dispatchException: function(exception) {
            if (this.done) {
              throw exception;
            }
            var context = this;
            function handle(loc, caught) {
              record.type = "throw";
              record.arg = exception;
              context.next = loc;
              if (caught) {
                context.method = "next";
                context.arg = undefined2;
              }
              return !!caught;
            }
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              var record = entry.completion;
              if (entry.tryLoc === "root") {
                return handle("end");
              }
              if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, "catchLoc");
                var hasFinally = hasOwn.call(entry, "finallyLoc");
                if (hasCatch && hasFinally) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  } else if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else if (hasCatch) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  }
                } else if (hasFinally) {
                  if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else {
                  throw new Error("try statement without catch or finally");
                }
              }
            }
          },
          abrupt: function(type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
              }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
              finallyEntry = null;
            }
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
              this.method = "next";
              this.next = finallyEntry.finallyLoc;
              return ContinueSentinel;
            }
            return this.complete(record);
          },
          complete: function(record, afterLoc) {
            if (record.type === "throw") {
              throw record.arg;
            }
            if (record.type === "break" || record.type === "continue") {
              this.next = record.arg;
            } else if (record.type === "return") {
              this.rval = this.arg = record.arg;
              this.method = "return";
              this.next = "end";
            } else if (record.type === "normal" && afterLoc) {
              this.next = afterLoc;
            }
            return ContinueSentinel;
          },
          finish: function(finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.finallyLoc === finallyLoc) {
                this.complete(entry.completion, entry.afterLoc);
                resetTryEntry(entry);
                return ContinueSentinel;
              }
            }
          },
          "catch": function(tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc === tryLoc) {
                var record = entry.completion;
                if (record.type === "throw") {
                  var thrown = record.arg;
                  resetTryEntry(entry);
                }
                return thrown;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
              iterator: values(iterable),
              resultName,
              nextLoc
            };
            if (this.method === "next") {
              this.arg = undefined2;
            }
            return ContinueSentinel;
          }
        };
      }(
        // Among the various tricks for obtaining a reference to the global
        // object, this seems to be the most reliable technique that does not
        // use indirect eval (which violates Content Security Policy).
        typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : exports
      );
    }
  });

  // node_modules/core-js/modules/_replacer.js
  var require_replacer = __commonJS({
    "node_modules/core-js/modules/_replacer.js"(exports, module) {
      module.exports = function(regExp, replace) {
        var replacer = replace === Object(replace) ? function(part) {
          return replace[part];
        } : replace;
        return function(it) {
          return String(it).replace(regExp, replacer);
        };
      };
    }
  });

  // node_modules/core-js/modules/core.regexp.escape.js
  var require_core_regexp_escape = __commonJS({
    "node_modules/core-js/modules/core.regexp.escape.js"() {
      var $export = require_export();
      var $re = require_replacer()(/[\\^$*+?.()|[\]{}]/g, "\\$&");
      $export($export.S, "RegExp", { escape: function escape(it) {
        return $re(it);
      } });
    }
  });

  // node_modules/core-js/fn/regexp/escape.js
  var require_escape = __commonJS({
    "node_modules/core-js/fn/regexp/escape.js"(exports, module) {
      require_core_regexp_escape();
      module.exports = require_core().RegExp.escape;
    }
  });

  // node_modules/babel-polyfill/lib/index.js
  require_shim();
  require_runtime();
  require_escape();
  if (global._babelPolyfill) {
    throw new Error("only one instance of babel-polyfill is allowed");
  }
  global._babelPolyfill = true;
  var DEFINE_PROPERTY = "defineProperty";
  function define(O, key, value) {
    O[key] || Object[DEFINE_PROPERTY](O, key, {
      writable: true,
      configurable: true,
      value
    });
  }
  define(String.prototype, "padLeft", "".padStart);
  define(String.prototype, "padRight", "".padEnd);
  "pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function(key) {
    [][key] && define(Array, key, Function.call.bind([][key]));
  });

  // node_modules/array-flat-polyfill/index.mjs
  Array.prototype.flat || Object.defineProperty(Array.prototype, "flat", { configurable: true, value: function r() {
    var t = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
    return t ? Array.prototype.reduce.call(this, function(a, e) {
      return Array.isArray(e) ? a.push.apply(a, r.call(e, t - 1)) : a.push(e), a;
    }, []) : Array.prototype.slice.call(this);
  }, writable: true }), Array.prototype.flatMap || Object.defineProperty(Array.prototype, "flatMap", { configurable: true, value: function(r2) {
    return Array.prototype.map.apply(this, arguments).flat();
  }, writable: true });

  // scripts/core/owl.carousel.min.js
  !function(a, b, c, d) {
    function e(b2, c2) {
      this.settings = null, this.options = a.extend({}, e.Defaults, c2), this.$element = a(b2), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = { time: null, target: null, pointer: null, stage: { start: null, current: null }, direction: null }, this._states = { current: {}, tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] } }, a.each(["onResize", "onThrottledResize"], a.proxy(function(b3, c3) {
        this._handlers[c3] = a.proxy(this[c3], this);
      }, this)), a.each(e.Plugins, a.proxy(function(a2, b3) {
        this._plugins[a2.charAt(0).toLowerCase() + a2.slice(1)] = new b3(this);
      }, this)), a.each(e.Workers, a.proxy(function(b3, c3) {
        this._pipe.push({ filter: c3.filter, run: a.proxy(c3.run, this) });
      }, this)), this.setup(), this.initialize();
    }
    e.Defaults = { items: 3, loop: false, center: false, rewind: false, checkVisibility: true, mouseDrag: true, touchDrag: true, pullDrag: true, freeDrag: false, margin: 0, stagePadding: 0, merge: false, mergeFit: true, autoWidth: false, startPosition: 0, rtl: false, smartSpeed: 250, fluidSpeed: false, dragEndSpeed: false, responsive: {}, responsiveRefreshRate: 200, responsiveBaseElement: b, fallbackEasing: "swing", slideTransition: "", info: false, nestedItemSelector: false, itemElement: "div", stageElement: "div", refreshClass: "owl-refresh", loadedClass: "owl-loaded", loadingClass: "owl-loading", rtlClass: "owl-rtl", responsiveClass: "owl-responsive", dragClass: "owl-drag", itemClass: "owl-item", stageClass: "owl-stage", stageOuterClass: "owl-stage-outer", grabClass: "owl-grab" }, e.Width = { Default: "default", Inner: "inner", Outer: "outer" }, e.Type = { Event: "event", State: "state" }, e.Plugins = {}, e.Workers = [{ filter: ["width", "settings"], run: function() {
      this._width = this.$element.width();
    } }, { filter: ["width", "items", "settings"], run: function(a2) {
      a2.current = this._items && this._items[this.relative(this._current)];
    } }, { filter: ["items", "settings"], run: function() {
      this.$stage.children(".cloned").remove();
    } }, { filter: ["width", "items", "settings"], run: function(a2) {
      var b2 = this.settings.margin || "", c2 = !this.settings.autoWidth, d2 = this.settings.rtl, e2 = { width: "auto", "margin-left": d2 ? b2 : "", "margin-right": d2 ? "" : b2 };
      !c2 && this.$stage.children().css(e2), a2.css = e2;
    } }, { filter: ["width", "items", "settings"], run: function(a2) {
      var b2 = (this.width() / this.settings.items).toFixed(3) - this.settings.margin, c2 = null, d2 = this._items.length, e2 = !this.settings.autoWidth, f = [];
      for (a2.items = { merge: false, width: b2 }; d2--; ) c2 = this._mergers[d2], c2 = this.settings.mergeFit && Math.min(c2, this.settings.items) || c2, a2.items.merge = c2 > 1 || a2.items.merge, f[d2] = e2 ? b2 * c2 : this._items[d2].width();
      this._widths = f;
    } }, { filter: ["items", "settings"], run: function() {
      var b2 = [], c2 = this._items, d2 = this.settings, e2 = Math.max(2 * d2.items, 4), f = 2 * Math.ceil(c2.length / 2), g = d2.loop && c2.length ? d2.rewind ? e2 : Math.max(e2, f) : 0, h = "", i = "";
      for (g /= 2; g > 0; ) b2.push(this.normalize(b2.length / 2, true)), h += c2[b2[b2.length - 1]][0].outerHTML, b2.push(this.normalize(c2.length - 1 - (b2.length - 1) / 2, true)), i = c2[b2[b2.length - 1]][0].outerHTML + i, g -= 1;
      this._clones = b2, a(h).addClass("cloned").appendTo(this.$stage), a(i).addClass("cloned").prependTo(this.$stage);
    } }, { filter: ["width", "items", "settings"], run: function() {
      for (var a2 = this.settings.rtl ? 1 : -1, b2 = this._clones.length + this._items.length, c2 = -1, d2 = 0, e2 = 0, f = []; ++c2 < b2; ) d2 = f[c2 - 1] || 0, e2 = this._widths[this.relative(c2)] + this.settings.margin, f.push(d2 + e2 * a2);
      this._coordinates = f;
    } }, { filter: ["width", "items", "settings"], run: function() {
      var a2 = this.settings.stagePadding, b2 = this._coordinates, c2 = { width: Math.ceil(Math.abs(b2[b2.length - 1])) + 2 * a2, "padding-left": a2 || "", "padding-right": a2 || "" };
      this.$stage.css(c2);
    } }, { filter: ["width", "items", "settings"], run: function(a2) {
      var b2 = this._coordinates.length, c2 = !this.settings.autoWidth, d2 = this.$stage.children();
      if (c2 && a2.items.merge) for (; b2--; ) a2.css.width = this._widths[this.relative(b2)], d2.eq(b2).css(a2.css);
      else c2 && (a2.css.width = a2.items.width, d2.css(a2.css));
    } }, { filter: ["items"], run: function() {
      this._coordinates.length < 1 && this.$stage.removeAttr("style");
    } }, { filter: ["width", "items", "settings"], run: function(a2) {
      a2.current = a2.current ? this.$stage.children().index(a2.current) : 0, a2.current = Math.max(this.minimum(), Math.min(this.maximum(), a2.current)), this.reset(a2.current);
    } }, { filter: ["position"], run: function() {
      this.animate(this.coordinates(this._current));
    } }, { filter: ["width", "position", "items", "settings"], run: function() {
      var a2, b2, c2, d2, e2 = this.settings.rtl ? 1 : -1, f = 2 * this.settings.stagePadding, g = this.coordinates(this.current()) + f, h = g + this.width() * e2, i = [];
      for (c2 = 0, d2 = this._coordinates.length; c2 < d2; c2++) a2 = this._coordinates[c2 - 1] || 0, b2 = Math.abs(this._coordinates[c2]) + f * e2, (this.op(a2, "<=", g) && this.op(a2, ">", h) || this.op(b2, "<", g) && this.op(b2, ">", h)) && i.push(c2);
      this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass("active"), this.$stage.children(".center").removeClass("center"), this.settings.center && this.$stage.children().eq(this.current()).addClass("center");
    } }], e.prototype.initializeStage = function() {
      this.$stage = this.$element.find("." + this.settings.stageClass), this.$stage.length || (this.$element.addClass(this.options.loadingClass), this.$stage = a("<" + this.settings.stageElement + ">", { class: this.settings.stageClass }).wrap(a("<div/>", { class: this.settings.stageOuterClass })), this.$element.append(this.$stage.parent()));
    }, e.prototype.initializeItems = function() {
      var b2 = this.$element.find(".owl-item");
      if (b2.length) return this._items = b2.get().map(function(b3) {
        return a(b3);
      }), this._mergers = this._items.map(function() {
        return 1;
      }), void this.refresh();
      this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);
    }, e.prototype.initialize = function() {
      if (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) {
        var a2, b2, c2;
        a2 = this.$element.find("img"), b2 = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d, c2 = this.$element.children(b2).width(), a2.length && c2 <= 0 && this.preloadAutoWidthImages(a2);
      }
      this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized");
    }, e.prototype.isVisible = function() {
      return !this.settings.checkVisibility || this.$element.is(":visible");
    }, e.prototype.setup = function() {
      var b2 = this.viewport(), c2 = this.options.responsive, d2 = -1, e2 = null;
      c2 ? (a.each(c2, function(a2) {
        a2 <= b2 && a2 > d2 && (d2 = Number(a2));
      }), e2 = a.extend({}, this.options, c2[d2]), "function" == typeof e2.stagePadding && (e2.stagePadding = e2.stagePadding()), delete e2.responsive, e2.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + d2))) : e2 = a.extend({}, this.options), this.trigger("change", { property: { name: "settings", value: e2 } }), this._breakpoint = d2, this.settings = e2, this.invalidate("settings"), this.trigger("changed", { property: { name: "settings", value: this.settings } });
    }, e.prototype.optionsLogic = function() {
      this.settings.autoWidth && (this.settings.stagePadding = false, this.settings.merge = false);
    }, e.prototype.prepare = function(b2) {
      var c2 = this.trigger("prepare", { content: b2 });
      return c2.data || (c2.data = a("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(b2)), this.trigger("prepared", { content: c2.data }), c2.data;
    }, e.prototype.update = function() {
      for (var b2 = 0, c2 = this._pipe.length, d2 = a.proxy(function(a2) {
        return this[a2];
      }, this._invalidated), e2 = {}; b2 < c2; ) (this._invalidated.all || a.grep(this._pipe[b2].filter, d2).length > 0) && this._pipe[b2].run(e2), b2++;
      this._invalidated = {}, !this.is("valid") && this.enter("valid");
    }, e.prototype.width = function(a2) {
      switch (a2 = a2 || e.Width.Default) {
        case e.Width.Inner:
        case e.Width.Outer:
          return this._width;
        default:
          return this._width - 2 * this.settings.stagePadding + this.settings.margin;
      }
    }, e.prototype.refresh = function() {
      this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed");
    }, e.prototype.onThrottledResize = function() {
      b.clearTimeout(this.resizeTimer), this.resizeTimer = b.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
    }, e.prototype.onResize = function() {
      return !!this._items.length && (this._width !== this.$element.width() && (!!this.isVisible() && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), false) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))));
    }, e.prototype.registerEventHandlers = function() {
      a.support.transition && this.$stage.on(a.support.transition.end + ".owl.core", a.proxy(this.onTransitionEnd, this)), false !== this.settings.responsive && this.on(b, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function() {
        return false;
      })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", a.proxy(this.onDragEnd, this)));
    }, e.prototype.onDragStart = function(b2) {
      var d2 = null;
      3 !== b2.which && (a.support.transform ? (d2 = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","), d2 = { x: d2[16 === d2.length ? 12 : 4], y: d2[16 === d2.length ? 13 : 5] }) : (d2 = this.$stage.position(), d2 = { x: this.settings.rtl ? d2.left + this.$stage.width() - this.width() + this.settings.margin : d2.left, y: d2.top }), this.is("animating") && (a.support.transform ? this.animate(d2.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === b2.type), this.speed(0), this._drag.time = (/* @__PURE__ */ new Date()).getTime(), this._drag.target = a(b2.target), this._drag.stage.start = d2, this._drag.stage.current = d2, this._drag.pointer = this.pointer(b2), a(c).on("mouseup.owl.core touchend.owl.core", a.proxy(this.onDragEnd, this)), a(c).one("mousemove.owl.core touchmove.owl.core", a.proxy(function(b3) {
        var d3 = this.difference(this._drag.pointer, this.pointer(b3));
        a(c).on("mousemove.owl.core touchmove.owl.core", a.proxy(this.onDragMove, this)), Math.abs(d3.x) < Math.abs(d3.y) && this.is("valid") || (b3.preventDefault(), this.enter("dragging"), this.trigger("drag"));
      }, this)));
    }, e.prototype.onDragMove = function(a2) {
      var b2 = null, c2 = null, d2 = null, e2 = this.difference(this._drag.pointer, this.pointer(a2)), f = this.difference(this._drag.stage.start, e2);
      this.is("dragging") && (a2.preventDefault(), this.settings.loop ? (b2 = this.coordinates(this.minimum()), c2 = this.coordinates(this.maximum() + 1) - b2, f.x = ((f.x - b2) % c2 + c2) % c2 + b2) : (b2 = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), c2 = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), d2 = this.settings.pullDrag ? -1 * e2.x / 5 : 0, f.x = Math.max(Math.min(f.x, b2 + d2), c2 + d2)), this._drag.stage.current = f, this.animate(f.x));
    }, e.prototype.onDragEnd = function(b2) {
      var d2 = this.difference(this._drag.pointer, this.pointer(b2)), e2 = this._drag.stage.current, f = d2.x > 0 ^ this.settings.rtl ? "left" : "right";
      a(c).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== d2.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(e2.x, 0 !== d2.x ? f : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = f, (Math.abs(d2.x) > 3 || (/* @__PURE__ */ new Date()).getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function() {
        return false;
      })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
    }, e.prototype.closest = function(b2, c2) {
      var e2 = -1, f = 30, g = this.width(), h = this.coordinates();
      return this.settings.freeDrag || a.each(h, a.proxy(function(a2, i) {
        return "left" === c2 && b2 > i - f && b2 < i + f ? e2 = a2 : "right" === c2 && b2 > i - g - f && b2 < i - g + f ? e2 = a2 + 1 : this.op(b2, "<", i) && this.op(b2, ">", h[a2 + 1] !== d ? h[a2 + 1] : i - g) && (e2 = "left" === c2 ? a2 + 1 : a2), -1 === e2;
      }, this)), this.settings.loop || (this.op(b2, ">", h[this.minimum()]) ? e2 = b2 = this.minimum() : this.op(b2, "<", h[this.maximum()]) && (e2 = b2 = this.maximum())), e2;
    }, e.prototype.animate = function(b2) {
      var c2 = this.speed() > 0;
      this.is("animating") && this.onTransitionEnd(), c2 && (this.enter("animating"), this.trigger("translate")), a.support.transform3d && a.support.transition ? this.$stage.css({ transform: "translate3d(" + b2 + "px,0px,0px)", transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "") }) : c2 ? this.$stage.animate({ left: b2 + "px" }, this.speed(), this.settings.fallbackEasing, a.proxy(this.onTransitionEnd, this)) : this.$stage.css({ left: b2 + "px" });
    }, e.prototype.is = function(a2) {
      return this._states.current[a2] && this._states.current[a2] > 0;
    }, e.prototype.current = function(a2) {
      if (a2 === d) return this._current;
      if (0 === this._items.length) return d;
      if (a2 = this.normalize(a2), this._current !== a2) {
        var b2 = this.trigger("change", { property: { name: "position", value: a2 } });
        b2.data !== d && (a2 = this.normalize(b2.data)), this._current = a2, this.invalidate("position"), this.trigger("changed", { property: { name: "position", value: this._current } });
      }
      return this._current;
    }, e.prototype.invalidate = function(b2) {
      return "string" === a.type(b2) && (this._invalidated[b2] = true, this.is("valid") && this.leave("valid")), a.map(this._invalidated, function(a2, b3) {
        return b3;
      });
    }, e.prototype.reset = function(a2) {
      (a2 = this.normalize(a2)) !== d && (this._speed = 0, this._current = a2, this.suppress(["translate", "translated"]), this.animate(this.coordinates(a2)), this.release(["translate", "translated"]));
    }, e.prototype.normalize = function(a2, b2) {
      var c2 = this._items.length, e2 = b2 ? 0 : this._clones.length;
      return !this.isNumeric(a2) || c2 < 1 ? a2 = d : (a2 < 0 || a2 >= c2 + e2) && (a2 = ((a2 - e2 / 2) % c2 + c2) % c2 + e2 / 2), a2;
    }, e.prototype.relative = function(a2) {
      return a2 -= this._clones.length / 2, this.normalize(a2, true);
    }, e.prototype.maximum = function(a2) {
      var b2, c2, d2, e2 = this.settings, f = this._coordinates.length;
      if (e2.loop) f = this._clones.length / 2 + this._items.length - 1;
      else if (e2.autoWidth || e2.merge) {
        if (b2 = this._items.length) for (c2 = this._items[--b2].width(), d2 = this.$element.width(); b2-- && !((c2 += this._items[b2].width() + this.settings.margin) > d2); ) ;
        f = b2 + 1;
      } else f = e2.center ? this._items.length - 1 : this._items.length - e2.items;
      return a2 && (f -= this._clones.length / 2), Math.max(f, 0);
    }, e.prototype.minimum = function(a2) {
      return a2 ? 0 : this._clones.length / 2;
    }, e.prototype.items = function(a2) {
      return a2 === d ? this._items.slice() : (a2 = this.normalize(a2, true), this._items[a2]);
    }, e.prototype.mergers = function(a2) {
      return a2 === d ? this._mergers.slice() : (a2 = this.normalize(a2, true), this._mergers[a2]);
    }, e.prototype.clones = function(b2) {
      var c2 = this._clones.length / 2, e2 = c2 + this._items.length, f = function(a2) {
        return a2 % 2 == 0 ? e2 + a2 / 2 : c2 - (a2 + 1) / 2;
      };
      return b2 === d ? a.map(this._clones, function(a2, b3) {
        return f(b3);
      }) : a.map(this._clones, function(a2, c3) {
        return a2 === b2 ? f(c3) : null;
      });
    }, e.prototype.speed = function(a2) {
      return a2 !== d && (this._speed = a2), this._speed;
    }, e.prototype.coordinates = function(b2) {
      var c2, e2 = 1, f = b2 - 1;
      return b2 === d ? a.map(this._coordinates, a.proxy(function(a2, b3) {
        return this.coordinates(b3);
      }, this)) : (this.settings.center ? (this.settings.rtl && (e2 = -1, f = b2 + 1), c2 = this._coordinates[b2], c2 += (this.width() - c2 + (this._coordinates[f] || 0)) / 2 * e2) : c2 = this._coordinates[f] || 0, c2 = Math.ceil(c2));
    }, e.prototype.duration = function(a2, b2, c2) {
      return 0 === c2 ? 0 : Math.min(Math.max(Math.abs(b2 - a2), 1), 6) * Math.abs(c2 || this.settings.smartSpeed);
    }, e.prototype.to = function(a2, b2) {
      var c2 = this.current(), d2 = null, e2 = a2 - this.relative(c2), f = (e2 > 0) - (e2 < 0), g = this._items.length, h = this.minimum(), i = this.maximum();
      this.settings.loop ? (!this.settings.rewind && Math.abs(e2) > g / 2 && (e2 += -1 * f * g), a2 = c2 + e2, (d2 = ((a2 - h) % g + g) % g + h) !== a2 && d2 - e2 <= i && d2 - e2 > 0 && (c2 = d2 - e2, a2 = d2, this.reset(c2))) : this.settings.rewind ? (i += 1, a2 = (a2 % i + i) % i) : a2 = Math.max(h, Math.min(i, a2)), this.speed(this.duration(c2, a2, b2)), this.current(a2), this.isVisible() && this.update();
    }, e.prototype.next = function(a2) {
      a2 = a2 || false, this.to(this.relative(this.current()) + 1, a2);
    }, e.prototype.prev = function(a2) {
      a2 = a2 || false, this.to(this.relative(this.current()) - 1, a2);
    }, e.prototype.onTransitionEnd = function(a2) {
      if (a2 !== d && (a2.stopPropagation(), (a2.target || a2.srcElement || a2.originalTarget) !== this.$stage.get(0))) return false;
      this.leave("animating"), this.trigger("translated");
    }, e.prototype.viewport = function() {
      var d2;
      return this.options.responsiveBaseElement !== b ? d2 = a(this.options.responsiveBaseElement).width() : b.innerWidth ? d2 = b.innerWidth : c.documentElement && c.documentElement.clientWidth ? d2 = c.documentElement.clientWidth : console.warn("Can not detect viewport width."), d2;
    }, e.prototype.replace = function(b2) {
      this.$stage.empty(), this._items = [], b2 && (b2 = b2 instanceof jQuery ? b2 : a(b2)), this.settings.nestedItemSelector && (b2 = b2.find("." + this.settings.nestedItemSelector)), b2.filter(function() {
        return 1 === this.nodeType;
      }).each(a.proxy(function(a2, b3) {
        b3 = this.prepare(b3), this.$stage.append(b3), this._items.push(b3), this._mergers.push(1 * b3.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1);
      }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items");
    }, e.prototype.add = function(b2, c2) {
      var e2 = this.relative(this._current);
      c2 = c2 === d ? this._items.length : this.normalize(c2, true), b2 = b2 instanceof jQuery ? b2 : a(b2), this.trigger("add", { content: b2, position: c2 }), b2 = this.prepare(b2), 0 === this._items.length || c2 === this._items.length ? (0 === this._items.length && this.$stage.append(b2), 0 !== this._items.length && this._items[c2 - 1].after(b2), this._items.push(b2), this._mergers.push(1 * b2.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[c2].before(b2), this._items.splice(c2, 0, b2), this._mergers.splice(c2, 0, 1 * b2.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[e2] && this.reset(this._items[e2].index()), this.invalidate("items"), this.trigger("added", { content: b2, position: c2 });
    }, e.prototype.remove = function(a2) {
      (a2 = this.normalize(a2, true)) !== d && (this.trigger("remove", { content: this._items[a2], position: a2 }), this._items[a2].remove(), this._items.splice(a2, 1), this._mergers.splice(a2, 1), this.invalidate("items"), this.trigger("removed", { content: null, position: a2 }));
    }, e.prototype.preloadAutoWidthImages = function(b2) {
      b2.each(a.proxy(function(b3, c2) {
        this.enter("pre-loading"), c2 = a(c2), a(new Image()).one("load", a.proxy(function(a2) {
          c2.attr("src", a2.target.src), c2.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh();
        }, this)).attr("src", c2.attr("src") || c2.attr("data-src") || c2.attr("data-src-retina"));
      }, this));
    }, e.prototype.destroy = function() {
      this.$element.off(".owl.core"), this.$stage.off(".owl.core"), a(c).off(".owl.core"), false !== this.settings.responsive && (b.clearTimeout(this.resizeTimer), this.off(b, "resize", this._handlers.onThrottledResize));
      for (var d2 in this._plugins) this._plugins[d2].destroy();
      this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.remove(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel");
    }, e.prototype.op = function(a2, b2, c2) {
      var d2 = this.settings.rtl;
      switch (b2) {
        case "<":
          return d2 ? a2 > c2 : a2 < c2;
        case ">":
          return d2 ? a2 < c2 : a2 > c2;
        case ">=":
          return d2 ? a2 <= c2 : a2 >= c2;
        case "<=":
          return d2 ? a2 >= c2 : a2 <= c2;
      }
    }, e.prototype.on = function(a2, b2, c2, d2) {
      a2.addEventListener ? a2.addEventListener(b2, c2, d2) : a2.attachEvent && a2.attachEvent("on" + b2, c2);
    }, e.prototype.off = function(a2, b2, c2, d2) {
      a2.removeEventListener ? a2.removeEventListener(b2, c2, d2) : a2.detachEvent && a2.detachEvent("on" + b2, c2);
    }, e.prototype.trigger = function(b2, c2, d2, f, g) {
      var h = { item: { count: this._items.length, index: this.current() } }, i = a.camelCase(a.grep(["on", b2, d2], function(a2) {
        return a2;
      }).join("-").toLowerCase()), j = a.Event([b2, "owl", d2 || "carousel"].join(".").toLowerCase(), a.extend({ relatedTarget: this }, h, c2));
      return this._supress[b2] || (a.each(this._plugins, function(a2, b3) {
        b3.onTrigger && b3.onTrigger(j);
      }), this.register({ type: e.Type.Event, name: b2 }), this.$element.trigger(j), this.settings && "function" == typeof this.settings[i] && this.settings[i].call(this, j)), j;
    }, e.prototype.enter = function(b2) {
      a.each([b2].concat(this._states.tags[b2] || []), a.proxy(function(a2, b3) {
        this._states.current[b3] === d && (this._states.current[b3] = 0), this._states.current[b3]++;
      }, this));
    }, e.prototype.leave = function(b2) {
      a.each([b2].concat(this._states.tags[b2] || []), a.proxy(function(a2, b3) {
        this._states.current[b3]--;
      }, this));
    }, e.prototype.register = function(b2) {
      if (b2.type === e.Type.Event) {
        if (a.event.special[b2.name] || (a.event.special[b2.name] = {}), !a.event.special[b2.name].owl) {
          var c2 = a.event.special[b2.name]._default;
          a.event.special[b2.name]._default = function(a2) {
            return !c2 || !c2.apply || a2.namespace && -1 !== a2.namespace.indexOf("owl") ? a2.namespace && a2.namespace.indexOf("owl") > -1 : c2.apply(this, arguments);
          }, a.event.special[b2.name].owl = true;
        }
      } else b2.type === e.Type.State && (this._states.tags[b2.name] ? this._states.tags[b2.name] = this._states.tags[b2.name].concat(b2.tags) : this._states.tags[b2.name] = b2.tags, this._states.tags[b2.name] = a.grep(this._states.tags[b2.name], a.proxy(function(c3, d2) {
        return a.inArray(c3, this._states.tags[b2.name]) === d2;
      }, this)));
    }, e.prototype.suppress = function(b2) {
      a.each(b2, a.proxy(function(a2, b3) {
        this._supress[b3] = true;
      }, this));
    }, e.prototype.release = function(b2) {
      a.each(b2, a.proxy(function(a2, b3) {
        delete this._supress[b3];
      }, this));
    }, e.prototype.pointer = function(a2) {
      var c2 = { x: null, y: null };
      return a2 = a2.originalEvent || a2 || b.event, a2 = a2.touches && a2.touches.length ? a2.touches[0] : a2.changedTouches && a2.changedTouches.length ? a2.changedTouches[0] : a2, a2.pageX ? (c2.x = a2.pageX, c2.y = a2.pageY) : (c2.x = a2.clientX, c2.y = a2.clientY), c2;
    }, e.prototype.isNumeric = function(a2) {
      return !isNaN(parseFloat(a2));
    }, e.prototype.difference = function(a2, b2) {
      return { x: a2.x - b2.x, y: a2.y - b2.y };
    }, a.fn.owlCarousel = function(b2) {
      var c2 = Array.prototype.slice.call(arguments, 1);
      return this.each(function() {
        var d2 = a(this), f = d2.data("owl.carousel");
        f || (f = new e(this, "object" == typeof b2 && b2), d2.data("owl.carousel", f), a.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function(b3, c3) {
          f.register({ type: e.Type.Event, name: c3 }), f.$element.on(c3 + ".owl.carousel.core", a.proxy(function(a2) {
            a2.namespace && a2.relatedTarget !== this && (this.suppress([c3]), f[c3].apply(this, [].slice.call(arguments, 1)), this.release([c3]));
          }, f));
        })), "string" == typeof b2 && "_" !== b2.charAt(0) && f[b2].apply(f, c2);
      });
    }, a.fn.owlCarousel.Constructor = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    var e = function(b2) {
      this._core = b2, this._interval = null, this._visible = null, this._handlers = { "initialized.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.settings.autoRefresh && this.watch();
      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers);
    };
    e.Defaults = { autoRefresh: true, autoRefreshInterval: 500 }, e.prototype.watch = function() {
      this._interval || (this._visible = this._core.isVisible(), this._interval = b.setInterval(a.proxy(this.refresh, this), this._core.settings.autoRefreshInterval));
    }, e.prototype.refresh = function() {
      this._core.isVisible() !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh());
    }, e.prototype.destroy = function() {
      var a2, c2;
      b.clearInterval(this._interval);
      for (a2 in this._handlers) this._core.$element.off(a2, this._handlers[a2]);
      for (c2 in Object.getOwnPropertyNames(this)) "function" != typeof this[c2] && (this[c2] = null);
    }, a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    var e = function(b2) {
      this._core = b2, this._loaded = [], this._handlers = { "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function(b3) {
        if (b3.namespace && this._core.settings && this._core.settings.lazyLoad && (b3.property && "position" == b3.property.name || "initialized" == b3.type)) {
          var c2 = this._core.settings, e2 = c2.center && Math.ceil(c2.items / 2) || c2.items, f = c2.center && -1 * e2 || 0, g = (b3.property && b3.property.value !== d ? b3.property.value : this._core.current()) + f, h = this._core.clones().length, i = a.proxy(function(a2, b4) {
            this.load(b4);
          }, this);
          for (c2.lazyLoadEager > 0 && (e2 += c2.lazyLoadEager, c2.loop && (g -= c2.lazyLoadEager, e2++)); f++ < e2; ) this.load(h / 2 + this._core.relative(g)), h && a.each(this._core.clones(this._core.relative(g)), i), g++;
        }
      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers);
    };
    e.Defaults = { lazyLoad: false, lazyLoadEager: 0 }, e.prototype.load = function(c2) {
      var d2 = this._core.$stage.children().eq(c2), e2 = d2 && d2.find(".owl-lazy");
      !e2 || a.inArray(d2.get(0), this._loaded) > -1 || (e2.each(a.proxy(function(c3, d3) {
        var e3, f = a(d3), g = b.devicePixelRatio > 1 && f.attr("data-src-retina") || f.attr("data-src") || f.attr("data-srcset");
        this._core.trigger("load", { element: f, url: g }, "lazy"), f.is("img") ? f.one("load.owl.lazy", a.proxy(function() {
          f.css("opacity", 1), this._core.trigger("loaded", { element: f, url: g }, "lazy");
        }, this)).attr("src", g) : f.is("source") ? f.one("load.owl.lazy", a.proxy(function() {
          this._core.trigger("loaded", { element: f, url: g }, "lazy");
        }, this)).attr("srcset", g) : (e3 = new Image(), e3.onload = a.proxy(function() {
          f.css({ "background-image": 'url("' + g + '")', opacity: "1" }), this._core.trigger("loaded", { element: f, url: g }, "lazy");
        }, this), e3.src = g);
      }, this)), this._loaded.push(d2.get(0)));
    }, e.prototype.destroy = function() {
      var a2, b2;
      for (a2 in this.handlers) this._core.$element.off(a2, this.handlers[a2]);
      for (b2 in Object.getOwnPropertyNames(this)) "function" != typeof this[b2] && (this[b2] = null);
    }, a.fn.owlCarousel.Constructor.Plugins.Lazy = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    var e = function(c2) {
      this._core = c2, this._previousHeight = null, this._handlers = { "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.settings.autoHeight && this.update();
      }, this), "changed.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.settings.autoHeight && "position" === a2.property.name && this.update();
      }, this), "loaded.owl.lazy": a.proxy(function(a2) {
        a2.namespace && this._core.settings.autoHeight && a2.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update();
      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers), this._intervalId = null;
      var d2 = this;
      a(b).on("load", function() {
        d2._core.settings.autoHeight && d2.update();
      }), a(b).resize(function() {
        d2._core.settings.autoHeight && (null != d2._intervalId && clearTimeout(d2._intervalId), d2._intervalId = setTimeout(function() {
          d2.update();
        }, 250));
      });
    };
    e.Defaults = { autoHeight: false, autoHeightClass: "owl-height" }, e.prototype.update = function() {
      var b2 = this._core._current, c2 = b2 + this._core.settings.items, d2 = this._core.settings.lazyLoad, e2 = this._core.$stage.children().toArray().slice(b2, c2), f = [], g = 0;
      a.each(e2, function(b3, c3) {
        f.push(a(c3).height());
      }), g = Math.max.apply(null, f), g <= 1 && d2 && this._previousHeight && (g = this._previousHeight), this._previousHeight = g, this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass);
    }, e.prototype.destroy = function() {
      var a2, b2;
      for (a2 in this._handlers) this._core.$element.off(a2, this._handlers[a2]);
      for (b2 in Object.getOwnPropertyNames(this)) "function" != typeof this[b2] && (this[b2] = null);
    }, a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    var e = function(b2) {
      this._core = b2, this._videos = {}, this._playing = null, this._handlers = { "initialized.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.register({ type: "state", name: "playing", tags: ["interacting"] });
      }, this), "resize.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.settings.video && this.isInFullScreen() && a2.preventDefault();
      }, this), "refreshed.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove();
      }, this), "changed.owl.carousel": a.proxy(function(a2) {
        a2.namespace && "position" === a2.property.name && this._playing && this.stop();
      }, this), "prepared.owl.carousel": a.proxy(function(b3) {
        if (b3.namespace) {
          var c2 = a(b3.content).find(".owl-video");
          c2.length && (c2.css("display", "none"), this.fetch(c2, a(b3.content)));
        }
      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", a.proxy(function(a2) {
        this.play(a2);
      }, this));
    };
    e.Defaults = { video: false, videoHeight: false, videoWidth: false }, e.prototype.fetch = function(a2, b2) {
      var c2 = function() {
        return a2.attr("data-vimeo-id") ? "vimeo" : a2.attr("data-vzaar-id") ? "vzaar" : "youtube";
      }(), d2 = a2.attr("data-vimeo-id") || a2.attr("data-youtube-id") || a2.attr("data-vzaar-id"), e2 = a2.attr("data-width") || this._core.settings.videoWidth, f = a2.attr("data-height") || this._core.settings.videoHeight, g = a2.attr("href");
      if (!g) throw new Error("Missing video URL.");
      if (d2 = g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), d2[3].indexOf("youtu") > -1) c2 = "youtube";
      else if (d2[3].indexOf("vimeo") > -1) c2 = "vimeo";
      else {
        if (!(d2[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
        c2 = "vzaar";
      }
      d2 = d2[6], this._videos[g] = { type: c2, id: d2, width: e2, height: f }, b2.attr("data-video", g), this.thumbnail(a2, this._videos[g]);
    }, e.prototype.thumbnail = function(b2, c2) {
      var d2, e2, f, g = c2.width && c2.height ? "width:" + c2.width + "px;height:" + c2.height + "px;" : "", h = b2.find("img"), i = "src", j = "", k = this._core.settings, l = function(c3) {
        e2 = '<div class="owl-video-play-icon"></div>', d2 = k.lazyLoad ? a("<div/>", { class: "owl-video-tn " + j, srcType: c3 }) : a("<div/>", { class: "owl-video-tn", style: "opacity:1;background-image:url(" + c3 + ")" }), b2.after(d2), b2.after(e2);
      };
      if (b2.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })), this._core.settings.lazyLoad && (i = "data-src", j = "owl-lazy"), h.length) return l(h.attr(i)), h.remove(), false;
      "youtube" === c2.type ? (f = "//img.youtube.com/vi/" + c2.id + "/hqdefault.jpg", l(f)) : "vimeo" === c2.type ? a.ajax({ type: "GET", url: "//vimeo.com/api/v2/video/" + c2.id + ".json", jsonp: "callback", dataType: "jsonp", success: function(a2) {
        f = a2[0].thumbnail_large, l(f);
      } }) : "vzaar" === c2.type && a.ajax({ type: "GET", url: "//vzaar.com/api/videos/" + c2.id + ".json", jsonp: "callback", dataType: "jsonp", success: function(a2) {
        f = a2.framegrab_url, l(f);
      } });
    }, e.prototype.stop = function() {
      this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video");
    }, e.prototype.play = function(b2) {
      var c2, d2 = a(b2.target), e2 = d2.closest("." + this._core.settings.itemClass), f = this._videos[e2.attr("data-video")], g = f.width || "100%", h = f.height || this._core.$stage.height();
      this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), e2 = this._core.items(this._core.relative(e2.index())), this._core.reset(e2.index()), c2 = a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'), c2.attr("height", h), c2.attr("width", g), "youtube" === f.type ? c2.attr("src", "//www.youtube.com/embed/" + f.id + "?autoplay=1&rel=0&v=" + f.id) : "vimeo" === f.type ? c2.attr("src", "//player.vimeo.com/video/" + f.id + "?autoplay=1") : "vzaar" === f.type && c2.attr("src", "//view.vzaar.com/" + f.id + "/player?autoplay=true"), a(c2).wrap('<div class="owl-video-frame" />').insertAfter(e2.find(".owl-video")), this._playing = e2.addClass("owl-video-playing"));
    }, e.prototype.isInFullScreen = function() {
      var b2 = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;
      return b2 && a(b2).parent().hasClass("owl-video-frame");
    }, e.prototype.destroy = function() {
      var a2, b2;
      this._core.$element.off("click.owl.video");
      for (a2 in this._handlers) this._core.$element.off(a2, this._handlers[a2]);
      for (b2 in Object.getOwnPropertyNames(this)) "function" != typeof this[b2] && (this[b2] = null);
    }, a.fn.owlCarousel.Constructor.Plugins.Video = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    var e = function(b2) {
      this.core = b2, this.core.options = a.extend({}, e.Defaults, this.core.options), this.swapping = true, this.previous = d, this.next = d, this.handlers = { "change.owl.carousel": a.proxy(function(a2) {
        a2.namespace && "position" == a2.property.name && (this.previous = this.core.current(), this.next = a2.property.value);
      }, this), "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function(a2) {
        a2.namespace && (this.swapping = "translated" == a2.type);
      }, this), "translate.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
      }, this) }, this.core.$element.on(this.handlers);
    };
    e.Defaults = {
      animateOut: false,
      animateIn: false
    }, e.prototype.swap = function() {
      if (1 === this.core.settings.items && a.support.animation && a.support.transition) {
        this.core.speed(0);
        var b2, c2 = a.proxy(this.clear, this), d2 = this.core.$stage.children().eq(this.previous), e2 = this.core.$stage.children().eq(this.next), f = this.core.settings.animateIn, g = this.core.settings.animateOut;
        this.core.current() !== this.previous && (g && (b2 = this.core.coordinates(this.previous) - this.core.coordinates(this.next), d2.one(a.support.animation.end, c2).css({ left: b2 + "px" }).addClass("animated owl-animated-out").addClass(g)), f && e2.one(a.support.animation.end, c2).addClass("animated owl-animated-in").addClass(f));
      }
    }, e.prototype.clear = function(b2) {
      a(b2.target).css({ left: "" }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd();
    }, e.prototype.destroy = function() {
      var a2, b2;
      for (a2 in this.handlers) this.core.$element.off(a2, this.handlers[a2]);
      for (b2 in Object.getOwnPropertyNames(this)) "function" != typeof this[b2] && (this[b2] = null);
    }, a.fn.owlCarousel.Constructor.Plugins.Animate = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    var e = function(b2) {
      this._core = b2, this._call = null, this._time = 0, this._timeout = 0, this._paused = true, this._handlers = { "changed.owl.carousel": a.proxy(function(a2) {
        a2.namespace && "settings" === a2.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : a2.namespace && "position" === a2.property.name && this._paused && (this._time = 0);
      }, this), "initialized.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.settings.autoplay && this.play();
      }, this), "play.owl.autoplay": a.proxy(function(a2, b3, c2) {
        a2.namespace && this.play(b3, c2);
      }, this), "stop.owl.autoplay": a.proxy(function(a2) {
        a2.namespace && this.stop();
      }, this), "mouseover.owl.autoplay": a.proxy(function() {
        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
      }, this), "mouseleave.owl.autoplay": a.proxy(function() {
        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
      }, this), "touchstart.owl.core": a.proxy(function() {
        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
      }, this), "touchend.owl.core": a.proxy(function() {
        this._core.settings.autoplayHoverPause && this.play();
      }, this) }, this._core.$element.on(this._handlers), this._core.options = a.extend({}, e.Defaults, this._core.options);
    };
    e.Defaults = { autoplay: false, autoplayTimeout: 5e3, autoplayHoverPause: false, autoplaySpeed: false }, e.prototype._next = function(d2) {
      this._call = b.setTimeout(a.proxy(this._next, this, d2), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()), this._core.is("interacting") || c.hidden || this._core.next(d2 || this._core.settings.autoplaySpeed);
    }, e.prototype.read = function() {
      return (/* @__PURE__ */ new Date()).getTime() - this._time;
    }, e.prototype.play = function(c2, d2) {
      var e2;
      this._core.is("rotating") || this._core.enter("rotating"), c2 = c2 || this._core.settings.autoplayTimeout, e2 = Math.min(this._time % (this._timeout || c2), c2), this._paused ? (this._time = this.read(), this._paused = false) : b.clearTimeout(this._call), this._time += this.read() % c2 - e2, this._timeout = c2, this._call = b.setTimeout(a.proxy(this._next, this, d2), c2 - e2);
    }, e.prototype.stop = function() {
      this._core.is("rotating") && (this._time = 0, this._paused = true, b.clearTimeout(this._call), this._core.leave("rotating"));
    }, e.prototype.pause = function() {
      this._core.is("rotating") && !this._paused && (this._time = this.read(), this._paused = true, b.clearTimeout(this._call));
    }, e.prototype.destroy = function() {
      var a2, b2;
      this.stop();
      for (a2 in this._handlers) this._core.$element.off(a2, this._handlers[a2]);
      for (b2 in Object.getOwnPropertyNames(this)) "function" != typeof this[b2] && (this[b2] = null);
    }, a.fn.owlCarousel.Constructor.Plugins.autoplay = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    "use strict";
    var e = function(b2) {
      this._core = b2, this._initialized = false, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }, this._handlers = { "prepared.owl.carousel": a.proxy(function(b3) {
        b3.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + a(b3.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>");
      }, this), "added.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.settings.dotsData && this._templates.splice(a2.position, 0, this._templates.pop());
      }, this), "remove.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._core.settings.dotsData && this._templates.splice(a2.position, 1);
      }, this), "changed.owl.carousel": a.proxy(function(a2) {
        a2.namespace && "position" == a2.property.name && this.draw();
      }, this), "initialized.owl.carousel": a.proxy(function(a2) {
        a2.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = true, this._core.trigger("initialized", null, "navigation"));
      }, this), "refreshed.owl.carousel": a.proxy(function(a2) {
        a2.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"));
      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers);
    };
    e.Defaults = { nav: false, navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'], navSpeed: false, navElement: 'button type="button" role="presentation"', navContainer: false, navContainerClass: "owl-nav", navClass: ["owl-prev", "owl-next"], slideBy: 1, dotClass: "owl-dot", dotsClass: "owl-dots", dots: true, dotsEach: false, dotsData: false, dotsSpeed: false, dotsContainer: false }, e.prototype.initialize = function() {
      var b2, c2 = this._core.settings;
      this._controls.$relative = (c2.navContainer ? a(c2.navContainer) : a("<div>").addClass(c2.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = a("<" + c2.navElement + ">").addClass(c2.navClass[0]).html(c2.navText[0]).prependTo(this._controls.$relative).on("click", a.proxy(function(a2) {
        this.prev(c2.navSpeed);
      }, this)), this._controls.$next = a("<" + c2.navElement + ">").addClass(c2.navClass[1]).html(c2.navText[1]).appendTo(this._controls.$relative).on("click", a.proxy(function(a2) {
        this.next(c2.navSpeed);
      }, this)), c2.dotsData || (this._templates = [a('<button role="button">').addClass(c2.dotClass).append(a("<span>")).prop("outerHTML")]), this._controls.$absolute = (c2.dotsContainer ? a(c2.dotsContainer) : a("<div>").addClass(c2.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "button", a.proxy(function(b3) {
        var d2 = a(b3.target).parent().is(this._controls.$absolute) ? a(b3.target).index() : a(b3.target).parent().index();
        b3.preventDefault(), this.to(d2, c2.dotsSpeed);
      }, this));
      for (b2 in this._overrides) this._core[b2] = a.proxy(this[b2], this);
    }, e.prototype.destroy = function() {
      var a2, b2, c2, d2, e2;
      e2 = this._core.settings;
      for (a2 in this._handlers) this.$element.off(a2, this._handlers[a2]);
      for (b2 in this._controls) "$relative" === b2 && e2.navContainer ? this._controls[b2].html("") : this._controls[b2].remove();
      for (d2 in this.overides) this._core[d2] = this._overrides[d2];
      for (c2 in Object.getOwnPropertyNames(this)) "function" != typeof this[c2] && (this[c2] = null);
    }, e.prototype.update = function() {
      var a2, b2, c2, d2 = this._core.clones().length / 2, e2 = d2 + this._core.items().length, f = this._core.maximum(true), g = this._core.settings, h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
      if ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)), g.dots || "page" == g.slideBy) for (this._pages = [], a2 = d2, b2 = 0, c2 = 0; a2 < e2; a2++) {
        if (b2 >= h || 0 === b2) {
          if (this._pages.push({ start: Math.min(f, a2 - d2), end: a2 - d2 + h - 1 }), Math.min(f, a2 - d2) === f) break;
          b2 = 0, ++c2;
        }
        b2 += this._core.mergers(this._core.relative(a2));
      }
    }, e.prototype.draw = function() {
      var b2, c2 = this._core.settings, d2 = this._core.items().length <= c2.items, e2 = this._core.relative(this._core.current()), f = c2.loop || c2.rewind;
      this._controls.$relative.toggleClass("disabled", !c2.nav || d2), c2.nav && (this._controls.$previous.toggleClass("disabled", !f && e2 <= this._core.minimum(true)), this._controls.$next.toggleClass("disabled", !f && e2 >= this._core.maximum(true))), this._controls.$absolute.toggleClass("disabled", !c2.dots || d2), c2.dots && (b2 = this._pages.length - this._controls.$absolute.children().length, c2.dotsData && 0 !== b2 ? this._controls.$absolute.html(this._templates.join("")) : b2 > 0 ? this._controls.$absolute.append(new Array(b2 + 1).join(this._templates[0])) : b2 < 0 && this._controls.$absolute.children().slice(b2).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(a.inArray(this.current(), this._pages)).addClass("active"));
    }, e.prototype.onTrigger = function(b2) {
      var c2 = this._core.settings;
      b2.page = { index: a.inArray(this.current(), this._pages), count: this._pages.length, size: c2 && (c2.center || c2.autoWidth || c2.dotsData ? 1 : c2.dotsEach || c2.items) };
    }, e.prototype.current = function() {
      var b2 = this._core.relative(this._core.current());
      return a.grep(this._pages, a.proxy(function(a2, c2) {
        return a2.start <= b2 && a2.end >= b2;
      }, this)).pop();
    }, e.prototype.getPosition = function(b2) {
      var c2, d2, e2 = this._core.settings;
      return "page" == e2.slideBy ? (c2 = a.inArray(this.current(), this._pages), d2 = this._pages.length, b2 ? ++c2 : --c2, c2 = this._pages[(c2 % d2 + d2) % d2].start) : (c2 = this._core.relative(this._core.current()), d2 = this._core.items().length, b2 ? c2 += e2.slideBy : c2 -= e2.slideBy), c2;
    }, e.prototype.next = function(b2) {
      a.proxy(this._overrides.to, this._core)(this.getPosition(true), b2);
    }, e.prototype.prev = function(b2) {
      a.proxy(this._overrides.to, this._core)(this.getPosition(false), b2);
    }, e.prototype.to = function(b2, c2, d2) {
      var e2;
      !d2 && this._pages.length ? (e2 = this._pages.length, a.proxy(this._overrides.to, this._core)(this._pages[(b2 % e2 + e2) % e2].start, c2)) : a.proxy(this._overrides.to, this._core)(b2, c2);
    }, a.fn.owlCarousel.Constructor.Plugins.Navigation = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    "use strict";
    var e = function(c2) {
      this._core = c2, this._hashes = {}, this.$element = this._core.$element, this._handlers = { "initialized.owl.carousel": a.proxy(function(c3) {
        c3.namespace && "URLHash" === this._core.settings.startPosition && a(b).trigger("hashchange.owl.navigation");
      }, this), "prepared.owl.carousel": a.proxy(function(b2) {
        if (b2.namespace) {
          var c3 = a(b2.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
          if (!c3) return;
          this._hashes[c3] = b2.content;
        }
      }, this), "changed.owl.carousel": a.proxy(function(c3) {
        if (c3.namespace && "position" === c3.property.name) {
          var d2 = this._core.items(this._core.relative(this._core.current())), e2 = a.map(this._hashes, function(a2, b2) {
            return a2 === d2 ? b2 : null;
          }).join();
          if (!e2 || b.location.hash.slice(1) === e2) return;
          b.location.hash = e2;
        }
      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers), a(b).on("hashchange.owl.navigation", a.proxy(function(a2) {
        var c3 = b.location.hash.substring(1), e2 = this._core.$stage.children(), f = this._hashes[c3] && e2.index(this._hashes[c3]);
        f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), false, true);
      }, this));
    };
    e.Defaults = { URLhashListener: false }, e.prototype.destroy = function() {
      var c2, d2;
      a(b).off("hashchange.owl.navigation");
      for (c2 in this._handlers) this._core.$element.off(c2, this._handlers[c2]);
      for (d2 in Object.getOwnPropertyNames(this)) "function" != typeof this[d2] && (this[d2] = null);
    }, a.fn.owlCarousel.Constructor.Plugins.Hash = e;
  }(window.Zepto || window.jQuery, window, document), function(a, b, c, d) {
    function e(b2, c2) {
      var e2 = false, f2 = b2.charAt(0).toUpperCase() + b2.slice(1);
      return a.each((b2 + " " + h.join(f2 + " ") + f2).split(" "), function(a2, b3) {
        if (g[b3] !== d) return e2 = !c2 || b3, false;
      }), e2;
    }
    function f(a2) {
      return e(a2, true);
    }
    var g = a("<support>").get(0).style, h = "Webkit Moz O ms".split(" "), i = { transition: { end: { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend" } }, animation: { end: { WebkitAnimation: "webkitAnimationEnd", MozAnimation: "animationend", OAnimation: "oAnimationEnd", animation: "animationend" } } }, j = { csstransforms: function() {
      return !!e("transform");
    }, csstransforms3d: function() {
      return !!e("perspective");
    }, csstransitions: function() {
      return !!e("transition");
    }, cssanimations: function() {
      return !!e("animation");
    } };
    j.csstransitions() && (a.support.transition = new String(f("transition")), a.support.transition.end = i.transition.end[a.support.transition]), j.cssanimations() && (a.support.animation = new String(f("animation")), a.support.animation.end = i.animation.end[a.support.animation]), j.csstransforms() && (a.support.transform = new String(f("transform")), a.support.transform3d = j.csstransforms3d());
  }(window.Zepto || window.jQuery, window, document);

  // scripts/core/theme.js
  window.theme = window.theme || {};
  window.theme = window.theme || {};
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  };
  theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function(container3, constructor) {
      var $container = $(container3);
      var id = $container.attr("data-section-id");
      var type = $container.attr("data-section-type");
      constructor = constructor || this.constructors[type];
      if (_.isUndefined(constructor)) {
        return;
      }
      var instance = _.assignIn(new constructor(container3), {
        id,
        type,
        container: container3
      });
      this.instances.push(instance);
    },
    _onSectionLoad: function(evt) {
      var container3 = $("[data-section-id]", evt.target)[0];
      if (container3) {
        this._createInstance(container3);
      }
    },
    _onSectionUnload: function(evt) {
      this.instances = _.filter(this.instances, function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
        if (isEventInstance) {
          if (_.isFunction(instance.onUnload)) {
            instance.onUnload(evt);
          }
        }
        return !isEventInstance;
      });
    },
    _onSelect: function(evt) {
      var instance = _.find(this.instances, function(instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
        instance.onSelect(evt);
      }
    },
    _onDeselect: function(evt) {
      var instance = _.find(this.instances, function(instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
        instance.onDeselect(evt);
      }
    },
    _onBlockSelect: function(evt) {
      var instance = _.find(this.instances, function(instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
        instance.onBlockSelect(evt);
      }
    },
    _onBlockDeselect: function(evt) {
      var instance = _.find(this.instances, function(instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
        instance.onBlockDeselect(evt);
      }
    },
    register: function(type, constructor) {
      this.constructors[type] = constructor;
      $("[data-section-type=" + type + "]").each(
        function(index, container3) {
          this._createInstance(container3, constructor);
        }.bind(this)
      );
    }
  });
  window.slate = window.slate || {};
  slate.utils = {
    /**
     * Get the query params in a Url
     * Ex
     * https://mysite.com/search?q=noodles&b
     * getParameterByName('q') = "noodles"
     * getParameterByName('b') = "" (empty value)
     * getParameterByName('test') = null (absent)
     */
    getParameterByName: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    keyboardKeys: {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      LEFTARROW: 37,
      RIGHTARROW: 39
    }
  };
  window.slate = window.slate || {};
  slate.rte = {
    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    wrapTable: function(options) {
      options.$tables.wrap(
        '<div class="' + options.tableWrapperClass + '"></div>'
      );
    },
    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    wrapIframe: function(options) {
      options.$iframes.each(function() {
        $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
        this.src = this.src;
      });
    }
  };
  window.slate = window.slate || {};
  slate.a11y = {
    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
      var focusClass = "js-focus-hidden";
      $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);
      function callback() {
        $element.first().removeClass(focusClass).removeAttr("tabindex");
      }
    },
    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
      var hash = window.location.hash;
      if (hash && document.getElementById(hash.slice(1))) {
        this.pageLinkFocus($(hash));
      }
    },
    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
      $("a[href*=#]").on(
        "click",
        function(evt) {
          this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this)
      );
    },
    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? "focusin." + options.namespace : "focusin",
        focusout: options.namespace ? "focusout." + options.namespace : "focusout",
        keydown: options.namespace ? "keydown." + options.namespace : "keydown.handleFocus"
      };
      var $focusableElements = options.$container.find(
        $(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
        ).filter(":visible")
      );
      var firstFocusable = $focusableElements[0];
      var lastFocusable = $focusableElements[$focusableElements.length - 1];
      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }
      function _manageFocus(evt) {
        if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
      options.$container.attr("tabindex", "-1");
      options.$elementToFocus.focus();
      $(document).off("focusin");
      $(document).on(eventsName.focusout, function() {
        $(document).off(eventsName.keydown);
      });
      $(document).on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
        $(document).on(eventsName.keydown, function(evt2) {
          _manageFocus(evt2);
        });
      });
    },
    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
      if (options.$container && options.$container.length) {
        options.$container.removeAttr("tabindex");
      }
      $(document).off(eventName);
    },
    /**
     * Add aria-describedby attribute to external and new window links
     *
     * @param {object} options - Options to be used
     * @param {object} options.messages - Custom messages to be used
     * @param {jQuery} options.$links - Specific links to be targeted
     */
    accessibleLinks: function(options) {
      var body = document.querySelector("body");
      var idSelectors = {
        newWindow: "a11y-new-window-message",
        external: "a11y-external-message",
        newWindowExternal: "a11y-new-window-external-message"
      };
      if (options.$links === void 0 || !options.$links.jquery) {
        options.$links = $("a[href]:not([aria-describedby])");
      }
      function generateHTML(customMessages) {
        if (typeof customMessages !== "object") {
          customMessages = {};
        }
        var messages = $.extend(
          {
            newWindow: "Opens in a new window.",
            external: "Opens external website.",
            newWindowExternal: "Opens external website in a new window."
          },
          customMessages
        );
        var container3 = document.createElement("ul");
        var htmlMessages = "";
        for (var message in messages) {
          htmlMessages += "<li id=" + idSelectors[message] + ">" + messages[message] + "</li>";
        }
        container3.setAttribute("hidden", true);
        container3.innerHTML = htmlMessages;
        body.appendChild(container3);
      }
      function _externalSite($link) {
        var hostname = window.location.hostname;
        return $link[0].hostname !== hostname;
      }
      $.each(options.$links, function() {
        var $link = $(this);
        var target = $link.attr("target");
        var rel = $link.attr("rel");
        var isExternal = _externalSite($link);
        var isTargetBlank = target === "_blank";
        if (isExternal) {
          $link.attr("aria-describedby", idSelectors.external);
        }
        if (isTargetBlank) {
          if (rel === void 0 || rel.indexOf("noopener") === -1) {
            $link.attr("rel", "noopener");
          }
          $link.attr("aria-describedby", idSelectors.newWindow);
        }
        if (isExternal && isTargetBlank) {
          $link.attr("aria-describedby", idSelectors.newWindowExternal);
        }
      });
      generateHTML(options.messages);
    }
  };
  slate.Image = /* @__PURE__ */ function() {
    function preload(images, size) {
      if (typeof images === "string") {
        images = [images];
      }
      for (var i = 0; i < images.length; i++) {
        var image = images[i];
        this.loadImage(this.getSizedImageUrl(image, size));
      }
    }
    function loadImage(path) {
      new Image().src = path;
    }
    function imageSize(src) {
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
      if (match) {
        return match[1];
      } else {
        return null;
      }
    }
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }
      if (size === "master") {
        return this.removeProtocol(src);
      }
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return this.removeProtocol(prefix[0] + "_" + size + suffix);
      } else {
        return null;
      }
    }
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }
    return {
      preload,
      loadImage,
      imageSize,
      getSizedImageUrl,
      removeProtocol
    };
  }();
  theme.Currency = /* @__PURE__ */ function() {
    var moneyFormat = "${{amount}}";
    function formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;
      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";
        if (isNaN(number) || number === null) {
          return 0;
        }
        number = (number / 100).toFixed(precision);
        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
    return {
      formatMoney
    };
  }();
  slate.Variants = function() {
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
      $(this.singleOptionSelector, this.$container).on(
        "change",
        this._onSelectChange.bind(this)
      );
    }
    Variants.prototype = _.assignIn({}, Variants.prototype, {
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function() {
        var currentOptions = _.map(
          $(this.singleOptionSelector, this.$container),
          function(element) {
            var $element = $(element);
            var type = $element.attr("type");
            var currentOption = {};
            if (type === "radio" || type === "checkbox") {
              if ($element[0].checked) {
                currentOption.value = $element.val();
                currentOption.index = $element.data("index");
                return currentOption;
              } else {
                return false;
              }
            } else {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");
              return currentOption;
            }
          }
        );
        currentOptions = _.compact(currentOptions);
        return currentOptions;
      },
      /**
       * Find variant based on selected values.
       *
       * @param  {array} selectedValues - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.product.variants;
        var found = _.find(variants, function(variant) {
          return selectedValues.every(function(values) {
            return _.isEqual(variant[values.index], values.value);
          });
        });
        return found;
      },
      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
        this.$container.trigger({
          type: "variantChange",
          variant
        });
        if (!variant) {
          return;
        }
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
        this.$container.trigger({
          type: "variantImageChange",
          variant
        });
      },
      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
        this.$container.trigger({
          type: "variantPriceChange",
          variant
        });
      },
      /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
        this.$container.trigger({
          type: "variantSKUChange",
          variant
        });
      },
      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      },
      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      }
    });
    return Variants;
  }();
  theme.Drawers = function() {
    function Drawer(id, position, options) {
      var defaults = {
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + position,
        openClass: "js-drawer-open",
        dirOpenClass: "js-drawer-open-" + position
      };
      this.nodes = {
        $parent: $("html").add("body"),
        $page: $("#PageContainer")
      };
      this.config = $.extend(defaults, options);
      this.position = position;
      this.$drawer = $("#" + id);
      if (!this.$drawer.length) {
        return false;
      }
      this.drawerIsOpen = false;
      this.init();
    }
    Drawer.prototype.init = function() {
      $(this.config.open).on("click", $.proxy(this.open, this));
      this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
    };
    Drawer.prototype.open = function(evt) {
      var externalCall = false;
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        this.$activeSource = $(evt.currentTarget);
      }
      if (this.drawerIsOpen && !externalCall) {
        return this.close();
      }
      this.$drawer.prepareTransition();
      this.nodes.$parent.addClass(
        this.config.openClass + " " + this.config.dirOpenClass
      );
      this.drawerIsOpen = true;
      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: "drawer_focus"
      });
      if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === "function") {
        if (!externalCall) {
          this.config.onDrawerOpen();
        }
      }
      if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
        this.$activeSource.attr("aria-expanded", "true");
      }
      this.bindEvents();
      return this;
    };
    Drawer.prototype.close = function() {
      if (!this.drawerIsOpen) {
        return;
      }
      $(document.activeElement).trigger("blur");
      this.$drawer.prepareTransition();
      this.nodes.$parent.removeClass(
        this.config.dirOpenClass + " " + this.config.openClass
      );
      if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
        this.$activeSource.attr("aria-expanded", "false");
      }
      this.drawerIsOpen = false;
      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: "drawer_focus"
      });
      this.unbindEvents();
      if (this.config.onDrawerClose && typeof this.config.onDrawerClose === "function") {
        this.config.onDrawerClose();
      }
    };
    Drawer.prototype.bindEvents = function() {
      this.nodes.$parent.on(
        "keyup.drawer",
        $.proxy(function(evt) {
          if (evt.keyCode === 27) {
            this.close();
            return false;
          } else {
            return true;
          }
        }, this)
      );
      this.nodes.$page.on("touchmove.drawer", function() {
        return false;
      });
      this.nodes.$page.on(
        "click.drawer",
        $.proxy(function() {
          this.close();
          return false;
        }, this)
      );
    };
    Drawer.prototype.unbindEvents = function() {
      this.nodes.$page.off(".drawer");
      this.nodes.$parent.off(".drawer");
    };
    return Drawer;
  }();
  window.theme = window.theme || {};
  theme.Header = /* @__PURE__ */ function() {
    var selectors = {
      body: "body",
      multicurrencySelector: "[data-currency-selector]",
      navigation: "#AccessibleNav",
      siteNavHasDropdown: "[data-has-dropdowns]",
      siteNavChildLinks: ".site-nav__child-link",
      siteNavActiveDropdown: ".site-nav--active-dropdown",
      siteNavHasCenteredDropdown: ".site-nav--has-centered-dropdown",
      siteNavCenteredDropdown: ".site-nav__dropdown--centered",
      siteNavLinkMain: ".site-nav__link--main",
      siteNavChildLink: ".site-nav__link--last",
      siteNavDropdown: ".site-nav__dropdown",
      siteHeader: ".site-header"
    };
    var config = {
      activeClass: "site-nav--active-dropdown",
      childLinkClass: "site-nav__child-link",
      rightDropdownClass: "site-nav__dropdown--right",
      leftDropdownClass: "site-nav__dropdown--left"
    };
    var cache = {};
    function init() {
      cacheSelectors();
      styleDropdowns($(selectors.siteNavHasDropdown));
      positionFullWidthDropdowns();
      cache.$parents.on("click.siteNav", function() {
        var $el = $(this);
        $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
      });
      $(selectors.siteNavChildLink).on("focusout.siteNav", function() {
        setTimeout(function() {
          if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
            return;
          }
          hideDropdown(cache.$activeDropdown);
        });
      });
      cache.$topLevel.on("focus.siteNav", function() {
        if (cache.$activeDropdown.length) {
          hideDropdown(cache.$activeDropdown);
        }
      });
      cache.$subMenuLinks.on("click.siteNav", function(evt) {
        evt.stopImmediatePropagation();
      });
      $(selectors.multicurrencySelector).on("change", function() {
        $(this).parents("form").submit();
      });
      $(window).resize(
        $.debounce(50, function() {
          styleDropdowns($(selectors.siteNavHasDropdown));
          positionFullWidthDropdowns();
        })
      );
    }
    function cacheSelectors() {
      cache = {
        $nav: $(selectors.navigation),
        $topLevel: $(selectors.siteNavLinkMain),
        $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
        $subMenuLinks: $(selectors.siteNavChildLinks),
        $activeDropdown: $(selectors.siteNavActiveDropdown),
        $siteHeader: $(selectors.siteHeader)
      };
    }
    function showDropdown($el) {
      $el.addClass(config.activeClass);
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
      cache.$activeDropdown = $el;
      $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "true");
      setTimeout(function() {
        $(window).on("keyup.siteNav", function(evt) {
          if (evt.keyCode === 27) {
            hideDropdown($el);
          }
        });
        $(selectors.body).on("click.siteNav", function() {
          hideDropdown($el);
        });
      }, 250);
    }
    function hideDropdown($el) {
      $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "false");
      $el.removeClass(config.activeClass);
      cache.$activeDropdown = $(selectors.siteNavActiveDropdown);
      $(selectors.body).off("click.siteNav");
      $(window).off("keyup.siteNav");
    }
    function styleDropdowns($dropdownListItems) {
      $dropdownListItems.each(function() {
        var $dropdownLi = $(this).find(selectors.siteNavDropdown);
        if (!$dropdownLi.length) {
          return;
        }
        var isRightOfLogo = Math.ceil($(this).offset().left) > Math.floor(cache.$siteHeader.outerWidth()) / 2 ? true : false;
        if (isRightOfLogo) {
          $dropdownLi.removeClass(config.leftDropdownClass).addClass(config.rightDropdownClass);
        } else {
          $dropdownLi.removeClass(config.rightDropdownClass).addClass(config.leftDropdownClass);
        }
      });
    }
    function positionFullWidthDropdowns() {
      var $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown);
      $listWithCenteredDropdown.each(function() {
        var $hasCenteredDropdown = $(this);
        var $fullWidthDropdown = $hasCenteredDropdown.find(
          selectors.siteNavCenteredDropdown
        );
        var fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 41;
        $fullWidthDropdown.css("top", fullWidthDropdownOffset);
      });
    }
    function unload() {
      $(window).off(".siteNav");
      cache.$parents.off(".siteNav");
      cache.$subMenuLinks.off(".siteNav");
      cache.$topLevel.off(".siteNav");
      $(selectors.siteNavChildLink).off(".siteNav");
      $(selectors.body).off(".siteNav");
    }
    return {
      init,
      unload
    };
  }();
  window.theme = window.theme || {};
  theme.MobileNav = /* @__PURE__ */ function() {
    var classes = {
      mobileNavOpenIcon: "mobile-nav--open",
      mobileNavCloseIcon: "mobile-nav--close",
      navLinkWrapper: "mobile-nav__item",
      navLink: "mobile-nav__link",
      subNavLink: "mobile-nav__sublist-link",
      return: "mobile-nav__return-btn",
      subNavActive: "is-active",
      subNavClosing: "is-closing",
      navOpen: "js-menu--is-open",
      subNavShowing: "sub-nav--is-open",
      thirdNavShowing: "third-nav--is-open",
      subNavToggleBtn: "js-toggle-submenu"
    };
    var cache = {};
    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var menuLevel = 1;
    var mediaQuerySmall = "screen and (max-width: 749px)";
    function init() {
      cacheSelectors();
      cache.$mobileNavToggle.on("click", toggleMobileNav);
      cache.$subNavToggleBtn.on("click.subNav", toggleSubNav);
      enquire.register(mediaQuerySmall, {
        unmatch: function() {
          if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
            closeMobileNav();
          }
        }
      });
    }
    function toggleMobileNav() {
      if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    }
    function cacheSelectors() {
      cache = {
        $pageContainer: $("#PageContainer"),
        $body: $("body"),
        $siteHeader: $(".site-header"),
        $mobileNavToggle: $(".js-mobile-nav-toggle"),
        $mobileNavContainer: $(".mobile-nav-wrapper"),
        $mobileNav: $("#MobileNav"),
        $sectionHeader: $("#shopify-section-header"),
        $subNavToggleBtn: $("." + classes.subNavToggleBtn)
      };
    }
    function openMobileNav() {
      var translateHeaderHeight = cache.$siteHeader.outerHeight();
      cache.$body.addClass(classes.navOpen);
      cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);
      cache.$siteHeader.addClass("alt-design");
      cache.$mobileNavContainer.css({
        transform: "translateY(" + translateHeaderHeight + "px)"
      });
      cache.$pageContainer.css({
        transform: "translate3d(0, " + cache.$mobileNavContainer[0].scrollHeight + "px, 0)"
      });
      slate.a11y.trapFocus({
        $container: cache.$sectionHeader,
        $elementToFocus: cache.$mobileNavToggle,
        namespace: "navFocus"
      });
      cache.$mobileNavToggle.addClass(classes.mobileNavCloseIcon).removeClass(classes.mobileNavOpenIcon).attr("aria-expanded", true);
      $(window).on("keyup.mobileNav", function(evt) {
        if (evt.which === 27) {
          closeMobileNav();
        }
      });
    }
    function closeMobileNav() {
      cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);
      cache.$body.removeClass(classes.navOpen);
      cache.$mobileNavContainer.css({
        transform: "translateY(-100%)"
      });
      cache.$pageContainer.removeAttr("style");
      slate.a11y.trapFocus({
        $container: $("html"),
        $elementToFocus: $("body")
      });
      cache.$mobileNavContainer.one(
        "TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle",
        function() {
          slate.a11y.removeTrapFocus({
            $container: cache.$mobileNav,
            namespace: "navFocus"
          });
        }
      );
      cache.$mobileNavToggle.addClass(classes.mobileNavOpenIcon).removeClass(classes.mobileNavCloseIcon).attr("aria-expanded", false).focus();
      $(window).off("keyup.mobileNav");
      scrollTo(0, 0);
    }
    function toggleSubNav(evt) {
      if (isTransitioning) {
        return;
      }
      var $toggleBtn = $(evt.currentTarget);
      var isReturn = $toggleBtn.hasClass(classes.return);
      isTransitioning = true;
      if (isReturn) {
        $(
          "." + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
        ).removeClass(classes.subNavActive);
        if ($activeTrigger && $activeTrigger.length) {
          $activeTrigger.removeClass(classes.subNavActive);
        }
      } else {
        $toggleBtn.addClass(classes.subNavActive);
      }
      $activeTrigger = $toggleBtn;
      goToSubnav($toggleBtn.data("target"));
    }
    function goToSubnav(target) {
      var $targetMenu = target ? $('.mobile-nav__dropdown[data-parent="' + target + '"]') : cache.$mobileNav;
      menuLevel = $targetMenu.data("level") ? $targetMenu.data("level") : 1;
      if ($activeSubNav && $activeSubNav.length) {
        $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
      }
      $activeSubNav = $targetMenu;
      var translateMenuHeight = $targetMenu.outerHeight();
      var openNavClass = menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
      cache.$mobileNavContainer.css("height", translateMenuHeight).removeClass(classes.thirdNavShowing).addClass(openNavClass);
      if (!target) {
        cache.$mobileNavContainer.removeClass(classes.thirdNavShowing).removeClass(classes.subNavShowing);
      }
      var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;
      var $menuTitle = $targetMenu.find("[data-menu-title=" + menuLevel + "]");
      var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;
      cache.$mobileNavContainer.one(
        "TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle",
        function() {
          slate.a11y.trapFocus({
            $container,
            $elementToFocus,
            namespace: "subNavFocus"
          });
          cache.$mobileNavContainer.off(".subnavToggle");
          isTransitioning = false;
        }
      );
      cache.$pageContainer.css({
        transform: "translateY(" + translateMenuHeight + "px)"
      });
      $activeSubNav.removeClass(classes.subNavClosing);
    }
    return {
      init,
      closeMobileNav
    };
  }(jQuery);
  window.theme = window.theme || {};
  theme.Search = /* @__PURE__ */ function() {
    var selectors = {
      search: ".search",
      searchSubmit: ".search__submit",
      searchInput: ".search__input",
      siteHeader: ".site-header",
      siteHeaderSearchToggle: ".site-header__search-toggle",
      siteHeaderSearch: ".site-header__search",
      searchDrawer: ".search-bar",
      searchDrawerInput: ".search-bar__input",
      searchHeader: ".search-header",
      searchHeaderInput: ".search-header__input",
      searchHeaderSubmit: ".search-header__submit",
      searchResultSubmit: "#SearchResultSubmit",
      searchResultInput: "#SearchInput",
      searchResultMessage: "[data-search-error-message]",
      mobileNavWrapper: ".mobile-nav-wrapper"
    };
    var classes = {
      focus: "search--focus",
      hidden: "hide",
      mobileNavIsOpen: "js-menu--is-open"
    };
    function init() {
      if (!$(selectors.siteHeader).length) {
        return;
      }
      this.$searchResultInput = $(selectors.searchResultInput);
      this.$searchErrorMessage = $(selectors.searchResultMessage);
      initDrawer();
      var isSearchPage = slate.utils.getParameterByName("q") !== null && window.location.pathname === "/search";
      if (isSearchPage) {
        validateSearchResultForm.call(this);
      }
      $(selectors.searchResultSubmit).on(
        "click",
        validateSearchResultForm.bind(this)
      );
      $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on("focus blur", function() {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });
      $(selectors.siteHeaderSearchToggle).on("click", function() {
        var searchHeight = $(selectors.siteHeader).outerHeight();
        var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
        $(selectors.searchDrawer).css({
          height: searchHeight + "px",
          top: searchOffset + "px"
        });
      });
    }
    function initDrawer() {
      $("#PageContainer").addClass("drawer-page-content");
      $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false").attr("aria-haspopup", "dialog");
      theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
        onDrawerOpen: searchDrawerFocus,
        onDrawerClose: searchDrawerFocusClose
      });
    }
    function searchDrawerFocus() {
      searchFocus($(selectors.searchDrawerInput));
      if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
        theme.MobileNav.closeMobileNav();
      }
    }
    function searchFocus($el) {
      $el.focus();
      $el[0].setSelectionRange(0, $el[0].value.length);
    }
    function searchDrawerFocusClose() {
      $(selectors.siteHeaderSearchToggle).focus();
    }
    function hideErrorMessage() {
      this.$searchErrorMessage.addClass(classes.hidden);
      this.$searchResultInput.removeAttr("aria-describedby").removeAttr("aria-invalid");
    }
    function showErrorMessage() {
      this.$searchErrorMessage.removeClass(classes.hidden);
      this.$searchResultInput.attr("aria-describedby", "error-search-form").attr("aria-invalid", true);
    }
    function validateSearchResultForm(evt) {
      var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;
      if (!isInputValueEmpty) {
        hideErrorMessage.call(this);
        return;
      }
      if (typeof evt !== "undefined") {
        evt.preventDefault();
      }
      searchFocus(this.$searchResultInput);
      showErrorMessage.call(this);
    }
    return {
      init
    };
  }();
  (function() {
    var selectors = {
      backButton: ".return-link"
    };
    var $backButton = $(selectors.backButton);
    if (!document.referrer || !$backButton.length || !window.history.length) {
      return;
    }
    $backButton.one("click", function(evt) {
      evt.preventDefault();
      var referrerDomain = urlDomain(document.referrer);
      var shopDomain = urlDomain(window.location.href);
      if (shopDomain === referrerDomain) {
        history.back();
      }
      return false;
    });
    function urlDomain(url) {
      var anchor = document.createElement("a");
      anchor.ref = url;
      return anchor.hostname;
    }
  })();
  theme.Slideshow = function() {
    this.$slideshow = null;
    var classes = {
      slideshow: "slideshow",
      slickActiveMobile: "slick-active-mobile",
      controlsHover: "slideshow__controls--hover",
      isPaused: "is-paused"
    };
    var selectors = {
      section: ".shopify-section",
      wrapper: "#SlideshowWrapper-",
      slides: ".slideshow__slide",
      textWrapperMobile: ".slideshow__text-wrap--mobile",
      textContentMobile: ".slideshow__text-content--mobile",
      controls: ".slideshow__controls",
      pauseButton: ".slideshow__pause",
      dots: ".slick-dots",
      arrows: ".slideshow__arrows",
      arrowsMobile: ".slideshow__arrows--mobile",
      arrowLeft: ".slideshow__arrow-left",
      arrowRight: ".slideshow__arrow-right"
    };
    function slideshow(el, sectionId) {
      var $slideshow = this.$slideshow = $(el);
      this.adaptHeight = this.$slideshow.data("adapt-height");
      this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
      this.$section = this.$wrapper.closest(selectors.section);
      this.$controls = this.$wrapper.find(selectors.controls);
      this.$arrows = this.$section.find(selectors.arrows);
      this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
      this.$pause = this.$controls.find(selectors.pauseButton);
      this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
      this.autorotate = this.$slideshow.data("autorotate");
      var autoplaySpeed = this.$slideshow.data("speed");
      var loadSlideA11yString = this.$slideshow.data("slide-nav-a11y");
      this.settings = {
        accessibility: true,
        arrows: false,
        dots: true,
        fade: true,
        draggable: true,
        touchThreshold: 20,
        autoplay: this.autorotate,
        autoplaySpeed,
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        appendDots: this.$arrows,
        customPaging: function(slick, index) {
          return '<a href="' + selectors.wrapper + sectionId + '" aria-label="' + loadSlideA11yString.replace("[slide_number]", index + 1) + '" data-slide-number="' + index + '"></a>';
        }
      };
      this.$slideshow.on("beforeChange", beforeChange.bind(this));
      this.$slideshow.on("init", slideshowA11ySetup.bind(this));
      this.$slideshow.on(
        "init",
        function() {
          this.$mobileDots.find("li:first-of-type").addClass(classes.slickActiveMobile);
          this.showMobileText(0);
        }.bind(this)
      );
      if (this.autorotate) {
        $(document).scroll(
          $.debounce(
            250,
            function() {
              if (this.$arrowsMobile.offset().top + this.$arrowsMobile.outerHeight() < window.pageYOffset) {
                $slideshow.slick("slickPause");
              } else if (!this.$pause.hasClass(classes.isPaused)) {
                $slideshow.slick("slickPlay");
              }
            }.bind(this)
          )
        );
      }
      if (this.adaptHeight) {
        this.setSlideshowHeight();
        $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
      }
      this.$slideshow.slick(this.settings);
      slideshowPostInitA11ySetup.bind(this)();
      this.$arrows.find(selectors.arrowLeft).on("click", function() {
        $slideshow.slick("slickPrev");
      });
      this.$arrows.find(selectors.arrowRight).on("click", function() {
        $slideshow.slick("slickNext");
      });
      this.$pause.on("click", this.togglePause.bind(this));
    }
    function slideshowA11ySetup(event2, obj) {
      var $slider = obj.$slider;
      var $list = obj.$list;
      this.$dots = this.$section.find(selectors.dots);
      this.$mobileDots = this.$dots.eq(1);
      $list.removeAttr("aria-live");
      this.$wrapper.on("keyup", keyboardNavigation.bind(this));
      this.$controls.on("keyup", keyboardNavigation.bind(this));
      this.$textWrapperMobile.on("keyup", keyboardNavigation.bind(this));
      this.$wrapper.on(
        "focusin",
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }
          $list.attr("aria-live", "polite");
          if (this.autorotate) {
            $slider.slick("slickPause");
          }
        }.bind(this)
      ).on(
        "focusout",
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }
          $list.removeAttr("aria-live");
          if (this.autorotate) {
            if (!this.$pause.is(".is-paused")) {
              $slider.slick("slickPlay");
            }
          }
        }.bind(this)
      );
      if (this.$dots) {
        this.$dots.find("a").each(function() {
          var $dot = $(this);
          $dot.on("click keyup", function(evt) {
            if (evt.type === "keyup" && evt.which !== slate.utils.keyboardKeys.ENTER)
              return;
            evt.preventDefault();
            var slideNumber = $(evt.target).data("slide-number");
            $slider.attr("tabindex", -1).slick("slickGoTo", slideNumber);
            if (evt.type === "keyup") {
              $slider.focus();
            }
          });
        }).eq(0).attr("aria-current", "true");
      }
      this.$controls.on("focusin", highlightControls.bind(this)).on("focusout", unhighlightControls.bind(this));
    }
    function slideshowPostInitA11ySetup() {
      var $slides = this.$slideshow.find(selectors.slides);
      $slides.removeAttr("role").removeAttr("aria-labelledby");
      this.$dots.removeAttr("role").find("li").removeAttr("role").removeAttr("aria-selected").each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr("aria-controls");
        $dot.removeAttr("aria-controls").find("a").attr("aria-controls", ariaControls);
      });
    }
    function beforeChange(event2, slick, currentSlide, nextSlide) {
      var $dotLinks = this.$dots.find("a");
      var $mobileDotLinks = this.$mobileDots.find("li");
      $dotLinks.removeAttr("aria-current").eq(nextSlide).attr("aria-current", "true");
      $mobileDotLinks.removeClass(classes.slickActiveMobile).eq(nextSlide).addClass(classes.slickActiveMobile);
      this.showMobileText(nextSlide);
    }
    function keyboardNavigation() {
      if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
        this.$slideshow.slick("slickPrev");
      }
      if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
        this.$slideshow.slick("slickNext");
      }
    }
    function highlightControls() {
      this.$controls.addClass(classes.controlsHover);
    }
    function unhighlightControls() {
      this.$controls.removeClass(classes.controlsHover);
    }
    slideshow.prototype.togglePause = function() {
      var slideshowSelector = getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused).attr("aria-pressed", "false");
        if (this.autorotate) {
          $(slideshowSelector).slick("slickPlay");
        }
      } else {
        this.$pause.addClass(classes.isPaused).attr("aria-pressed", "true");
        if (this.autorotate) {
          $(slideshowSelector).slick("slickPause");
        }
      }
    };
    slideshow.prototype.setSlideshowHeight = function() {
      var minAspectRatio = this.$slideshow.data("min-aspect-ratio");
      this.$slideshow.height($(document).width() / minAspectRatio);
    };
    slideshow.prototype.showMobileText = function(slideIndex) {
      var $allTextContent = this.$textWrapperMobile.find(
        selectors.textContentMobile
      );
      var currentTextContentSelector = selectors.textContentMobile + "-" + slideIndex;
      var $currentTextContent = this.$textWrapperMobile.find(
        currentTextContentSelector
      );
      if (!$currentTextContent.length && this.$slideshow.find(selectors.slides).length === 1) {
        this.$textWrapperMobile.hide();
      } else {
        this.$textWrapperMobile.show();
      }
      $allTextContent.hide();
      $currentTextContent.show();
    };
    function getSlideshowId($el) {
      return "#Slideshow-" + $el.data("id");
    }
    return slideshow;
  }();
  theme.Video = function() {
    var autoplayCheckComplete = false;
    var autoplayAvailable = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
      ratio: 16 / 9,
      scrollAnimationDuration: 400,
      playerVars: {
        // eslint-disable-next-line camelcase
        iv_load_policy: 3,
        modestbranding: 1,
        autoplay: 0,
        controls: 0,
        wmode: "opaque",
        branding: 0,
        autohide: 0,
        rel: 0
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerChange
      }
    };
    var classes = {
      playing: "video-is-playing",
      paused: "video-is-paused",
      loading: "video-is-loading",
      loaded: "video-is-loaded",
      backgroundVideoWrapper: "video-background-wrapper",
      videoWithImage: "video--image_with_play",
      backgroundVideo: "video--background",
      userPaused: "is-paused",
      supportsAutoplay: "autoplay",
      supportsNoAutoplay: "no-autoplay",
      wrapperMinHeight: "video-section-wrapper--min-height"
    };
    var selectors = {
      section: ".video-section",
      videoWrapper: ".video-section-wrapper",
      playVideoBtn: ".video-control__play",
      closeVideoBtn: ".video-control__close-wrapper",
      pauseVideoBtn: ".video__pause"
    };
    function init($video) {
      if (!$video.length) {
        return;
      }
      videos[$video.attr("id")] = {
        id: $video.attr("id"),
        videoId: $video.data("id"),
        type: $video.data("type"),
        status: $video.data("type") === "image_with_play" ? "closed" : "background",
        // closed, open, background
        $video,
        $videoWrapper: $video.closest(selectors.videoWrapper),
        $section: $video.closest(selectors.section),
        controls: $video.data("type") === "background" ? 0 : 1
      };
      if (!youtubeLoaded) {
        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
      playOnClickCheck();
    }
    function customPlayVideo(playerId) {
      if (!playOnClickChecked && !playOnClick) {
        return;
      }
      if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
        privatePlayVideo(playerId);
      }
    }
    function pauseVideo(playerId) {
      if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === "function") {
        videoPlayers[playerId].pauseVideo();
      }
    }
    function loadVideos() {
      for (var key in videos) {
        if (videos.hasOwnProperty(key)) {
          createPlayer(key);
        }
      }
      initEvents();
      youtubeLoaded = true;
    }
    function editorLoadVideo(key) {
      if (!youtubeLoaded) {
        return;
      }
      createPlayer(key);
      initEvents();
    }
    function privatePlayVideo(id, clicked) {
      var videoData = videos[id];
      var player = videoPlayers[id];
      var $videoWrapper = videoData.$videoWrapper;
      if (playOnClick) {
        setAsPlaying(videoData);
      } else if (clicked || autoplayCheckComplete && autoplayAvailable) {
        $videoWrapper.removeClass(classes.loading);
        setAsPlaying(videoData);
        player.playVideo();
        return;
      }
      if (!autoplayCheckComplete) {
        autoplayCheckFunction(player, $videoWrapper);
      }
    }
    function setAutoplaySupport(supported) {
      var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
      $(document.documentElement).removeClass(classes.supportsAutoplay).removeClass(classes.supportsNoAutoplay).addClass(supportClass);
      if (!supported) {
        playOnClick = true;
      } else {
        autoplayAvailable = true;
      }
      autoplayCheckComplete = true;
    }
    function autoplayCheckFunction(player, $videoWrapper) {
      player.playVideo();
      autoplayTest(player).then(function() {
        setAutoplaySupport(true);
      }).fail(function() {
        setAutoplaySupport(false);
        player.stopVideo();
      }).always(function() {
        autoplayCheckComplete = true;
        $videoWrapper.removeClass(classes.loading);
      });
    }
    function autoplayTest(player) {
      var deferred = $.Deferred();
      var wait;
      var timeout;
      wait = setInterval(function() {
        if (player.getCurrentTime() <= 0) {
          return;
        }
        autoplayAvailable = true;
        clearInterval(wait);
        clearTimeout(timeout);
        deferred.resolve();
      }, 500);
      timeout = setTimeout(function() {
        clearInterval(wait);
        deferred.reject();
      }, 4e3);
      return deferred;
    }
    function playOnClickCheck() {
      if (playOnClickChecked) {
        return;
      }
      if (isMobile()) {
        playOnClick = true;
      }
      if (playOnClick) {
        setAutoplaySupport(false);
      }
      playOnClickChecked = true;
    }
    function onPlayerReady(evt) {
      evt.target.setPlaybackQuality("hd1080");
      var videoData = getVideoOptions(evt);
      playOnClickCheck();
      $("#" + videoData.id).attr("tabindex", "-1");
      sizeBackgroundVideos();
      if (videoData.type === "background") {
        evt.target.mute();
        privatePlayVideo(videoData.id);
      }
      videoData.$videoWrapper.addClass(classes.loaded);
    }
    function onPlayerChange(evt) {
      var videoData = getVideoOptions(evt);
      switch (evt.data) {
        case YT.PlayerState.ENDED:
          setAsFinished(videoData);
          break;
        case YT.PlayerState.PAUSED:
          setTimeout(function() {
            if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
              setAsPaused(videoData);
            }
          }, 200);
          break;
      }
    }
    function setAsFinished(videoData) {
      switch (videoData.type) {
        case "background":
          videoPlayers[videoData.id].seekTo(0);
          break;
        case "image_with_play":
          closeVideo(videoData.id);
          toggleExpandVideo(videoData.id, false);
          break;
      }
    }
    function setAsPlaying(videoData) {
      var $videoWrapper = videoData.$videoWrapper;
      var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
      $videoWrapper.removeClass(classes.loading);
      if ($pauseButton.hasClass(classes.userPaused)) {
        $pauseButton.removeClass(classes.userPaused);
      }
      if (videoData.status === "background") {
        return;
      }
      $("#" + videoData.id).attr("tabindex", "0");
      if (videoData.type === "image_with_play") {
        $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
      }
      setTimeout(function() {
        $videoWrapper.find(selectors.closeVideoBtn).focus();
      }, videoOptions.scrollAnimationDuration);
    }
    function setAsPaused(videoData) {
      var $videoWrapper = videoData.$videoWrapper;
      if (videoData.type === "image_with_play") {
        if (videoData.status === "closed") {
          $videoWrapper.removeClass(classes.paused);
        } else {
          $videoWrapper.addClass(classes.paused);
        }
      }
      $videoWrapper.removeClass(classes.playing);
    }
    function closeVideo(playerId) {
      var videoData = videos[playerId];
      var $videoWrapper = videoData.$videoWrapper;
      var classesToRemove = [classes.paused, classes.playing].join(" ");
      if (isMobile()) {
        $videoWrapper.removeAttr("style");
      }
      $("#" + videoData.id).attr("tabindex", "-1");
      videoData.status = "closed";
      switch (videoData.type) {
        case "image_with_play":
          videoPlayers[playerId].stopVideo();
          setAsPaused(videoData);
          break;
        case "background":
          videoPlayers[playerId].mute();
          setBackgroundVideo(playerId);
          break;
      }
      $videoWrapper.removeClass(classesToRemove);
    }
    function getVideoOptions(evt) {
      return videos[evt.target.a.id];
    }
    function toggleExpandVideo(playerId, expand) {
      var video = videos[playerId];
      var elementTop = video.$videoWrapper.offset().top;
      var offset = 0;
      var newHeight = 0;
      if (isMobile()) {
        video.$videoWrapper.parent().toggleClass("page-width", !expand);
      }
      if (expand) {
        if (isMobile()) {
          newHeight = $(window).width() / videoOptions.ratio;
        } else {
          newHeight = video.$videoWrapper.width() / videoOptions.ratio;
        }
        offset = ($(window).height() - newHeight) / 2;
        video.$videoWrapper.removeClass(classes.wrapperMinHeight).animate({ height: newHeight }, 600);
        if (!(isMobile() && Shopify.designMode)) {
          $("html, body").animate(
            {
              scrollTop: elementTop - offset
            },
            videoOptions.scrollAnimationDuration
          );
        }
      } else {
        if (isMobile()) {
          newHeight = video.$videoWrapper.data("mobile-height");
        } else {
          newHeight = video.$videoWrapper.data("desktop-height");
        }
        video.$videoWrapper.height(video.$videoWrapper.width() / videoOptions.ratio).animate({ height: newHeight }, 600);
        setTimeout(function() {
          video.$videoWrapper.addClass(classes.wrapperMinHeight);
        }, 600);
      }
    }
    function togglePause(playerId) {
      var $pauseButton = videos[playerId].$videoWrapper.find(
        selectors.pauseVideoBtn
      );
      if ($pauseButton.hasClass(classes.userPaused)) {
        $pauseButton.removeClass(classes.userPaused);
        customPlayVideo(playerId);
      } else {
        $pauseButton.addClass(classes.userPaused);
        pauseVideo(playerId);
      }
    }
    function startVideoOnClick(playerId) {
      var video = videos[playerId];
      video.$videoWrapper.addClass(classes.loading);
      video.$videoWrapper.attr(
        "style",
        "height: " + video.$videoWrapper.height() + "px"
      );
      video.status = "open";
      switch (video.type) {
        case "image_with_play":
          privatePlayVideo(playerId, true);
          break;
        case "background":
          unsetBackgroundVideo(playerId, video);
          videoPlayers[playerId].unMute();
          privatePlayVideo(playerId, true);
          break;
      }
      toggleExpandVideo(playerId, true);
      $(document).on("keydown.videoPlayer", function(evt) {
        var playerId2 = $(document.activeElement).data("controls");
        if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId2) {
          return;
        }
        closeVideo(playerId2);
        toggleExpandVideo(playerId2, false);
      });
    }
    function sizeBackgroundVideos() {
      $("." + classes.backgroundVideo).each(function(index, el) {
        sizeBackgroundVideo($(el));
      });
    }
    function sizeBackgroundVideo($videoPlayer) {
      if (!youtubeLoaded) {
        return;
      }
      if (isMobile()) {
        $videoPlayer.removeAttr("style");
      } else {
        var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
        var videoWidth = $videoWrapper.width();
        var playerWidth = $videoPlayer.width();
        var desktopHeight = $videoWrapper.data("desktop-height");
        if (videoWidth / videoOptions.ratio < desktopHeight) {
          playerWidth = Math.ceil(desktopHeight * videoOptions.ratio);
          $videoPlayer.width(playerWidth).height(desktopHeight).css({
            left: (videoWidth - playerWidth) / 2,
            top: 0
          });
        } else {
          desktopHeight = Math.ceil(videoWidth / videoOptions.ratio);
          $videoPlayer.width(videoWidth).height(desktopHeight).css({
            left: 0,
            top: (desktopHeight - desktopHeight) / 2
          });
        }
        $videoPlayer.prepareTransition();
        $videoWrapper.addClass(classes.loaded);
      }
    }
    function unsetBackgroundVideo(playerId) {
      $("#" + playerId).removeClass(classes.backgroundVideo).addClass(classes.videoWithImage);
      setTimeout(function() {
        $("#" + playerId).removeAttr("style");
      }, 600);
      videos[playerId].$videoWrapper.removeClass(classes.backgroundVideoWrapper).addClass(classes.playing);
      videos[playerId].status = "open";
    }
    function setBackgroundVideo(playerId) {
      $("#" + playerId).removeClass(classes.videoWithImage).addClass(classes.backgroundVideo);
      videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);
      videos[playerId].status = "background";
      sizeBackgroundVideo($("#" + playerId));
    }
    function isMobile() {
      return $(window).width() < 750 || window.mobileCheck();
    }
    function initEvents() {
      $(document).on("click.videoPlayer", selectors.playVideoBtn, function(evt) {
        var playerId = $(evt.currentTarget).data("controls");
        startVideoOnClick(playerId);
      });
      $(document).on("click.videoPlayer", selectors.closeVideoBtn, function(evt) {
        var playerId = $(evt.currentTarget).data("controls");
        $(evt.currentTarget).blur();
        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
      });
      $(document).on("click.videoPlayer", selectors.pauseVideoBtn, function(evt) {
        var playerId = $(evt.currentTarget).data("controls");
        togglePause(playerId);
      });
      $(window).on(
        "resize.videoPlayer",
        $.debounce(200, function() {
          if (!youtubeLoaded) return;
          var key;
          var fullscreen = window.innerHeight === screen.height;
          sizeBackgroundVideos();
          if (isMobile()) {
            for (key in videos) {
              if (videos.hasOwnProperty(key)) {
                if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                  if (!fullscreen) {
                    pauseVideo(key);
                    setAsPaused(videos[key]);
                  }
                }
                videos[key].$videoWrapper.height(
                  $(document).width() / videoOptions.ratio
                );
              }
            }
            setAutoplaySupport(false);
          } else {
            setAutoplaySupport(true);
            for (key in videos) {
              if (videos[key].$videoWrapper.find("." + classes.videoWithImage).length) {
                continue;
              }
              videoPlayers[key].playVideo();
              setAsPlaying(videos[key]);
            }
          }
        })
      );
      $(window).on(
        "scroll.videoPlayer",
        $.debounce(50, function() {
          if (!youtubeLoaded) return;
          for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
              var $videoWrapper = videos[key].$videoWrapper;
              if ($videoWrapper.hasClass(classes.playing) && ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 < $(window).scrollTop() || $videoWrapper.offset().top + $videoWrapper.height() * 0.25 > $(window).scrollTop() + $(window).height())) {
                closeVideo(key);
                toggleExpandVideo(key, false);
              }
            }
          }
        })
      );
    }
    function createPlayer(key) {
      var args = $.extend({}, videoOptions, videos[key]);
      args.playerVars.controls = args.controls;
      videoPlayers[key] = new YT.Player(key, args);
    }
    function removeEvents() {
      $(document).off(".videoPlayer");
      $(window).off(".videoPlayer");
    }
    return {
      init,
      editorLoadVideo,
      loadVideos,
      playVideo: customPlayVideo,
      pauseVideo,
      removeEvents
    };
  }();
  window.theme = window.theme || {};
  theme.FormStatus = /* @__PURE__ */ function() {
    var selectors = {
      statusMessage: "[data-form-status]"
    };
    function init() {
      this.$statusMessage = $(selectors.statusMessage);
      if (!this.$statusMessage) return;
      this.$statusMessage.attr("tabindex", -1).focus();
      this.$statusMessage.on("blur", handleBlur.bind(this));
    }
    function handleBlur() {
      this.$statusMessage.removeAttr("tabindex");
    }
    return {
      init
    };
  }();
  (function() {
    var $filterBy = $("#BlogTagFilter");
    if (!$filterBy.length) {
      return;
    }
    $filterBy.on("change", function() {
      location.href = $(this).val();
    });
  })();
  window.theme = theme || {};
  theme.customerTemplates = /* @__PURE__ */ function() {
    var selectors = {
      RecoverHeading: "#RecoverHeading",
      RecoverEmail: "#RecoverEmail",
      LoginHeading: "#LoginHeading"
    };
    function initEventListeners() {
      this.$RecoverHeading = $(selectors.RecoverHeading);
      this.$RecoverEmail = $(selectors.RecoverEmail);
      this.$LoginHeading = $(selectors.LoginHeading);
      $("#RecoverPassword").on(
        "click",
        function(evt) {
          evt.preventDefault();
          showRecoverPasswordForm();
          this.$RecoverHeading.attr("tabindex", "-1").focus();
        }.bind(this)
      );
      $("#HideRecoverPasswordLink").on(
        "click",
        function(evt) {
          evt.preventDefault();
          hideRecoverPasswordForm();
          this.$LoginHeading.attr("tabindex", "-1").focus();
        }.bind(this)
      );
      this.$RecoverHeading.on("blur", function() {
        $(this).removeAttr("tabindex");
      });
      this.$LoginHeading.on("blur", function() {
        $(this).removeAttr("tabindex");
      });
    }
    function showRecoverPasswordForm() {
      $("#RecoverPasswordForm").removeClass("hide");
      $("#CustomerLoginForm").addClass("hide");
      if (this.$RecoverEmail.attr("aria-invalid") === "true") {
        this.$RecoverEmail.focus();
      }
    }
    function hideRecoverPasswordForm() {
      $("#RecoverPasswordForm").addClass("hide");
      $("#CustomerLoginForm").removeClass("hide");
    }
    function resetPasswordSuccess() {
      var $formState = $(".reset-password-success");
      if (!$formState.length) {
        return;
      }
      $("#ResetSuccess").removeClass("hide").focus();
    }
    function customerAddressForm() {
      var $newAddressForm = $("#AddressNewForm");
      var $newAddressFormButton = $("#AddressNewButton");
      if (!$newAddressForm.length) {
        return;
      }
      if (Shopify) {
        new Shopify.CountryProvinceSelector(
          "AddressCountryNew",
          "AddressProvinceNew",
          {
            hideElement: "AddressProvinceContainerNew"
          }
        );
      }
      $(".address-country-option").each(function() {
        var formId = $(this).data("form-id");
        var countrySelector = "AddressCountry_" + formId;
        var provinceSelector = "AddressProvince_" + formId;
        var containerSelector = "AddressProvinceContainer_" + formId;
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });
      $(".address-new-toggle").on("click", function() {
        var isExpanded = $newAddressFormButton.attr("aria-expanded") === "true";
        $newAddressForm.toggleClass("hide");
        $newAddressFormButton.attr("aria-expanded", !isExpanded).focus();
      });
      $(".address-edit-toggle").on("click", function() {
        var formId = $(this).data("form-id");
        var $editButton = $("#EditFormButton_" + formId);
        var $editAddress = $("#EditAddress_" + formId);
        var isExpanded = $editButton.attr("aria-expanded") === "true";
        $editAddress.toggleClass("hide");
        $editButton.attr("aria-expanded", !isExpanded).focus();
      });
      $(".address-delete").on("click", function() {
        var $el = $(this);
        var formId = $el.data("form-id");
        var confirmMessage = $el.data("confirm-message");
        if (confirm(
          confirmMessage || "Are you sure you wish to delete this address?"
        )) {
          Shopify.postLink("/account/addresses/" + formId, {
            parameters: { _method: "delete" }
          });
        }
      });
    }
    function checkUrlHash() {
      var hash = window.location.hash;
      if (hash === "#recover") {
        showRecoverPasswordForm.bind(this)();
      }
    }
    return {
      init: function() {
        initEventListeners();
        checkUrlHash();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  }();
  window.theme = window.theme || {};
  theme.Cart = function() {
    var selectors = {
      edit: ".js-edit-toggle",
      inputQty: ".cart__qty-input",
      thumbnails: ".cart__image",
      item: ".cart__row"
    };
    var config = {
      showClass: "cart__update--show",
      showEditClass: "cart__edit--active",
      cartNoCookies: "cart--no-cookies"
    };
    function Cart(container3) {
      this.$container = $(container3);
      this.$edit = $(selectors.edit, this.$container);
      this.$inputQuantities = $(selectors.inputQty, this.$container);
      this.$thumbnails = $(selectors.thumbnails, this.$container);
      if (!this.cookiesEnabled()) {
        this.$container.addClass(config.cartNoCookies);
      }
      this.$edit.on("click", this._onEditClick);
      this.$inputQuantities.on("change", this._handleInputQty);
      this.$thumbnails.css("cursor", "pointer");
      this.$thumbnails.on("click", this._handleThumbnailClick);
    }
    Cart.prototype = _.assignIn({}, Cart.prototype, {
      onUnload: function() {
        this.$edit.off("click", this._onEditClick);
      },
      _onEditClick: function(evt) {
        var $evtTarget = $(evt.target);
        var $updateLine = $("." + $evtTarget.data("target"));
        var isExpanded = $evtTarget.attr("aria-expanded") === "true";
        $evtTarget.toggleClass(config.showEditClass).attr("aria-expanded", !isExpanded);
        $updateLine.toggleClass(config.showClass);
      },
      _handleInputQty: function(evt) {
        var $input = $(evt.target);
        var value = $input.val();
        var itemKey = $input.data("quantity-item");
        var $itemQtyInputs = $("[data-quantity-item=" + itemKey + "]");
        $itemQtyInputs.val(value);
      },
      _handleThumbnailClick: function(evt) {
        var url = $(evt.target).data("item-url");
        window.location.href = url;
      },
      cookiesEnabled: function() {
        var cookieEnabled = navigator.cookieEnabled;
        if (!cookieEnabled) {
          document.cookie = "testcookie";
          cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
        }
        return cookieEnabled;
      }
    });
    return Cart;
  }();
  window.theme = window.theme || {};
  theme.Filters = function() {
    var settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: "screen and (min-width: 750px)"
    };
    var constants = {
      SORT_BY: "sort_by"
    };
    var selectors = {
      mainContent: "#MainContent",
      filterSelection: "#FilterTags",
      sortSelection: "#SortBy"
    };
    var data = {
      sortBy: "data-default-sortby"
    };
    function Filters(container3) {
      var $container = this.$container = $(container3);
      this.$filterSelect = $(selectors.filterSelection, $container);
      this.$sortSelect = $(selectors.sortSelection, $container);
      this.$selects = $(selectors.filterSelection, $container).add(
        $(selectors.sortSelection, $container)
      );
      this.defaultSort = this._getDefaultSortValue();
      this.$selects.removeClass("hidden");
      this.$filterSelect.on("change", this._onFilterChange.bind(this));
      this.$sortSelect.on("change", this._onSortChange.bind(this));
      this._initBreakpoints();
    }
    Filters.prototype = _.assignIn({}, Filters.prototype, {
      _initBreakpoints: function() {
        var self2 = this;
        enquire.register(settings.mediaQueryMediumUp, {
          match: function() {
            self2._resizeSelect(self2.$selects);
          }
        });
      },
      _onSortChange: function() {
        var sort = this._sortValue();
        var url = window.location.href.replace(window.location.search, "");
        var queryStringValue = slate.utils.getParameterByName("q");
        var query = queryStringValue !== null ? queryStringValue : "";
        if (sort.length) {
          var urlStripped = url.replace(window.location.hash, "");
          query = query !== "" ? "?q=" + query + "&" : "?";
          window.location.href = urlStripped + query + sort + selectors.mainContent;
        } else {
          window.location.href = url;
        }
      },
      _onFilterChange: function() {
        var filter = this._getFilterValue();
        var search = document.location.search.replace(/\?(page=\w+)?&?/, "");
        search = search !== "" ? "?" + search : "";
        document.location.href = filter + search + selectors.mainContent;
      },
      _getFilterValue: function() {
        return this.$filterSelect.val();
      },
      _getSortValue: function() {
        return this.$sortSelect.val() || this.defaultSort;
      },
      _getDefaultSortValue: function() {
        return this.$sortSelect.attr(data.sortBy);
      },
      _sortValue: function() {
        var sort = this._getSortValue();
        var query = "";
        if (sort !== this.defaultSort) {
          query = constants.SORT_BY + "=" + sort;
        }
        return query;
      },
      _resizeSelect: function($selection) {
        $selection.each(function() {
          var $this = $(this);
          var arrowWidth = 10;
          var text = $this.find("option:selected").text();
          var $test = $("<span>").html(text);
          $test.appendTo("body");
          var width = $test.width();
          $test.remove();
          $this.width(width + arrowWidth);
        });
      },
      onUnload: function() {
        this.$filterSelect.off("change", this._onFilterChange);
        this.$sortSelect.off("change", this._onSortChange);
      }
    });
    return Filters;
  }();
  window.theme = window.theme || {};
  theme.HeaderSection = function() {
    function Header() {
      theme.Header.init();
      theme.MobileNav.init();
      theme.Search.init();
    }
    Header.prototype = _.assignIn({}, Header.prototype, {
      onUnload: function() {
        theme.Header.unload();
      }
    });
    return Header;
  }();
  theme.Maps = function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };
    var selectors = {
      section: '[data-section-type="map"]',
      map: "[data-map]",
      mapOverlay: "[data-map-overlay]"
    };
    var classes = {
      mapError: "map-section--load-error",
      errorMsg: "map-section__error errors text-center"
    };
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' + classes.errorMsg + '">' + theme.strings.authError + "</div>"
      );
    };
    function Map(container3) {
      this.$container = $(container3);
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data("api-key");
      if (typeof this.key === "undefined") {
        return;
      }
      if (apiStatus === "loaded") {
        this.createMap();
      } else {
        mapsToLoad.push(this);
        if (apiStatus !== "loading") {
          apiStatus = "loading";
          if (typeof window.google === "undefined") {
            $.getScript(
              "https://maps.googleapis.com/maps/api/js?key=" + this.key
            ).then(function() {
              apiStatus = "loaded";
              initAllMaps();
            });
          }
        }
      }
    }
    function initAllMaps() {
      $.each(mapsToLoad, function(index, instance) {
        instance.createMap();
      });
    }
    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data("address-setting");
      geocoder.geocode({ address }, function(results, status2) {
        if (status2 !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status2);
        }
        deferred.resolve(results);
      });
      return deferred;
    }
    Map.prototype = _.assignIn({}, Map.prototype, {
      createMap: function() {
        var $map = this.$map;
        return geolocate($map).then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };
            var map = this.map = new google.maps.Map($map[0], mapOptions);
            var center = this.center = map.getCenter();
            var marker = new google.maps.Marker({
              map,
              position: map.getCenter()
            });
            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function() {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
                $map.removeAttr("style");
              })
            );
          }.bind(this)
        ).fail(function() {
          var errorMessage;
          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = errors.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = errors.addressQueryLimit;
              break;
            case "REQUEST_DENIED":
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }
          if (Shopify.designMode) {
            $map.parent().addClass(classes.mapError).html(
              '<div class="' + classes.errorMsg + '">' + errorMessage + "</div>"
            );
          }
        });
      },
      onUnload: function() {
        if (this.$map.length === 0) {
          return;
        }
        google.maps.event.clearListeners(this.map, "resize");
      }
    });
    return Map;
  }();
  theme.Product = function() {
    function Product(container3) {
      var $container = this.$container = $(container3);
      var sectionId = $container.attr("data-section-id");
      this.settings = {
        // Breakpoints from src/stylesheets/global/variables.scss.liquid
        mediaQueryMediumUp: "screen and (min-width: 750px)",
        mediaQuerySmall: "screen and (max-width: 749px)",
        bpSmall: false,
        enableHistoryState: $container.data("enable-history-state") || false,
        namespace: ".slideshow-" + sectionId,
        sectionId,
        sliderActive: false,
        zoomEnabled: false
      };
      this.selectors = {
        addToCart: "#AddToCart-" + sectionId,
        addToCartText: "#AddToCartText-" + sectionId,
        errorQuantityMessage: "#error-quantity-" + sectionId,
        quantity: "#Quantity-" + sectionId,
        SKU: ".variant-sku",
        productStatus: "[data-product-status]",
        originalSelectorId: "#ProductSelect-" + sectionId,
        productImageWraps: ".product-single__photo",
        productThumbImages: ".product-single__thumbnail--" + sectionId,
        productThumbs: ".product-single__thumbnails-" + sectionId,
        productThumbListItem: ".product-single__thumbnails-item",
        productFeaturedImage: ".product-featured-img",
        productThumbsWrapper: ".thumbnails-wrapper",
        saleLabel: ".product-price__sale-label-" + sectionId,
        singleOptionSelector: ".single-option-selector-" + sectionId,
        shopifyPaymentButton: ".shopify-payment-button",
        priceContainer: "[data-price]",
        regularPrice: "[data-regular-price]",
        salePrice: "[data-sale-price]"
      };
      this.classes = {
        hidden: "hide",
        productOnSale: "price--on-sale",
        productUnavailable: "price--unavailable",
        activeClass: "active-thumb"
      };
      if (!$("#ProductJson-" + sectionId).html()) {
        return;
      }
      this.productSingleObject = JSON.parse(
        document.getElementById("ProductJson-" + sectionId).innerHTML
      );
      this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
        "js-zoom-enabled"
      );
      this._initBreakpoints();
      this._stringOverrides();
      this._initVariants();
      this._initImageSwitch();
      this._initAddToCart();
      this._setActiveThumbnail();
    }
    Product.prototype = _.assignIn({}, Product.prototype, {
      _stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
      _initBreakpoints: function() {
        var self2 = this;
        enquire.register(this.settings.mediaQuerySmall, {
          match: function() {
            if ($(self2.selectors.productThumbImages).length > 3) {
              self2._initThumbnailSlider();
            }
            if (self2.settings.zoomEnabled) {
              $(self2.selectors.productImageWraps).each(function() {
                _destroyZoom(this);
              });
            }
            self2.settings.bpSmall = true;
          },
          unmatch: function() {
            if (self2.settings.sliderActive) {
              self2._destroyThumbnailSlider();
            }
            self2.settings.bpSmall = false;
          }
        });
        enquire.register(this.settings.mediaQueryMediumUp, {
          match: function() {
            if (self2.settings.zoomEnabled) {
              $(self2.selectors.productImageWraps).each(function() {
                _enableZoom(this);
              });
            }
          }
        });
      },
      _initVariants: function() {
        var options = {
          $container: this.$container,
          enableHistoryState: this.$container.data("enable-history-state") || false,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: this.productSingleObject
        };
        this.variants = new slate.Variants(options);
        this.$container.on(
          "variantChange" + this.settings.namespace,
          this._updateAvailability.bind(this)
        );
        this.$container.on(
          "variantImageChange" + this.settings.namespace,
          this._updateImages.bind(this)
        );
        this.$container.on(
          "variantPriceChange" + this.settings.namespace,
          this._updatePrice.bind(this)
        );
        this.$container.on(
          "variantSKUChange" + this.settings.namespace,
          this._updateSKU.bind(this)
        );
      },
      _initImageSwitch: function() {
        if (!$(this.selectors.productThumbImages).length) {
          return;
        }
        var self2 = this;
        $(this.selectors.productThumbImages).on("click", function(evt) {
          evt.preventDefault();
          var $el = $(this);
          var imageId = $el.data("thumbnail-id");
          self2._switchImage(imageId);
          self2._setActiveThumbnail(imageId);
        }).on("keyup", self2._handleImageFocus.bind(self2));
      },
      _initAddToCart: function() {
        var self2 = this;
        var $quantityInput = $(self2.selectors.quantity);
        if ($quantityInput.length === 0) return;
        $(self2.selectors.addToCart).on("click", function(evt) {
          var isInvalidQuantity = $quantityInput.val() <= 0;
          $(self2.selectors.errorQuantityMessage).toggleClass(
            self2.classes.hidden,
            !isInvalidQuantity
          );
          if (isInvalidQuantity) {
            $quantityInput.attr(
              "aria-describedby",
              "error-quantity-" + self2.settings.sectionId
            ).attr("aria-invalid", true);
            $(self2.selectors.errorQuantityMessage).focus();
            evt.preventDefault();
          } else {
            $quantityInput.removeAttr("aria-describedby").removeAttr("aria-invalid");
          }
        });
      },
      _setActiveThumbnail: function(imageId) {
        if (typeof imageId === "undefined") {
          imageId = $(
            this.selectors.productImageWraps + ":not(.hide)",
            this.$container
          ).data("image-id");
        }
        var $thumbnailWrappers = $(
          this.selectors.productThumbListItem + ":not(.slick-cloned)",
          this.$container
        );
        var $activeThumbnail = $thumbnailWrappers.find(
          this.selectors.productThumbImages + "[data-thumbnail-id='" + imageId + "']"
        );
        $(this.selectors.productThumbImages).removeClass(this.classes.activeClass).removeAttr("aria-current");
        $activeThumbnail.addClass(this.classes.activeClass);
        $activeThumbnail.attr("aria-current", true);
        if (!$thumbnailWrappers.hasClass("slick-slide")) {
          return;
        }
        var slideIndex = $activeThumbnail.parent().data("slick-index");
        $(this.selectors.productThumbs).slick("slickGoTo", slideIndex, true);
      },
      _switchImage: function(imageId) {
        var $newImage = $(
          this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
          this.$container
        );
        var $otherImages = $(
          this.selectors.productImageWraps + ":not([data-image-id='" + imageId + "'])",
          this.$container
        );
        $newImage.removeClass(this.classes.hidden);
        $otherImages.addClass(this.classes.hidden);
      },
      _handleImageFocus: function(evt) {
        if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;
        $(this.selectors.productFeaturedImage + ":visible").focus();
      },
      _initThumbnailSlider: function() {
        var options = {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: false,
          prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
          nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
          responsive: [
            {
              breakpoint: 321,
              settings: {
                slidesToShow: 3
              }
            }
          ]
        };
        $(this.selectors.productThumbs).slick(options);
        $(this.selectors.productThumbsWrapper, this.$container).find(".slick-list").removeAttr("aria-live");
        $(this.selectors.productThumbsWrapper, this.$container).find(".slick-disabled").removeAttr("aria-disabled");
        this.settings.sliderActive = true;
      },
      _destroyThumbnailSlider: function() {
        $(this.selectors.productThumbs).slick("unslick");
        this.settings.sliderActive = false;
        $(this.selectors.productThumbsWrapper, this.$container).find('[tabindex="-1"]').removeAttr("tabindex");
      },
      _liveRegionText: function(variant) {
        var liveRegionText = "[Availability] [Regular] [$$] [Sale] [$]";
        if (!variant) {
          liveRegionText = theme.strings.unavailable;
          return liveRegionText;
        }
        var availability = variant.available ? "" : theme.strings.soldOut + ",";
        liveRegionText = liveRegionText.replace("[Availability]", availability);
        var regularLabel = "";
        var regularPrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
        var saleLabel = "";
        var salePrice = "";
        if (variant.compare_at_price > variant.price) {
          regularLabel = theme.strings.regularPrice;
          regularPrice = theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ",";
          saleLabel = theme.strings.sale;
          salePrice = theme.Currency.formatMoney(
            variant.price,
            theme.moneyFormat
          );
        }
        liveRegionText = liveRegionText.replace("[Regular]", regularLabel).replace("[$$]", regularPrice).replace("[Sale]", saleLabel).replace("[$]", salePrice).trim();
        return liveRegionText;
      },
      _updateLiveRegion: function(evt) {
        var variant = evt.variant;
        var liveRegion = this.container.querySelector(
          this.selectors.productStatus
        );
        liveRegion.textContent = this._liveRegionText(variant);
        liveRegion.setAttribute("aria-hidden", false);
        setTimeout(function() {
          liveRegion.setAttribute("aria-hidden", true);
        }, 1e3);
      },
      _updateAddToCart: function(evt) {
        var variant = evt.variant;
        if (variant) {
          if (variant.available) {
            $(this.selectors.addToCart).prop("disabled", false);
            $(this.selectors.addToCartText).text(theme.strings.addToCart);
            $(this.selectors.shopifyPaymentButton, this.$container).show();
          } else {
            $(this.selectors.addToCart).prop("disabled", true);
            $(this.selectors.addToCartText).text(theme.strings.soldOut);
            $(this.selectors.shopifyPaymentButton, this.$container).hide();
          }
        } else {
          $(this.selectors.addToCart).prop("disabled", true);
          $(this.selectors.addToCartText).text(theme.strings.unavailable);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      },
      _updateAvailability: function(evt) {
        this._updateAddToCart(evt);
        this._updateLiveRegion(evt);
        this._updatePrice(evt);
      },
      _updateImages: function(evt) {
        var variant = evt.variant;
        var imageId = variant.featured_image.id;
        this._switchImage(imageId);
        this._setActiveThumbnail(imageId);
      },
      _updatePrice: function(evt) {
        var variant = evt.variant;
        var $priceContainer = $(this.selectors.priceContainer, this.$container);
        var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
        var $salePrice = $(this.selectors.salePrice, $priceContainer);
        $priceContainer.removeClass(this.classes.productUnavailable).removeClass(this.classes.productOnSale).removeAttr("aria-hidden");
        if (!variant) {
          $priceContainer.addClass(this.classes.productUnavailable).attr("aria-hidden", true);
          return;
        }
        if (variant.compare_at_price > variant.price) {
          $regularPrice.html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          );
          $salePrice.html(
            theme.Currency.formatMoney(variant.price, theme.moneyFormat)
          );
          $priceContainer.addClass(this.classes.productOnSale);
        } else {
          $regularPrice.html(
            theme.Currency.formatMoney(variant.price, theme.moneyFormat)
          );
        }
      },
      _updateSKU: function(evt) {
        var variant = evt.variant;
        $(this.selectors.SKU).html(variant.sku);
      },
      onUnload: function() {
        this.$container.off(this.settings.namespace);
      }
    });
    function _enableZoom(el) {
      var zoomUrl = $(el).data("zoom");
      $(el).zoom({
        url: zoomUrl
      });
    }
    function _destroyZoom(el) {
      $(el).trigger("zoom.destroy");
    }
    return Product;
  }();
  theme.Quotes = function() {
    var config = {
      mediaQuerySmall: "screen and (max-width: 749px)",
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      slideCount: 0
    };
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };
    function Quotes(container3) {
      var $container = this.$container = $(container3);
      var sectionId = $container.attr("data-section-id");
      var wrapper = this.wrapper = ".quotes-wrapper";
      var slider = this.slider = "#Quotes-" + sectionId;
      var $slider = $(slider, wrapper);
      var sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
      config.slideCount = $slider.data("count");
      if (config.slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = config.slideCount;
        defaults.slidesToScroll = config.slideCount;
      }
      $slider.on("init", this.a11y.bind(this));
      enquire.register(config.mediaQuerySmall, {
        match: function() {
          initSlider($slider, mobileOptions);
        }
      });
      enquire.register(config.mediaQueryMediumUp, {
        match: function() {
          initSlider($slider, defaults);
        }
      });
      function initSlider(sliderObj, args) {
        if (sliderActive) {
          sliderObj.slick("unslick");
          sliderActive = false;
        }
        sliderObj.slick(args);
        sliderActive = true;
      }
    }
    Quotes.prototype = _.assignIn({}, Quotes.prototype, {
      onUnload: function() {
        enquire.unregister(config.mediaQuerySmall);
        enquire.unregister(config.mediaQueryMediumUp);
        $(this.slider, this.wrapper).slick("unslick");
      },
      onBlockSelect: function(evt) {
        var $slide = $(
          ".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)"
        );
        var slideIndex = $slide.data("slick-index");
        $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
      },
      a11y: function(event2, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
        $list.removeAttr("aria-live");
        $wrapper.on("focusin", function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr("aria-live", "polite");
          }
        });
        $wrapper.on("focusout", function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr("aria-live");
          }
        });
      }
    });
    return Quotes;
  }();
  theme.slideshows = {};
  theme.SlideshowSection = /* @__PURE__ */ function() {
    function SlideshowSection(container3) {
      var $container = this.$container = $(container3);
      var sectionId = $container.attr("data-section-id");
      var slideshow = this.slideshow = "#Slideshow-" + sectionId;
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
    }
    return SlideshowSection;
  }();
  theme.SlideshowSection.prototype = _.assignIn(
    {},
    theme.SlideshowSection.prototype,
    {
      onUnload: function() {
        delete theme.slideshows[this.slideshow];
      },
      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
        var adaptHeight = $slideshow.data("adapt-height");
        if (adaptHeight) {
          theme.slideshows[this.slideshow].setSlideshowHeight();
        }
        var $slide = $(
          ".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"
        );
        var slideIndex = $slide.data("slick-index");
        $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
      },
      onBlockDeselect: function() {
        $(this.slideshow).slick("slickPlay");
      }
    }
  );
  theme.slideshows = {};
  theme.VideoSection = /* @__PURE__ */ function() {
    function VideoSection(container3) {
      var $container = this.$container = $(container3);
      $(".video", $container).each(function() {
        var $el = $(this);
        theme.Video.init($el);
        theme.Video.editorLoadVideo($el.attr("id"));
      });
    }
    return VideoSection;
  }();
  theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
    onUnload: function() {
      theme.Video.removeEvents();
    }
  });
  $(document).ready(function() {
    var sections = new theme.Sections();
    sections.register("cart-template", theme.Cart);
    sections.register("product", theme.Product);
    sections.register("collection-template", theme.Filters);
    sections.register("product-template", theme.Product);
    sections.register("header-section", theme.HeaderSection);
    sections.register("map", theme.Maps);
    sections.register("slideshow-section", theme.SlideshowSection);
    sections.register("video-section", theme.VideoSection);
    sections.register("quotes", theme.Quotes);
  });
  theme.init = function() {
    theme.customerTemplates.init();
    var tableSelectors = ".rte table,.custom__item-inner--html table";
    slate.rte.wrapTable({
      $tables: $(tableSelectors),
      tableWrapperClass: "scrollable-wrapper"
    });
    var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]';
    slate.rte.wrapIframe({
      $iframes: $(iframeSelectors),
      iframeWrapperClass: "video-wrapper"
    });
    slate.a11y.pageLinkFocus($(window.location.hash));
    $(".in-page-link").on("click", function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
    $('a[href="#"]').on("click", function(evt) {
      evt.preventDefault();
    });
    slate.a11y.accessibleLinks({
      messages: {
        newWindow: theme.strings.newWindow,
        external: theme.strings.external,
        newWindowExternal: theme.strings.newWindowExternal
      },
      $links: $("a[href]:not([aria-describedby], .product-single__thumbnail)")
    });
    theme.FormStatus.init();
  };
  (function() {
    if ($(".lf__product-images").length > 0) {
      let handleChangeVariantImage2 = function() {
        if ($(".lf__product-images").attr("data-product-images-style") == "variant has many") {
          $(".lf__product-images").on("changeVariantImage", function(e, variant) {
            if ($product_image_carousel) {
              $product_image_carousel.flickity("destroy");
              $product_image_carousel = null;
            }
            $(".images-container.current-variant").removeClass("current-variant");
            if (variant) {
              var variant_compare_src = variant.featured_image.src.replace("https:", "");
              variant_compare_src = variant_compare_src.split("?")[0];
            } else {
              var variant_compare_src = "unavailable";
            }
            $(".images-container").each(function() {
              if ($(this).find('img[data-image-raw*="' + variant_compare_src + '"]').length > 0) {
                $(this).addClass("current-variant");
              }
            });
            initCarousel2();
            $(".filmstrip-container.current-variant").removeClass("current-variant");
            $(".filmstrip-container").each(function() {
              if ($(this).find('img[data-image-raw*="' + variant_compare_src + '"]').length > 0) {
                $(this).addClass("current-variant");
              }
            });
          });
        }
      }, initCarousel2 = function(selector) {
        if (!selector) {
          if ($(".lf__product-images").attr("data-product-images-style") == "variant has many") {
            selector = ".images-container.current-variant";
          } else {
            selector = ".images-container";
          }
        }
        if ($(".img-slide", selector).length < 2) {
          return;
        }
        var initialIndex = 0;
        if ($(selector).attr("data-initial")) {
          initialIndex = parseInt($(selector).attr("data-initial"));
        }
        $product_image_carousel = $(selector).flickity({
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 60,
            y2: 45,
            x3: 15
          },
          on: {
            ready: function() {
              setTimeout(function() {
                $(".product-filmstrip").show();
              }, 2e3);
            }
          },
          wrapAround: true,
          contain: true,
          cellAlign: "center",
          imagesLoaded: false,
          initialIndex
        });
        if ($(".product-has-many.image-controls-option-selectors").length > 0) {
          $product_image_carousel.off("select.flickity");
          $product_image_carousel.on("select.flickity", function(e) {
            var selected_slide_index = $(this).data().flickity.selectedIndex;
            [1, 2].forEach(function(option_index) {
              var option_exists = $('select[data-single-option-selector][data-index="option' + option_index + '"]').length > 0;
              var image_controls_option = $(".product-has-many.image-controls-selector-option-" + option_index).length > 0;
              if (option_exists && image_controls_option) {
                var option_from_image = $(".images-container .img-slide").eq(selected_slide_index).attr("data-option-" + option_index);
                $('select[data-single-option-selector][data-index="option' + option_index + '"]').val(option_from_image).trigger("change");
                if ($('.selectric-hide-select select[data-single-option-selector][data-index="option' + option_index + '"]').length > 0) {
                  $('select[data-single-option-selector][data-index="option' + option_index + '"]').selectric("refresh");
                }
              }
            });
          });
        }
      };
      var handleChangeVariantImage = handleChangeVariantImage2, initCarousel = initCarousel2;
      var $product_image_carousel;
      initCarousel2();
      handleChangeVariantImage2();
      $(document).on("shopify:section:load", function(e) {
        if (e.target.id != "shopify-section-lf__product-overview") {
          return;
        }
        initCarousel2();
        handleChangeVariantImage2();
      });
    }
  })();
  (function() {
    var lf__carousels = {};
    var lf__carousels_mobile = {};
    $(".lf__carousel").each(function() {
      var section_id = $(this).parent().parent().data("sectionId");
      carouselInit(section_id, $(this));
    });
    $(document).on("shopify:section:load", function(e) {
      var section_id = e.detail.sectionId;
      if ($("#lf__carousel" + section_id).length > 0) {
        if (lf__carousels[section_id]) {
          var index = lf__carousels[section_id].data("flickity").selectedIndex;
          var mobile_index = lf__carousels_mobile[section_id].data("flickity").selectedIndex;
          lf__carousels[section_id].flickity("destroy");
          lf__carousels_mobile[section_id].flickity("destroy");
          delete lf__carousels[section_id];
          delete lf__carousels_mobile[section_id];
        }
        carouselInit(section_id, $("#lf__carousel" + section_id), index);
        carouselInit(section_id, $("#lf__carousel_mobile" + section_id), mobile_index);
      }
    });
    $(document).on("shopify:block:select", function(e) {
      var section_id = e.detail.sectionId;
      if ($("#lf__carousel" + section_id).length > 0) {
        var block_id = e.detail.blockId;
        var index = $("#lf__slide" + block_id).index();
        lf__carousels[section_id].flickity("select", index).flickity("pausePlayer");
        lf__carousels_mobile[section_id].flickity("select", index).flickity("pausePlayer");
      }
    });
    $(document).on("shopify:block:deselect", function(e) {
      var section_id = e.detail.sectionId;
      if ($("#lf__carousel" + section_id).length > 0) {
        var block_id = e.detail.blockId;
        var index = $("#lf__slide" + block_id).index();
        lf__carousels[section_id].flickity("unpausePlayer");
        lf__carousels_mobile[section_id].flickity("unpausePlayer");
      }
    });
    function carouselInit(section_id, carousel, index) {
      if (carousel.children().length > 1) {
        var object = lf__carousels;
        if (carousel.attr("id").indexOf("mobile") >= 0) {
          object = lf__carousels_mobile;
        }
        object[section_id] = carousel.flickity({
          initialIndex: index ? index : 0,
          prevNextButtons: carousel.data("prevNextButtons"),
          pageDots: carousel.data("pageDots"),
          draggable: carousel.data("draggable"),
          wrapAround: carousel.data("wrapAround"),
          autoPlay: carousel.data("autoPlay"),
          pauseAutoPlayOnHover: carousel.data("pauseAutoPlayOnHover"),
          adaptiveHeight: true,
          imagesLoaded: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 60,
            y2: 45,
            x3: 15
          }
        });
        carousel.css("overflow", "visible");
      }
    }
  })();
  (function() {
    var image_zoom_init = false;
    function enableImageZoom(zoomable_element) {
      image_zoom_init = true;
      zoomable_element.click(function() {
        $(this).closest(".images-container").toggleClass("zoomed");
      });
      zoomable_element.each(function() {
        var zoom_container = $(this);
        if (zoom_container.find("img").width() >= zoom_container.width()) {
          zoom_container.zoom({
            url: zoom_container.find("img").data("zoom"),
            on: "click",
            onZoomIn: function() {
              zoom_container.closest(".images-container").addClass("zoomed");
            },
            onZoomOut: function() {
              zoom_container.closest(".images-container").removeClass("zoomed");
            }
          });
        } else {
          zoom_container.zoom({
            url: zoom_container.find("img").data("zoom"),
            on: "click",
            magnify: 2,
            onZoomIn: function() {
              zoom_container.closest(".images-container").addClass("zoomed");
            },
            onZoomOut: function() {
              zoom_container.closest(".images-container").removeClass("zoomed");
            }
          });
        }
      });
    }
    $(window).on("resize", function() {
      if ($(window).outerWidth() > 1024 && !image_zoom_init) {
        enableImageZoom($(".lf__product-images .images-container .img-slide"));
      }
    });
    $(window).on("load", function() {
      if ($(window).outerWidth() > 1024 && !image_zoom_init) {
        enableImageZoom($(".lf__product-images .images-container .img-slide"));
      }
    });
  })();
  $(theme.init);

  // scripts/product-parent.js
  var colorCollections = {
    "algae": `/collections/color-algae`,
    "army": `/collections/color-army`,
    "basil": `/collections/color-basil`,
    "berry": `/collections/berry`,
    "bite": `/collections/color-bite`,
    "black-ribbed": `/collections/black-ribbed`,
    "black": `/collections/color-black`,
    "blue-flame": `/collections/color-blue-flame`,
    "blue-moon": `/collections/color-blue-moon`,
    "blueberry": `/collections/blueberry`,
    "bluebird": `/collections/color-bluebird`,
    "bluefin": `/collections/color-bluefin`,
    "bolt": `/collections/color-bolt`,
    "bondi-blossom": `/collections/color-bondi-blossom`,
    "brightlight": `/collections/color-brightlight`,
    "butterflies": `/collections/color-butterflies`,
    "cabernet": `/collections/color-cabernet`,
    "calendula": `/collections/color-calendula`,
    "calliope": `/collections/color-calliope`,
    "canvas": `/collections/color-canvas`,
    "cascade": `/collections/color-cascade`,
    "cherish": `/collections/color-cherish`,
    "cherry-blossom": `/collections/cherry-blossom`,
    "cherryade": `/collections/color-cherryade`,
    "chocolate": `/collections/color-chocolate`,
    "clamshell-ribbed": `/collections/color-clamshell-ribbed`,
    "cocopalm": `/collections/color-cocopalm`,
    "coral-reef": `/collections/coral-reef`,
    "cornflower-ribbed": `/collections/color-cornflower-ribbed`,
    "cruise": `/collections/color-cruise`,
    "daisy-dottie": `/collections/color-daisy-dottie`,
    "dolphins": `/collections/dolphins`,
    "dovie": `/collections/color-dovie`,
    "dragon-fruit": `/collections/color-dragon-fruit`,
    "dreamweave": `/collections/color-dreamweave`,
    "drift": `/collections/color-drift`,
    "elderberry": `/collections/color-elderberry`,
    "electric-bloom": `/collections/color-electric-bloom`,
    "fig": `/collections/color-fig`,
    "flippy": `/collections/color-flippy`,
    "flutterfly": `/collections/color-flutterfly`,
    "garden-gaze": `/collections/color-garden-gaze`,
    "gleam": `/collections/color-gleam`,
    "grape": `/collections/color-grape`,
    "harbor-bloom": `/collections/color-harbor-bloom`,
    "hawaii-blue": `/collections/color-hawaii-blue`,
    "heather-grey": `/collections/color-heather-grey`,
    "hop-hop": `/collections/color-hop-hop`,
    "horizon": `/collections/color-horizon`,
    "hot-pink": `/collections/color-hot-pink`,
    "indigo": `/collections/color-indigo`,
    "island-life": `/collections/color-island-life`,
    "islander-ribbed": `/collections/color-islander`,
    "jam-ribbed": `/collections/color-jam-ribbed`,
    "jellybean": `/collections/color-jellybean`,
    "kale": `/collections/kale`,
    "keylime": `/collections/color-keylime`,
    "lavender": `/collections/color-lavender`,
    "lilac-haze": `/collections/color-lilac-haze`,
    "lime": `/collections/color-lime`,
    "love-berry": `/collections/color-love-berry`,
    "mango": `/collections/color-mango`,
    "maui": `/collections/color-maui`,
    "mint-tulip": `/collections/color-mint-tulip`,
    "mint": `/collections/color-mint`,
    "moody": `/collections/color-moody`,
    "moon-flower": `/collections/color-moon-flower`,
    "mountain-mist": `/collections/color-mountain-mist`,
    "navy": `/collections/color-navy`,
    "neon-guava": `/collections/color-neon-guava`,
    "ocean": `/collections/color-ocean`,
    "odyssey": `/collections/color-odyssey`,
    "orange-zest": `/collections/color-orange-zest`,
    "orchids-ribbed": `/collections/color-orchids-ribbed`,
    "paddle": `/collections/color-paddle`,
    "panorama": `/collections/color-panorama`,
    "papaya": `/collections/color-papaya`,
    "paprika": `/collections/color-paprika`,
    "peacock": `/collections/peacock`,
    "pearla": `/collections/pearla`,
    "pine": `/collections/color-pine`,
    "pink-prism": `/collections/color-pink-prism`,
    "pinky": `/collections/color-pinky`,
    "polar": `/collections/color-polar`,
    "pua": `/collections/color-pua`,
    "purple": `/collections/color-purple`,
    "red": `/collections/color-red`,
    "sangria": `/collections/color-sangria`,
    "serrano-ribbed": `/collections/color-serrano`,
    "shells": `/collections/color-shells`,
    "shorebreak": `/collections/color-shorebreak`,
    "shortfin": `/collections/color-shortfin`,
    "sky-blue": `/collections/color-sky-blue`,
    "sky-wave": `/collections/color-sky-wave`,
    "solar-grin": `/collections/color-solar-grin`,
    "solar-plum": `/collections/color-solar-plum`,
    "space": `/collections/color-space`,
    "spice": `/collections/color-spice`,
    "sumatra": `/collections/color-sumatra`,
    "summernova": `/collections/color-summernova`,
    "sundae": `/collections/color-sundae`,
    "surreal-magic": `/collections/color-surreal-magic`,
    "stawberry": `/collections/color-strawberry`,
    "sweetheart": `/collections/color-sweetheart`,
    "sweety": `/collections/color-sweety`,
    "swell": `/collections/color-swell`,
    "tea-rose-ribbed": `/collections/color-tea-rose-ribbed`,
    "tidepool": `/collections/color-tidepool`,
    "tropical-island": `/collections/color-tropical-island`,
    "undersea": `/collections/color-undersea`,
    "underwater": `/collections/color-underwater`,
    "vanilla": `/collections/color-vanilla`,
    "waikiki": `/collections/color-waikiki`,
    "waves": `/collections/color-waves`,
    "wonders": `/collections/color-wonders`,
    "zinna": `/collections/color-zinna`,
    "zippy": `/collections/color-zippy`,
    "zucchini": `/collections/color-zucchini`
    // NOTE: ADD NEW COLORS IN ALPHABETICAL ORDER
  };
  var waitForEl = function(selector, callback, maxtries, interval) {
    maxtries = maxtries || false;
    interval = interval || 100;
    var poller = setInterval(function() {
      var el = jQuery(selector);
      var retry = maxtries === false || maxtries-- > 0;
      if (retry && el.length < 1) return;
      clearInterval(poller);
      callback(el || null);
    }, interval);
  };
  function isPreorder(product) {
    var _a, _b;
    return ((_a = product == null ? void 0 : product.tags) == null ? void 0 : _a.includes("preorder")) || ((_b = product == null ? void 0 : product.tags) == null ? void 0 : _b.includes("pre-order"));
  }
  var badges = {
    "popular-gift": {
      icon: `<?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.7 99.77">
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <path class="cls-1" d="M89.56,99.77H7.14c-3.94,0-7.14-3.2-7.14-7.14v-58.82c0-3.94,3.2-7.14,7.14-7.14h82.43c3.93,0,7.14,3.2,7.14,7.14v58.82c0,3.94-3.2,7.14-7.14,7.14ZM7.14,30.12c-2.04,0-3.69,1.66-3.69,3.69v58.82c0,2.04,1.66,3.69,3.69,3.69h82.43c2.04,0,3.69-1.66,3.69-3.69v-58.82c0-2.04-1.66-3.69-3.69-3.69H7.14Z"/>
  <path class="cls-1" d="M45.58,30.18c-15.41,0-29.84-13.27-30.69-22-.43-4.37,2.45-7.37,7.69-8.02,21.5-2.65,26.43,27.66,26.48,27.97.07.48-.06.96-.35,1.34s-.74.61-1.22.64c-.63.05-1.27.07-1.9.07ZM25.11,3.45c-.68,0-1.38.04-2.11.13-5.04.62-4.78,3.36-4.69,4.26.64,6.53,13.25,18.71,26.95,18.89-1.34-5.89-6.45-23.29-20.16-23.29Z"/>
  <path class="cls-1" d="M49.13,30.18c-.63,0-1.27-.02-1.9-.07-.48-.03-.92-.27-1.22-.64s-.43-.86-.35-1.34c.05-.31,5.03-30.61,26.48-27.97,5.25.65,8.12,3.64,7.69,8.02-.85,8.73-15.28,22-30.69,22ZM69.6,3.45c-13.71,0-18.82,17.39-20.16,23.29,13.7-.18,26.31-12.36,26.95-18.89.09-.9.36-3.64-4.69-4.26-.72-.09-1.43-.13-2.11-.13Z"/>
  <path class="cls-1" d="M94.98,46.48h-37.95c-.95,0-1.72-.77-1.72-1.72s.77-1.72,1.72-1.72h37.95c.95,0,1.72.77,1.72,1.72s-.77,1.72-1.72,1.72Z"/>
  <path class="cls-1" d="M37.7,46.48H1.72C.77,46.48,0,45.71,0,44.76s.77-1.72,1.72-1.72h35.97c.95,0,1.72.77,1.72,1.72s-.77,1.72-1.72,1.72Z"/>
  <path class="cls-1" d="M57.02,99.77h-19.34c-.95,0-1.72-.77-1.72-1.72V28.46c0-.95.77-1.72,1.72-1.72h19.34c.95,0,1.72.77,1.72,1.72v69.59c0,.95-.77,1.72-1.72,1.72ZM39.41,96.33h15.89V30.18h-15.89v66.15Z"/>
</svg>`,
      label: "Popular Gift",
      color: "red"
    },
    "new-stuff": {
      label: "New"
    }
  };
  var ProductParent = class {
    constructor(container3) {
      this.container = container3;
      this.collectionHandle = this.container.getAttribute("data-collection-handle");
      this.$submitBtn = $("#add-to-cart-variant-button");
      this.updateUrlAllowed = false;
      this.getProductData((data) => {
        var _a;
        this.tabs = data.tabs;
        this.variants = data.variants;
        let currentVariantId = this.getUrlParameter("variant");
        let group = this.getUrlParameter("group");
        if (currentVariantId) {
          this.selectedVariant = Object.values(this.variants).find(
            (variant) => variant.id.toString() === currentVariantId.toString()
          );
          if (this.selectedVariant) {
            var swatch = this.tabs[this.selectedVariant.tab].swatches[this.selectedVariant.swatch];
            if (swatch.images.length === 0 || !swatch.available) {
              this.selectedVariant = null;
            }
          }
        } else if (group) {
          this.selectedGroup = group;
        }
        this.buildPage();
        if (this.selectedVariant) {
          window.scrollToSwatch(this.getSwatchSlug(this.selectedVariant.swatch));
        }
        this.injectSearchspringWidgets((_a = this.selectedVariant) == null ? void 0 : _a.sku);
      });
      this.addListeners();
      this.firstInStockVariant = null;
      this.zoomOverlayInitialized = false;
      this.fullscreenZoomState = null;
      this.zoomGalleryItems = [];
      this.activeZoomIndex = 0;
    }
    buildPage() {
      this.setFabricContent();
      var that = this;
      var length = 0;
      Object.values(this.tabs).forEach((tab, index) => {
        var tabId = "swatch-tab-" + tab.handle;
        var panelId = "swatch-container-panel";
        var $tab = $(`
          <button
              type="button"
              color-tab-opener="${tab.handle}"
              class="color-swatch__tab-opener"
              role="tab"
              id="${tabId}"
              aria-selected="false"
              aria-controls="${panelId}"
              tabindex="-1">
              ${tab.name}
          </button>
      `);
        length++;
        $("#swatch-tabs").append($tab);
        if (index === 0 && !this.selectedVariant && !this.selectedGroup) {
          this.updateTab(tab.handle);
        } else if (this.selectedVariant && this.selectedVariant.tab === tab.handle) {
          this.updateTab(tab.handle);
        } else if (this.selectedGroup) {
          this.updateTab(this.selectedGroup);
        }
        $tab.click(function(event2) {
          var $this = $(this);
          event2.stopPropagation();
          that.selectedVariant = null;
          var tabHandle = $this.attr("color-tab-opener");
          that.updateTab(tabHandle);
        });
        $tab.on("keydown", function(event2) {
          var tabs = $(".color-swatch__tab-opener");
          var currentIndex = tabs.index(this);
          var newIndex = currentIndex;
          if (event2.key === "ArrowRight" || event2.key === "ArrowDown") {
            newIndex = (currentIndex + 1) % tabs.length;
            event2.preventDefault();
          } else if (event2.key === "ArrowLeft" || event2.key === "ArrowUp") {
            newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            event2.preventDefault();
          } else if (event2.key === "Home") {
            newIndex = 0;
            event2.preventDefault();
          } else if (event2.key === "End") {
            newIndex = tabs.length - 1;
            event2.preventDefault();
          }
          if (newIndex !== currentIndex) {
            tabs.eq(newIndex).focus().click();
          }
        });
      });
      if (length <= 1) {
        $("#swatch-tabs").hide();
        $(".color-swatch__tab-header").hide();
      }
      this.updateWair();
      this.checkModelSizeFit();
      this.listCategories();
      this.adjustForPreorder();
      this.checkExclusions();
      this.checkEcommerceExclusives();
      this.checkDelayedShipping();
      this.checkBadges();
      this.checkSizes();
      this.checkSeeAll();
    }
    updateTab(tabHandle, clickFirstSwatch) {
      if (!this.tabs[tabHandle]) {
        return;
      }
      $(".color-swatch__tab-opener").removeClass("active").attr("aria-selected", "false").attr("tabindex", "-1");
      $(`.color-swatch__tab-opener[color-tab-opener="${tabHandle}"]`).addClass("active").attr("aria-selected", "true").attr("tabindex", "0");
      this.makeSizes(Object.values(this.tabs[tabHandle].sizes));
      this.showSwatches(this.tabs[tabHandle].swatches, tabHandle);
      this.initTipsyForSwatches();
      var regex = new RegExp("[\\?&]variant=([^&#]*)");
      var results = regex.exec(location.search);
      if (results !== null || this.selectedVariant.id) {
        var currentVariantId = results ? decodeURIComponent(results[1].replace(/\+/g, " ")) : this.selectedVariant.id;
        var variantIdInput = $(".variant_id");
        if (variantIdInput.length) {
          variantIdInput.val(currentVariantId);
        }
        var fabricBadgeClass = ".surf-features_fabric--" + currentVariantId;
        $(".surf-features_fabric").hide();
        $(fabricBadgeClass).show();
        var inventory_item = $(".inventory-container").find("[data-id='" + currentVariantId + "']");
        var inventoryDiv = $(inventory_item[0]).clone();
        $(".inventory-alternate").html(inventoryDiv);
        $(".promo_message_container").hide();
        $(".promo_message_container .promo_message_1").hide();
        $(".promo_message_container .promo_message_2").hide();
        $(".promo_message_container .promo_message_3").hide();
        if (window.promoMessageArray[0].includes(currentVariantId)) {
          $(".promo_message_container .promo_message_1").show();
          $(".promo_message_container").show();
        }
        if (window.promoMessageArray[1].includes(currentVariantId)) {
          $(".promo_message_container .promo_message_2").show();
          $(".promo_message_container").show();
        }
        if (window.promoMessageArray[2].includes(currentVariantId)) {
          $(".promo_message_container .promo_message_3").show();
          $(".promo_message_container").show();
        }
        var isFinalSale = $(".final-sale-badge-data-wrapper").find("[data-id='" + currentVariantId + "']");
        isFinalSale = isFinalSale.data("final-sale") == true;
        if (isFinalSale) {
          $(".product-final-sale").show();
        } else {
          $(".product-final-sale").hide();
        }
      } else {
        var firstVariantID = this.selectedVariant.id;
        var fabricBadgeClass = ".surf-features_fabric--" + firstVariantID;
        $(".surf-features_fabric").hide();
        $(fabricBadgeClass).show();
      }
      var $selectedSwatchInput = $("input[name='color-input']:checked");
      var $selectedSwatchInputColor = $selectedSwatchInput.val();
      $(".product-print-collection__wrapper").hide();
      $(".product-print-collection-body").owlCarousel("destroy");
      $(".product-print-collection-body").empty();
      if (window.print_products) {
        var print_product_limit = 4;
        var iterator = 1;
        window.print_products.every(function(print_product) {
          if (iterator > print_product_limit) {
            return false;
          }
          var print_product_slug = print_product.slug;
          print_product.variants.every(function(variant) {
            if (variant.option1 == $selectedSwatchInputColor && variant.id != currentVariantId) {
              iterator++;
              var productLink = "/products/" + print_product_slug + "?variant=" + variant.id;
              $(".product-print-collection-body").append(`
            <div class="product-print-collection_item">
              <a href="${productLink}">
                <div class="product-print-collection_item_image" style="background-image: url(${Shopify.resizeImage(variant.featured_image_src, "x200")})"></div>

                <div class="product-print-collection_item_content">
                  <div class="product-print-collection_item_title">
                    ${print_product.title}
                  </div>

                  <div class="product-print-collection_item_price">
                    ${Shopify.formatMoney(variant.price)}
                  </div>
                </div>
              </a>
            </div>
          `);
              $(".product-print-collection__wrapper").show();
              return false;
            }
            return true;
          });
          return true;
        });
        var owlConfig = {
          items: 4,
          autoWidth: false,
          lazyLoad: true,
          loop: true,
          margin: 30,
          nav: true,
          dots: false,
          responsive: {
            0: {
              items: 1
            },
            375: {
              items: 2,
              margin: 60
            },
            767: {
              items: 3
            },
            992: {
              items: 4
            }
          }
        };
        $(".product-print-collection-body").owlCarousel(owlConfig);
      }
    }
    showSwatches(swatches, tabHandle) {
      var $group = $("#swatch-container");
      $group.empty();
      Object.values(swatches).filter((s) => {
        if (s.available && s.images.length > 0) return true;
      }).forEach((swatch, index) => {
        $group.append($(`
      <li id="swatch-container-${this.getSwatchSlug(swatch.name)}" in-stock="available" class="swatch-element color solids ${this.getSwatchSlug(swatch.name)} available" originating-product="Fendrick Top - Lights" data-value="${swatch.name}" data-price="$32.00" data-variant="37970412865">
        <input id="swatch-${this.getSwatchSlug(swatch.name)}" type="radio" name="color-input" value="${swatch.name}" data-swatch-tab="${tabHandle}">
        <label for="swatch-${this.getSwatchSlug(swatch.name)}" rel="tipsy" original-title="${swatch.name}">
            <span class="offscreen">${swatch.name}</span>
        </label>
        ${swatch.isOnSale ? '<span class="swatch__sale-icon" aria-label="Sale Icon">Sale</span>' : ""}
      </li>
      `));
        if (index === 0 && !this.selectedVariant) {
          $(`#swatch-${this.getSwatchSlug(swatch.name)}`).prop("checked", true);
          this.checkSwatches();
        } else if (this.selectedVariant && this.selectedVariant.swatch === swatch.name) {
          $(`#swatch-${this.getSwatchSlug(swatch.name)}`).prop("checked", true);
          this.checkSwatches();
          this.updateCarousel();
          this.showTeammatesFlag();
        }
      });
      const $swatches = $("li.swatch-element.color");
      this.applySwatches($swatches, "label");
    }
    initTipsyForSwatches() {
      if ($("[rel=tipsy]").tipsy) {
        $("[rel=tipsy]").tipsy({ gravity: "s" });
      }
    }
    applySwatches(swatches, applyToSelector) {
      console.log("applySwatches called with:", {
        swatchCount: swatches.length,
        selector: applyToSelector
      });
      swatches.each(function(index, swatch) {
        const swatchColorAttribute = swatch.dataset.value;
        console.log("Processing swatch:", swatchColorAttribute);
        if (window.hybridSwatches && window.hybridSwatches[swatchColorAttribute]) {
          const hybridDef = window.hybridSwatches[swatchColorAttribute];
          const colorHex = window.colors[hybridDef.colorName];
          const imageUrl = hybridDef.imageName;
          console.log("Found hybrid swatch:", {
            swatchValue: swatchColorAttribute,
            color: hybridDef.colorName,
            hex: colorHex,
            imageUrl
          });
          if (colorHex && imageUrl) {
            const $label = $(swatch).find(applyToSelector);
            const background = `linear-gradient(135deg, rgba(0,0,0,0) 50%, ${colorHex} 50%), url("${imageUrl}")`;
            const style = `background: ${background} !important; background-size: cover !important;`;
            console.log("Applying hybrid style:", style);
            $label.attr("style", style);
            $(swatch).attr("data-hybrid-applied", "true");
          }
        } else {
          const swatchColors = swatchColorAttribute.split(" & ");
          const swatchHexes = swatchColors.map((name) => window.colors[name] || "#fff");
          let bg;
          if (swatchHexes.length === 1) {
            bg = swatchHexes[0];
          } else if (swatchHexes.length === 2) {
            bg = `linear-gradient(135deg, ${swatchHexes[0]} 50%, ${swatchHexes[1]} 50%)`;
          } else if (swatchHexes.length === 3) {
            bg = `linear-gradient(135deg, ${swatchHexes[0]} 40%, ${swatchHexes[1]} 40%, ${swatchHexes[1]} 60%, ${swatchHexes[2]} 60%)`;
          }
          const $label = $(swatch).find(applyToSelector);
          $label.attr("style", `background: ${bg};`);
        }
      });
      var $selectedSizeInput = $("input[name='size-input']:checked");
      var selectedSize = $selectedSizeInput.val();
      this.setUnavailableColorsWithSize(selectedSize);
      this.checkSeeAll();
    }
    checkSwatches() {
      var _a, _b, _c;
      var $selectedSwatchInput = $("input[name='color-input']:checked");
      var selectedSwatchColor = $selectedSwatchInput.val();
      var selectedSwatchTab = $selectedSwatchInput.data("swatch-tab");
      var $selectedSizeInput = $("input[name='size-input']:checked");
      var selectedSize = $selectedSizeInput.val();
      var tab = this.tabs[selectedSwatchTab];
      this.selectedSize = selectedSize;
      var previousSwatchName = this.selectedVariant ? this.selectedVariant.swatch : null;
      this.selectedVariant = null;
      var $addToCartBtn = $(".add-to-cart.add-to-cart-button");
      if (selectedSize && selectedSwatchColor) {
        this.selectedVariant = this.variants[`${selectedSwatchColor}-${selectedSize}`];
        var unavailable = false;
        var swatchVariants;
        if (!this.selectedVariant) {
          unavailable = true;
          swatchVariants = this.getSwatchVariants(selectedSwatchTab, selectedSwatchColor);
          swatchVariants.forEach((sw) => {
            if (sw && !this.selectedVariant) {
              this.selectedVariant = sw;
            }
          });
        }
        swatchVariants = this.getSwatchVariants(selectedSwatchTab, this.selectedVariant.swatch);
        $addToCartBtn.attr("variant-id", this.selectedVariant.id);
        this.$submitBtn.prop("disabled", false);
        this.$submitBtn.attr("value", "Add to Cart");
        $(".notify-restock-container").hide();
        $("#size-container li").addClass("soldout");
        swatchVariants.forEach((swatch) => {
          if (!swatch) {
            return;
          }
          if (swatch.available) {
            $(`#size-container-${this.getSwatchSlug(swatch.size)}`).removeClass("soldout");
            if (this.firstInStockVariant == null && this.firstInStockVariant != "no-variant") {
              $(`#swatch-${this.getSwatchSlug(swatch.size)}`).trigger("click");
              this.firstInStockVariant = `#swatch-${this.getSwatchSlug(swatch.size)}`;
            }
          } else {
            $(`#size-container-${this.getSwatchSlug(swatch.size)}`).addClass("soldout");
            if (selectedSize === swatch.size) {
              this.$submitBtn.hide();
              $("#add-to-cart-sticky-header-button").hide();
              $(".notify-button").show();
              $(".notify-button-wrapper").show();
              $(".notify-restock-container").show();
            }
          }
        });
        if (unavailable) {
          setTimeout(() => {
            this.$submitBtn.hide();
            $(".notify-button").show();
            $(".notify-button-wrapper").show();
          }, 0);
        } else if (this.selectedVariant.available) {
          this.$submitBtn.show();
          $("#add-to-cart-sticky-header-button").css("display", "inline-block");
          $(".notify-button").hide();
          $(".notify-button-wrapper").hide();
        }
        const currencySelector = document.getElementById("CurrencySelectorMobile");
        const currencySelectorValue = currencySelector == null ? void 0 : currencySelector.value;
        const currencySymbol = window.currencySymbol || (currencySelectorValue === "GBP" ? "\xA3" : "$");
        const formatPrice = (price) => {
          if (currencySelectorValue === "CAD") {
            return `${currencySymbol}${price} CAD`;
          } else if (currencySelectorValue === "AUD") {
            return `${currencySymbol}${price} AUD`;
          } else {
            return `${currencySymbol}${price}`;
          }
        };
        this.updatePriceBlock(
          formatPrice(this.selectedVariant.price),
          formatPrice(this.selectedVariant.oldPrice)
        );
        this.atcPrice = formatPrice(this.selectedVariant.price).replace(/\.00(\s|$)/, "$1");
        this.updateAtcButton();
        if (previousSwatchName !== this.selectedVariant.swatch) {
          this.updateCarousel();
          this.showTeammatesFlag();
        }
        $(".product-details.panel > .inner-panel").html(this.selectedVariant.product.body_html);
        var pageUrl = `?variant=${this.selectedVariant.id}`;
        if (this.updateUrlAllowed) {
          window.history.replaceState("", "", pageUrl);
        }
      }
      $("#swatch-indicator").text(selectedSwatchColor);
      $("#size-indicator").text(selectedSize);
      const colorCollectionLink = document.getElementById("color-collection-link");
      if (colorCollectionLink) {
        colorCollectionLink.innerHTML = "";
        const colorSlug = selectedSwatchColor == null ? void 0 : selectedSwatchColor.replaceAll(" ", "-").toLowerCase();
        if (typeof colorCollections[colorSlug] === "object") {
          const selectedProductId = (_b = (_a = this.selectedVariant) == null ? void 0 : _a.product) == null ? void 0 : _b.id;
          this.getProductFabricType(selectedProductId).then((fabricType) => {
            const collection = colorCollections[colorSlug][fabricType];
            if (collection == null ? void 0 : collection.url) {
              colorCollectionLink.innerHTML = `(<a href="${collection.url}">Shop All</a>)`;
            }
          }).catch((error) => {
            console.error("Error setting black collection link by fabric type:", error);
          });
        } else if (typeof colorCollections[colorSlug] === "string") {
          colorCollectionLink.innerHTML = `(<a href="${colorCollections[colorSlug]}">Shop All</a>)`;
        }
      }
      $("#size-indicator").text(selectedSize);
      this.setUnavailableColorsWithSize(selectedSize);
      this.injectSearchspringWidgets((_c = this.selectedVariant) == null ? void 0 : _c.sku);
      this.checkModelSizeFit();
      this.checkSizes();
    }
    injectSearchspringWidgets(sku) {
      const container3 = document.getElementById("searchspring-widgets-container");
      if (container3) {
        container3.replaceChildren();
        const profiles = ["similar", "cross-sell"];
        profiles.forEach((profile) => {
          const script = document.createElement("script");
          script.type = "searchspring/personalized-recommendations";
          script.setAttribute("profile", profile);
          script.textContent = `seed = "${sku}";`;
          document.getElementById("searchspring-widgets-container").appendChild(script);
        });
      }
    }
    getSwatchVariants(tabName, swatchName) {
      var sizes = this.tabs[tabName].sizes;
      var variants = [];
      Object.values(sizes).forEach((size) => {
        variants.push(
          this.variants[`${swatchName}-${size.name}`]
        );
      });
      return variants;
    }
    getProductFabricType(productId) {
      return __async(this, null, function* () {
        var _a, _b, _c;
        if (!productId) {
          return null;
        }
        const storefrontAccessToken = "d9957d4f65657f2b7e9954866327c71f";
        const query = `{
      product(id: "gid://shopify/Product/${productId}") {
        metafield(namespace: "product_attribute", key: "fabric_name_branded") {
          value
        }
      }
    }`;
        const response = yield fetch("https://jolyn-clothing-company-usa.myshopify.com/api/2024-01/graphql.json", {
          method: "POST",
          headers: {
            "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ query })
        });
        const data = yield response.json();
        return (_c = (_b = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.product) == null ? void 0 : _b.metafield) == null ? void 0 : _c.value;
      });
    }
    setUnavailableColorsWithSize(selectedSize) {
      var variants = this.variants;
      var availableArray = {};
      Object.entries(variants).forEach(function(item) {
        var key = item[0];
        var value = item[1];
        var variantColor = key.split("-")[0];
        var variantSize = key.split("-")[1];
        if (variantSize == selectedSize) {
          availableArray[variantColor] = value.available || isPreorder(value.product);
        }
      });
      $("#swatch-container li").each(function(index, item) {
        var itemColor = $(item).data("value");
        if (itemColor in availableArray) {
          if (availableArray[itemColor]) {
            $(this).css("opacity", "1");
            $(this).removeClass("currently-unavailable");
          } else {
            $(this).css("opacity", "0.4");
            $(this).addClass("currently-unavailable");
          }
        } else {
          $(this).css("opacity", "1");
          $(this).removeClass("currently-unavailable");
        }
      });
    }
    makeSizes(sizes) {
      var $container = $("#size-container");
      $container.empty();
      var letterVariants = sizes.filter((size) => /[a-zA-Z]/gi.test(size.name));
      letterVariants.concat(sizes.filter((size) => !/[a-zA-Z]/gi.test(size.name))).forEach((size, index) => {
        let handle = this.getSwatchSlug(size.name);
        let $size = $(`
          <li id="size-container-${handle}" class="swatch-element size ${size.name} available" data-value="${size.name}">
              <input id="swatch-${handle}" type="radio" name="size-input" value="${size.name}">
              <label for="swatch-${handle}">
                  ${size.name}
                  <span class="crossed-out" title="Not available in this option"></span>
              </label>
          </li>
          `);
        $container.append($size);
        if (this.selectedVariant && this.selectedVariant.size === size.name) {
          $(`#swatch-${handle}`).prop("checked", true);
        } else if (this.selectedSize === size.name || index === 0 && !this.selectedSize) {
          $(`#swatch-${handle}`).prop("checked", true);
        }
      });
    }
    getProductData(callback) {
      $.ajax({
        method: "GET",
        url: "/collections/" + this.collectionHandle + "/products.json?limit=250"
      }).then(function(res) {
        return __async(this, null, function* () {
          var data = {};
          var variants = {};
          var swatches = [];
          res.products.forEach((product) => {
            product.variants.forEach((v) => {
              v.options = [];
              if (v.option1) {
                v.options.push(v.option1);
              }
              if (v.option2) {
                v.options.push(v.option2);
              }
              if (v.option3) {
                v.options.push(v.option3);
              }
              v.public_title = `${v.option1}  / ${v.option2}`;
              v.name = `${product.title} - ${v.public_title}`;
              v.inventory_quantity = 0;
              v.inventory_management = "shopify";
              v.inventory_policy = "deny";
            });
            var productJson = JSON.stringify(product);
            const handle = product.handle;
            let type = "solids";
            if (handle.indexOf("-prints") > -1 || handle.indexOf("-patterns") > -1) {
              type = "prints";
            } else if (handle.indexOf("-contrasts") > -1) {
              type = "contrasts";
            }
            if (!data[type]) {
              data[type] = {
                handle: type,
                // Uppercase the first letter:
                name: type.charAt(0).toUpperCase() + type.substring(1),
                swatches: {},
                sizes: {}
              };
            }
            var sizeOptionKey = "option1";
            var swatchOptionKey = "option2";
            product.options.forEach((opt) => {
              if (opt.name === "Color") {
                swatchOptionKey = `option${opt.position}`;
                opt.values.forEach((val) => {
                  if (!data[type].swatches[val]) {
                    data[type].swatches[val] = {
                      name: val,
                      available: false,
                      images: []
                    };
                  }
                });
              } else if (opt.name === "Size") {
                sizeOptionKey = `option${opt.position}`;
                opt.values.forEach((val) => {
                  if (!data[type].sizes[val]) {
                    data[type].sizes[val] = {
                      name: val
                    };
                  }
                });
              }
            });
            product.variants.forEach((variant) => {
              var _a, _b;
              const swatch = variant[swatchOptionKey];
              const size = variant[sizeOptionKey];
              variant.size = size;
              variant.swatch = swatch;
              variant.tab = type;
              variant.oldPrice = variant.compare_at_price;
              variant.product = product;
              variant.productJson = productJson;
              variant.isOnSale = variant.compare_at_price && variant.compare_at_price !== variant.price ? true : false;
              variants[`${swatch}-${size}`] = variant;
              if ((variant.available || isPreorder(variant.product)) && data[type].swatches[swatch]) {
                data[type].swatches[swatch].available = true;
              }
              if (variant.isOnSale && data[type].swatches[swatch]) {
                data[type].swatches[swatch].isOnSale = true;
              }
              if (((_b = (_a = variant == null ? void 0 : variant.product) == null ? void 0 : _a.images) == null ? void 0 : _b.length) > 0) {
                variant.product.images.forEach((image) => {
                  const filename2 = image.src;
                  const thumb = filename2.substring(0, filename2.lastIndexOf(".")) + "_160x" + filename2.substring(filename2.lastIndexOf("."));
                  const large = filename2.substring(0, filename2.lastIndexOf(".")) + "_1120x" + filename2.substring(filename2.lastIndexOf("."));
                  image.thumb = thumb;
                  image.large = large;
                  if (!data[type].swatches[swatch].images.some((image2) => image2.thumb === thumb || image2.large === large)) {
                    data[type].swatches[swatch].images.push(image);
                  }
                });
              }
              if (variant.featured_image && variant.featured_image.src && data[type].swatches[swatch]) {
                if (data[type].swatches[swatch].images.filter((img) => img.src === variant.featured_image.src).length === 0) {
                  var filename = variant.featured_image.src;
                  variant.featured_image.thumb = filename.substring(0, filename.lastIndexOf(".")) + "_160x" + filename.substring(filename.lastIndexOf("."));
                  variant.featured_image.large = filename.substring(0, filename.lastIndexOf(".")) + "_1120x" + filename.substring(filename.lastIndexOf("."));
                  data[type].swatches[swatch].images.push(variant.featured_image);
                }
              }
            });
          });
          Object.keys(data).forEach((entry) => {
            data[entry].available = false;
            Object.values(data[entry].swatches).forEach((sw) => {
              if (sw.available) {
                data[entry].available = true;
              }
            });
            if (!data[entry].available) {
              Object.values(data[entry].sizes).forEach((size) => {
                Object.keys(data[entry].swatches).forEach((sw) => {
                  if (variants[`${data[entry].swatches[sw].name}-${size.name}`]) {
                    delete variants[`${data[entry].swatches[sw].name}-${size.name}`];
                  }
                });
              });
              delete data[entry];
            }
          });
          try {
            const productHandles = res.products.map((p) => p.handle);
            const fullProducts = yield Promise.all(
              productHandles.map(
                (handle) => fetch(`/products/${handle}.json`).then((r2) => r2.json()).then((d) => d.product).catch(() => null)
              )
            );
            const altMap = {};
            fullProducts.forEach((product) => {
              if (product == null ? void 0 : product.images) {
                product.images.forEach((img) => {
                  if (img.id && img.alt) {
                    altMap[img.id] = img.alt;
                  }
                });
              }
            });
            Object.values(variants).forEach((variant) => {
              var _a;
              if ((_a = variant.product) == null ? void 0 : _a.images) {
                variant.product.images.forEach((img) => {
                  if (img.id && altMap[img.id]) {
                    img.alt = altMap[img.id];
                  }
                });
              }
            });
          } catch (err) {
            console.error("Error fetching product alt text:", err);
          }
          callback({
            tabs: data,
            variants
          });
        });
      });
    }
    getExclusions() {
      const fetchExclusions = (page = 1, allProducts = []) => {
        return fetch(`/collections/sitewide-promotion-exclusions/products.json?limit=250&page=${page}`).then((res) => res.json()).then((data) => {
          allProducts = allProducts.concat(data.products);
          if (data.products.length === 250) {
            return fetchExclusions(page + 1, allProducts);
          }
          this.exclusions = allProducts;
          return allProducts;
        });
      };
      return fetchExclusions();
    }
    getEcommerceExclusives() {
      const fetchExclusives = (page = 1, allProducts = []) => {
        return fetch(`/collections/ecommerce-exclusive/products.json?limit=250&page=${page}`).then((res) => res.json()).then((data) => {
          allProducts = allProducts.concat(data.products);
          if (data.products.length === 250) {
            return fetchExclusives(page + 1, allProducts);
          }
          this.ecommerceExclusives = allProducts;
          return allProducts;
        });
      };
      return fetchExclusives();
    }
    markExclusion() {
      const excluded = this.exclusions.some((product) => product.id === this.selectedVariant.product.id);
      if (excluded) {
        document.getElementById("promotion-exclusions-container").innerHTML = `<p style="color: red; font-size: .8rem; margin: 1rem 0 -.5rem 0;">Excluded from promotion</p>`;
      }
    }
    markEcommerceExclusive() {
      console.log("ecommerce exclusives", this.ecommerceExclusives, this.selectedVariant.product.id);
      const isExclusive = this.ecommerceExclusives.some((product) => product.id === this.selectedVariant.product.id);
      if (isExclusive) {
        document.getElementById("ecommerce-exclusive-container").innerHTML = `<p style="color: #00825E; font-size: .8rem; margin: 1rem 0 -.5rem 0;">Online exclusive</p>`;
      }
    }
    checkExclusions() {
      try {
        document.getElementById("promotion-exclusions-container").innerHTML = "";
        if (!this.exclusions) {
          this.getExclusions().then(() => {
            this.markExclusion();
          });
        } else {
          this.markExclusion();
        }
      } catch (e) {
        console.error(`Error checking exclusions: ${e}`);
      }
    }
    checkEcommerceExclusives() {
      try {
        document.getElementById("ecommerce-exclusive-container").innerHTML = "";
        if (!this.ecommerceExclusives) {
          this.getEcommerceExclusives().then(() => {
            this.markEcommerceExclusive();
          });
        } else {
          this.markEcommerceExclusive();
        }
      } catch (e) {
        console.error(`Error checking ecommerce exclusives: ${e}`);
      }
    }
    checkDelayedShipping() {
      try {
        document.getElementById("delayed-shipping-container").innerHTML = "";
        const tags = this.selectedVariant.product.tags;
        if (tags.includes("0425-delayed-shipping")) {
          document.getElementById("delayed-shipping-container").innerHTML = `<p style="color: red; font-size: .8rem; margin: 1rem 0 -.5rem 0;">Expected to ship by April 25th</p>`;
        }
      } catch (e) {
        console.error(`Error checking delayed shipping: ${e}`);
      }
    }
    checkBadges() {
      var _a, _b;
      try {
        const badgeContainer = document.getElementById("product-badge-container");
        badgeContainer.innerHTML = "";
        const tags = (_b = (_a = this == null ? void 0 : this.selectedVariant) == null ? void 0 : _a.product) == null ? void 0 : _b.tags;
        const badge = badges[tags == null ? void 0 : tags.find((tag) => badges[tag])];
        if (badge) {
          badgeContainer.innerHTML = `
        <div class="product-badge" style="color: ${badge.color || "inherit"}">
          ${badge.icon ? `<div class="product-badge-icon">${badge.icon}</div>` : ""}
          <div class="product-badge-label">${badge.label}</div>
        </div>
      `;
        }
      } catch (e) {
        console.error(`Error checking badges: ${e}`);
      }
    }
    checkSizes() {
      try {
        const selectedSwatchColor = $("input[name='color-input']:checked").val();
        if (!selectedSwatchColor) {
          return;
        }
        const sizeItems = document.getElementById("size-container").querySelectorAll("li");
        sizeItems.forEach((item) => {
          const variantExists = this.variants[`${selectedSwatchColor}-${item.dataset.value}`];
          item.style.display = variantExists ? "inline-block" : "none";
        });
      } catch (e) {
        console.error(`Error checking sizes: ${e}`);
      }
    }
    checkSeeAll() {
      try {
        const seeMoreButton = document.querySelector(".color-swatch__see-more");
        const activeSolidTab = document.querySelector('[color-tab-opener="solids"].active');
        if (seeMoreButton) {
          seeMoreButton.style.display = activeSolidTab ? "none" : "block";
        }
      } catch (e) {
        console.error(`Error checking see all: ${e}`);
      }
    }
    adjustForPreorder() {
      $(".add-to-cart-button").show();
      $(".preorder-product").remove();
      if (!this.selectedVariant.available) {
        if (isPreorder(this.selectedVariant.product)) {
          $("<div class='preorder-product out-of-stock promo_message_container'>This product is coming soon!</div>").insertBefore(document.querySelector(".variants-container"));
        }
        $(".add-to-cart-button").hide();
      }
    }
    setFabricContent() {
      try {
        setTimeout(() => {
          var _a, _b;
          const fabricContainer = document.querySelector(".fabric-info");
          const imageContainers = fabricContainer.querySelectorAll(".fabric-image-container");
          const contentContainers = fabricContainer.querySelectorAll(".fabric-content-container");
          for (const imageContainer of imageContainers) {
            imageContainer.style.display = "none";
          }
          for (const contentContainer of contentContainers) {
            contentContainer.style.display = "none";
          }
          fabricContainer.style.display = "none";
          const tags = (_b = (_a = this == null ? void 0 : this.selectedVariant) == null ? void 0 : _a.product) == null ? void 0 : _b.tags;
          if (tags) {
            for (const tag of tags) {
              const els = fabricContainer.getElementsByClassName(tag);
              if (els.length > 0) {
                fabricContainer.style.display = "grid";
                for (const el of els) {
                  el.style.display = "block";
                }
                break;
              }
            }
          }
        }, 0);
      } catch (e) {
        console.error(`Error setting fabric content: ${e}`);
      }
    }
    addListeners() {
      $(".product_form").on("keyup change paste", "input", () => {
        this.updateUrlAllowed = true;
        this.checkSwatches();
      });
      $(".qty .plus").click(function() {
        var qty = parseInt($(".qty-num").val());
        var newQty = qty + 1;
        $(".qty-num").val(newQty);
      });
      $(".notify-button").click((e) => {
        if (!this.selectedVariant) {
          return;
        }
        window._BISConfig = window._BISConfig || {};
        var data = JSON.parse(this.selectedVariant.productJson);
        window._BISConfig.product = data;
        window.BIS.init();
        setTimeout(() => {
          window.BISPopover.show({ variantId: this.selectedVariant.id });
        }, 10);
      });
      $(".qty .minus").click(function() {
        var qty = parseInt($(".qty-num").val());
        qty--;
        if (qty < 1) {
          $(".qty-num").val(1);
        } else {
          $(".qty-num").val(qty);
        }
      });
      $(".product_form").on("submit", (e) => {
        e.preventDefault();
        if (this.selectedVariant && this.selectedVariant.id) {
          var quantity = $("input[name='quantity']").val();
          this.ajaxPost(this.selectedVariant.id, quantity);
          $("input[name='quantity']").val(1);
        }
      });
      $(document).on("click", ".product__image__thumbs a", (event2) => {
        event2.preventDefault();
        var videoLoaded = $("video").length;
        if (videoLoaded) {
          $("video").each(function() {
            this.pause();
          });
        }
        if (this.currentCarousel) {
          this.currentCarousel.slideToLoop($(event2.currentTarget).index());
        }
      });
      $(this.container).find(".product_form").attr("action", "/cart/add");
      $(window).resize(
        $.debounce(50, () => {
          this.resize();
        })
      );
      $(document).on(
        "click",
        "#desktop-carousel .swiper-wrapper img, #mobile-carousel .swiper-wrapper img",
        (event2) => {
          event2.preventDefault();
          const $target = $(event2.currentTarget);
          const zoomSrc = $target.attr("data-zoom-src") || $target.attr("src");
          const zoomIndex = Number($target.attr("data-zoom-index"));
          this.activateZoomImage(
            zoomSrc,
            Number.isNaN(zoomIndex) ? null : zoomIndex
          );
        }
      );
      var acc = document.getElementsByClassName("accordion");
      var i;
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }
      var regex = new RegExp("[\\?&]variant=([^&#]*)");
      var results = regex.exec(location.search);
      if (results !== null) {
        var currentVariantId = decodeURIComponent(results[1].replace(/\+/g, " "));
        var variantIdInput = $(".variant_id");
        if (variantIdInput.length) {
          variantIdInput.val(currentVariantId);
        }
        var fabricBadgeClass = ".surf-features_fabric--" + currentVariantId;
        $(".surf-features_fabric").hide();
        $(fabricBadgeClass).show();
        var inventory_item = $(".inventory-container").find("[data-id='" + currentVariantId + "']");
        var inventoryDiv = $(inventory_item[0]).clone();
        $(".inventory-alternate").html(inventoryDiv);
        $(".promo_message_container").hide();
        $(".promo_message_container .promo_message_1").hide();
        $(".promo_message_container .promo_message_2").hide();
        $(".promo_message_container .promo_message_3").hide();
        if (window.promoMessageArray[0].includes(currentVariantId)) {
          $(".promo_message_container .promo_message_1").show();
          $(".promo_message_container").show();
          console.log("YES");
        }
        if (window.promoMessageArray[1].includes(currentVariantId)) {
          $(".promo_message_container .promo_message_2").show();
          $(".promo_message_container").show();
        }
        if (window.promoMessageArray[2].includes(currentVariantId)) {
          $(".promo_message_container .promo_message_3").show();
          $(".promo_message_container").show();
        }
        var isFinalSale = $(".final-sale-badge-data-wrapper").find("[data-id='" + currentVariantId + "']");
        isFinalSale = isFinalSale.data("final-sale") == true;
        if (isFinalSale) {
          $(".product-final-sale").show();
        } else {
          $(".product-final-sale").hide();
        }
      }
      $("body").on("change", ".swatch-element", () => {
        var regex2 = new RegExp("[\\?&]variant=([^&#]*)");
        var results2 = regex2.exec(location.search);
        if (results2 !== null) {
          var currentVariantId2 = decodeURIComponent(results2[1].replace(/\+/g, " "));
          var variantIdInput2 = $(".variant_id");
          if (variantIdInput2.length) {
            variantIdInput2.val(currentVariantId2);
          }
          var fabricBadgeClass2 = ".surf-features_fabric--" + currentVariantId2;
          $(".surf-features_fabric").hide();
          $(fabricBadgeClass2).show();
          var inventory_item2 = $(".inventory-container").find("[data-id='" + currentVariantId2 + "']");
          var inventoryDiv2 = $(inventory_item2[0]).clone();
          $(".inventory-alternate").html(inventoryDiv2);
          $(".promo_message_container").hide();
          $(".promo_message_container .promo_message_1").hide();
          $(".promo_message_container .promo_message_2").hide();
          $(".promo_message_container .promo_message_3").hide();
          if (window.promoMessageArray[0].includes(currentVariantId2)) {
            $(".promo_message_container .promo_message_1").show();
            $(".promo_message_container").show();
            console.log("YES");
          }
          if (window.promoMessageArray[1].includes(currentVariantId2)) {
            $(".promo_message_container .promo_message_2").show();
            $(".promo_message_container").show();
          }
          if (window.promoMessageArray[2].includes(currentVariantId2)) {
            $(".promo_message_container .promo_message_3").show();
            $(".promo_message_container").show();
          }
          var isFinalSale2 = $(".final-sale-badge-data-wrapper").find("[data-id='" + currentVariantId2 + "']");
          isFinalSale2 = isFinalSale2.data("final-sale") == true;
          if (isFinalSale2) {
            $(".product-final-sale").show();
          } else {
            $(".product-final-sale").hide();
          }
        }
        this.updateWair();
        this.checkModelSizeFit();
        this.adjustForPreorder();
        this.checkExclusions();
        this.checkEcommerceExclusives();
        this.checkDelayedShipping();
        this.setFabricContent();
        this.checkBadges();
        this.checkSizes();
        var $selectedSwatchInput = $("input[name='color-input']:checked");
        var $selectedSwatchInputColor = $selectedSwatchInput.val();
        $(".product-print-collection__wrapper").hide();
        $(".product-print-collection-body").owlCarousel("destroy");
        $(".product-print-collection-body").empty();
        if (window.print_products) {
          var print_product_limit = 4;
          var iterator = 1;
          window.print_products.every(function(print_product) {
            if (iterator > print_product_limit) {
              return false;
            }
            var print_product_slug = print_product.slug;
            print_product.variants.every(function(variant) {
              if (variant.option1 == $selectedSwatchInputColor && variant.id != currentVariantId2) {
                iterator++;
                var productLink = "/products/" + print_product_slug + "?variant=" + variant.id;
                $(".product-print-collection-body").append(`
              <div class="product-print-collection_item">
                <a href="${productLink}">
                  <div class="product-print-collection_item_image" style="background-image: url(${Shopify.resizeImage(variant.featured_image_src, "x200")})"></div>

                  <div class="product-print-collection_item_content">
                    <div class="product-print-collection_item_title">
                      ${print_product.title}
                    </div>

                    <div class="product-print-collection_item_price">
                      ${Shopify.formatMoney(variant.price)}
                    </div>
                  </div>
                </a>
              </div>
            `);
                $(".product-print-collection__wrapper").show();
                return false;
              }
              return true;
            });
            return true;
          });
          var owlConfig = {
            items: 4,
            autoWidth: false,
            lazyLoad: true,
            loop: true,
            margin: 30,
            nav: true,
            dots: false,
            responsive: {
              0: {
                items: 1
              },
              375: {
                items: 2,
                margin: 60
              },
              767: {
                items: 3
              },
              992: {
                items: 4
              }
            }
          };
          $(".product-print-collection-body").owlCarousel(owlConfig);
        }
      });
    }
    checkModelSizeFit() {
      var _a, _b;
      const header = document.querySelector("#model-size-fit-header");
      const content = document.querySelector("#model-size-fit-content");
      if (!header || !content) return;
      content.innerHTML = "";
      header.style.display = "none";
      content.style.display = "none";
      const productId = (_b = (_a = this.selectedVariant) == null ? void 0 : _a.product) == null ? void 0 : _b.id;
      if (!productId) return;
      const storefrontAccessToken = "d9957d4f65657f2b7e9954866327c71f";
      const query = `{
      product(id: "gid://shopify/Product/${productId}") {
        metafield(namespace: "global", key: "model_info") {
          key
          value
        }
      }
    }`;
      fetch(`https://jolyn-clothing-company-usa.myshopify.com/api/2024-01/graphql.json`, {
        method: "POST",
        headers: {
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ query })
      }).then((response) => response.json()).then((data) => {
        var _a2, _b2, _c;
        const modelInfo = (_c = (_b2 = (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.product) == null ? void 0 : _b2.metafield) == null ? void 0 : _c.value;
        if (modelInfo) {
          content.innerHTML = modelInfo.replace(/\n/g, "<br>");
          header.style.display = "block";
          $(".accordion.collapsible-product-details").accordion("refresh");
        }
      }).catch((error) => {
        console.error("Error checking model size fit:", error);
      });
    }
    updateWair() {
      var _a, _b, _c, _d, _e;
      try {
        const v = this.selectedVariant;
        if (!v || !window.updateWairProduct) return;
        const imgSrc = ((_a = v.featured_image) == null ? void 0 : _a.src) || ((_b = v.product) == null ? void 0 : _b.featured_image) || ((_e = (_d = (_c = v.product) == null ? void 0 : _c.images) == null ? void 0 : _d[0]) == null ? void 0 : _e.src);
        window.updateWairProduct({
          key: v.product.handle,
          // child product handle
          name: v.product.title || v.name,
          image: imgSrc ? Shopify.resizeImage(imgSrc, "x600") : void 0
        });
      } catch (err) {
        console.error("Error updating Wair:", err);
      }
    }
    resize() {
      const $carousel = $(".product__image");
      var vpWidth = $(window).width();
      if (vpWidth > 767) {
        $carousel.appendTo($("#desktop-carousel .carousel-container"));
      } else {
        $carousel.appendTo($("#mobile-carousel .carousel-container"));
      }
      this.updateAtcButton();
    }
    // The price sits in the add-to-cart button on mobile only (the price block is
    // visually separated from the button there). On desktop the button is just the
    // label. Called on variant change and on resize (to react to crossing 768px).
    updateAtcButton() {
      if (!this.$submitBtn || !this.$submitBtn.length) return;
      var atcLabel = this.$submitBtn.data("atc-label") || "Add to cart";
      if (this.atcPrice && window.matchMedia("(max-width: 767px)").matches) {
        this.$submitBtn.val(atcLabel + " \u2022 " + this.atcPrice);
      } else {
        this.$submitBtn.val(atcLabel);
      }
    }
    initializeFullscreenZoom() {
      if (this.zoomOverlayInitialized) {
        return;
      }
      this.injectFullscreenZoomStyles();
      this.$zoomImage = this.ensureZoomOverlayElement();
      this.$zoomImageViewport = this.$zoomImage.find(".zoom-image__viewport");
      this.$zoomImageMedia = this.$zoomImage.find(".zoom-image__media");
      this.fullscreenZoomState = {
        scale: 1,
        minScale: 1,
        maxScale: 4,
        translateX: 0,
        translateY: 0,
        isDragging: false,
        dragStart: { x: 0, y: 0 },
        dragOrigin: { x: 0, y: 0 },
        pinchDistance: null,
        pinchStartScale: 1,
        assetWidth: null,
        assetHeight: null
      };
      this.$zoomImageMedia.attr("draggable", "false").off(".fullscreenZoom").on("load.fullscreenZoom", () => {
        var _a, _b;
        this.fullscreenZoomState.assetWidth = ((_a = this.$zoomImageMedia[0]) == null ? void 0 : _a.naturalWidth) || this.$zoomImageViewport.innerWidth();
        this.fullscreenZoomState.assetHeight = ((_b = this.$zoomImageMedia[0]) == null ? void 0 : _b.naturalHeight) || this.$zoomImageViewport.innerHeight();
        this.resetFullscreenZoomState();
      }).on("dragstart.fullscreenZoom", (event2) => {
        event2.preventDefault();
      });
      this.bindFullscreenZoomEvents();
      this.zoomOverlayInitialized = true;
    }
    ensureZoomOverlayElement() {
      let $zoomImage = $(".zoom-image");
      if (!$zoomImage.length) {
        $zoomImage = $('<div class="zoom-image"></div>');
      }
      $zoomImage.appendTo("body");
      $zoomImage.addClass("zoom-image--fullscreen").attr({
        role: "dialog",
        "aria-hidden": "true",
        "aria-modal": "true",
        tabindex: "-1"
      });
      if (!$zoomImage.find(".zoom-image__viewport").length) {
        $zoomImage.html(`
      <button type="button" class="zoom-image__close" aria-label="Close zoomed image">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="zoom-image__viewport" role="presentation">
        <img class="zoom-image__media" alt="Zoomed product image" />
      </div>
      <button type="button" class="zoom-image__nav zoom-image__nav--prev" aria-label="Show previous image">
        <span aria-hidden="true">&#10094;</span>
      </button>
      <button type="button" class="zoom-image__nav zoom-image__nav--next" aria-label="Show next image">
        <span aria-hidden="true">&#10095;</span>
      </button>
    `);
      }
      return $zoomImage;
    }
    injectFullscreenZoomStyles() {
      if (document.getElementById("zoom-image-fullscreen-styles")) {
        return;
      }
      const style = document.createElement("style");
      style.id = "zoom-image-fullscreen-styles";
      style.textContent = `
    .zoom-image.zoom-image--fullscreen {
      position: fixed;
      inset: 0;
      width: 100vw;
      height: 100vh;
      background-color: #fff;
      opacity: 0;
      pointer-events: none;
      transition: opacity 200ms ease;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      z-index: 10000;
    }

    .zoom-image.zoom-image--fullscreen.is-visible {
      opacity: 1;
      pointer-events: auto;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__viewport {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      background-color: #fff;
      border-radius: 0;
      cursor: grab;
      touch-action: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__viewport.is-dragging {
      cursor: grabbing;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__media {
      max-width: 100%;
      max-height: 100%;
      transition: transform 80ms ease-out;
      user-select: none;
      pointer-events: none;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__close {
      position: absolute;
      top: 24px;
      right: 24px;
      background: #000;
      border: none;
      color: #fff;
      font-size: 36px;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10001;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: transparent;
      border: none;
      color: #000;
      font-size: 32px;
      width: 48px;
      height: 48px;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10001;
      transition: background 150ms ease;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__nav:hover {
      background: rgba(0, 0, 0, 0.05);
      color: #000;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__nav--prev {
      left: 12px;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__nav--next {
      right: 12px;
    }

    .zoom-image.zoom-image--fullscreen .zoom-image__nav.is-hidden {
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
    }

    body.zoom-image--locked {
      overflow: hidden;
    }
  `;
      document.head.appendChild(style);
    }
    bindFullscreenZoomEvents() {
      const $doc = $(document);
      this.$zoomImage.on("click", ".zoom-image__close", (event2) => {
        event2.preventDefault();
        this.deactivateZoomImage();
      });
      this.$zoomImage.on("click", ".zoom-image__nav--prev", (event2) => {
        event2.preventDefault();
        this.showAdjacentZoomImage(-1);
      });
      this.$zoomImage.on("click", ".zoom-image__nav--next", (event2) => {
        event2.preventDefault();
        this.showAdjacentZoomImage(1);
      });
      this.$zoomImage.on("click", (event2) => {
        if ($(event2.target).is(".zoom-image.zoom-image--fullscreen")) {
          this.deactivateZoomImage();
        }
      });
      this.$zoomImageViewport.on("wheel.fullscreenZoom", (event2) => this.handleZoomWheel(event2)).on("mousedown.fullscreenZoom", (event2) => this.handleZoomPanStart(event2)).on("mousemove.fullscreenZoom", (event2) => this.handleZoomPanMove(event2)).on("touchstart.fullscreenZoom", (event2) => this.handleZoomTouchStart(event2)).on("touchmove.fullscreenZoom", (event2) => this.handleZoomTouchMove(event2)).on(
        "touchend.fullscreenZoom touchcancel.fullscreenZoom",
        (event2) => this.handleZoomTouchEnd(event2)
      );
      $doc.on("mouseup.fullscreenZoom", () => this.handleZoomPanEnd()).on("keydown.fullscreenZoom", (event2) => {
        if (event2.key === "Escape") {
          this.deactivateZoomImage();
        } else if (event2.key === "ArrowLeft") {
          this.showAdjacentZoomImage(-1);
        } else if (event2.key === "ArrowRight") {
          this.showAdjacentZoomImage(1);
        }
      });
    }
    resetFullscreenZoomState() {
      if (!this.fullscreenZoomState) {
        return;
      }
      this.fullscreenZoomState.scale = 1;
      this.fullscreenZoomState.translateX = 0;
      this.fullscreenZoomState.translateY = 0;
      this.fullscreenZoomState.isDragging = false;
      this.fullscreenZoomState.dragStart = { x: 0, y: 0 };
      this.fullscreenZoomState.dragOrigin = { x: 0, y: 0 };
      this.fullscreenZoomState.pinchDistance = null;
      this.fullscreenZoomState.pinchStartScale = 1;
      this.applyZoomTransform();
    }
    resolveZoomIndex(url, providedIndex) {
      const gallery = this.zoomGalleryItems || [];
      if (typeof providedIndex === "number" && !Number.isNaN(providedIndex) && gallery.length) {
        return this.normalizeZoomIndex(providedIndex);
      }
      const foundIndex = gallery.indexOf(url);
      if (foundIndex >= 0) {
        return foundIndex;
      }
      if (gallery.length) {
        return this.normalizeZoomIndex(this.activeZoomIndex);
      }
      return 0;
    }
    showZoomImageAt(index, fallbackUrl) {
      const gallery = this.zoomGalleryItems || [];
      let targetUrl = fallbackUrl || null;
      let resolvedIndex = index;
      if (gallery.length) {
        resolvedIndex = this.normalizeZoomIndex(index);
        targetUrl = gallery[resolvedIndex];
      }
      if (!targetUrl) {
        return;
      }
      if (gallery.length) {
        this.activeZoomIndex = resolvedIndex;
      }
      this.loadZoomImage(targetUrl);
      this.updateZoomNavState();
    }
    showAdjacentZoomImage(step) {
      var _a, _b;
      if (!((_a = this.$zoomImage) == null ? void 0 : _a.hasClass("is-visible")) || (((_b = this.zoomGalleryItems) == null ? void 0 : _b.length) || 0) < 2) {
        return;
      }
      const nextIndex = this.normalizeZoomIndex(this.activeZoomIndex + step);
      this.showZoomImageAt(nextIndex);
    }
    loadZoomImage(url) {
      var _a;
      if (!url) {
        return;
      }
      const imgEl = (_a = this.$zoomImageMedia) == null ? void 0 : _a[0];
      const handleImageReady = () => {
        this.fullscreenZoomState.assetWidth = (imgEl == null ? void 0 : imgEl.naturalWidth) || this.$zoomImageViewport.innerWidth();
        this.fullscreenZoomState.assetHeight = (imgEl == null ? void 0 : imgEl.naturalHeight) || this.$zoomImageViewport.innerHeight();
        this.resetFullscreenZoomState();
      };
      if ((imgEl == null ? void 0 : imgEl.src) === url && imgEl.complete) {
        handleImageReady();
      } else {
        this.$zoomImageMedia.attr("src", url);
        if (imgEl == null ? void 0 : imgEl.complete) {
          handleImageReady();
        }
      }
    }
    updateZoomNavState() {
      var _a, _b;
      const hasMultiple = (((_a = this.zoomGalleryItems) == null ? void 0 : _a.length) || 0) > 1;
      (_b = this.$zoomImage) == null ? void 0 : _b.find(".zoom-image__nav").toggleClass("is-hidden", !hasMultiple);
    }
    normalizeZoomIndex(index) {
      var _a;
      const galleryLength = ((_a = this.zoomGalleryItems) == null ? void 0 : _a.length) || 0;
      if (!galleryLength) {
        return 0;
      }
      return (index % galleryLength + galleryLength) % galleryLength;
    }
    activateZoomImage(url, index) {
      if (!url) {
        if (!this.zoomGalleryItems.length) {
          return;
        }
      }
      this.initializeFullscreenZoom();
      this.$zoomImage.addClass("is-visible").attr("aria-hidden", "false");
      $("body").addClass("zoom-image--locked");
      const resolvedIndex = this.resolveZoomIndex(url, index);
      this.showZoomImageAt(resolvedIndex, url);
      this.$zoomImage.focus();
    }
    deactivateZoomImage() {
      var _a;
      if (!this.$zoomImage) {
        return;
      }
      this.$zoomImage.removeClass("is-visible").attr("aria-hidden", "true");
      $("body").removeClass("zoom-image--locked");
      if (this.fullscreenZoomState) {
        this.fullscreenZoomState.isDragging = false;
        this.fullscreenZoomState.pinchDistance = null;
      }
      (_a = this.$zoomImageViewport) == null ? void 0 : _a.removeClass("is-dragging");
    }
    handleZoomWheel(event2) {
      if (!this.fullscreenZoomState) {
        return;
      }
      event2.preventDefault();
      const direction = event2.originalEvent.deltaY < 0 ? 1 : -1;
      const increment = direction * 0.15;
      this.fullscreenZoomState.scale = this.clampZoomScale(
        this.fullscreenZoomState.scale + increment
      );
      this.applyZoomTransform();
    }
    handleZoomPanStart(event2) {
      if (!this.fullscreenZoomState) {
        return;
      }
      event2.preventDefault();
      this.fullscreenZoomState.isDragging = true;
      this.fullscreenZoomState.dragStart = this.getPointerPosition(event2);
      this.fullscreenZoomState.dragOrigin = {
        x: this.fullscreenZoomState.translateX,
        y: this.fullscreenZoomState.translateY
      };
      this.$zoomImageViewport.addClass("is-dragging");
    }
    handleZoomPanMove(event2) {
      var _a;
      if (!((_a = this.fullscreenZoomState) == null ? void 0 : _a.isDragging)) {
        return;
      }
      event2.preventDefault();
      const pointer = this.getPointerPosition(event2);
      this.fullscreenZoomState.translateX = this.fullscreenZoomState.dragOrigin.x + (pointer.x - this.fullscreenZoomState.dragStart.x);
      this.fullscreenZoomState.translateY = this.fullscreenZoomState.dragOrigin.y + (pointer.y - this.fullscreenZoomState.dragStart.y);
      this.applyZoomTransform();
    }
    handleZoomPanEnd() {
      var _a;
      if (!this.fullscreenZoomState) {
        return;
      }
      this.fullscreenZoomState.isDragging = false;
      (_a = this.$zoomImageViewport) == null ? void 0 : _a.removeClass("is-dragging");
    }
    handleZoomTouchStart(event2) {
      if (!this.fullscreenZoomState) {
        return;
      }
      if (event2.originalEvent.touches.length === 2) {
        event2.preventDefault();
        this.fullscreenZoomState.isDragging = false;
        this.$zoomImageViewport.removeClass("is-dragging");
        this.fullscreenZoomState.pinchDistance = this.getTouchDistance(event2);
        this.fullscreenZoomState.pinchStartScale = this.fullscreenZoomState.scale;
      } else if (event2.originalEvent.touches.length === 1) {
        this.handleZoomPanStart(event2);
      }
    }
    handleZoomTouchMove(event2) {
      if (!this.fullscreenZoomState) {
        return;
      }
      if (event2.originalEvent.touches.length === 2) {
        event2.preventDefault();
        const distance = this.getTouchDistance(event2);
        if (!distance || !this.fullscreenZoomState.pinchDistance) {
          this.fullscreenZoomState.pinchDistance = distance;
          return;
        }
        const scaleFactor = distance / this.fullscreenZoomState.pinchDistance;
        this.fullscreenZoomState.scale = this.clampZoomScale(
          this.fullscreenZoomState.pinchStartScale * scaleFactor
        );
        this.applyZoomTransform();
      } else if (event2.originalEvent.touches.length === 1 && this.fullscreenZoomState.isDragging) {
        this.handleZoomPanMove(event2);
      }
    }
    handleZoomTouchEnd(event2) {
      var _a, _b, _c;
      if (!this.fullscreenZoomState) {
        return;
      }
      const remainingTouches = ((_b = (_a = event2.originalEvent) == null ? void 0 : _a.touches) == null ? void 0 : _b.length) || 0;
      this.fullscreenZoomState.pinchDistance = null;
      if (remainingTouches === 0) {
        this.handleZoomPanEnd();
        return;
      }
      this.fullscreenZoomState.isDragging = false;
      (_c = this.$zoomImageViewport) == null ? void 0 : _c.removeClass("is-dragging");
    }
    getPointerPosition(event2) {
      var _a, _b;
      if ((_b = (_a = event2.originalEvent) == null ? void 0 : _a.touches) == null ? void 0 : _b.length) {
        const touch = event2.originalEvent.touches[0];
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
      return {
        x: event2.clientX,
        y: event2.clientY
      };
    }
    getTouchDistance(event2) {
      const touches = event2.originalEvent.touches;
      if (touches.length < 2) {
        return null;
      }
      const [first, second] = touches;
      const dx = first.clientX - second.clientX;
      const dy = first.clientY - second.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    applyZoomTransform() {
      if (!this.$zoomImageMedia || !this.fullscreenZoomState) {
        return;
      }
      this.constrainZoomTranslation();
      this.$zoomImageMedia.css(
        "transform",
        `translate(${this.fullscreenZoomState.translateX}px, ${this.fullscreenZoomState.translateY}px) scale(${this.fullscreenZoomState.scale})`
      );
    }
    constrainZoomTranslation() {
      if (!this.fullscreenZoomState || !this.$zoomImageMedia) {
        return;
      }
      const viewportWidth = this.$zoomImageViewport.innerWidth();
      const viewportHeight = this.$zoomImageViewport.innerHeight();
      const baseWidth = this.fullscreenZoomState.assetWidth || this.$zoomImageMedia.width();
      const baseHeight = this.fullscreenZoomState.assetHeight || this.$zoomImageMedia.height();
      if (!viewportWidth || !viewportHeight || !baseWidth || !baseHeight) {
        return;
      }
      const widthRatio = Math.min(viewportWidth / baseWidth, 1);
      const heightRatio = Math.min(viewportHeight / baseHeight, 1);
      const ratio = Math.min(widthRatio, heightRatio);
      const displayedWidth = baseWidth * ratio;
      const displayedHeight = baseHeight * ratio;
      const scaledWidth = displayedWidth * this.fullscreenZoomState.scale;
      const scaledHeight = displayedHeight * this.fullscreenZoomState.scale;
      const maxTranslateX = Math.max((scaledWidth - viewportWidth) / 2, 0);
      const maxTranslateY = Math.max((scaledHeight - viewportHeight) / 2, 0);
      this.fullscreenZoomState.translateX = this.clampTranslation(
        this.fullscreenZoomState.translateX,
        maxTranslateX
      );
      this.fullscreenZoomState.translateY = this.clampTranslation(
        this.fullscreenZoomState.translateY,
        maxTranslateY
      );
    }
    clampTranslation(value, max) {
      if (max <= 0) {
        return 0;
      }
      return Math.min(Math.max(value, -max), max);
    }
    clampZoomScale(value) {
      if (!this.fullscreenZoomState) {
        return value;
      }
      return Math.min(
        Math.max(value, this.fullscreenZoomState.minScale),
        this.fullscreenZoomState.maxScale
      );
    }
    buildVariantMap(variantJson) {
      var flatVariants = variantJson.flat(2);
      var variantIds = [
        ...new Set(flatVariants.map((variant) => variant.variantId))
      ];
      return variantMap = variantIds.map((variant) => {
        let values = flatVariants.filter((e) => e.variantId == variant);
        return {
          size: values[0].size,
          color: values[1].color,
          image: values[0].image,
          price: values[0].price,
          available: values[0].available === "true",
          oldPrice: values[0].oldPrice,
          isOnSale: values[0].isOnSale === "true",
          variant
        };
      });
    }
    addSwatchesToContainer(colorTabIdList) {
      colorTabIdList.forEach(function(id) {
        $(`[swatch-color-tab="${id}"]`).detach().appendTo(`[color-tab-id="${id}"]`);
      });
      $(".swatch-element.size").detach().appendTo(".size-list");
    }
    setImgThumbs(imgObjs, color) {
      $(".img-slide.all_thumb").hide();
      if (color) {
        color = this.getSwatchSlug(color);
        $(`.img-slide.all_thumb.${color}`).css("display", "block");
      }
    }
    listCategories() {
      var categories = [];
      $(".color-swatch__tab-opener").each(function(i, item) {
        categories.push(
          $(item).text().replace(/ /g, "").replace(/(?:\r\n|\r|\n)/g, "")
        );
      });
      var phrase = categories.reduce(function(prev, curr, i) {
        return prev + curr + (i === categories.length - 2 ? " or " : ", ");
      }, "").slice(0, -2);
      $(".color-swatch__tab-header").text("Select: " + phrase);
    }
    showTeammatesFlag() {
      if (!this.selectedVariant) {
        return;
      }
      var product_tags = this.selectedVariant.product.tags;
      if ($.inArray("teammates-collection", product_tags) != -1) {
        $("#teammates-badge").css("display", "inline-flex");
      } else {
        $("#teammates-badge").css("display", "none");
      }
    }
    updateCarousel(swatch) {
      if (!this.selectedVariant) {
        return;
      }
      var swatch = this.tabs[this.selectedVariant.tab].swatches[this.selectedVariant.swatch];
      var swatchImages = swatch.images;
      this.zoomGalleryItems = swatchImages.map((image) => image.large);
      this.activeZoomIndex = 0;
      if (this.currentCarousel && this.currentCarousel.destroy) {
        this.currentCarousel.destroy(true, true);
      }
      $(".product__image__photos").attr(
        "style",
        `width: ${$(".product__image__photos").width()}px`
      );
      $(".product__image__thumbs").empty();
      $(".product__image__photos").empty();
      $(".product__image__photos").append(
        $('<div class="swiper-wrapper"></div>')
      );
      $(".product-button-prev").hide();
      $(".product-button-next").hide();
      swatchImages.forEach((img, index) => {
        var _a, _b, _c;
        const modelSize = (_c = (_b = (_a = img == null ? void 0 : img.alt) == null ? void 0 : _a.split("||")) == null ? void 0 : _b[1]) == null ? void 0 : _c.trim();
        if (swatchImages.length > 1) {
          $(".product__image__thumbs").append(
            $(
              `<a href="#" aria-label="View product image ${index + 1} of ${swatchImages.length}">
             <img src="${img.thumb}" alt="${img.color}">
           </a>`
            )
          );
        }
        $(".swiper-wrapper").append(
          $(
            `<div class="swiper-slide product__image__photos--slide">
            <div style="position: relative;">
              ${modelSize ? `<div style="position: absolute; top: 10px; left: 10px; background-color: white; color: black; padding: 5px 8px; border-radius: 20px; font-size: 12px; font-weight: bold;">${modelSize}</div>` : ""}
              <img src="${img.large}" class="" fetchpriority="high" alt="${this.selectedVariant.product.title}" data-zoom-src="${img.large}" data-zoom-index="${index}">
            </div>
         </div>`
          )
        );
      });
      var variant_image_message_selector = $(".variant_metafield[data-variant-id=" + this.selectedVariant.id + "] span");
      var variant_image_message = "";
      if (variant_image_message_selector.length > 0) {
        variant_image_message = variant_image_message_selector[0].innerText;
      }
      $(".variant_image_message").text(variant_image_message);
      var productID = this.selectedVariant.product.id;
      var productMetafield = $(".product_metafields").find("[data-product-id=" + productID + "]");
      if (productMetafield.length > 0) {
        var productVideoThumbnail = $($(productMetafield[0]).find(".product_metafield__video_thumbnail")[0]).data("video-thumbnail");
        var productVideoUrl = $($(productMetafield[0]).find(".product_metafield__video_url")[0]).data("video-url");
        var productVideoModel = $(productMetafield[0]).find(".product_metafield__video_model")[0];
        $(".product__image__thumbs").append($('<a href="#" aria-label="Jump to image"><img\n            src="'.concat(productVideoThumbnail, '" alt="').concat(`"><svg width='30pt' height='30pt' version='1.1' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' style='position: absolute; left: 20px; bottom: 40px; fill: #fff;'><path d='m50 12c-20.988 0-38 17.012-38 38s17.012 38 38 38 38-17.012 38-38-17.012-38-38-38zm-11 20l30 18-30 18z'></path></svg></a>`)));
        if (productVideoModel) {
          productVideoModel = productVideoModel.innerText;
          $(".swiper-wrapper").append($('<div class="swiper-slide product__image__photos--slide"><video controls preload="none" style="width:100%; cursor: default;" poster="'.concat(productVideoThumbnail, '"><source src="'.concat(productVideoUrl, `" type='video/mp4' /></video><div style="font-size: 12px; cursor: default; text-align: center;">` + productVideoModel + "</span></div>"))));
        } else {
          $(".swiper-wrapper").append($('<video controls preload="none" class="swiper-slide product__image__photos--slide" style="width:100%; cursor: default; text-align: centerl;" poster="'.concat(productVideoThumbnail, '"><source src="'.concat(productVideoUrl, `" type='video/mp4' /></video>`))));
        }
      }
      this.currentCarousel = new Swiper(".product__image__photos", {
        // autoHeight: true, can't use with first image being lazyloaded
        slidesPerView: 1,
        speed: 500,
        loop: swatchImages.length > 0 ? true : false,
        direction: "horizontal",
        navigation: {
          nextEl: ".product-button-next",
          prevEl: ".product-button-prev"
        },
        pagination: {
          el: ".product-pagination",
          type: "bullets"
        },
        a11y: {
          enabled: true,
          prevSlideMessage: "Previous product image",
          nextSlideMessage: "Next product image",
          paginationBulletMessage: "Go to product image {{index}}"
        },
        on: {
          imagesReady: () => {
            this.loadPlugins();
            $(".product-template-alt").css({ opacity: 1 });
            if (swatchImages.length > 1) {
              $(".product-button-prev").show();
              $(".product-button-next").show();
              $(".product-pagination").show();
            }
            $(".product__image__photos").attr("style", "");
            if (this.currentCarousel && this.currentCarousel.update) {
              this.currentCarousel.update();
            }
          }
        }
      });
      setTimeout(() => {
        if (this.currentCarousel && this.currentCarousel.update) {
          this.currentCarousel.update();
        } else {
          setTimeout(() => {
            this.currentCarousel.update();
          }, 1500);
        }
      }, 300);
      $.ajax({
        method: "GET",
        url: "https://pairswith.app/products/getImages?variant_id=" + this.selectedVariant.id
      }).then(function(res) {
        var metafields = res.images;
        var direction = res.position_flag;
        var handles = res.handles;
        var prices = res.prices;
        var titles = res.titles;
        if (metafields.length != 0) {
          var image_add = metafields.split(",");
          var handle_add = handles.split(",");
          var price_add = prices.split(",");
          var title_add = titles.split(",");
          if (direction == 1) {
            $("#top-image").empty();
            $("#top-image").append($('<img src="'.concat(swatchImages[0].medium, '" class="swiper-slide product__image__photos--slide" alt="').concat(swatchImages[0].color, '"><div class="current-product">This product</div>')));
          } else {
            $("#bottom-image").empty();
            $("#bottom-image").append($('<img src="'.concat(swatchImages[0].large, '" class="swiper-slide product__image__photos--slide" alt="').concat(swatchImages[0].color, '"><div class="current-product">This product</div>')));
          }
          $("#slideshow .slick").slick("unslick");
          $("#slideshow .slick").empty();
          for (var i = 0; i < image_add.length; i++) {
            $("#slideshow .slick").append($("<div><a href='/products/" + handle_add[i] + "'><img src='" + image_add[i] + `' ><div class="product-info"><p class="product-name">` + title_add[i] + '</p><p class="product-price">$' + price_add[i] + "</p></div></a></div>"));
          }
          $("#slideshow .slick").slick();
        } else {
          $("#slideshow .slick").slick("unslick");
          $("#slideshow .slick").empty();
          $("#top-image").empty();
          $("#bottom-image").empty();
        }
      });
    }
    getUrlParameter(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    /**
     *  Get element from variantMap
     */
    findElement(size, color, variantMap2) {
      return variantMap2.find(function(element) {
        return element["size"] == size && element["color"] == color;
      });
    }
    findElementBySwatch(color, variantMap2) {
      return variantMap2.find(function(element) {
        return element["color"] == color;
      });
    }
    findSwatchSizes(color, variantMap2) {
      return variantMap2.filter(function(element) {
        return element["color"] == color;
      });
    }
    findParentTabName(variantId) {
      var tabName;
      var variantId = parseInt(variantId, 10);
      for (var key in productParentProductData) {
        if (productParentProductData.hasOwnProperty(key)) {
          productParentProductData[key].variants.forEach((varient) => {
            if (varient.id === variantId) {
              tabName = key;
            }
          });
        }
      }
      return tabName;
    }
    findColorElements(color, variantMap2) {
      var objs = [];
      variantMap2.map(function(element) {
        if (element["color"] == color) {
          objs.push(element);
        }
      });
      var images = [...new Set(objs.map((variant) => variant.image))];
      return images;
    }
    ajaxPost(id, quantity) {
      var data = new URLSearchParams();
      data.append("quantity", quantity);
      data.append("id", id);
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString()
      }).then(function(response) {
        if (!response.ok) throw response;
        return response.json();
      }).then(function(t) {
        Shopify.getCart(function(e) {
          let box = $("#cart-box");
          box.find(".product-link").attr("href", t.url), box.find(".product-img").attr("src", Shopify.resizeImage(t.image, "medium")).attr("alt", ""), box.find(".product-title .product-link").html("title"), box.find(".product-price").html(Shopify.formatMoney(t.price, money_format)), setTimeout(function() {
            $(".loader-container").hide();
            $("#resultLoading").hide();
            if (window.rebuyEnabled === false) {
              box.addClass("show");
              $(".mini-cart .cart-wrapper").show("show");
              setTimeout(function() {
                box.removeClass("show");
                $(".mini-cart .cart-wrapper").hide("show");
              }, 5e3);
            }
          }, 500), SW.collection.updateCartInfo(
            e,
            ".cart-container .cart-wrapper .cart-inner-content"
          );
          maestra("async", {
            operation: "SetCart",
            data: Object.assign(
              {},
              window.loggedInCustomerEmail ? {
                customer: {
                  email: window.loggedInCustomerEmail
                }
              } : {},
              {
                productList: e.items.map(function(product) {
                  return {
                    product: {
                      ids: {
                        shopifyid: product.id
                      }
                    },
                    count: product.quantity,
                    pricePerItem: product.price
                  };
                })
              }
            ),
            onSuccess: function() {
            },
            onError: function(error) {
              console.log(error);
            }
          });
        });
      }).catch(function(err) {
        console.log("error", err);
        Shopify.getCart(function(e) {
          setTimeout(function() {
            $(".loader-container").hide();
            $("#resultLoading").hide();
            if (window.rebuyEnabled === false) {
              let box = $("#cart-box");
              box.addClass("show");
              $(".mini-cart .cart-wrapper").show("show");
              setTimeout(function() {
                box.removeClass("show");
                $(".mini-cart .cart-wrapper").hide("show");
              }, 5e3);
            }
          }, 500);
          SW.collection.updateCartInfo(
            e,
            ".cart-container .cart-wrapper .cart-inner-content"
          );
        });
      });
    }
    openTab(tabName, clickFirstSwatch) {
      var $tabOpeners = $(".color-swatch__tab-opener");
      var $tab = $(`[color-tab-opener="${tabName}"]`);
      var $tabVariantContainers = $(".variants-container.color-list");
      var $thisTabVariantContainer = $(`[color-tab-id="${tabName}"]`);
      if (clickFirstSwatch) {
        var $firstLabel = $thisTabVariantContainer.find("li").first().find("label");
        $firstLabel.click();
      }
      $tabOpeners.attr("aria-pressed", false);
      $tabOpeners.removeClass("active");
      $tab.addClass("active");
      $tab.attr("aria-pressed", true);
      $tabVariantContainers.hide();
      $thisTabVariantContainer.css("display", "flex");
    }
    getSwatchSlug(swatchName) {
      let updated = swatchName.toLowerCase().replace(/ & /g, " ").replace(/&/g, " ");
      updated.replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
      return updated.replace(/\//g, "-").replace(/ /g, "-");
    }
    additionalSetupRefactorThis() {
      var owlConfig = {
        items: 4,
        autoWidth: false,
        lazyLoad: true,
        loop: true,
        margin: 30,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 1
          },
          375: {
            items: 2,
            margin: 20
          },
          767: {
            items: 3
          },
          992: {
            items: 4
          }
        }
      };
      waitForEl(
        ".you-may-also-like .recommendify-panel-body",
        function() {
          $(".you-may-also-like .recommendify-panel-body").owlCarousel(owlConfig);
        },
        20,
        200
      );
      waitForEl(
        ".recently-viewed .recommendify-panel-body",
        function() {
          $(".recently-viewed .recommendify-panel-body").owlCarousel(owlConfig);
        },
        20,
        200
      );
    }
    loadPlugins() {
      if (!this.pluginsLoaded) {
        this.pluginsLoaded = true;
        this.additionalSetupRefactorThis();
      }
    }
    /**
     * Render the selected child variant's price into the markup that
     * snippets/product-price.liquid already provides, and stamp the real child
     * variant/product ids onto it.
     *
     * The .price container drives sale styling on its own — .price__sale is hidden
     * unless .price--on-sale is present, and .price-item--regular gets the
     * strikethrough from the same class (see assets/theme.scss.liquid) — so we fill
     * the existing slots rather than injecting markup.
     *
     * This replaces an earlier getSaleLabel() that injected a whole <dl class="price">
     * INSIDE span.price-item--regular. That produced invalid nesting and a second
     * .price-item--regular in the DOM, which left the displayed price ambiguous to
     * third-party price-replacement scripts (and to our own selectors).
     *
     * The ids are what the Absolutely price-replacement integration keys off: the
     * page URL is the grouped PARENT product, but the price shown — and the variant
     * actually added to the cart — belongs to a CHILD product.
     */
    updatePriceBlock(priceText, oldPriceText) {
      const variant = this.selectedVariant;
      if (!variant) return;
      let $price = $(this.container).find(".product-price .price");
      if (!$price.length) {
        $price = $(".product-price .price");
      }
      if (!$price.length) return;
      const onSale = Boolean(variant.isOnSale);
      const variantId = variant.id;
      const productId = variant.product && variant.product.id;
      $price.toggleClass("price--on-sale", onSale);
      $price.find(".price-item--regular").text(onSale ? oldPriceText : priceText);
      $price.find(".price-item--sale").text(priceText);
      const $idTargets = $price.add($price.find(".price-item"));
      $idTargets.attr("data-variant-id", variantId);
      if (productId) {
        $idTargets.attr("data-product-id", productId);
      }
      document.dispatchEvent(new CustomEvent("jolyn:price-updated", {
        detail: { variantId, productId, onSale }
      }));
    }
  };
  window.addEventListener("DOMContentLoaded", (event2) => {
    const targetNode = document.querySelector("body.template-product");
    if (!targetNode) return;
    const showStars = function(mutationsList, observer2) {
      let isLoaded = false;
      for (const mutation of mutationsList) {
        if (mutation.type !== "childList") return;
      }
    };
    const observer = new MutationObserver(showStars);
    observer.observe(targetNode, { childList: true, subtree: true });
    Array.from(document.querySelector(".color-list.swatch").children).forEach(
      (el) => el.addEventListener("click", function(e) {
        document.querySelector(".header.color span").textContent = this.dataset.value;
      })
    );
  });
  var container = document.querySelector(".product-template-alt");
  if (container) {
    new ProductParent(container);
  }

  // scripts/product-page.js
  var ProductPage = class {
    constructor(container3) {
      this.container = container3;
      $(".product_form").on("keyup change paste", "input", () => {
        this.checkSwatches();
      });
      $(document).ready(() => {
        this.resize();
        this.checkSwatches();
      }).bind(this);
      $(document).on("click", ".product__image__thumbs a", (event2) => {
        event2.preventDefault();
        var videoLoaded = $("video").length;
        if (videoLoaded) {
          $("video").get(0).pause();
          $("video").get(1).pause();
        }
        if (this.currentCarousel) {
          this.currentCarousel.slideToLoop($(event2.currentTarget).index());
        }
      });
      $(window).on("resize", () => {
        this.resize();
      }).bind(this);
      $(document).on("click", "#desktop-carousel .swiper-wrapper img", (event2) => {
        event2.preventDefault();
        this.positionZoomImage(event2.offsetX, event2.offsetY);
        this.activateZoomImage($(event2.currentTarget).attr("src"));
      }).bind(this);
      $(".zoom-image").click(this.deactivateZoomImage);
      this.$zoomImage = $(".zoom-image");
      this.$zoomImage.mousemove((event2) => {
        this.positionZoomImage(event2.offsetX, event2.offsetY);
      }).bind(this);
    }
    map(input, in_min, in_max, out_min, out_max) {
      return (input - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
    }
    positionZoomImage(x, y) {
      const maxX = this.$zoomImage.innerWidth();
      const maxY = this.$zoomImage.innerHeight();
      let scaledX = this.map(x, 0, maxX, 0, 100);
      let scaledY = this.map(y, 0, maxY, 0, 100);
      this.$zoomImage.css({
        "background-position": `${scaledX}% ${scaledY}%`
      });
    }
    activateZoomImage(url) {
      $(".zoom-image").css({
        "pointer-events": "auto",
        opacity: 1,
        "background-image": `url('${url}')`
      }).mousemove();
    }
    deactivateZoomImage() {
      $(".zoom-image").css({
        "pointer-events": "none",
        opacity: 0
      }).mousemove();
    }
    resize() {
      const $carousel = $(".product__image__group");
      var vpWidth = $(window).width();
      if (vpWidth > 768) {
        $carousel.appendTo($(".product__image--desktop"));
      } else {
        $carousel.appendTo($(".product__image--mobile"));
      }
    }
    getSwatchSlug(swatchName) {
      if (typeof swatchName === "undefined") {
        return "";
      }
      let updated = swatchName.toLowerCase().replace(/ & /g, " ").replace(/&/g, " ");
      updated.replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
      return updated.replace(/\//g, "-").replace(/ /g, "-");
    }
    checkSwatches() {
      var colorLookup = $(".color-list input:checked").val();
      if (colorLookup) {
        let slug = this.getSwatchSlug(colorLookup);
        if (slug !== this.slug) {
          this.updateCarousel(slug);
        }
        this.slug = slug;
      } else {
        this.slug = null;
        console.log("no slug");
        this.updateCarousel();
      }
    }
    updateCarousel(swatch) {
      this.deactivateZoomImage();
      let swatchImages;
      if (swatch) {
        swatchImages = productImages.filter((item) => {
          return item.slug === swatch;
        });
      } else {
        swatchImages = productImages;
      }
      if (this.currentCarousel && this.currentCarousel.destroy) {
        this.currentCarousel.destroy(true, true);
      }
      $(".product__image__photos").attr(
        "style",
        `width: ${$(".product__image__photos").width()}px`
      );
      $(".product__image__thumbs").empty();
      $(".product__image__photos").empty();
      $(".product__image__photos").append(
        $('<div class="swiper-wrapper"></div>')
      );
      swatchImages.forEach((img, index) => {
        if (swatchImages.length > 1) {
          $(".product__image__thumbs").append(
            $(
              `<a href="#" aria-label="View product image ${index + 1} of ${swatchImages.length}">
              <img src="${img.thumb}" alt="${img.color}">
            </a>`
            )
          );
        }
        $(".swiper-wrapper").append(
          $(
            `<div class="swiper-slide product__image__photos--slide">
            <img src="${img.large}" class="" alt="${img.color}">
          </div>`
          )
        );
      });
      var variant_image_message = "";
      swatchImages.forEach((img) => {
        if (variant_image_message == "") {
          var img_variants = $.parseJSON(img.variants);
          img_variants.forEach((img_variant) => {
            if (variant_image_message == "") {
              var variant_image_message_selector = $(".variant_metafield[data-variant-id=" + img_variant.id + "] span");
              if (variant_image_message_selector.length > 0) {
                variant_image_message = variant_image_message_selector[0].innerText;
              }
            }
          });
        }
      });
      $(".variant_image_message").text(variant_image_message);
      var productMetafield = $(".product_metafield");
      if (productMetafield.length > 0) {
        var productVideoThumbnail = $($(productMetafield[0]).find(".product_metafield__video_thumbnail")[0]).data("video-thumbnail");
        var productVideoUrl = $($(productMetafield[0]).find(".product_metafield__video_url")[0]).data("video-url");
        var productVideoModel = $(productMetafield[0]).find(".product_metafield__video_model")[0];
        $(".product__image__thumbs").append($('<a href="#" aria-label="Jump to image"><img\n            src="'.concat(productVideoThumbnail, '" alt="').concat(`"><svg width='30pt' height='30pt' version='1.1' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' style='position: absolute; left: 20px; bottom: 40px;'><path d='m50 12c-20.988 0-38 17.012-38 38s17.012 38 38 38 38-17.012 38-38-17.012-38-38-38zm-11 20l30 18-30 18z'></path></svg></a>`)));
        if (productVideoModel) {
          productVideoModel = productVideoModel.innerText;
          $(".swiper-wrapper").append($('<div class="swiper-slide product__image__photos--slide"><video controls preload="none" style="width:100%; cursor: default;" poster="'.concat(productVideoThumbnail, '"><source src="'.concat(productVideoUrl, `" type='video/mp4' /></video><div style="font-size: 12px; cursor: default;">` + productVideoModel + "</span></div>"))));
        } else {
          $(".swiper-wrapper").append($('<video controls preload="none" class="swiper-slide product__image__photos--slide" style="width:100%; cursor: default;" poster="'.concat(productVideoThumbnail, '"><source src="'.concat(productVideoUrl, `" type='video/mp4' /></video>`))));
        }
      }
      this.currentCarousel = new Swiper(".product__image__photos", {
        // autoHeight: true, can't use with first image being lazyloaded
        slidesPerView: 1,
        loop: swatchImages.length > 0,
        speed: 500,
        direction: "horizontal",
        navigation: {
          nextEl: ".product-button-next",
          prevEl: ".product-button-prev"
        },
        pagination: {
          el: ".product-pagination",
          type: "bullets"
        },
        a11y: {
          enabled: true,
          prevSlideMessage: "Previous product image",
          nextSlideMessage: "Next product image",
          paginationBulletMessage: "Go to product image {{index}}"
        },
        on: {
          imagesReady: () => {
            $(".product-template-alt").css({ opacity: 1 });
            if (swatchImages.length > 1) {
              $(".product-button-prev").show();
              $(".product-button-next").show();
              $(".product-pagination").show();
            } else {
              $(".product-button-prev").hide();
              $(".product-button-next").hide();
            }
            $(".product__image__photos").attr("style", "");
            if (this.currentCarousel && this.currentCarousel.update) {
              this.currentCarousel.update();
            }
          }
        }
      });
      setTimeout(() => {
        if (this.currentCarousel && this.currentCarousel.update) {
          this.currentCarousel.update();
        } else {
          setTimeout(() => {
            this.currentCarousel.update();
          }, 1500);
        }
      }, 300);
    }
  };
  var container2 = document.querySelector("#ProductSection-product-template");
  if (container2) {
    new ProductPage(container2);
  }

  // scripts/zeynep.js
  (function($2, pluginName) {
    var defaults = {
      htmlClass: true
    };
    function Plugin(element, options) {
      this.element = element;
      this.eventController = eventController;
      this.options = $2.extend({}, defaults, options);
      this.options.initialized = false;
      this.init();
    }
    Plugin.prototype.init = function() {
      var zeynep = this.element;
      var options = this.options;
      var eventController2 = this.eventController.bind(this);
      if (options.initialized === true) return;
      eventController2("loading");
      zeynep.find("[data-submenu]").on("click", function(event2) {
        event2.preventDefault();
        var self2 = $2(this);
        var subMenuId = self2.attr("data-submenu");
        var subMenuEl = $2("#" + subMenuId);
        if (!subMenuEl.length) return;
        var eventDetails = {
          subMenu: true,
          menuId: subMenuId
        };
        eventController2("opening", eventDetails);
        zeynep.find(".submenu.current").removeClass("current");
        subMenuEl.addClass("opened current");
        !zeynep.hasClass("submenu-opened") && zeynep.addClass("submenu-opened");
        zeynep[0].scrollTo({ top: 0 });
        eventController2("opened", eventDetails);
      });
      zeynep.find("[data-submenu-close]").on("click", function(event2) {
        event2.preventDefault();
        var self2 = $2(this);
        var subMenuId = self2.attr("data-submenu-close");
        var subMenuEl = $2("#" + subMenuId);
        if (!subMenuEl.length) return;
        var eventDetails = {
          subMenu: true,
          menuId: subMenuId
        };
        eventController2("closing", eventDetails);
        subMenuEl.removeClass("opened current");
        zeynep.find(".submenu.opened").last().addClass("current");
        !zeynep.find(".submenu.opened").length && zeynep.removeClass("submenu-opened");
        subMenuEl[0].scrollTo({ top: 0 });
        eventController2("closed", eventDetails);
      });
      eventController2("load");
      this.options.htmlClass && !$2("html").hasClass("zeynep-initialized") && $2("html").addClass("zeynep-initialized");
      options.initialized = true;
    };
    Plugin.prototype.open = function() {
      this.eventController(
        "opening",
        { subMenu: false }
      );
      this.element.addClass("opened");
      this.options.htmlClass && $2("html").addClass("zeynep-opened");
      this.eventController(
        "opened",
        { subMenu: false }
      );
    };
    Plugin.prototype.close = function(disableEvent) {
      !disableEvent && this.eventController("closing", { subMenu: false });
      this.element.removeClass("opened");
      this.options.htmlClass && $2("html").removeClass("zeynep-opened");
      !disableEvent && this.eventController("closed", { subMenu: false });
    };
    Plugin.prototype.destroy = function() {
      this.eventController("destroying");
      this.close(true);
      this.element.find(".submenu.opened").removeClass("opened");
      this.element.removeData(pluginName);
      this.eventController("destroyed");
      this.options = defaults;
      this.options.htmlClass && $2("html").removeClass("zeynep-initialized");
      delete this.element;
      delete this.options;
      delete this.eventController;
    };
    Plugin.prototype.on = function(name, handler) {
      eventBinder.call(this, name, handler);
    };
    var eventController = function(type, details) {
      if (!this.options[type]) return;
      if (typeof this.options[type] !== "function") throw Error("event handler must be a function: " + type);
      this.options[type].call(this, this.element, this.options, details);
    };
    var getInstance = function(element, options) {
      var instance = null;
      if (!element.data(pluginName)) {
        instance = new Plugin(element, options || {});
        element.data(pluginName, instance);
      } else {
        instance = element.data(pluginName);
      }
      return instance;
    };
    var eventBinder = function(name, handler) {
      if (typeof name !== "string") throw Error("event name is expected to be a string but got: " + typeof name);
      if (typeof handler !== "function") throw Error("event handler is not a function for: " + name);
      this.options[name] = handler;
    };
    $2.fn[pluginName] = function(options) {
      var instance = getInstance($2(this[0]), options);
      return instance;
    };
  })(window.jQuery || window.cash, "zeynep");

  // scripts/loyalty.js
  document.addEventListener("DOMContentLoaded", function() {
    if (!window.customerId) return;
    fetch("https://maestra-auth.vercel.app/api/maestra-check-customer", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ customerId: window.customerId })
    }).then((r2) => r2.json()).then((data) => {
      let points = 0;
      let tier = "JOLYNSIDER";
      if (data.getData && data.getData.balances && data.getData.balances.length > 0) {
        points = parseInt(data.getData.balances[0].available, 10) || 0;
      }
      if (data.getData && data.getData.customerSegmentations) {
        const segments = data.getData.customerSegmentations.map((seg) => seg.segment && seg.segment.name);
        if (segments.includes("Maestra JOLYNPIAN")) {
          tier = "JOLYNPIAN";
        } else if (segments.includes("Maestra JOLYNFLUENCER")) {
          tier = "JOLYNFLUENCER";
        } else if (segments.includes("Maestra JOLYNSIDER")) {
          tier = "JOLYNSIDER";
        }
      }
      window.loyaltyPoints = points;
      window.loyaltyTier = tier;
      document.dispatchEvent(new CustomEvent("loyaltyDataLoaded", { detail: { points, tier } }));
      console.log("[Loyalty] Loaded:", { points, tier });
    }).catch((err) => {
      window.loyaltyPoints = null;
      window.loyaltyTier = null;
      document.dispatchEvent(new CustomEvent("loyaltyDataLoaded", { detail: { points: null, tier: null, error: err } }));
      console.error("[Loyalty] Error loading data:", err);
    });
  });

  // scripts/accessibility.js
  function enhancePopMechanicForms() {
    const embedContainers = document.querySelectorAll("[data-popmechanic-embed]");
    embedContainers.forEach((container3) => {
      if (container3.dataset.a11yEnhanced) return;
      const emailInput = container3.querySelector('input[type="email"], input[name*="email"], input[placeholder*="email" i]');
      if (emailInput) {
        if (!emailInput.hasAttribute("autocomplete")) {
          emailInput.setAttribute("autocomplete", "email");
        }
        const formId = container3.dataset.popmechanicEmbed;
        const statusId = `popmechanic-status-${formId}`;
        let statusRegion = container3.querySelector(`#${statusId}`);
        if (!statusRegion) {
          statusRegion = document.createElement("div");
          statusRegion.id = statusId;
          statusRegion.className = "popmechanic-a11y-status";
          statusRegion.setAttribute("aria-live", "polite");
          statusRegion.setAttribute("aria-atomic", "true");
          statusRegion.setAttribute("role", "status");
          statusRegion.style.cssText = "position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;";
          container3.appendChild(statusRegion);
        }
        const existingDescribedBy = emailInput.getAttribute("aria-describedby");
        if (existingDescribedBy) {
          if (!existingDescribedBy.includes(statusId)) {
            emailInput.setAttribute("aria-describedby", `${existingDescribedBy} ${statusId}`);
          }
        } else {
          emailInput.setAttribute("aria-describedby", statusId);
        }
        const form = emailInput.closest("form");
        if (form && !form.dataset.a11yEnhanced) {
          form.dataset.a11yEnhanced = "true";
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              mutation.addedNodes.forEach((node) => {
                var _a, _b, _c, _d, _e;
                if (node.nodeType === Node.ELEMENT_NODE) {
                  const messageText = (_a = node.textContent) == null ? void 0 : _a.trim();
                  if (messageText && messageText.length > 0 && messageText.length < 200) {
                    const isMessage = ((_b = node.classList) == null ? void 0 : _b.contains("error")) || ((_c = node.classList) == null ? void 0 : _c.contains("success")) || ((_d = node.classList) == null ? void 0 : _d.contains("message")) || node.getAttribute("role") === "alert" || messageText.toLowerCase().includes("thank") || messageText.toLowerCase().includes("error") || messageText.toLowerCase().includes("invalid") || messageText.toLowerCase().includes("subscribed") || messageText.toLowerCase().includes("email");
                    if (isMessage) {
                      statusRegion.textContent = messageText;
                      if (((_e = node.classList) == null ? void 0 : _e.contains("error")) || messageText.toLowerCase().includes("error") || messageText.toLowerCase().includes("invalid")) {
                        setTimeout(() => {
                          emailInput.focus();
                          emailInput.setAttribute("aria-invalid", "true");
                        }, 100);
                      } else {
                        emailInput.removeAttribute("aria-invalid");
                      }
                    }
                  }
                }
              });
            });
          });
          observer.observe(container3, {
            childList: true,
            subtree: true
          });
        }
        container3.dataset.a11yEnhanced = "true";
      }
    });
  }
  function enhanceSearchSpring() {
    const autocomplete = document.querySelector(".ss__autocomplete");
    if (autocomplete && !autocomplete.dataset.a11yEnhanced) {
      const searchInput = document.querySelector('input[type="search"]');
      if (searchInput) {
        searchInput.setAttribute("role", "combobox");
        searchInput.setAttribute("aria-autocomplete", "list");
        searchInput.setAttribute("aria-expanded", "false");
        if (!autocomplete.id) {
          autocomplete.id = "ss-autocomplete-results";
        }
        searchInput.setAttribute("aria-controls", autocomplete.id);
        autocomplete.setAttribute("role", "listbox");
        const autocompleteObserver = new MutationObserver(() => {
          const searchContainer = autocomplete.closest(".show-desktop-search");
          const isSearchHidden = searchContainer && searchContainer.getBoundingClientRect().top < 0;
          const isVisible = !isSearchHidden && (autocomplete.offsetParent !== null && window.getComputedStyle(autocomplete).display !== "none");
          searchInput.setAttribute("aria-expanded", isVisible ? "true" : "false");
          if (isVisible) {
            const resultItems = autocomplete.querySelectorAll('.ss__autocomplete__term, .ss__autocomplete__option, [class*="ss__autocomplete__"]');
            resultItems.forEach((item, index) => {
              item.setAttribute("tabindex", "-1");
              if (!item.hasAttribute("role")) {
                item.setAttribute("role", "option");
                item.id = `ss-autocomplete-option-${index}`;
              }
            });
          }
        });
        autocompleteObserver.observe(autocomplete, {
          attributes: true,
          attributeFilter: ["style", "class"],
          childList: true,
          subtree: true
        });
        let currentIndex = -1;
        searchInput.addEventListener("keydown", function(e) {
          var _a, _b, _c, _d;
          const options = autocomplete.querySelectorAll('[role="option"]');
          if (!options.length) return;
          if (e.key === "ArrowDown") {
            e.preventDefault();
            currentIndex = Math.min(currentIndex + 1, options.length - 1);
            (_a = options[currentIndex]) == null ? void 0 : _a.focus();
            searchInput.setAttribute("aria-activedescendant", ((_b = options[currentIndex]) == null ? void 0 : _b.id) || "");
          } else if (e.key === "ArrowUp") {
            e.preventDefault();
            currentIndex = Math.max(currentIndex - 1, 0);
            (_c = options[currentIndex]) == null ? void 0 : _c.focus();
            searchInput.setAttribute("aria-activedescendant", ((_d = options[currentIndex]) == null ? void 0 : _d.id) || "");
          } else if (e.key === "Escape") {
            currentIndex = -1;
            searchInput.removeAttribute("aria-activedescendant");
          }
        });
      }
      autocomplete.dataset.a11yEnhanced = "true";
    }
    const resultCards = document.querySelectorAll('.ss__result:not([data-a11y-enhanced]), [class*="ss-result"]:not([data-a11y-enhanced])');
    resultCards.forEach((card) => {
      var _a, _b;
      const link = card.querySelector("a");
      const productName = (_b = (_a = card.querySelector('.ss__result__details__title, [class*="title"], h3, h4')) == null ? void 0 : _a.textContent) == null ? void 0 : _b.trim();
      if (link && productName && !link.getAttribute("aria-label")) {
        link.setAttribute("aria-label", `View ${productName}`);
      }
      const images = card.querySelectorAll('img:not([alt]), img[alt=""]');
      images.forEach((img) => {
        if (productName) {
          img.setAttribute("alt", productName);
        }
      });
      card.dataset.a11yEnhanced = "true";
    });
    const recommendations = document.querySelectorAll(".ss__recommendation:not([data-a11y-enhanced])");
    recommendations.forEach((rec) => {
      if (!rec.hasAttribute("role")) {
        rec.setAttribute("role", "region");
        const heading = rec.querySelector('h2, h3, h4, [class*="title"]');
        if (heading) {
          if (!heading.id) {
            heading.id = `ss-rec-heading-${Math.random().toString(36).substr(2, 9)}`;
          }
          rec.setAttribute("aria-labelledby", heading.id);
        } else {
          rec.setAttribute("aria-label", "Product recommendations");
        }
      }
      rec.dataset.a11yEnhanced = "true";
    });
  }
  function enhanceDesktopNavigation() {
    const menuContainer = document.querySelector("#menu-container-1-content");
    if (!menuContainer || menuContainer.dataset.a11yEnhanced) return;
    const dropdownTriggers = menuContainer.querySelectorAll("[aria-expanded]");
    dropdownTriggers.forEach((trigger) => {
      const submenuId = trigger.getAttribute("aria-controls");
      const submenu = submenuId ? document.getElementById(submenuId) : null;
      const parentLi = trigger.closest("li");
      if (!parentLi) return;
      function openSubmenu() {
        trigger.setAttribute("aria-expanded", "true");
        if (submenu) submenu.classList.add("active");
      }
      function closeSubmenu() {
        trigger.setAttribute("aria-expanded", "false");
        if (submenu) submenu.classList.remove("active");
      }
      parentLi.addEventListener("mouseenter", () => {
        trigger.setAttribute("aria-expanded", "true");
      });
      parentLi.addEventListener("mouseleave", () => {
        if (!submenu || !submenu.classList.contains("active")) {
          trigger.setAttribute("aria-expanded", "false");
        }
      });
      parentLi.addEventListener("focusout", (e) => {
        if (!parentLi.contains(e.relatedTarget)) {
          closeSubmenu();
        }
      });
      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          const isExpanded = trigger.getAttribute("aria-expanded") === "true";
          if (isExpanded) {
            closeSubmenu();
          } else {
            openSubmenu();
            if (submenu) {
              const firstLink = submenu.querySelector("a, button");
              if (firstLink) firstLink.focus();
            }
          }
        } else if (e.key === "Escape") {
          closeSubmenu();
          trigger.focus();
        }
      });
      trigger.addEventListener("click", (e) => {
        const isExpanded = trigger.getAttribute("aria-expanded") === "true";
        if (isExpanded) {
          closeSubmenu();
        } else {
          openSubmenu();
          if (submenu) {
            const firstLink = submenu.querySelector("a, button");
            if (firstLink) firstLink.focus();
          }
        }
      });
      if (submenu) {
        submenu.addEventListener("keydown", (e) => {
          if (e.key === "Escape") {
            closeSubmenu();
            trigger.focus();
          }
        });
      }
    });
    menuContainer.dataset.a11yEnhanced = "true";
  }
  function enhancePrivacyAccessibilitySettings() {
    const accessibilityWidget = document.getElementById("accessibilityWidget");
    if (accessibilityWidget && !accessibilityWidget.dataset.a11yEnhanced) {
      accessibilityWidget.setAttribute("role", "button");
      accessibilityWidget.setAttribute("aria-label", "Open accessibility settings");
      accessibilityWidget.addEventListener("keydown", function(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }
      });
      accessibilityWidget.dataset.a11yEnhanced = "true";
    }
    const cookiePrefsBtn = document.getElementById("cookie-preferences-btn");
    if (cookiePrefsBtn && !cookiePrefsBtn.dataset.a11yEnhanced) {
      cookiePrefsBtn.setAttribute("role", "button");
      cookiePrefsBtn.setAttribute("aria-label", "Open your privacy choices");
      cookiePrefsBtn.addEventListener("keydown", function(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (typeof privacyBanner !== "undefined" && privacyBanner.showPreferences) {
            privacyBanner.showPreferences();
          }
        }
      });
      cookiePrefsBtn.dataset.a11yEnhanced = "true";
    }
  }
  function initAccessibilityEnhancements() {
    enhancePopMechanicForms();
    enhancePrivacyAccessibilitySettings();
    enhanceDesktopNavigation();
    enhanceSearchSpring();
    const observer = new MutationObserver((mutations) => {
      let shouldEnhanceForms = false;
      let shouldEnhanceSearchSpring = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          var _a, _b, _c, _d, _e, _f, _g, _h;
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (((_a = node.querySelector) == null ? void 0 : _a.call(node, "[data-popmechanic-embed] input")) || ((_b = node.matches) == null ? void 0 : _b.call(node, 'input[type="email"]'))) {
              shouldEnhanceForms = true;
            }
            if (((_c = node.classList) == null ? void 0 : _c.contains("ss__autocomplete")) || ((_d = node.classList) == null ? void 0 : _d.contains("ss__result")) || ((_e = node.classList) == null ? void 0 : _e.contains("ss__recommendation")) || ((_f = node.querySelector) == null ? void 0 : _f.call(node, ".ss__autocomplete")) || ((_g = node.querySelector) == null ? void 0 : _g.call(node, ".ss__result")) || ((_h = node.querySelector) == null ? void 0 : _h.call(node, '[class*="ss__"]'))) {
              shouldEnhanceSearchSpring = true;
            }
          }
        });
      });
      if (shouldEnhanceForms) {
        setTimeout(enhancePopMechanicForms, 100);
      }
      if (shouldEnhanceSearchSpring) {
        setTimeout(enhanceSearchSpring, 100);
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAccessibilityEnhancements);
  } else {
    initAccessibilityEnhancements();
  }
  setTimeout(initAccessibilityEnhancements, 2e3);
  setTimeout(initAccessibilityEnhancements, 5e3);

  // scripts/theme.js
  console.log("v3");
  window.applySwatches = function(swatches, applyToSelector) {
    swatches.each(function(index, swatch) {
      var swatchColorAttribute = swatch.dataset.value;
      var swatchColors = swatchColorAttribute.split(" & ");
      var swatchHexes = swatchColors.map(function(name) {
        return colors[name] || "#000";
      });
      var bg;
      if (swatchHexes.length === 1) {
        bg = swatchHexes[0];
      } else if (swatchHexes.length === 2) {
        bg = `linear-gradient(135deg, ${swatchHexes[0]} 50%, ${swatchHexes[1]} 50%)`;
      } else if (swatchHexes.length === 3) {
        bg = `linear-gradient(135deg, ${swatchHexes[0]} 40%, ${swatchHexes[1]} 40%, ${swatchHexes[1]} 60%, ${swatchHexes[2]} 60%)`;
      }
      $(swatch).find(applyToSelector).css("background", bg);
    });
  };
  Shopify.handleize = function(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };
  function checkExclusions() {
    return __async(this, null, function* () {
      const fetchExclusions = (page = 1, allProductIds = []) => {
        return fetch(`/collections/sitewide-promotion-exclusions/products.json?limit=250&page=${page}`).then((res) => res.json()).then((data) => {
          const productIds = data.products.map((product) => product.id);
          allProductIds = allProductIds.concat(productIds);
          if (data.products.length === 250) {
            return fetchExclusions(page + 1, allProductIds);
          }
          window.exclusions = allProductIds;
          return allProductIds;
        });
      };
      return fetchExclusions();
    });
  }
  function checkEcommerceExclusives() {
    return __async(this, null, function* () {
      const fetchEcommerceExclusives = (page = 1, allProductIds = []) => {
        return fetch(`/collections/ecommerce-exclusive/products.json?limit=250&page=${page}`).then((res) => res.json()).then((data) => {
          const productIds = data.products.map((product) => product.id);
          allProductIds = allProductIds.concat(productIds);
          if (data.products.length === 250) {
            return fetchEcommerceExclusives(page + 1, allProductIds);
          }
          window.ecommerceExclusives = allProductIds;
          return allProductIds;
        });
      };
      return fetchEcommerceExclusives();
    });
  }
  document.addEventListener("DOMContentLoaded", function() {
    var lazyloadImages;
    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".lazybg");
      var imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            image.classList.remove("lazybg");
            imageObserver.unobserve(image);
          }
        });
      });
      lazyloadImages.forEach(function(image) {
        imageObserver.observe(image);
      });
    } else {
      let lazyload = function() {
        if (lazyloadThrottleTimeout) {
          clearTimeout(lazyloadThrottleTimeout);
        }
        lazyloadThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function(img) {
            if (img.offsetTop < window.innerHeight + scrollTop) {
              img.src = img.dataset.src;
              img.classList.remove("lazybg");
            }
          });
          if (lazyloadImages.length == 0) {
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      };
      var lazyloadThrottleTimeout;
      lazyloadImages = document.querySelectorAll(".lazybg");
      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
    try {
      checkExclusions();
      checkEcommerceExclusives();
    } catch (e) {
      console.error("Error checking exclusions:", e);
    }
  });
})();
/*!
* zeynepjs v2.2.0
* A light-weight multi-level jQuery side menu plugin.
* It's fully customizable and is compatible with modern browsers such as Google Chrome, Mozilla Firefox, Safari, Edge and Internet Explorer
* MIT License
* by Huseyin ELMAS
*/
